(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6e22"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6e22"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kev3W", function(module, exports) {
!function(e, r) {
    r(module.exports);
}(module.exports, function(e) {
    var r = /*#__PURE__*/ function() {
        function e(r) {
            void 0 === r && (r = e.defaultCreateUrl), this.createURL = void 0, this.createURL = r;
        }
        return e.defaultCreateUrl = function(e, r) {
            return "https://" + e + ".ipns.dweb.link" + r.replace(/^\/?/, "/");
        }, e.prototype.resolve = function(e) {
            try {
                var r, n, t;
                if (e.startsWith("/ipfs/") || e.startsWith("/ipns/")) t = e.substring(1, 5), r = e.substring(6).split("/")[0], n = e.substring(6 + r.length);
                else {
                    var o = new URL(e);
                    if ("" !== o.hash || "" !== o.password || "" !== o.port || "" !== o.search || "" !== o.username) throw new Error("invalid ipfs uri");
                    t = o.protocol.substring(0, 4), r = o.hostname, n = o.pathname;
                }
                if ("ipfs" !== t) throw new Error("only ipfs is supported, (not ipns)");
                return Promise.resolve(fetch(this.createURL(r, n)).then(function(e) {
                    return e.ok ? e.text() : Promise.reject(new Error("bad response"));
                }));
            } catch (e) {
                return Promise.reject(e);
            }
        }, e;
    }(), n = /*#__PURE__*/ function() {
        function e(e) {
            this.options = void 0, this.options = e;
        }
        return e.prototype.resolve = function(e, r) {
            try {
                var n, t = "";
                if (e.includes("@")) {
                    var o = e.split("@", 1);
                    t = o[0], n = o[1];
                } else n = e;
                var i = "http://openid.net/specs/connect/1.0/issuer";
                return Promise.resolve(this.options.webfingerResolver.resolve(n, t, i, r)).then(function(e) {
                    var r, n = null == (r = e.links) ? void 0 : r.find(function(e) {
                        return e.rel === i;
                    });
                    if (!n || !n.href) throw new Error("bad jrd");
                    return Promise.resolve(fetch(n.href + "/.well-known/openid-configuration").then(function(e) {
                        return e.ok ? e.json() : Promise.reject(new Error("bad openid-configuration response"));
                    }));
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, e;
    }();
    function t(e, r, n) {
        if (!e.s) {
            if (n instanceof o) {
                if (!n.s) return void (n.o = t.bind(null, e, r));
                1 & r && (r = n.s), n = n.v;
            }
            if (n && n.then) return void n.then(t.bind(null, e, r), t.bind(null, e, 2));
            e.s = r, e.v = n;
            const i = e.o;
            i && i(e);
        }
    }
    var o = /*#__PURE__*/ function() {
        function e() {}
        return e.prototype.then = function(r, n) {
            var o = new e, i = this.s;
            if (i) {
                var s = 1 & i ? r : n;
                if (s) {
                    try {
                        t(o, 1, s(this.v));
                    } catch (e) {
                        t(o, 2, e);
                    }
                    return o;
                }
                return this;
            }
            return this.o = function(e) {
                try {
                    var i = e.v;
                    1 & e.s ? t(o, 1, r ? r(i) : i) : n ? t(o, 1, n(i)) : t(o, 2, i);
                } catch (e) {
                    t(o, 2, e);
                }
            }, o;
        }, e;
    }();
    if ("undefined" != typeof window) {
        var i = window;
        i.UAUTH_VERSION = i.UAUTH_VERSION || {}, i.UAUTH_VERSION.COMMON = "2.3.0";
    }
    var s = /*#__PURE__*/ function() {
        function e(e) {
            this.options = void 0, this.options = e;
        }
        return e.prototype.resolve = function(e, r, n, i) {
            try {
                var s = this, u = "webfinger." + r + "." + n;
                return Promise.resolve(s.options.domainResolver.records(e, [
                    u
                ])).then(function(f) {
                    function a(e) {
                        if (h.subject !== c) throw new Error("resource invalid");
                        return h;
                    }
                    var c = r ? "acct:" + r + "@" + e : "" + e;
                    if (!f[u]) return {
                        subject: c,
                        links: [
                            {
                                rel: n,
                                href: i
                            }
                        ]
                    };
                    var h, v = JSON.parse(f[u]), l = "string" == typeof v.host ? Promise.resolve(fetch("/.well-known/webfinger?" + new URLSearchParams({
                        resource: c,
                        rel: n
                    }).toString(), {
                        headers: {
                            Host: v.host
                        }
                    }).then(function(e) {
                        return e.ok ? e.json() : Promise.reject(new Error("bad webfinger response"));
                    })).then(function(e) {
                        h = e;
                    }) : function() {
                        if ("string" == typeof v.uri) {
                            var e = new URL(v.uri);
                            return function(e, r) {
                                var n, i = -1;
                                e: {
                                    for(var s = 0; s < r.length; s++){
                                        var u = r[s][0];
                                        if (u) {
                                            var f = u();
                                            if (f && f.then) break e;
                                            if (f === e) {
                                                i = s;
                                                break;
                                            }
                                        } else i = s;
                                    }
                                    if (-1 !== i) {
                                        do {
                                            for(var a = r[i][1]; !a;)i++, a = r[i][1];
                                            var c = a();
                                            if (c && c.then) {
                                                n = !0;
                                                break e;
                                            }
                                            var h = r[i][2];
                                            i++;
                                        }while (h && !h());
                                        return c;
                                    }
                                }
                                var v = new o, l = t.bind(null, v, 2);
                                return (n ? c.then(p) : f.then(function n(o) {
                                    for(;;){
                                        if (o === e) {
                                            i = s;
                                            break;
                                        }
                                        if (++s === r.length) {
                                            if (-1 !== i) break;
                                            return void t(v, 1, a);
                                        }
                                        if (u = r[s][0]) {
                                            if ((o = u()) && o.then) return void o.then(n).then(void 0, l);
                                        } else i = s;
                                    }
                                    do {
                                        for(var f = r[i][1]; !f;)i++, f = r[i][1];
                                        var a = f();
                                        if (a && a.then) return void a.then(p).then(void 0, l);
                                        var c = r[i][2];
                                        i++;
                                    }while (c && !c());
                                    t(v, 1, a);
                                })).then(void 0, l), v;
                                function p(e) {
                                    for(;;){
                                        var n = r[i][2];
                                        if (!n || n()) break;
                                        i++;
                                        for(var o = r[i][1]; !o;)i++, o = r[i][1];
                                        if ((e = o()) && e.then) return void e.then(p).then(void 0, l);
                                    }
                                    t(v, 1, e);
                                }
                            }(e.protocol, [
                                [
                                    function() {
                                        return "http:";
                                    }
                                ],
                                [
                                    function() {
                                        return "https:";
                                    },
                                    function() {
                                        return Promise.resolve(fetch(e.toString()).then(function(e) {
                                            return e.ok ? e.json() : Promise.reject(new Error("bad webfinger response"));
                                        })).then(function(e) {
                                            h = e;
                                        });
                                    }
                                ],
                                [
                                    function() {
                                        return "ipfs:";
                                    },
                                    function() {
                                        return Promise.resolve(s.options.ipfsResolver.resolve(v.uri)).then(function(e) {
                                            h = JSON.parse(e);
                                        });
                                    }
                                ],
                                [
                                    function() {
                                        return "ipns:";
                                    }
                                ],
                                [
                                    function() {
                                        return "swarm:";
                                    }
                                ],
                                [
                                    void 0,
                                    function() {
                                        throw new Error("uri scheme not supported");
                                    }
                                ]
                            ]);
                        }
                        if ("string" != typeof v.value) throw new Error("bad webfinger record");
                        h = JSON.parse(v.value);
                    }();
                    return l && l.then ? l.then(a) : a();
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, e;
    }();
    function u() {
        return u = Object.assign || function(e) {
            for(var r = 1; r < arguments.length; r++){
                var n = arguments[r];
                for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
            }
            return e;
        }, u.apply(this, arguments);
    }
    var f = /*#__PURE__*/ function() {
        function e() {
            var e = this;
            this.map = new Map, this.records = function(r, n) {
                try {
                    var t = e.map.get(r);
                    if (0 === n.length) throw new Error("no keys");
                    return Promise.resolve(t ? n.reduce(function(e, r) {
                        return e[r] = t[r] || "", e;
                    }, {}) : {});
                } catch (e) {
                    return Promise.reject(e);
                }
            };
        }
        return e.prototype.set = function(e, r) {
            this.map.has(e) ? this.map.set(e, u({}, this.map.get(e), r)) : this.map.set(e, r);
        }, e;
    }(), a = /*#__PURE__*/ function() {
        function e() {
            this.map = new Map;
        }
        var r = e.prototype;
        return r.set = function(e, r, n, t) {
            this.map.set(e + "." + r + "." + n, t);
        }, r.resolve = function(e, r, n, t) {
            try {
                var o = this.map.get(e + "." + r + "." + n);
                return Promise.resolve(o || {
                    subject: e,
                    links: [
                        {
                            rel: n,
                            href: t
                        }
                    ]
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, e;
    }();
    e.DefaultIPFSResolver = r, e.DefaultIssuerResolver = n, e.DefaultWebFingerResolver = s, e.MemoryDomainResolver = f, e.MemoryWebFingerResolver = a, e.isJRD = function(e) {
        return !0;
    }, e.isJRDLink = function(e) {
        return !0;
    };
});

});

parcelRegister("gtl9B", function(module, exports) {
"use strict";
var $bfdfc37847fb227e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bfdfc37847fb227e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bfdfc37847fb227e$var$__createBinding(exports1, m, p);
};
var $bfdfc37847fb227e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProviderFactories = module.exports.Eip1193Factories = module.exports.Eip1993Factories = module.exports.DnsRecordsErrorCode = module.exports.DnsRecordsError = module.exports.ConfigurationErrorCode = module.exports.ConfigurationError = module.exports.ResolutionErrorCode = module.exports.ResolutionError = module.exports.DnsUtils = module.exports.default = module.exports.Resolution = void 0;

var $87teb = parcelRequire("87teb");
Object.defineProperty(module.exports, "Resolution", {
    enumerable: true,
    get: function() {
        return $87teb.Resolution;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $87teb.Resolution;
    }
});

$bfdfc37847fb227e$var$__exportStar((parcelRequire("bq44C")), module.exports);

var $6dH2g = parcelRequire("6dH2g");
Object.defineProperty(module.exports, "DnsUtils", {
    enumerable: true,
    get: function() {
        return $bfdfc37847fb227e$var$__importDefault($6dH2g).default;
    }
});

var $anKpg = parcelRequire("anKpg");
Object.defineProperty(module.exports, "ResolutionError", {
    enumerable: true,
    get: function() {
        return $anKpg.ResolutionError;
    }
});
Object.defineProperty(module.exports, "ResolutionErrorCode", {
    enumerable: true,
    get: function() {
        return $anKpg.ResolutionErrorCode;
    }
});

var $6yp4P = parcelRequire("6yp4P");
Object.defineProperty(module.exports, "ConfigurationError", {
    enumerable: true,
    get: function() {
        return $6yp4P.ConfigurationError;
    }
});
Object.defineProperty(module.exports, "ConfigurationErrorCode", {
    enumerable: true,
    get: function() {
        return $6yp4P.ConfigurationErrorCode;
    }
});

var $2gWQY = parcelRequire("2gWQY");
Object.defineProperty(module.exports, "DnsRecordsError", {
    enumerable: true,
    get: function() {
        return $2gWQY.DnsRecordsError;
    }
});
Object.defineProperty(module.exports, "DnsRecordsErrorCode", {
    enumerable: true,
    get: function() {
        return $2gWQY.DnsRecordsErrorCode;
    }
});

var $9GlGG = parcelRequire("9GlGG");
Object.defineProperty(module.exports, "Eip1993Factories", {
    enumerable: true,
    get: function() {
        return $9GlGG.Eip1993Factories;
    }
});

var $9GlGG = parcelRequire("9GlGG");
Object.defineProperty(module.exports, "Eip1193Factories", {
    enumerable: true,
    get: function() {
        return $9GlGG.Eip1993Factories;
    }
});

var $9GlGG = parcelRequire("9GlGG");
Object.defineProperty(module.exports, "ProviderFactories", {
    enumerable: true,
    get: function() {
        return $9GlGG.Eip1993Factories;
    }
});

});
parcelRegister("87teb", function(module, exports) {
"use strict";
var $5e95a6341722a445$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e95a6341722a445$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5e95a6341722a445$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5e95a6341722a445$var$__createBinding(result, mod, k);
    }
    $5e95a6341722a445$var$__setModuleDefault(result, mod);
    return result;
};
var $5e95a6341722a445$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5e95a6341722a445$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5e95a6341722a445$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Resolution = void 0;

var $5e95a6341722a445$var$bn_js_1 = $5e95a6341722a445$var$__importDefault((parcelRequire("lONYJ")));

var $5e95a6341722a445$var$Zns_1 = $5e95a6341722a445$var$__importDefault((parcelRequire("61rj9")));

var $5e95a6341722a445$var$Uns_1 = $5e95a6341722a445$var$__importDefault((parcelRequire("1xVWq")));

var $5e95a6341722a445$var$UdApi_1 = $5e95a6341722a445$var$__importDefault((parcelRequire("3AD97")));

var $bq44C = parcelRequire("bq44C");

var $5e95a6341722a445$var$resolutionError_1 = $5e95a6341722a445$var$__importStar((parcelRequire("anKpg")));

var $5e95a6341722a445$var$DnsUtils_1 = $5e95a6341722a445$var$__importDefault((parcelRequire("6dH2g")));

var $jECMB = parcelRequire("jECMB");

var $9GlGG = parcelRequire("9GlGG");

var $5e95a6341722a445$var$Networking_1 = $5e95a6341722a445$var$__importDefault((parcelRequire("5J7oF")));

var $6dKzR = parcelRequire("6dKzR");

var $bPRni = parcelRequire("bPRni");
/**
 * Blockchain domain Resolution library - Resolution.
 * @example
 * ```
 * import Resolution from '@unstoppabledomains/resolution';
 *
 * let resolution = new Resolution({ blockchain: {
 *        uns: {
 *           url: "https://mainnet.infura.io/v3/c4bb906ed6904c42b19c95825fe55f39",
 *           network: "mainnet"
 *        }
 *      }
 *   });
 *
 * let domain = "brad.zil";
 * resolution.addr(domain, "eth").then(addr => console.log(addr));;
 * ```
 */ var $5e95a6341722a445$var$Resolution = /** @class */ function() {
    function Resolution(_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.sourceConfig, sourceConfig = _d === void 0 ? undefined : _d;
        var uns = $5e95a6341722a445$var$isApi(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.uns) ? new $5e95a6341722a445$var$UdApi_1.default(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.uns) : new $5e95a6341722a445$var$Uns_1.default(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.uns);
        var zns = $5e95a6341722a445$var$isApi(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.zns) ? new $5e95a6341722a445$var$UdApi_1.default(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.zns) : new $5e95a6341722a445$var$Zns_1.default(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.zns);
        // If both UNS and ZNS use the same UdApi providers, we don't want to call the API twice as it would return same
        // responses. It should be enough to compare just the URLs, as the network param isn't actually used in the calls.
        var equalUdApiProviders = uns instanceof $5e95a6341722a445$var$UdApi_1.default && zns instanceof $5e95a6341722a445$var$UdApi_1.default && uns.url === zns.url;
        // If a user configures the lib with an API source, we still want to initialise native blockchain services to access
        // some non-async methods such as namehash, as they are unavailable in the UdApi service.
        this.serviceMap = (_b = {}, _b[$bq44C.NamingServiceName.UNS] = {
            usedServices: [
                uns
            ],
            native: $5e95a6341722a445$var$isApi(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.uns) ? new $5e95a6341722a445$var$Uns_1.default() : uns
        }, _b[$bq44C.NamingServiceName.ZNS] = {
            usedServices: equalUdApiProviders ? [
                uns
            ] : [
                uns,
                zns
            ],
            native: $5e95a6341722a445$var$isApi(sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.zns) ? new $5e95a6341722a445$var$Zns_1.default() : zns
        }, _b);
    }
    /**
     * AutoConfigure the blockchain network for UNS
     * We make a "net_version" JSON RPC call to the blockchain either via url or with the help of given provider.
     * @param sourceConfig - configuration object for uns
     * @returns configured Resolution object
     */ Resolution.autoNetwork = function(sourceConfig) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var resolution, uns;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolution = new this();
                        if (!sourceConfig.uns) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            $5e95a6341722a445$var$Uns_1.default.autoNetwork(sourceConfig.uns)
                        ];
                    case 1:
                        uns = _a.sent();
                        resolution.serviceMap[$bq44C.NamingServiceName.UNS] = {
                            usedServices: [
                                uns
                            ],
                            native: uns
                        };
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            resolution
                        ];
                }
            });
        });
    };
    /**
     * Creates a resolution with configured infura id for uns
     * @param infura - infura project id
     * @param networks - an optional object that describes what network to use when connecting UNS default is mainnet
     */ Resolution.infura = function(infura, networks) {
        var _a, _b, _c, _d;
        return new this({
            sourceConfig: {
                uns: {
                    locations: {
                        Layer1: {
                            url: (0, $jECMB.signedLink)(infura, ((_a = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _a === void 0 ? void 0 : _a.locations.Layer1.network) || "mainnet", "infura"),
                            network: ((_b = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _b === void 0 ? void 0 : _b.locations.Layer1.network) || "mainnet"
                        },
                        Layer2: {
                            url: (0, $jECMB.signedLink)(infura, ((_c = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _c === void 0 ? void 0 : _c.locations.Layer2.network) || "polygon-mainnet", "infura"),
                            network: ((_d = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _d === void 0 ? void 0 : _d.locations.Layer2.network) || "polygon-mainnet"
                        }
                    }
                }
            }
        });
    };
    /**
     * Creates a resolution with configured alchemy API keys for uns
     * @param alchemy - alchemy API keys
     * @param networks - an optional object that describes what network to use when connecting UNS default is mainnet
     */ Resolution.alchemy = function(alchemy, networks) {
        var _a, _b, _c, _d;
        return new this({
            sourceConfig: {
                uns: {
                    locations: {
                        Layer1: {
                            url: (0, $jECMB.signedLink)(alchemy, ((_a = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _a === void 0 ? void 0 : _a.locations.Layer1.network) || "mainnet"),
                            network: ((_b = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _b === void 0 ? void 0 : _b.locations.Layer1.network) || "mainnet"
                        },
                        Layer2: {
                            url: (0, $jECMB.signedLink)(alchemy, ((_c = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _c === void 0 ? void 0 : _c.locations.Layer2.network) || "polygon-mainnet"),
                            network: ((_d = networks === null || networks === void 0 ? void 0 : networks.uns) === null || _d === void 0 ? void 0 : _d.locations.Layer2.network) || "polygon-mainnet"
                        }
                    }
                }
            }
        });
    };
    /**
     * Creates a resolution instance with configured provider
     * @param networks - an object that describes what network to use when connecting UNS or ZNS default is mainnet
     * @see https://eips.ethereum.org/EIPS/eip-1193
     */ Resolution.fromResolutionProvider = function(networks) {
        if (networks.uns) return this.fromEthereumEip1193Provider({
            uns: networks.uns
        });
        if (networks.zns) return this.fromZilliqaProvider(networks.zns.provider, networks);
        throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
            providerMessage: "Must specify network for uns or zns"
        });
    };
    /**
     * Creates a resolution instance with configured provider
     * @param networks - an object that describes what network to use when connecting UNS default is mainnet
     * @see https://eips.ethereum.org/EIPS/eip-1193
     */ Resolution.fromEthereumEip1193Provider = function(networks) {
        var sourceConfig = {};
        if (networks.uns) sourceConfig.uns = {
            locations: {
                Layer1: {
                    provider: networks.uns.locations.Layer1.provider,
                    network: networks.uns.locations.Layer1.network || "mainnet"
                },
                Layer2: {
                    provider: networks.uns.locations.Layer2.provider,
                    network: networks.uns.locations.Layer2.network || "polygon-mainnet"
                }
            }
        };
        return new this({
            sourceConfig: sourceConfig
        });
    };
    /**
     * Creates a resolution instance with configured provider
     * @param provider - any provider compatible with EIP-1193
     * @param networks - an optional object that describes what network to use when connecting ZNS default is mainnet
     * @see https://eips.ethereum.org/EIPS/eip-1193
     */ Resolution.fromZilliqaProvider = function(provider, networks) {
        var _a;
        return new this({
            sourceConfig: {
                zns: {
                    provider: provider,
                    network: ((_a = networks === null || networks === void 0 ? void 0 : networks.zns) === null || _a === void 0 ? void 0 : _a.network) || "mainnet"
                }
            }
        });
    };
    /**
     * Create a resolution instance from web3 0.x version provider
     * @param networks - Ethereum network configuration with 0.x version provider from web3 ( must implement sendAsync(payload, callback) )
     * @see https://github.com/ethereum/web3.js/blob/0.20.7/lib/web3/httpprovider.js#L116
     */ Resolution.fromWeb3Version0Provider = function(networks) {
        return this.fromEthereumEip1193Provider({
            uns: networks.uns ? {
                locations: {
                    Layer1: {
                        network: networks.uns.locations.Layer1.network,
                        provider: $9GlGG.Eip1993Factories.fromWeb3Version0Provider(networks.uns.locations.Layer1.provider)
                    },
                    Layer2: {
                        network: networks.uns.locations.Layer2.network,
                        provider: $9GlGG.Eip1993Factories.fromWeb3Version0Provider(networks.uns.locations.Layer2.provider)
                    }
                }
            } : undefined
        });
    };
    /**
     * Create a resolution instance from web3 1.x version provider
     * @param networks - an optional object with 1.x version provider from web3 ( must implement send(payload, callback) ) that describes what network to use when connecting UNS default is mainnet
     * @see https://github.com/ethereum/web3.js/blob/1.x/packages/web3-core-helpers/types/index.d.ts#L165
     * @see https://github.com/ethereum/web3.js/blob/1.x/packages/web3-providers-http/src/index.js#L95
     */ Resolution.fromWeb3Version1Provider = function(networks) {
        return this.fromEthereumEip1193Provider({
            uns: networks.uns ? {
                locations: {
                    Layer1: {
                        network: networks.uns.locations.Layer1.network,
                        provider: $9GlGG.Eip1993Factories.fromWeb3Version1Provider(networks.uns.locations.Layer1.provider)
                    },
                    Layer2: {
                        network: networks.uns.locations.Layer2.network,
                        provider: $9GlGG.Eip1993Factories.fromWeb3Version1Provider(networks.uns.locations.Layer2.provider)
                    }
                }
            } : undefined
        });
    };
    /**
     * Creates instance of resolution from provider that implements Ethers Provider#call interface.
     * This wrapper support only `eth_call` method for now, which is enough for all the current Resolution functionality
     * @param networks - an object that describes what network to use when connecting UNS default is mainnet
     * @see https://github.com/ethers-io/ethers.js/blob/v4-legacy/providers/abstract-provider.d.ts#L91
     * @see https://github.com/ethers-io/ethers.js/blob/v5.0.4/packages/abstract-provider/src.ts/index.ts#L224
     * @see https://docs.ethers.io/ethers.js/v5-beta/api-providers.html#jsonrpcprovider-inherits-from-provider
     * @see https://github.com/ethers-io/ethers.js/blob/master/packages/providers/src.ts/json-rpc-provider.ts
     */ Resolution.fromEthersProvider = function(networks) {
        return this.fromEthereumEip1193Provider({
            uns: networks.uns ? {
                locations: {
                    Layer1: {
                        network: networks.uns.locations.Layer1.network,
                        provider: $9GlGG.Eip1993Factories.fromEthersProvider(networks.uns.locations.Layer1.provider)
                    },
                    Layer2: {
                        network: networks.uns.locations.Layer2.network,
                        provider: $9GlGG.Eip1993Factories.fromEthersProvider(networks.uns.locations.Layer2.provider)
                    }
                }
            } : undefined
        });
    };
    /**
     * Resolves given domain name to a specific currency address if exists
     * @async
     * @param domain - domain name to be resolved
     * @param ticker - currency ticker like BTC, ETH, ZIL
     * @throws [[ResolutionError]] if address is not found
     * @returns A promise that resolves in an address
     */ Resolution.prototype.addr = function(domain, ticker) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.record(domain, "crypto.".concat(ticker.toUpperCase(), ".address"))
                ];
            });
        });
    };
    /**
     * Read multi-chain currency address if exists
     * @async
     * @param domain - domain name to be resolved
     * @param ticker - currency ticker (USDT, FTM, etc.)
     * @param chain - chain version, usually means blockchain ( ERC20, BEP2, OMNI, etc. )
     * @throws [[ResolutionError]] if address is not found
     * @returns A promise that resolves in an adress
     */ Resolution.prototype.multiChainAddr = function(domain, ticker, chain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var recordKey;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                recordKey = "crypto.".concat(ticker.toUpperCase(), ".version.").concat(chain.toUpperCase(), ".address");
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.record(domain, recordKey);
                    })
                ];
            });
        });
    };
    /**
     * Resolves given domain name to a verified twitter handle
     * @async
     * @param domain - domain name to be resolved
     * @throws [[ResolutionError]] if twitter is not found
     * @returns A promise that resolves in a verified twitter handle
     */ Resolution.prototype.twitter = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.twitter(domain);
                    })
                ];
            });
        });
    };
    /**
     * Resolve a chat id from the domain record
     * @param domain - domain name to be resolved
     * @throws [[ResolutionError]]
     * @returns A promise that resolves in chatId
     */ Resolution.prototype.chatId = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.record(domain, "gundb.username.value")
                ];
            });
        });
    };
    /**
     * Resolve a gundb public key from the domain record
     * @param domain - domain name to be resolved
     * @throws [[ResolutionError]]
     * @returns a promise that resolves in gundb public key
     */ Resolution.prototype.chatPk = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.record(domain, "gundb.public_key.value")
                ];
            });
        });
    };
    /**
     * Resolves the IPFS hash configured for domain records on ZNS
     * @param domain - domain name
     * @throws [[ResolutionError]]
     */ Resolution.prototype.ipfsHash = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.getPreferableNewRecord(domain, "dweb.ipfs.hash", "ipfs.html.value")
                ];
            });
        });
    };
    /**
     * Resolves the httpUrl attached to domain
     * @param domain - domain name
     */ Resolution.prototype.httpUrl = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.getPreferableNewRecord(domain, "browser.redirect_url", "ipfs.redirect_domain.value")
                ];
            });
        });
    };
    /**
     * Resolves the ipfs email field from whois configurations
     * @param domain - domain name
     * @throws [[ResolutionError]]
     * @returns A Promise that resolves in an email address configured for this domain whois
     */ Resolution.prototype.email = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.record(domain, "whois.email.value")
                ];
            });
        });
    };
    /**
     * @returns the resolver address for a specific domain
     * @param domain - domain to look for
     */ Resolution.prototype.resolver = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var resolver;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                        return [
                            4 /*yield*/ ,
                            this.callServiceForDomain(domain, function(service) {
                                return service.resolver(domain);
                            })
                        ];
                    case 1:
                        resolver = _a.sent();
                        if (!resolver) throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnspecifiedResolver, {
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            resolver
                        ];
                }
            });
        });
    };
    /**
     * @param domain - domain name
     * @returns An owner address of the domain
     */ Resolution.prototype.owner = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.owner(domain);
                    })
                ];
            });
        });
    };
    /**
     * @param domain - domain name
     * @param recordKey - a name of a record to be resolved
     * @returns A record value promise for a given record name
     */ Resolution.prototype.record = function(domain, recordKey) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.record(domain, recordKey);
                    })
                ];
            });
        });
    };
    /**
     * @param domain domain name
     * @param keys Array of record keys to be resolved
     * @returns A Promise with key-value mapping of domain records
     */ Resolution.prototype.records = function(domain, keys) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.records(domain, keys);
                    })
                ];
            });
        });
    };
    /**
     * @param domain domain name
     * @returns A Promise of whether or not the domain belongs to a wallet
     */ Resolution.prototype.isRegistered = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomainBoolean(domain, function(service) {
                        return service.isRegistered(domain);
                    }, {
                        throwIfUnsupportedDomain: true,
                        expectedValue: true
                    })
                ];
            });
        });
    };
    /**
     * @param domain domain name
     * @returns A Promise of whether or not the domain is available
     */ Resolution.prototype.isAvailable = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomainBoolean(domain, function(service) {
                        return service.isAvailable(domain);
                    }, {
                        throwIfUnsupportedDomain: true,
                        expectedValue: false
                    })
                ];
            });
        });
    };
    /**
     * @returns Produces a namehash from supported naming service in hex format with 0x prefix.
     * Corresponds to ERC721 token id in case of Ethereum based naming service like UNS.
     * @param domain domain name to be converted
     * @param namingService "UNS" or "ZNS" (uses keccak256 or sha256 algorithm respectively)
     * @param options formatting options
     * @throws [[ResolutionError]] with UnsupportedDomain error code if domain extension is unknown
     */ Resolution.prototype.namehash = function(domain, namingService, options) {
        if (options === void 0) options = $bq44C.NamehashOptionsDefault;
        var service = this.serviceMap[namingService];
        if (!service) throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnsupportedService, {
            namingService: namingService
        });
        domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
        return this.formatNamehash(service.native.namehash(domain), options);
    };
    /**
     * @returns a namehash of a subdomain with name label
     * @param parent namehash of a parent domain
     * @param label subdomain name
     * @param namingService "UNS" or "ZNS" (uses keccak256 or sha256 algorithm respectively)
     * @param options formatting options
     */ Resolution.prototype.childhash = function(parent, label, namingService, options) {
        if (options === void 0) options = $bq44C.NamehashOptionsDefault;
        var service = this.serviceMap[namingService];
        if (!service) throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnsupportedService, {
            namingService: namingService
        });
        return this.formatNamehash(service.native.childhash(parent, label), options);
    };
    Resolution.prototype.formatNamehash = function(hash, options) {
        hash = hash.replace("0x", "");
        if (options.format === "dec") return new $5e95a6341722a445$var$bn_js_1.default(hash, "hex").toString(10);
        else return options.prefix ? "0x" + hash : hash;
    };
    /**
     * Checks weather the domain name matches the hash
     * @param domain - domain name to check against
     * @param hash - hash obtained from the blockchain
     * @param namingService - "UNS" or "ZNS" (uses keccak256 or sha256 algorithm respectively)
     */ Resolution.prototype.isValidHash = function(domain, hash, namingService) {
        var service = this.serviceMap[namingService];
        if (!service) throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnsupportedService, {
            namingService: namingService
        });
        domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
        return service.native.namehash(domain) === hash;
    };
    /**
     * Checks if the domain name is valid according to naming service rules
     * for valid domain names.
     * @param domain - domain name to be checked
     */ Resolution.prototype.isSupportedDomain = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomainBoolean(domain, function(service) {
                        return service.isSupportedDomain(domain);
                    }, {
                        throwIfUnsupportedDomain: false,
                        expectedValue: true
                    })
                ];
            });
        });
    };
    /**
     * Returns all record keys of the domain.
     * This method is strongly unrecommended for production use due to lack of support for many ethereum service providers and low performance
     * @param domain - domain name
     * @deprecated
     */ Resolution.prototype.allRecords = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.allRecords(domain);
                    })
                ];
            });
        });
    };
    Resolution.prototype.dns = function(domain, types) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var dnsUtils, dnsRecordKeys, blockchainData;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dnsUtils = new $5e95a6341722a445$var$DnsUtils_1.default();
                        domain = (0, $6dKzR.prepareAndValidateDomain)(domain);
                        dnsRecordKeys = this.getDnsRecordKeys(types);
                        return [
                            4 /*yield*/ ,
                            this.callServiceForDomain(domain, function(service) {
                                return service.records(domain, dnsRecordKeys);
                            })
                        ];
                    case 1:
                        blockchainData = _a.sent();
                        return [
                            2 /*return*/ ,
                            dnsUtils.toList(blockchainData)
                        ];
                }
            });
        });
    };
    /**
     * Retrieves the tokenURI from the registry smart contract.
     * @returns the ERC721Metadata#tokenURI contract method result
     * @param domain - domain name
     */ Resolution.prototype.tokenURI = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var namehash;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                namehash = this.namehash(domain, $bq44C.NamingServiceName.UNS);
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.getTokenUri(namehash);
                    })
                ];
            });
        });
    };
    /**
     * Retrieves the data from the endpoint provided by tokenURI from the registry smart contract.
     * @returns the JSON response of the token URI endpoint
     * @param domain - domain name
     */ Resolution.prototype.tokenURIMetadata = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var tokenUri;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.tokenURI(domain)
                        ];
                    case 1:
                        tokenUri = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.getMetadataFromTokenURI(tokenUri)
                        ];
                }
            });
        });
    };
    /**
     * Retrieves address of registry contract used for domain
     * @param domain - domain name
     * @returns Registry contract address
     */ Resolution.prototype.registryAddress = function(domain) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.callServiceForDomain(domain, function(service) {
                        return service.registryAddress(domain);
                    })
                ];
            });
        });
    };
    /**
     * Retrieves the domain name from tokenId by parsing registry smart contract event logs.
     * @throws {ResolutionError} if returned domain name doesn't match the original namhash.
     * @returns the domain name retrieved from token metadata
     * @param hash - domain hash
     * @param service - nameservice which is used for lookup
     */ Resolution.prototype.unhash = function(hash, service) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var services, method;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                hash = (0, $bPRni.fromDecStringToHex)(hash);
                services = this.serviceMap[service].usedServices;
                method = services[services.length - 1];
                return [
                    2 /*return*/ ,
                    method.getDomainFromTokenId(hash)
                ];
            });
        });
    };
    /**
     * Retrieves address of registry contract used for domain
     * @param domains - domain name
     * @returns Promise<Locations> - A map of domain name and Location (a set of attributes like blockchain,
     */ Resolution.prototype.locations = function(domains) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var zilDomains, unsPromise, znsServices, znsService, znsPromise, unsLocations, emptyZilEntries, znsLocations, _i, emptyZilEntries_1, domain;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        zilDomains = domains.filter(function(domain) {
                            return domain.endsWith(".zil");
                        });
                        unsPromise = this.serviceMap.UNS.usedServices[0].locations(domains);
                        if (!zilDomains.length) return [
                            2 /*return*/ ,
                            unsPromise
                        ];
                        znsServices = this.serviceMap.ZNS.usedServices;
                        znsService = znsServices[znsServices.length - 1];
                        znsPromise = (0, $jECMB.wrapResult)(function() {
                            return znsService.locations(zilDomains);
                        });
                        return [
                            4 /*yield*/ ,
                            unsPromise
                        ];
                    case 1:
                        unsLocations = _a.sent();
                        emptyZilEntries = Object.entries(unsLocations).filter(function(_a) {
                            var domain = _a[0], location = _a[1];
                            return domain.endsWith(".zil") && !location;
                        });
                        if (!emptyZilEntries.length) return [
                            2 /*return*/ ,
                            unsLocations
                        ];
                        return [
                            4 /*yield*/ ,
                            znsPromise.then($jECMB.unwrapResult)
                        ];
                    case 2:
                        znsLocations = _a.sent();
                        for(_i = 0, emptyZilEntries_1 = emptyZilEntries; _i < emptyZilEntries_1.length; _i++){
                            domain = emptyZilEntries_1[_i][0];
                            unsLocations[domain] = znsLocations[domain];
                        }
                        return [
                            2 /*return*/ ,
                            unsLocations
                        ];
                }
            });
        });
    };
    /**
     * Returns the token ID that is the primary resolution of the provided address
     * @param address - owner's address
     * @returns Promise<tokenId> - token ID that is the primary resolution of the provided address
     */ Resolution.prototype.reverseTokenId = function(address, options) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var tokenId;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                tokenId = this.reverseGetTokenId(address, options === null || options === void 0 ? void 0 : options.location);
                return [
                    2 /*return*/ ,
                    tokenId
                ];
            });
        });
    };
    /**
     * Returns the domain that is the primary resolution of the provided address
     * @param address - owner's address
     * @returns Promise<URL> - domain URL that is the primary resolution of the provided addresss
     */ Resolution.prototype.reverse = function(address, options) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var tokenId;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.reverseGetTokenId(address, options === null || options === void 0 ? void 0 : options.location)
                        ];
                    case 1:
                        tokenId = _a.sent();
                        if (tokenId) return [
                            2 /*return*/ ,
                            this.unhash(tokenId, $bq44C.NamingServiceName.UNS)
                        ];
                        return [
                            2 /*return*/ ,
                            null
                        ];
                }
            });
        });
    };
    Resolution.prototype.getMetadataFromTokenURI = function(tokenUri) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var resp, _a, _b;
            var _c;
            return $5e95a6341722a445$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $5e95a6341722a445$var$Networking_1.default.fetch(tokenUri, {})
                        ];
                    case 1:
                        resp = _d.sent();
                        if (resp.ok) return [
                            2 /*return*/ ,
                            resp.json()
                        ];
                        _a = $5e95a6341722a445$var$resolutionError_1.default.bind;
                        _b = [
                            void 0,
                            $5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError
                        ];
                        _c = {};
                        return [
                            4 /*yield*/ ,
                            resp.text()
                        ];
                    case 2:
                        throw new (_a.apply($5e95a6341722a445$var$resolutionError_1.default, _b.concat([
                            (_c.providerMessage = _d.sent(), _c.method = "UDAPI", _c.methodName = "tokenURIMetadata", _c)
                        ])))();
                }
            });
        });
    };
    Resolution.prototype.getDnsRecordKeys = function(types) {
        var records = [
            "dns.ttl"
        ];
        types.forEach(function(type) {
            records.push("dns.".concat(type));
            records.push("dns.".concat(type, ".ttl"));
        });
        return records;
    };
    Resolution.prototype.getPreferableNewRecord = function(domain, newRecord, oldRecord) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var records;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.records(domain, [
                                newRecord,
                                oldRecord
                            ])
                        ];
                    case 1:
                        records = _a.sent();
                        if (!records[newRecord] && !records[oldRecord]) throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                            recordName: newRecord,
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            records[newRecord] || records[oldRecord]
                        ];
                }
            });
        });
    };
    Resolution.prototype.callServiceForDomain = function(domain, func) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var serviceName, servicePromises, _i, servicePromises_1, servicePromise, serviceCallResult;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        serviceName = (0, $jECMB.findNamingServiceName)(domain);
                        if (!serviceName) throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
                            domain: domain
                        });
                        servicePromises = this.serviceMap[serviceName].usedServices.map(function(service) {
                            return (0, $jECMB.wrapResult)(function() {
                                return func(service);
                            });
                        });
                        _i = 0, servicePromises_1 = servicePromises;
                        _a.label = 1;
                    case 1:
                        if (!(_i < servicePromises_1.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        servicePromise = servicePromises_1[_i];
                        return [
                            4 /*yield*/ ,
                            servicePromise
                        ];
                    case 2:
                        serviceCallResult = _a.sent();
                        if (serviceCallResult.error !== null) {
                            if (!(serviceCallResult.error instanceof $5e95a6341722a445$var$resolutionError_1.default && serviceCallResult.error.code === $5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain)) throw serviceCallResult.error;
                        } else return [
                            2 /*return*/ ,
                            serviceCallResult.result
                        ];
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                }
            });
        });
    };
    // Expects that a called method never throws the `ResolutionErrorCode.UnregisteredDomain` (it doesn't handle it).
    Resolution.prototype.callServiceForDomainBoolean = function(domain, func, options) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var serviceName, servicePromises, _i, servicePromises_2, servicePromise, _a, result, error;
            return $5e95a6341722a445$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        serviceName = (0, $jECMB.findNamingServiceName)(domain);
                        if (!serviceName) {
                            if (!options.throwIfUnsupportedDomain) return [
                                2 /*return*/ ,
                                !options.expectedValue
                            ];
                            throw new $5e95a6341722a445$var$resolutionError_1.default($5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
                                domain: domain
                            });
                        }
                        servicePromises = this.serviceMap[serviceName].usedServices.map(function(service) {
                            return (0, $jECMB.wrapResult)(function() {
                                return func(service);
                            });
                        });
                        _i = 0, servicePromises_2 = servicePromises;
                        _b.label = 1;
                    case 1:
                        if (!(_i < servicePromises_2.length)) return [
                            3 /*break*/ ,
                            4
                        ];
                        servicePromise = servicePromises_2[_i];
                        return [
                            4 /*yield*/ ,
                            servicePromise
                        ];
                    case 2:
                        _a = _b.sent(), result = _a.result, error = _a.error;
                        if (error) {
                            if (!(error instanceof $5e95a6341722a445$var$resolutionError_1.default && error.code === $5e95a6341722a445$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain)) throw error;
                        } else if (result === options.expectedValue) // If the result is not the one which is expected, we don't want to return it immediately.
                        return [
                            2 /*return*/ ,
                            result
                        ];
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            !options.expectedValue
                        ];
                }
            });
        });
    };
    Resolution.prototype.reverseGetTokenId = function(address, location) {
        return $5e95a6341722a445$var$__awaiter(this, void 0, void 0, function() {
            var service, tokenId;
            return $5e95a6341722a445$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        service = this.serviceMap["UNS"].native;
                        return [
                            4 /*yield*/ ,
                            service.reverseOf(address, location)
                        ];
                    case 1:
                        tokenId = _a.sent();
                        return [
                            2 /*return*/ ,
                            tokenId
                        ];
                }
            });
        });
    };
    return Resolution;
}();
module.exports.Resolution = $5e95a6341722a445$var$Resolution;
module.exports.default = $5e95a6341722a445$var$Resolution;
function $5e95a6341722a445$var$isApi(obj) {
    return obj && obj.api;
}

});
parcelRegister("lONYJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});


parcelRegister("61rj9", function(module, exports) {
"use strict";
var $462804de7336522f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $462804de7336522f$var$__assign = module.exports && module.exports.__assign || function() {
    $462804de7336522f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $462804de7336522f$var$__assign.apply(this, arguments);
};
var $462804de7336522f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $462804de7336522f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $462804de7336522f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $462804de7336522f$var$__createBinding(result, mod, k);
    }
    $462804de7336522f$var$__setModuleDefault(result, mod);
    return result;
};
var $462804de7336522f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $462804de7336522f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $462804de7336522f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $anWsB = parcelRequire("anWsB");

var $jECMB = parcelRequire("jECMB");

var $hRv97 = parcelRequire("hRv97");

var $anKpg = parcelRequire("anKpg");

var $bq44C = parcelRequire("bq44C");

var $462804de7336522f$var$FetchProvider_1 = $462804de7336522f$var$__importDefault((parcelRequire("2rLlp")));

var $bPRni = parcelRequire("bPRni");

var $2gwgp = parcelRequire("2gwgp");

var $462804de7336522f$var$configurationError_1 = $462804de7336522f$var$__importStar((parcelRequire("6yp4P")));
/**
 * @internal
 */ var $462804de7336522f$var$Zns = /** @class */ function(_super) {
    $462804de7336522f$var$__extends(Zns, _super);
    function Zns(source) {
        if (source === void 0) source = {
            url: Zns.UrlMap[1],
            network: "mainnet"
        };
        var _this = _super.call(this) || this;
        _this.name = $bq44C.NamingServiceName.ZNS;
        _this.checkNetworkConfig(source);
        _this.network = Zns.NetworkNameMap[source.network];
        _this.url = source["url"] || Zns.UrlMap[_this.network];
        _this.provider = source["provider"] || new $462804de7336522f$var$FetchProvider_1.default(_this.name, _this.url);
        _this.registryAddr = source["registryAddress"] || Zns.RegistryMap[_this.network];
        _this.checkRegistryAddress(_this.registryAddr);
        if (_this.registryAddr.startsWith("0x")) _this.registryAddr = (0, $anWsB.toBech32Address)(_this.registryAddr);
        return _this;
    }
    Zns.prototype.owner = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var recordAddresses, ownerAddress;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRecordsAddresses(domain)
                        ];
                    case 1:
                        recordAddresses = _a.sent();
                        if (!recordAddresses) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                        ownerAddress = recordAddresses[0];
                        if (!ownerAddress) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            ownerAddress
                        ];
                }
            });
        });
    };
    Zns.prototype.resolver = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var recordsAddresses, resolverAddress;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRecordsAddresses(domain)
                        ];
                    case 1:
                        recordsAddresses = _a.sent();
                        if (!recordsAddresses || !recordsAddresses[0]) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                        resolverAddress = recordsAddresses[1];
                        if ((0, $jECMB.isNullAddress)(resolverAddress)) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnspecifiedResolver, {
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            resolverAddress
                        ];
                }
            });
        });
    };
    Zns.prototype.namehash = function(domain) {
        if (!this.checkDomain(domain)) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedDomain, {
            domain: domain
        });
        return (0, $bPRni.znsNamehash)(domain);
    };
    Zns.prototype.childhash = function(parentHash, label) {
        return (0, $bPRni.znsChildhash)(parentHash, label);
    };
    Zns.prototype.isSupportedDomain = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.checkDomain(domain)
                ];
            });
        });
    };
    Zns.prototype.record = function(domain, key) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var records, record;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.records(domain, [
                                key
                            ])
                        ];
                    case 1:
                        records = _a.sent();
                        record = records[key];
                        if (!record) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.RecordNotFound, {
                            domain: domain,
                            recordName: key
                        });
                        return [
                            2 /*return*/ ,
                            record
                        ];
                }
            });
        });
    };
    Zns.prototype.records = function(domain, keys) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var records;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.allRecords(domain)
                        ];
                    case 1:
                        records = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $jECMB.constructRecords)(keys, records)
                        ];
                }
            });
        });
    };
    Zns.prototype.allRecords = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var resolverAddress;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.resolver(domain)
                        ];
                    case 1:
                        resolverAddress = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.getResolverRecords(resolverAddress)
                        ];
                }
            });
        });
    };
    Zns.prototype.twitter = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    domain: domain,
                    methodName: "twitter"
                });
            });
        });
    };
    Zns.prototype.reverse = function(address, currencyTicker) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "reverse"
                });
            });
        });
    };
    Zns.prototype.reverseOf = function(address, location) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "reverseOf"
                });
            });
        });
    };
    Zns.prototype.isRegistered = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var recordAddresses;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRecordsAddresses(domain)
                        ];
                    case 1:
                        recordAddresses = _a.sent();
                        return [
                            2 /*return*/ ,
                            Boolean(recordAddresses && recordAddresses[0])
                        ];
                }
            });
        });
    };
    Zns.prototype.getTokenUri = function(tokenId) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "getTokenUri"
                });
            });
        });
    };
    Zns.prototype.getDomainFromTokenId = function(tokenId) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "getDomainFromTokenId"
                });
            });
        });
    };
    Zns.prototype.isAvailable = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.isRegistered(domain)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            !_a.sent()
                        ];
                }
            });
        });
    };
    Zns.prototype.registryAddress = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            return $462804de7336522f$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.registryAddr
                ];
            });
        });
    };
    Zns.prototype.locations = function(domains) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var recordsAddresses;
            var _this = this;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(domains.map(function(domain) {
                                return _this.getRecordsAddresses(domain);
                            }))
                        ];
                    case 1:
                        recordsAddresses = _a.sent();
                        return [
                            2 /*return*/ ,
                            domains.reduce(function(locations, domain, i) {
                                var _a;
                                var location = null;
                                var domainRecordsAddresses = recordsAddresses[i];
                                if (domainRecordsAddresses) {
                                    var ownerAddress = domainRecordsAddresses[0], resolverAddress = domainRecordsAddresses[1];
                                    location = {
                                        registryAddress: _this.registryAddr,
                                        resolverAddress: resolverAddress,
                                        networkId: _this.network,
                                        blockchain: $bq44C.BlockchainType.ZIL,
                                        ownerAddress: ownerAddress,
                                        blockchainProviderUrl: _this.url
                                    };
                                }
                                return $462804de7336522f$var$__assign($462804de7336522f$var$__assign({}, locations), (_a = {}, _a[domain] = location, _a));
                            }, {})
                        ];
                }
            });
        });
    };
    Zns.prototype.getRecordsAddresses = function(domain) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var registryRecord, _a, ownerAddress, resolverAddress;
            return $462804de7336522f$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.isSupportedDomain(domain)) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedDomain, {
                            domain: domain
                        });
                        return [
                            4 /*yield*/ ,
                            this.getContractMapValue(this.registryAddr, "records", this.namehash(domain))
                        ];
                    case 1:
                        registryRecord = _b.sent();
                        if (!registryRecord) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        _a = registryRecord.arguments, ownerAddress = _a[0], resolverAddress = _a[1];
                        return [
                            2 /*return*/ ,
                            [
                                ownerAddress.startsWith("0x") ? (0, $anWsB.toBech32Address)(ownerAddress) : ownerAddress,
                                resolverAddress
                            ]
                        ];
                }
            });
        });
    };
    Zns.prototype.getResolverRecords = function(resolverAddress) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var resolver;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if ((0, $jECMB.isNullAddress)(resolverAddress)) return [
                            2 /*return*/ ,
                            {}
                        ];
                        resolver = (0, $anWsB.toChecksumAddress)(resolverAddress);
                        return [
                            4 /*yield*/ ,
                            this.getContractField(resolver, "records")
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent() || {}
                        ];
                }
            });
        });
    };
    Zns.prototype.fetchSubState = function(contractAddress, field, keys) {
        if (keys === void 0) keys = [];
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var params, method;
            return $462804de7336522f$var$__generator(this, function(_a) {
                params = [
                    contractAddress.replace("0x", ""),
                    field,
                    keys
                ];
                method = "GetSmartContractSubState";
                return [
                    2 /*return*/ ,
                    this.provider.request({
                        method: method,
                        params: params
                    })
                ];
            });
        });
    };
    Zns.prototype.getContractField = function(contractAddress, field, keys) {
        if (keys === void 0) keys = [];
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var contractAddr, result;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        contractAddr = contractAddress.startsWith("zil1") ? (0, $anWsB.fromBech32Address)(contractAddress) : contractAddress;
                        return [
                            4 /*yield*/ ,
                            this.fetchSubState(contractAddr, field, keys)
                        ];
                    case 1:
                        result = _a.sent() || {};
                        return [
                            2 /*return*/ ,
                            result[field]
                        ];
                }
            });
        });
    };
    Zns.prototype.getContractMapValue = function(contractAddress, field, key) {
        return $462804de7336522f$var$__awaiter(this, void 0, void 0, function() {
            var record;
            return $462804de7336522f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getContractField(contractAddress, field, [
                                key
                            ])
                        ];
                    case 1:
                        record = _a.sent();
                        return [
                            2 /*return*/ ,
                            record && record[key] || null
                        ];
                }
            });
        });
    };
    Zns.prototype.checkDomain = function(domain) {
        var tokens = domain.split(".");
        return !!tokens.length && tokens[tokens.length - 1] === "zil" && tokens.every(function(v) {
            return !!v.length;
        });
    };
    Zns.prototype.checkNetworkConfig = function(source) {
        if (!source.network) throw new $462804de7336522f$var$configurationError_1.default($462804de7336522f$var$configurationError_1.ConfigurationErrorCode.UnsupportedNetwork, {
            method: $bq44C.NamingServiceName.ZNS
        });
        if (!$hRv97.ZnsSupportedNetwork.guard(source.network)) this.checkCustomNetworkConfig(source);
    };
    Zns.prototype.checkRegistryAddress = function(address) {
        // Represents both versions of Zilliqa addresses eth-like and bech32 zil-like
        var addressValidator = new RegExp("^0x[a-fA-F0-9]{40}$|^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$");
        if (!addressValidator.test(address)) throw new $462804de7336522f$var$configurationError_1.default($462804de7336522f$var$configurationError_1.ConfigurationErrorCode.InvalidConfigurationField, {
            method: this.name,
            field: "registryAddress"
        });
    };
    Zns.prototype.checkCustomNetworkConfig = function(source) {
        if (!source.registryAddress) throw new $462804de7336522f$var$configurationError_1.default($462804de7336522f$var$configurationError_1.ConfigurationErrorCode.CustomNetworkConfigMissing, {
            method: $bq44C.NamingServiceName.ZNS,
            config: "registryAddress"
        });
        if (!source["url"] && !source["provider"]) throw new $462804de7336522f$var$configurationError_1.default($462804de7336522f$var$configurationError_1.ConfigurationErrorCode.CustomNetworkConfigMissing, {
            method: $bq44C.NamingServiceName.ZNS,
            config: "url or provider"
        });
    };
    Zns.UrlMap = {
        1: "https://api.zilliqa.com",
        333: "https://dev-api.zilliqa.com",
        111: "http://localhost:4201"
    };
    Zns.NetworkNameMap = {
        mainnet: 1,
        testnet: 333,
        localnet: 111
    };
    Zns.RegistryMap = {
        1: "zil1jcgu2wlx6xejqk9jw3aaankw6lsjzeunx2j0jz",
        333: "zil1hyj6m5w4atcn7s806s69r0uh5g4t84e8gp6nps"
    };
    return Zns;
}($2gwgp.NamingService);
module.exports.default = $462804de7336522f$var$Zns;

});
parcelRegister("anWsB", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $78f9666179180ce7$require$Buffer = $N0o3H.Buffer;
"use strict";
/**
 * All functionality below came from here https://github.com/Zilliqa/Zilliqa-JavaScript-Library/tree/dev/packages/zilliqa-js-crypto/src
 */ var $78f9666179180ce7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBech32Address = module.exports.toBech32Address = module.exports.toChecksumAddress = void 0;

var $78f9666179180ce7$var$bn_js_1 = $78f9666179180ce7$var$__importDefault((parcelRequire("lONYJ")));

var $78f9666179180ce7$var$sha256_1 = $78f9666179180ce7$var$__importDefault((parcelRequire("1AknP")));

var $78f9666179180ce7$var$enc_hex_1 = $78f9666179180ce7$var$__importDefault((parcelRequire("cd29Y")));
var $78f9666179180ce7$var$CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
var $78f9666179180ce7$var$GENERATOR = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
// HRP is the human-readable part of zilliqa bech32 addresses
var $78f9666179180ce7$var$HRP = "zil";
var $78f9666179180ce7$var$tHRP = "tzil";
function $78f9666179180ce7$var$isByteString(str, len) {
    return !!str.replace("0x", "").match("^[0-9a-fA-F]{".concat(len, "}$"));
}
function $78f9666179180ce7$var$isAddress(address) {
    return $78f9666179180ce7$var$isByteString(address, 40);
}
/**
 * convertBits
 *
 * groups buffers of a certain width to buffers of the desired width.
 *
 * For example, converts byte buffers to buffers of maximum 5 bit numbers,
 * padding those numbers as necessary. Necessary for encoding Ethereum-style
 * addresses as bech32 ones.
 * @param {Buffer} data
 * @param {number} fromWidth
 * @param {number} toWidth
 * @param {boolean} pad
 * @returns {Buffer|null}
 */ function $78f9666179180ce7$var$convertBits(data, fromWidth, toWidth, pad) {
    if (pad === void 0) pad = true;
    var acc = 0;
    var bits = 0;
    var ret = [];
    var maxv = (1 << toWidth) - 1;
    // tslint:disable-next-line
    for(var p = 0; p < data.length; ++p){
        var value = data[p];
        if (value < 0 || value >> fromWidth !== 0) return null;
        acc = acc << fromWidth | value;
        bits += fromWidth;
        while(bits >= toWidth){
            bits -= toWidth;
            ret.push(acc >> bits & maxv);
        }
    }
    if (pad) {
        if (bits > 0) ret.push(acc << toWidth - bits & maxv);
    } else if (bits >= fromWidth || acc << toWidth - bits & maxv) return null;
    return $78f9666179180ce7$require$Buffer.from(ret);
}
function $78f9666179180ce7$var$hrpExpand(hrp) {
    var ret = [];
    var p;
    for(p = 0; p < hrp.length; ++p)ret.push(hrp.charCodeAt(p) >> 5);
    ret.push(0);
    for(p = 0; p < hrp.length; ++p)ret.push(hrp.charCodeAt(p) & 31);
    return $78f9666179180ce7$require$Buffer.from(ret);
}
function $78f9666179180ce7$var$polymod(values) {
    var chk = 1;
    // tslint:disable-next-line
    for(var p = 0; p < values.length; ++p){
        var top_1 = chk >> 25;
        chk = (chk & 0x1ffffff) << 5 ^ values[p];
        for(var i = 0; i < 5; ++i)if (top_1 >> i & 1) chk ^= $78f9666179180ce7$var$GENERATOR[i];
    }
    return chk;
}
function $78f9666179180ce7$var$createChecksum(hrp, data) {
    var values = $78f9666179180ce7$require$Buffer.concat([
        $78f9666179180ce7$require$Buffer.from($78f9666179180ce7$var$hrpExpand(hrp)),
        data,
        $78f9666179180ce7$require$Buffer.from([
            0,
            0,
            0,
            0,
            0,
            0
        ])
    ]);
    // var values = hrpExpand(hrp).concat(data).concat([0, 0, 0, 0, 0, 0]);
    var mod = $78f9666179180ce7$var$polymod(values) ^ 1;
    var ret = [];
    for(var p = 0; p < 6; ++p)ret.push(mod >> 5 * (5 - p) & 31);
    return $78f9666179180ce7$require$Buffer.from(ret);
}
function $78f9666179180ce7$var$verifyChecksum(hrp, data) {
    return $78f9666179180ce7$var$polymod($78f9666179180ce7$require$Buffer.concat([
        $78f9666179180ce7$var$hrpExpand(hrp),
        data
    ])) === 1;
}
function $78f9666179180ce7$var$encode(hrp, data) {
    var combined = $78f9666179180ce7$require$Buffer.concat([
        data,
        $78f9666179180ce7$var$createChecksum(hrp, data)
    ]);
    var ret = hrp + "1";
    // tslint:disable-next-line
    for(var p = 0; p < combined.length; ++p)ret += $78f9666179180ce7$var$CHARSET.charAt(combined[p]);
    return ret;
}
function $78f9666179180ce7$var$decode(bechString) {
    var p;
    var hasLower = false;
    var hasUpper = false;
    for(p = 0; p < bechString.length; ++p){
        if (bechString.charCodeAt(p) < 33 || bechString.charCodeAt(p) > 126) return null;
        if (bechString.charCodeAt(p) >= 97 && bechString.charCodeAt(p) <= 122) hasLower = true;
        if (bechString.charCodeAt(p) >= 65 && bechString.charCodeAt(p) <= 90) hasUpper = true;
    }
    if (hasLower && hasUpper) return null;
    bechString = bechString.toLowerCase();
    var pos = bechString.lastIndexOf("1");
    if (pos < 1 || pos + 7 > bechString.length || bechString.length > 90) return null;
    var hrp = bechString.substring(0, pos);
    var data = [];
    for(p = pos + 1; p < bechString.length; ++p){
        var d = $78f9666179180ce7$var$CHARSET.indexOf(bechString.charAt(p));
        if (d === -1) return null;
        data.push(d);
    }
    if (!$78f9666179180ce7$var$verifyChecksum(hrp, $78f9666179180ce7$require$Buffer.from(data))) return null;
    return {
        hrp: hrp,
        data: $78f9666179180ce7$require$Buffer.from(data.slice(0, data.length - 6))
    };
}
/**
 * toChecksumAddress
 *
 * takes hex-encoded string and returns the corresponding address
 * @param {string} address
 * @returns {string}
 */ var $78f9666179180ce7$var$toChecksumAddress = function(address) {
    if (!$78f9666179180ce7$var$isAddress(address)) throw new Error("".concat(address, " is not a valid base 16 address"));
    address = address.toLowerCase().replace("0x", "");
    var hash = $78f9666179180ce7$var$enc_hex_1.default.stringify((0, $78f9666179180ce7$var$sha256_1.default)($78f9666179180ce7$var$enc_hex_1.default.parse(address)));
    var v = new $78f9666179180ce7$var$bn_js_1.default(hash, "hex", "be");
    var ret = "0x";
    for(var i = 0; i < address.length; i++)if ("0123456789".indexOf(address[i]) !== -1) ret += address[i];
    else ret += v.and(new $78f9666179180ce7$var$bn_js_1.default(2).pow(new $78f9666179180ce7$var$bn_js_1.default(255 - 6 * i))).gte(new $78f9666179180ce7$var$bn_js_1.default(1)) ? address[i].toUpperCase() : address[i].toLowerCase();
    return ret;
};
module.exports.toChecksumAddress = $78f9666179180ce7$var$toChecksumAddress;
/**
 * toBech32Address
 *
 * Encodes a canonical 20-byte Ethereum-style address as a bech32 zilliqa
 * address.
 *
 * The expected format is zil1<address><checksum> where address and checksum
 * are the result of bech32 encoding a Buffer containing the address bytes.
 * @param {string} address 20 byte canonical address
 * @param {boolean} testnet
 * @returns {string} 38 char bech32 encoded zilliqa address
 */ function $78f9666179180ce7$var$toBech32Address(address, testnet) {
    if (testnet === void 0) testnet = false;
    if (!$78f9666179180ce7$var$isAddress(address)) throw new Error("Invalid address format.");
    var addrBz = $78f9666179180ce7$var$convertBits($78f9666179180ce7$require$Buffer.from(address.replace("0x", ""), "hex"), 8, 5);
    if (addrBz === null) throw new Error("Could not convert byte Buffer to 5-bit Buffer");
    return $78f9666179180ce7$var$encode(testnet ? $78f9666179180ce7$var$tHRP : $78f9666179180ce7$var$HRP, addrBz);
}
module.exports.toBech32Address = $78f9666179180ce7$var$toBech32Address;
/**
 * fromBech32Address
 * @param {string} address - a valid Zilliqa bech32 address
 * @param {boolean} testnet
 * @returns {string} a canonical 20-byte Ethereum-style address
 */ function $78f9666179180ce7$var$fromBech32Address(address, testnet) {
    if (testnet === void 0) testnet = false;
    var res = $78f9666179180ce7$var$decode(address);
    if (res === null) throw new Error("Invalid bech32 address");
    var hrp = res.hrp, data = res.data;
    var shouldBe = testnet ? $78f9666179180ce7$var$tHRP : $78f9666179180ce7$var$HRP;
    if (hrp !== shouldBe) throw new Error("Expected hrp to be ".concat(shouldBe, " but got ").concat(hrp));
    var buf = $78f9666179180ce7$var$convertBits(data, 5, 8, false);
    if (buf === null) throw new Error("Could not convert buffer to bytes");
    return (0, module.exports.toChecksumAddress)(buf.toString("hex"));
}
module.exports.fromBech32Address = $78f9666179180ce7$var$fromBech32Address;

});
parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("1AknP", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});
parcelRegister("kSeFg", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("foUwZ"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});


parcelRegister("cd29Y", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    return CryptoJS.enc.Hex;
});

});


parcelRegister("jECMB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unwrapResult = module.exports.wrapResult = module.exports.EthereumNetworksInverted = module.exports.EthereumNetworks = module.exports.findNamingServiceName = module.exports.domainExtensionToNamingServiceName = module.exports.constructRecords = module.exports.isNullAddress = module.exports.hexToBytes = module.exports.signedLink = void 0;

var $bq44C = parcelRequire("bq44C");

var $hRv97 = parcelRequire("hRv97");
var $e4efd63bb26153b8$var$ProviderURLMap = {
    infura: {
        mainnet: "https://mainnet.infura.io/v3/",
        rinkeby: "https://rinkeby.infura.io/v3/",
        goerli: "https://goerli.infura.io/v3/",
        "polygon-mainnet": "https://polygon-mainnet.infura.io/v3/",
        "polygon-mumbai": "https://polygon-mumbai.infura.io/v3/"
    },
    alchemy: {
        mainnet: "https://eth-mainnet.alchemyapi.io/v2/",
        rinkeby: "https://eth-rinkeby.alchemyapi.io/v2/",
        goerli: "https://eth-goerli.alchemyapi.io/v2/",
        "polygon-mainnet": "https://polygon-mainnet.g.alchemy.com/v2/",
        "polygon-mumbai": "https://polygon-mumbai.g.alchemy.com/v2/"
    }
};
function $e4efd63bb26153b8$var$signedLink(key, network, provider) {
    if (network === void 0) network = "mainnet";
    if (provider === void 0) provider = "alchemy";
    var url = $e4efd63bb26153b8$var$ProviderURLMap[provider][network];
    return "".concat(url).concat(key);
}
module.exports.signedLink = $e4efd63bb26153b8$var$signedLink;
function $e4efd63bb26153b8$var$hexToBytes(hexString) {
    var hex = hexString.replace(/^0x/i, "");
    var bytes = [];
    for(var c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
}
module.exports.hexToBytes = $e4efd63bb26153b8$var$hexToBytes;
function $e4efd63bb26153b8$var$isNullAddress(key) {
    if (!key) return true;
    return Object.values($hRv97.NullAddresses).includes(key);
}
module.exports.isNullAddress = $e4efd63bb26153b8$var$isNullAddress;
function $e4efd63bb26153b8$var$constructRecords(keys, values) {
    var records = {};
    keys.forEach(function(key, index) {
        records[key] = (values instanceof Array ? values[index] : values === null || values === void 0 ? void 0 : values[key]) || "";
    });
    return records;
}
module.exports.constructRecords = $e4efd63bb26153b8$var$constructRecords;
module.exports.domainExtensionToNamingServiceName = {
    crypto: $bq44C.NamingServiceName.UNS,
    zil: $bq44C.NamingServiceName.ZNS
};
var $e4efd63bb26153b8$var$findNamingServiceName = function(domain) {
    var extension = domain.split(".").pop();
    if (!extension) return "";
    else if (extension in module.exports.domainExtensionToNamingServiceName) return module.exports.domainExtensionToNamingServiceName[extension];
    else return module.exports.domainExtensionToNamingServiceName.crypto;
};
module.exports.findNamingServiceName = $e4efd63bb26153b8$var$findNamingServiceName;
module.exports.EthereumNetworks = {
    mainnet: 1,
    ropsten: 3,
    rinkeby: 4,
    goerli: 5,
    "polygon-mainnet": 137,
    "polygon-mumbai": 80001
};
module.exports.EthereumNetworksInverted = {
    1: "mainnet",
    3: "ropsten",
    4: "rinkeby",
    5: "goerli",
    137: "polygon-mainnet",
    80001: "polygon-mumbai"
};
var $e4efd63bb26153b8$var$wrapResult = function(func) {
    var callResult;
    // Catch immediately in case it's not an async call.
    try {
        callResult = func();
    } catch (error) {
        return Promise.resolve({
            result: null,
            error: error
        });
    }
    // `Promise.resolve` will convert both promise-like objects and plain values to promises.
    var promise = callResult instanceof Promise ? callResult : Promise.resolve(callResult);
    // We wrap results and errors to avoid unhandled promise rejections in case we won't `await` every promise
    // and return earlier.
    return promise.then(function(result) {
        return {
            result: result,
            error: null
        };
    }, function(error) {
        return {
            result: null,
            error: error
        };
    });
};
module.exports.wrapResult = $e4efd63bb26153b8$var$wrapResult;
var $e4efd63bb26153b8$var$unwrapResult = function(wrappedResult) {
    if (wrappedResult.error !== null) throw wrappedResult.error;
    return wrappedResult.result;
};
module.exports.unwrapResult = $e4efd63bb26153b8$var$unwrapResult;

});
parcelRegister("bq44C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockchainType = module.exports.DnsRecordType = module.exports.NamehashOptionsDefault = module.exports.UDApiDefaultUrl = module.exports.UnclaimedDomainResponse = module.exports.NamingServiceName = module.exports.UnsLocation = void 0;
var $850548585aa69bef$var$UnsLocation;
(function(UnsLocation) {
    UnsLocation["Layer1"] = "UNSLayer1";
    UnsLocation["Layer2"] = "UNSLayer2";
})($850548585aa69bef$var$UnsLocation = module.exports.UnsLocation || (module.exports.UnsLocation = {}));
var $850548585aa69bef$var$NamingServiceName;
(function(NamingServiceName) {
    NamingServiceName["UNS"] = "UNS";
    NamingServiceName["ZNS"] = "ZNS";
})($850548585aa69bef$var$NamingServiceName = module.exports.NamingServiceName || (module.exports.NamingServiceName = {}));
module.exports.UnclaimedDomainResponse = {
    addresses: {},
    meta: {
        domain: "",
        namehash: "",
        resolver: "",
        owner: null,
        type: "",
        ttl: 0,
        blockchain: null
    },
    records: {}
};
module.exports.UDApiDefaultUrl = "https://unstoppabledomains.com/api/v1";
module.exports.NamehashOptionsDefault = {
    format: "hex",
    prefix: true,
    zns: false
};
var $850548585aa69bef$var$DnsRecordType;
(function(DnsRecordType) {
    DnsRecordType["A"] = "A";
    DnsRecordType["AAAA"] = "AAAA";
    DnsRecordType["AFSDB"] = "AFSDB";
    DnsRecordType["APL"] = "APL";
    DnsRecordType["CAA"] = "CAA";
    DnsRecordType["CDNSKEY"] = "CDNSKEY";
    DnsRecordType["CDS"] = "CDS";
    DnsRecordType["CERT"] = "CERT";
    DnsRecordType["CNAME"] = "CNAME";
    DnsRecordType["CSYNC"] = "CSYNC";
    DnsRecordType["DHCID"] = "DHCID";
    DnsRecordType["DLV"] = "DLV";
    DnsRecordType["DNAME"] = "DNAME";
    DnsRecordType["DNSKEY"] = "DNSKEY";
    DnsRecordType["DS"] = "DS";
    DnsRecordType["EUI48"] = "EUI48";
    DnsRecordType["EUI64"] = "EUI64";
    DnsRecordType["HINFO"] = "HINFO";
    DnsRecordType["HIP"] = "HIP";
    DnsRecordType["HTTPS"] = "HTTPS";
    DnsRecordType["IPSECKEY"] = "IPSECKEY";
    DnsRecordType["KEY"] = "KEY";
    DnsRecordType["KX"] = "KX";
    DnsRecordType["LOC"] = "LOC";
    DnsRecordType["MX"] = "MX";
    DnsRecordType["NAPTR"] = "NAPTR";
    DnsRecordType["NS"] = "NS";
    DnsRecordType["NSEC"] = "NSEC";
    DnsRecordType["NSEC3"] = "NSEC3";
    DnsRecordType["NSEC3PARAM"] = "NSEC3PARAM";
    DnsRecordType["OPENPGPKEY"] = "OPENPGPKEY";
    DnsRecordType["PTR"] = "PTR";
    DnsRecordType["RP"] = "RP";
    DnsRecordType["RRSIG"] = "RRSIG";
    DnsRecordType["SIG"] = "SIG";
    DnsRecordType["SMIMEA"] = "SMIMEA";
    DnsRecordType["SOA"] = "SOA";
    DnsRecordType["SRV"] = "SRV";
    DnsRecordType["SSHFP"] = "SSHFP";
    DnsRecordType["SVCB"] = "SVCB";
    DnsRecordType["TA"] = "TA";
    DnsRecordType["TKEY"] = "TKEY";
    DnsRecordType["TLSA"] = "TLSA";
    DnsRecordType["TSIG"] = "TSIG";
    DnsRecordType["TXT"] = "TXT";
    DnsRecordType["URI"] = "URI";
    DnsRecordType["ZONEMD"] = "ZONEMD";
})($850548585aa69bef$var$DnsRecordType = module.exports.DnsRecordType || (module.exports.DnsRecordType = {}));
var $850548585aa69bef$var$BlockchainType;
(function(BlockchainType) {
    BlockchainType["ETH"] = "ETH";
    BlockchainType["MATIC"] = "MATIC";
    BlockchainType["ZIL"] = "ZIL";
})($850548585aa69bef$var$BlockchainType = module.exports.BlockchainType || (module.exports.BlockchainType = {}));

});

parcelRegister("hRv97", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasProvider = module.exports.ZnsSupportedNetwork = module.exports.UnsSupportedNetwork = module.exports.NullAddresses = module.exports.NullAddress = void 0;
module.exports.NullAddress = "0x0000000000000000000000000000000000000000";
var $d00f8be3aed91505$var$NullAddresses;
(function(NullAddresses) {
    NullAddresses[NullAddresses["0x"] = 0] = "0x";
    NullAddresses[NullAddresses["0x0000000000000000000000000000000000000000"] = 1] = "0x0000000000000000000000000000000000000000";
    NullAddresses[NullAddresses["0x0000000000000000000000000000000000000000000000000000000000000000"] = 2] = "0x0000000000000000000000000000000000000000000000000000000000000000";
})($d00f8be3aed91505$var$NullAddresses = module.exports.NullAddresses || (module.exports.NullAddresses = {}));
// TypeScript will infer a string union type from the literal values passed to
// this function. Without `extends string`, it would instead generalize them
// to the common string type.
// @see https://stackoverflow.com/questions/36836011/checking-validity-of-string-literal-union-type-at-runtime
var $d00f8be3aed91505$var$StringUnion = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    Object.freeze(values);
    var valueSet = new Set(values);
    var guard = function(value) {
        return valueSet.has(value);
    };
    var check = function(value) {
        if (!guard(value)) {
            var actual = JSON.stringify(value);
            var expected = values.map(function(s) {
                return JSON.stringify(s);
            }).join(" | ");
            throw new TypeError("Value '".concat(actual, "' is not assignable to type '").concat(expected, "'."));
        }
        return value;
    };
    var unionNamespace = {
        guard: guard,
        check: check,
        values: values
    };
    return Object.freeze(unionNamespace);
};
module.exports.UnsSupportedNetwork = $d00f8be3aed91505$var$StringUnion("mainnet", "rinkeby", "goerli", "polygon-mainnet", "polygon-mumbai");
module.exports.ZnsSupportedNetwork = $d00f8be3aed91505$var$StringUnion("mainnet", "testnet");
function $d00f8be3aed91505$var$hasProvider(obj) {
    return obj && !!obj.provider;
}
module.exports.hasProvider = $d00f8be3aed91505$var$hasProvider;

});


parcelRegister("anKpg", function(module, exports) {
"use strict";
var $78f00cbf80ca729a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $78f00cbf80ca729a$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolutionError = module.exports.ResolutionErrorCode = void 0;
var $78f00cbf80ca729a$var$ResolutionErrorCode;
(function(ResolutionErrorCode) {
    ResolutionErrorCode["UnregisteredDomain"] = "UnregisteredDomain";
    ResolutionErrorCode["UnspecifiedResolver"] = "UnspecifiedResolver";
    ResolutionErrorCode["UnsupportedDomain"] = "UnsupportedDomain";
    ResolutionErrorCode["UnsupportedService"] = "UnsupportedService";
    ResolutionErrorCode["UnsupportedMethod"] = "UnsupportedMethod";
    ResolutionErrorCode["UnspecifiedCurrency"] = "UnspecifiedCurrency";
    ResolutionErrorCode["UnsupportedCurrency"] = "UnsupportedCurrency";
    ResolutionErrorCode["IncorrectResolverInterface"] = "IncorrectResolverInterface";
    ResolutionErrorCode["RecordNotFound"] = "RecordNotFound";
    ResolutionErrorCode["MetadataEndpointError"] = "MetadataEndpointError";
    ResolutionErrorCode["ServiceProviderError"] = "ServiceProviderError";
    ResolutionErrorCode["InvalidTwitterVerification"] = "InvalidTwitterVerification";
    ResolutionErrorCode["InconsistentDomainArray"] = "InconsistentDomainArray";
    ResolutionErrorCode["InvalidDomainAddress"] = "InvalidDomainAddress";
})($78f00cbf80ca729a$var$ResolutionErrorCode = module.exports.ResolutionErrorCode || (module.exports.ResolutionErrorCode = {}));
/**
 * @internal
 * Internal Mapping object from ResolutionErrorCode to a ResolutionErrorHandler
 */ var $78f00cbf80ca729a$var$HandlersByCode = ($78f00cbf80ca729a$var$_a = {}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.UnregisteredDomain] = function(params) {
    return "Domain ".concat(params.domain, " is not registered");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.UnspecifiedResolver] = function(params) {
    return "".concat(params.location ? "".concat(params.location, ": ") : "", "Domain ").concat(params.domain, " is not configured");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.UnsupportedDomain] = function(params) {
    return "Domain ".concat(params.domain, " is not supported");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.UnsupportedMethod] = function(params) {
    var _a;
    // We normally expect a domain name, but in can be absent in the tests.
    var zilHelp = ((_a = params.domain) === null || _a === void 0 ? void 0 : _a.endsWith(".zil")) ? " (if this method was called via the Resolution class with both UNS and ZNS providers configured not in the API mode, this error also means that the domain doesn't exist in UNS)" : "";
    return "Method ".concat(params.methodName, " is not supported for ").concat(params.domain).concat(zilHelp);
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.InvalidTwitterVerification] = function(params) {
    return "".concat(params.location ? "".concat(params.location, ": ") : "", "Domain ").concat(params.domain, " has invalid Twitter signature verification");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.UnsupportedCurrency] = function(params) {
    return "".concat(params.currencyTicker, " is not supported");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.IncorrectResolverInterface] = function(params) {
    return "Domain resolver is configured incorrectly for ".concat(params.method);
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.RecordNotFound] = function(params) {
    return "".concat(params.location ? "".concat(params.location, ": ") : "", "No ").concat(params.recordName, " record found for ").concat(params.domain);
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.ServiceProviderError] = function(params) {
    return "< ".concat(params.providerMessage, " >");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.MetadataEndpointError] = function(params) {
    return "Failed to query tokenUri ".concat(params.tokenUri, ". Error: ").concat(params.errorMessage);
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.UnsupportedService] = function(params) {
    return "Naming service ".concat(params.namingService, " is not supported");
}, $78f00cbf80ca729a$var$_a[$78f00cbf80ca729a$var$ResolutionErrorCode.InvalidDomainAddress] = function(params) {
    return "Domain address ".concat(params.domain, " is invalid");
}, $78f00cbf80ca729a$var$_a);
/**
 * Resolution Error class is designed to control every error being thrown by Resolution
 * @param code - Error Code
 * - UnsupportedDomain - domain is not supported by current Resolution instance
 * - UnregisteredDomain - domain is not owned by any address
 * - UnspecifiedResolver - domain has no resolver specified
 * - UnspecifiedCurrency - domain resolver doesn't have any address of specified currency
 * - UnsupportedCurrency - currency is not supported
 * - IncorrectResolverInterface - ResolverInterface is incorrected
 * - RecordNotFound - No record was found
 * @param domain - Domain name that was being used
 * @param method
 */ var $78f00cbf80ca729a$var$ResolutionError = /** @class */ function(_super) {
    $78f00cbf80ca729a$var$__extends(ResolutionError, _super);
    function ResolutionError(code, options) {
        if (options === void 0) options = {};
        var _this = this;
        var resolutionErrorHandler = $78f00cbf80ca729a$var$HandlersByCode[code];
        var domain = options.domain, method = options.method, currencyTicker = options.currencyTicker;
        var message = resolutionErrorHandler(options);
        _this = _super.call(this, message) || this;
        _this.code = code;
        _this.domain = domain;
        _this.method = method;
        _this.currencyTicker = currencyTicker;
        _this.name = "ResolutionError";
        Object.setPrototypeOf(_this, ResolutionError.prototype);
        return _this;
    }
    return ResolutionError;
}(Error);
module.exports.ResolutionError = $78f00cbf80ca729a$var$ResolutionError;
module.exports.default = $78f00cbf80ca729a$var$ResolutionError;

});

parcelRegister("2rLlp", function(module, exports) {
"use strict";
var $1c82d3fd02a997f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1c82d3fd02a997f8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1c82d3fd02a997f8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1c82d3fd02a997f8$var$__createBinding(result, mod, k);
    }
    $1c82d3fd02a997f8$var$__setModuleDefault(result, mod);
    return result;
};
var $1c82d3fd02a997f8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1c82d3fd02a997f8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1c82d3fd02a997f8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c82d3fd02a997f8$var$resolutionError_1 = $1c82d3fd02a997f8$var$__importStar((parcelRequire("anKpg")));

var $1c82d3fd02a997f8$var$Networking_1 = $1c82d3fd02a997f8$var$__importDefault((parcelRequire("5J7oF")));
var $1c82d3fd02a997f8$var$FetchProvider = /** @class */ function() {
    function FetchProvider(name, url) {
        this.url = url;
        this.name = name;
    }
    // This is used for test mocking
    FetchProvider.factory = function(name, url) {
        return new this(name, url);
    };
    FetchProvider.prototype.request = function(args) {
        return $1c82d3fd02a997f8$var$__awaiter(this, void 0, void 0, function() {
            var json;
            return $1c82d3fd02a997f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchJson(args)
                        ];
                    case 1:
                        json = _a.sent();
                        if (json.error) throw new $1c82d3fd02a997f8$var$resolutionError_1.default($1c82d3fd02a997f8$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                            providerMessage: json.error.message
                        });
                        return [
                            2 /*return*/ ,
                            json.result
                        ];
                }
            });
        });
    };
    FetchProvider.prototype.fetchJson = function(args) {
        return $1c82d3fd02a997f8$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $1c82d3fd02a997f8$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $1c82d3fd02a997f8$var$Networking_1.default.fetch(this.url, {
                                method: "POST",
                                body: JSON.stringify({
                                    jsonrpc: "2.0",
                                    id: "1",
                                    method: args.method,
                                    params: args.params || []
                                }),
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.status !== 200) throw new $1c82d3fd02a997f8$var$resolutionError_1.default($1c82d3fd02a997f8$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                            providerMessage: "Request to ".concat(this.url, " failed with response status ").concat(response.status)
                        });
                        return [
                            2 /*return*/ ,
                            response.json()
                        ];
                }
            });
        });
    };
    return FetchProvider;
}();
module.exports.default = $1c82d3fd02a997f8$var$FetchProvider;

});
parcelRegister("5J7oF", function(module, exports) {
"use strict";
var $42b6e48ffbd6ceae$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $42b6e48ffbd6ceae$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $42b6e48ffbd6ceae$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42b6e48ffbd6ceae$var$cross_fetch_1 = $42b6e48ffbd6ceae$var$__importDefault((parcelRequire("16s93")));
var $42b6e48ffbd6ceae$var$Networking = /** @class */ function() {
    function Networking() {}
    Networking.fetch = function(url, options) {
        return $42b6e48ffbd6ceae$var$__awaiter(this, void 0, void 0, function() {
            return $42b6e48ffbd6ceae$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $42b6e48ffbd6ceae$var$cross_fetch_1.default)(url, options)
                ];
            });
        });
    };
    return Networking;
}();
module.exports.default = $42b6e48ffbd6ceae$var$Networking;

});
parcelRegister("16s93", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("bPRni", function(module, exports) {
"use strict";
var $89dddc408453dce1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromDecStringToHex = module.exports.fromHexStringToDecimals = module.exports.znsChildhash = module.exports.znsNamehash = module.exports.eip137Childhash = module.exports.eip137Namehash = void 0;

var $89dddc408453dce1$var$sha256_1 = $89dddc408453dce1$var$__importDefault((parcelRequire("1AknP")));

var $89dddc408453dce1$var$sha3_1 = $89dddc408453dce1$var$__importDefault((parcelRequire("hWLSr")));

var $89dddc408453dce1$var$enc_hex_1 = $89dddc408453dce1$var$__importDefault((parcelRequire("cd29Y")));

var $89dddc408453dce1$var$lib_typedarrays_1 = $89dddc408453dce1$var$__importDefault((parcelRequire("eQ8Zr")));

var $89dddc408453dce1$var$bn_js_1 = $89dddc408453dce1$var$__importDefault((parcelRequire("lONYJ")));
function $89dddc408453dce1$var$eip137Namehash(domain) {
    var arr = $89dddc408453dce1$var$hashArray(domain, "sha3");
    return $89dddc408453dce1$var$arrayToHex(arr);
}
module.exports.eip137Namehash = $89dddc408453dce1$var$eip137Namehash;
function $89dddc408453dce1$var$eip137Childhash(parentHash, label) {
    return $89dddc408453dce1$var$childhash(parentHash, label, "sha3");
}
module.exports.eip137Childhash = $89dddc408453dce1$var$eip137Childhash;
function $89dddc408453dce1$var$znsNamehash(domain) {
    var arr = $89dddc408453dce1$var$hashArray(domain, "sha256");
    return $89dddc408453dce1$var$arrayToHex(arr);
}
module.exports.znsNamehash = $89dddc408453dce1$var$znsNamehash;
function $89dddc408453dce1$var$znsChildhash(parentHash, label) {
    return $89dddc408453dce1$var$childhash(parentHash, label, "sha256");
}
module.exports.znsChildhash = $89dddc408453dce1$var$znsChildhash;
function $89dddc408453dce1$var$childhash(parentHash, label, hashingAlgo) {
    var hash = hashingAlgo === "sha256" ? $89dddc408453dce1$var$sha256_1.default : $89dddc408453dce1$var$sha3_1.default;
    var opts = {
        outputLength: 256
    };
    var parent = parentHash.replace(/^0x/, "");
    var childHash = $89dddc408453dce1$var$enc_hex_1.default.stringify(hash(label, opts));
    return "0x".concat($89dddc408453dce1$var$enc_hex_1.default.stringify(hash($89dddc408453dce1$var$enc_hex_1.default.parse("".concat(parent).concat(childHash)), opts)));
}
function $89dddc408453dce1$var$hashArray(domain, hashingAlgo) {
    if (!domain) return $89dddc408453dce1$var$lib_typedarrays_1.default.create(Array.from(new Uint8Array(8)));
    var hash = hashingAlgo === "sha256" ? $89dddc408453dce1$var$sha256_1.default : $89dddc408453dce1$var$sha3_1.default;
    var opts = {
        outputLength: 256
    };
    var _a = domain.split("."), label = _a[0], remainder = _a.slice(1);
    var labelHash = hash(label, opts);
    var remainderHash = $89dddc408453dce1$var$hashArray(remainder.join("."), hashingAlgo);
    return hash(remainderHash.concat(labelHash), opts);
}
function $89dddc408453dce1$var$arrayToHex(arr) {
    return "0x".concat($89dddc408453dce1$var$enc_hex_1.default.stringify(arr));
}
function $89dddc408453dce1$var$fromHexStringToDecimals(value) {
    if (value.startsWith("0x")) {
        var valueWithoutPrefix = value.slice(2, value.length);
        var bn = new $89dddc408453dce1$var$bn_js_1.default(valueWithoutPrefix, 16);
        return bn.toString(10);
    }
    return value;
}
module.exports.fromHexStringToDecimals = $89dddc408453dce1$var$fromHexStringToDecimals;
function $89dddc408453dce1$var$fromDecStringToHex(value) {
    if (!value.startsWith("0x")) {
        var bn = new $89dddc408453dce1$var$bn_js_1.default(value, 10);
        var bnString = bn.toString(16);
        return "0x".concat(bnString.padStart(64, "0"));
    }
    return value;
}
module.exports.fromDecStringToHex = $89dddc408453dce1$var$fromDecStringToHex;

});
parcelRegister("hWLSr", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("aXmnC")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});
parcelRegister("aXmnC", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});


parcelRegister("eQ8Zr", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});


parcelRegister("2gwgp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamingService = void 0;
var $1a661a48d1ef543c$var$NamingService = /** @class */ function() {
    function NamingService() {}
    return NamingService;
}();
module.exports.NamingService = $1a661a48d1ef543c$var$NamingService;

});

parcelRegister("6yp4P", function(module, exports) {
"use strict";
var $4c595ec6f555bd10$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4c595ec6f555bd10$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigurationError = module.exports.ConfigurationErrorCode = void 0;
var $4c595ec6f555bd10$var$ConfigurationErrorCode;
(function(ConfigurationErrorCode) {
    ConfigurationErrorCode["IncorrectProvider"] = "IncorrectProvider";
    ConfigurationErrorCode["UnsupportedNetwork"] = "UnsupportedNetwork";
    ConfigurationErrorCode["UnspecifiedUrl"] = "UnspecifiedUrl";
    ConfigurationErrorCode["NetworkConfigMissing"] = "NetworkConfigMissing";
    ConfigurationErrorCode["CustomNetworkConfigMissing"] = "CustomNetworkConfigMissing";
    ConfigurationErrorCode["InvalidConfigurationField"] = "InvalidProxyReader";
})($4c595ec6f555bd10$var$ConfigurationErrorCode = module.exports.ConfigurationErrorCode || (module.exports.ConfigurationErrorCode = {}));
/**
 * @internal
 * Internal Mapping object from ConfigurationErrorCode to a ConfigurationErrorHandler
 */ var $4c595ec6f555bd10$var$HandlersByCode = ($4c595ec6f555bd10$var$_a = {}, $4c595ec6f555bd10$var$_a[$4c595ec6f555bd10$var$ConfigurationErrorCode.IncorrectProvider] = function() {
    return "Provider doesn't implement sendAsync or send method";
}, $4c595ec6f555bd10$var$_a[$4c595ec6f555bd10$var$ConfigurationErrorCode.UnsupportedNetwork] = function(params) {
    return "Unsupported network in Resolution ".concat(params.method || "", " configuration");
}, $4c595ec6f555bd10$var$_a[$4c595ec6f555bd10$var$ConfigurationErrorCode.UnspecifiedUrl] = function(params) {
    return "Unspecified url in Resolution ".concat(params.method, " configuration");
}, $4c595ec6f555bd10$var$_a[$4c595ec6f555bd10$var$ConfigurationErrorCode.NetworkConfigMissing] = function(params) {
    return "Missing configuration in Resolution ".concat(params.method, ". Please specify ").concat(params.config);
}, $4c595ec6f555bd10$var$_a[$4c595ec6f555bd10$var$ConfigurationErrorCode.CustomNetworkConfigMissing] = function(params) {
    return "Missing configuration in Resolution ".concat(params.method, ". Please specify ").concat(params.config, " when using a custom network");
}, $4c595ec6f555bd10$var$_a[$4c595ec6f555bd10$var$ConfigurationErrorCode.InvalidConfigurationField] = function(params) {
    return "Invalid '".concat(params.field, "' in Resolution ").concat(params.method);
}, $4c595ec6f555bd10$var$_a);
/**
 * Configuration Error class is designed to control every error being thrown by wrong configurations for objects
 * @param code - Error Code
 * - IncorrectProvider - When provider doesn't have implemented send or sendAsync methods
 * - UnsupportedNetwork - When network is not specified or not supported
 * - UnspecifiedUrl - When url is not specified for custom naming service configurations
 * - CustomNetworkConfigMissing - When configuration is missing for custom network configurations
 * @param method - optional param to specify which namingService errored out
 */ var $4c595ec6f555bd10$var$ConfigurationError = /** @class */ function(_super) {
    $4c595ec6f555bd10$var$__extends(ConfigurationError, _super);
    function ConfigurationError(code, options) {
        if (options === void 0) options = {};
        var _this = this;
        var configurationErrorHandler = $4c595ec6f555bd10$var$HandlersByCode[code];
        _this = _super.call(this, configurationErrorHandler(options)) || this;
        _this.code = code;
        _this.method = options.method;
        _this.name = "ConfigurationError";
        Object.setPrototypeOf(_this, ConfigurationError.prototype);
        return _this;
    }
    return ConfigurationError;
}(Error);
module.exports.ConfigurationError = $4c595ec6f555bd10$var$ConfigurationError;
module.exports.default = $4c595ec6f555bd10$var$ConfigurationError;

});


parcelRegister("1xVWq", function(module, exports) {
"use strict";
var $1205d16fea927d7d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1205d16fea927d7d$var$__assign = module.exports && module.exports.__assign || function() {
    $1205d16fea927d7d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1205d16fea927d7d$var$__assign.apply(this, arguments);
};
var $1205d16fea927d7d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1205d16fea927d7d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1205d16fea927d7d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1205d16fea927d7d$var$__createBinding(result, mod, k);
    }
    $1205d16fea927d7d$var$__setModuleDefault(result, mod);
    return result;
};
var $1205d16fea927d7d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1205d16fea927d7d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1205d16fea927d7d$var$__asyncValues = module.exports && module.exports.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $1205d16fea927d7d$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1205d16fea927d7d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hRv97 = parcelRequire("hRv97");

var $1205d16fea927d7d$var$resolutionError_1 = $1205d16fea927d7d$var$__importStar((parcelRequire("anKpg")));

var $jECMB = parcelRequire("jECMB");

var $bq44C = parcelRequire("bq44C");

var $911HQ = parcelRequire("911HQ");

var $1205d16fea927d7d$var$FetchProvider_1 = $1205d16fea927d7d$var$__importDefault((parcelRequire("2rLlp")));

var $bPRni = parcelRequire("bPRni");

var $2gwgp = parcelRequire("2gwgp");

var $1205d16fea927d7d$var$configurationError_1 = $1205d16fea927d7d$var$__importStar((parcelRequire("6yp4P")));

var $1205d16fea927d7d$var$UnsInternal_1 = $1205d16fea927d7d$var$__importDefault((parcelRequire("1Avfp")));

var $1205d16fea927d7d$var$Networking_1 = $1205d16fea927d7d$var$__importDefault((parcelRequire("5J7oF")));

var $1205d16fea927d7d$var$resolver_keys_json_1 = $1205d16fea927d7d$var$__importDefault((parcelRequire("d7bnB")));
/**
 * @internal
 */ var $1205d16fea927d7d$var$Uns = /** @class */ function(_super) {
    $1205d16fea927d7d$var$__extends(Uns, _super);
    function Uns(source) {
        var _this = _super.call(this) || this;
        _this.name = $bq44C.NamingServiceName.UNS;
        if (source && source.locations && (!source.locations.Layer1 || !source.locations.Layer2)) throw new $1205d16fea927d7d$var$configurationError_1.default($1205d16fea927d7d$var$configurationError_1.ConfigurationErrorCode.NetworkConfigMissing, {
            method: $bq44C.NamingServiceName.UNS,
            config: !source.locations.Layer1 ? "Layer1" : "Layer2"
        });
        if (!source) source = {
            locations: {
                Layer1: {
                    url: $1205d16fea927d7d$var$UnsInternal_1.default.UrlMap["mainnet"],
                    network: "mainnet"
                },
                Layer2: {
                    url: $1205d16fea927d7d$var$UnsInternal_1.default.UrlMap["polygon-mainnet"],
                    network: "polygon-mainnet"
                }
            }
        };
        _this.unsl1 = new $1205d16fea927d7d$var$UnsInternal_1.default($bq44C.UnsLocation.Layer1, source.locations.Layer1, $bq44C.BlockchainType.ETH);
        _this.unsl2 = new $1205d16fea927d7d$var$UnsInternal_1.default($bq44C.UnsLocation.Layer2, source.locations.Layer2, $bq44C.BlockchainType.MATIC);
        return _this;
    }
    Uns.autoNetwork = function(config) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var providerLayer1, providerLayer2, networkIdLayer1, networkIdLayer2, networkNameLayer1, networkNameLayer2;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if ((0, $hRv97.hasProvider)(config.locations.Layer1) && (0, $hRv97.hasProvider)(config.locations.Layer2)) {
                            providerLayer1 = config.locations.Layer1.provider;
                            providerLayer2 = config.locations.Layer2.provider;
                        } else {
                            if (!config.locations.Layer1["url"] || !config.locations.Layer2["url"]) throw new $1205d16fea927d7d$var$configurationError_1.default($1205d16fea927d7d$var$configurationError_1.ConfigurationErrorCode.UnspecifiedUrl, {
                                method: $bq44C.NamingServiceName.UNS
                            });
                            providerLayer1 = $1205d16fea927d7d$var$FetchProvider_1.default.factory($bq44C.NamingServiceName.UNS, config.locations.Layer1["url"]);
                            providerLayer2 = $1205d16fea927d7d$var$FetchProvider_1.default.factory($bq44C.NamingServiceName.UNS, config.locations.Layer2["url"]);
                        }
                        return [
                            4 /*yield*/ ,
                            providerLayer1.request({
                                method: "net_version"
                            })
                        ];
                    case 1:
                        networkIdLayer1 = _a.sent();
                        return [
                            4 /*yield*/ ,
                            providerLayer2.request({
                                method: "net_version"
                            })
                        ];
                    case 2:
                        networkIdLayer2 = _a.sent();
                        networkNameLayer1 = $jECMB.EthereumNetworksInverted[networkIdLayer1];
                        networkNameLayer2 = $jECMB.EthereumNetworksInverted[networkIdLayer2];
                        if (!networkNameLayer1 || !$hRv97.UnsSupportedNetwork.guard(networkNameLayer1) || !networkNameLayer2 || !$hRv97.UnsSupportedNetwork.guard(networkNameLayer2)) throw new $1205d16fea927d7d$var$configurationError_1.default($1205d16fea927d7d$var$configurationError_1.ConfigurationErrorCode.UnsupportedNetwork, {
                            method: $bq44C.NamingServiceName.UNS
                        });
                        return [
                            2 /*return*/ ,
                            new this({
                                locations: {
                                    Layer1: {
                                        network: networkNameLayer1,
                                        provider: providerLayer1
                                    },
                                    Layer2: {
                                        network: networkNameLayer2,
                                        provider: providerLayer2
                                    }
                                }
                            })
                        ];
                }
            });
        });
    };
    Uns.prototype.namehash = function(domain) {
        if (!this.checkDomain(domain)) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
            domain: domain
        });
        return (0, $bPRni.eip137Namehash)(domain);
    };
    Uns.prototype.childhash = function(parentHash, label) {
        return (0, $bPRni.eip137Childhash)(parentHash, label);
    };
    Uns.prototype.isSupportedDomain = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var tld, _a, existsL1, existsL2;
            return $1205d16fea927d7d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.checkDomain(domain)) return [
                            2 /*return*/ ,
                            false
                        ];
                        tld = domain.split(".").pop();
                        if (!tld) return [
                            2 /*return*/ ,
                            false
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.unsl1.exists(tld),
                                this.unsl2.exists(tld)
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), existsL1 = _a[0], existsL2 = _a[1];
                        return [
                            2 /*return*/ ,
                            existsL1 || existsL2
                        ];
                }
            });
        });
    };
    Uns.prototype.owner = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var tokenId, data;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenId = this.namehash(domain);
                        return [
                            4 /*yield*/ ,
                            this.get(tokenId, [])
                        ];
                    case 1:
                        data = _a.sent();
                        if ((0, $jECMB.isNullAddress)(data.owner)) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            data.owner
                        ];
                }
            });
        });
    };
    Uns.prototype.resolver = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getVerifiedData(domain)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent().resolver
                        ];
                }
            });
        });
    };
    Uns.prototype.record = function(domain, key) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var returnee;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.records(domain, [
                                key
                            ])
                        ];
                    case 1:
                        returnee = _a.sent()[key];
                        if (!returnee) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                            recordName: key,
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            returnee
                        ];
                }
            });
        });
    };
    Uns.prototype.records = function(domain, keys) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getVerifiedData(domain, keys)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent().records
                        ];
                }
            });
        });
    };
    Uns.prototype.allRecords = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.records(domain, $1205d16fea927d7d$var$__spreadArray([], Object.keys($1205d16fea927d7d$var$resolver_keys_json_1.default.keys), true))
                ];
            });
        });
    };
    Uns.prototype.twitter = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var tokenId, keys, data, records, location, validationSignature, twitterHandle, owner;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenId = this.namehash(domain);
                        keys = [
                            "validation.social.twitter.username",
                            "social.twitter.username"
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getVerifiedData(domain, keys)
                        ];
                    case 1:
                        data = _a.sent();
                        records = data.records, location = data.location;
                        validationSignature = records["validation.social.twitter.username"];
                        twitterHandle = records["social.twitter.username"];
                        if ((0, $jECMB.isNullAddress)(validationSignature)) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                            domain: domain,
                            location: location,
                            recordName: "validation.social.twitter.username"
                        });
                        if (!twitterHandle) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.RecordNotFound, {
                            domain: domain,
                            location: location,
                            recordName: "social.twitter.username"
                        });
                        owner = data.owner;
                        if (!(0, $911HQ.isValidTwitterSignature)({
                            tokenId: tokenId,
                            owner: owner,
                            twitterHandle: twitterHandle,
                            validationSignature: validationSignature
                        })) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.InvalidTwitterVerification, {
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            twitterHandle
                        ];
                }
            });
        });
    };
    Uns.prototype.reverse = function(address, currencyTicker) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "reverse"
                });
            });
        });
    };
    Uns.prototype.isRegistered = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var tokenId, data;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenId = this.namehash(domain);
                        return [
                            4 /*yield*/ ,
                            this.get(tokenId, [])
                        ];
                    case 1:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            !(0, $jECMB.isNullAddress)(data.owner)
                        ];
                }
            });
        });
    };
    Uns.prototype.getTokenUri = function(tokenId) {
        var e_1, _a;
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var _b, _c, result, tokenUri, e_1_1;
            var _this = this;
            return $1205d16fea927d7d$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            5,
                            6,
                            11
                        ]);
                        _b = $1205d16fea927d7d$var$__asyncValues([
                            (0, $jECMB.wrapResult)(function() {
                                return _this.unsl2.getTokenUri(tokenId);
                            }),
                            (0, $jECMB.wrapResult)(function() {
                                return _this.unsl1.getTokenUri(tokenId);
                            })
                        ]);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.next()
                        ];
                    case 2:
                        if (!(_c = _d.sent(), !_c.done)) return [
                            3 /*break*/ ,
                            4
                        ];
                        result = _c.value;
                        tokenUri = (0, $jECMB.unwrapResult)(result);
                        if (tokenUri) return [
                            2 /*return*/ ,
                            tokenUri
                        ];
                        _d.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 5:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 6:
                        _d.trys.push([
                            6,
                            ,
                            9,
                            10
                        ]);
                        if (!(_c && !_c.done && (_a = _b.return))) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_b)
                        ];
                    case 7:
                        _d.sent();
                        _d.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        // Note: if a token doesn't exist, ProxyReader returns an empty string. If both responses are empty,
                        // we know for sure that the domain isn't registered.
                        throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                            domain: "with tokenId ".concat(tokenId)
                        });
                }
            });
        });
    };
    Uns.prototype.isAvailable = function(domain) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.isRegistered(domain)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            !_a.sent()
                        ];
                }
            });
        });
    };
    Uns.prototype.registryAddress = function(domainOrNamehash) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var _a, resultOrErrorL1, resultOrErrorL2;
            return $1205d16fea927d7d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.unsl1.registryAddress(domainOrNamehash).catch(function(err) {
                                    return err;
                                }),
                                this.unsl2.registryAddress(domainOrNamehash).catch(function(err) {
                                    return err;
                                })
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), resultOrErrorL1 = _a[0], resultOrErrorL2 = _a[1];
                        if (resultOrErrorL2 instanceof Error) $1205d16fea927d7d$var$validResolutionErrorOrThrow(resultOrErrorL2, $1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain);
                        else if (!(0, $jECMB.isNullAddress)(resultOrErrorL2)) return [
                            2 /*return*/ ,
                            resultOrErrorL2
                        ];
                        return [
                            2 /*return*/ ,
                            $1205d16fea927d7d$var$validResultOrThrow(resultOrErrorL1)
                        ];
                }
            });
        });
    };
    Uns.prototype.locations = function(domains) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var _a, resultL1, resultL2, nonEmptyRecordsFromL2;
            return $1205d16fea927d7d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.unsl1.locations(domains),
                                this.unsl2.locations(domains)
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), resultL1 = _a[0], resultL2 = _a[1];
                        nonEmptyRecordsFromL2 = Object.keys(resultL2).filter(function(k) {
                            return resultL2[k] != null;
                        }).reduce(function(a, k) {
                            var _a;
                            return $1205d16fea927d7d$var$__assign($1205d16fea927d7d$var$__assign({}, a), (_a = {}, _a[k] = resultL2[k], _a));
                        }, {});
                        return [
                            2 /*return*/ ,
                            $1205d16fea927d7d$var$__assign($1205d16fea927d7d$var$__assign({}, resultL1), nonEmptyRecordsFromL2)
                        ];
                }
            });
        });
    };
    Uns.prototype.reverseOf = function(addr, location) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var _a, resultOrErrorL1, resultOrErrorL2, reverseL1, reverseL2, reversedL1, reversedL2;
            return $1205d16fea927d7d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.unsl1.reverseOf(addr).catch(function(err) {
                                    return err;
                                }),
                                this.unsl2.reverseOf(addr).catch(function(err) {
                                    return err;
                                })
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), resultOrErrorL1 = _a[0], resultOrErrorL2 = _a[1];
                        reverseL1 = function() {
                            $1205d16fea927d7d$var$validResultOrThrow(resultOrErrorL1);
                            if (resultOrErrorL1._hex !== "0x00") return (0, $bPRni.fromHexStringToDecimals)(resultOrErrorL1._hex);
                            else return null;
                        };
                        reverseL2 = function() {
                            $1205d16fea927d7d$var$validResultOrThrow(resultOrErrorL2);
                            if (resultOrErrorL2._hex !== "0x00") return (0, $bPRni.fromHexStringToDecimals)(resultOrErrorL2._hex);
                            else return null;
                        };
                        if (location === $bq44C.UnsLocation.Layer1) return [
                            2 /*return*/ ,
                            reverseL1()
                        ];
                        if (location === $bq44C.UnsLocation.Layer2) return [
                            2 /*return*/ ,
                            reverseL2()
                        ];
                        reversedL1 = reverseL1();
                        if (reversedL1) return [
                            2 /*return*/ ,
                            reversedL1
                        ];
                        reversedL2 = reverseL2();
                        if (reversedL2) return [
                            2 /*return*/ ,
                            reversedL2
                        ];
                        return [
                            2 /*return*/ ,
                            null
                        ];
                }
            });
        });
    };
    Uns.prototype.getDomainFromTokenId = function(tokenId) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var metadata;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getMetadata(tokenId)
                        ];
                    case 1:
                        metadata = _a.sent();
                        if (this.namehash(metadata.name) !== tokenId) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                            methodName: "unhash",
                            domain: metadata.name,
                            providerMessage: "Service provider returned an invalid domain name"
                        });
                        return [
                            2 /*return*/ ,
                            metadata.name
                        ];
                }
            });
        });
    };
    Uns.prototype.getMetadata = function(tokenId) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var tokenUri, resp, metadata;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getTokenUri(tokenId)
                        ];
                    case 1:
                        tokenUri = _a.sent();
                        return [
                            4 /*yield*/ ,
                            $1205d16fea927d7d$var$Networking_1.default.fetch(tokenUri, {}).catch(function(err) {
                                throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.MetadataEndpointError, {
                                    tokenUri: tokenUri || "undefined",
                                    errorMessage: err.message
                                });
                            })
                        ];
                    case 2:
                        resp = _a.sent();
                        if (!resp.ok) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.MetadataEndpointError, {
                            tokenUri: tokenUri || "undefined"
                        });
                        return [
                            4 /*yield*/ ,
                            resp.json()
                        ];
                    case 3:
                        metadata = _a.sent();
                        if (!metadata.name) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                            domain: "with tokenId ".concat(tokenId)
                        });
                        if (this.namehash(metadata.name) !== tokenId) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                            methodName: "unhash",
                            domain: metadata.name,
                            providerMessage: "Service provider returned an invalid domain name"
                        });
                        return [
                            2 /*return*/ ,
                            metadata
                        ];
                }
            });
        });
    };
    Uns.prototype.getVerifiedData = function(domain, keys) {
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var tokenId, data;
            return $1205d16fea927d7d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenId = this.namehash(domain);
                        return [
                            4 /*yield*/ ,
                            this.get(tokenId, keys)
                        ];
                    case 1:
                        data = _a.sent();
                        if ((0, $jECMB.isNullAddress)(data.resolver)) {
                            if ((0, $jECMB.isNullAddress)(data.owner)) throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                                domain: domain
                            });
                            throw new $1205d16fea927d7d$var$resolutionError_1.default($1205d16fea927d7d$var$resolutionError_1.ResolutionErrorCode.UnspecifiedResolver, {
                                location: data.location,
                                domain: domain
                            });
                        }
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    };
    Uns.prototype.get = function(tokenId, keys) {
        if (keys === void 0) keys = [];
        return $1205d16fea927d7d$var$__awaiter(this, void 0, void 0, function() {
            var _a, resultOrErrorL1, resultOrErrorL2, resolverL2, ownerL2, recordsL2, resolverL1, ownerL1, recordsL1;
            return $1205d16fea927d7d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                this.unsl1.get(tokenId, keys).catch(function(err) {
                                    return err;
                                }),
                                this.unsl2.get(tokenId, keys).catch(function(err) {
                                    return err;
                                })
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), resultOrErrorL1 = _a[0], resultOrErrorL2 = _a[1];
                        $1205d16fea927d7d$var$validResultOrThrow(resultOrErrorL2);
                        resolverL2 = resultOrErrorL2.resolver, ownerL2 = resultOrErrorL2.owner, recordsL2 = resultOrErrorL2.records;
                        if (!(0, $jECMB.isNullAddress)(ownerL2)) return [
                            2 /*return*/ ,
                            {
                                resolver: resolverL2,
                                owner: ownerL2,
                                records: (0, $jECMB.constructRecords)(keys, recordsL2),
                                location: $bq44C.UnsLocation.Layer2
                            }
                        ];
                        $1205d16fea927d7d$var$validResultOrThrow(resultOrErrorL1);
                        resolverL1 = resultOrErrorL1.resolver, ownerL1 = resultOrErrorL1.owner, recordsL1 = resultOrErrorL1.records;
                        return [
                            2 /*return*/ ,
                            {
                                resolver: resolverL1,
                                owner: ownerL1,
                                records: (0, $jECMB.constructRecords)(keys, recordsL1),
                                location: $bq44C.UnsLocation.Layer1
                            }
                        ];
                }
            });
        });
    };
    Uns.prototype.checkDomain = function(domain, passIfTokenID) {
        if (passIfTokenID === void 0) passIfTokenID = false;
        if (passIfTokenID) return true;
        var tokens = domain.split(".");
        return !!tokens.length && !(domain === "eth" || /^[^-]*[^-]*\.(eth|luxe|xyz|kred|addr\.reverse)$/.test(domain)) && tokens.every(function(v) {
            return !!v.length;
        });
    };
    return Uns;
}($2gwgp.NamingService);
module.exports.default = $1205d16fea927d7d$var$Uns;
function $1205d16fea927d7d$var$validResultOrThrow(resultOrError) {
    if (resultOrError instanceof Error) throw resultOrError;
    return resultOrError;
}
function $1205d16fea927d7d$var$validResolutionErrorOrThrow(error, validCode) {
    if (!(error instanceof $1205d16fea927d7d$var$resolutionError_1.default)) throw error;
    if (error.code === validCode) return true;
    throw error;
}

});
parcelRegister("911HQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidTwitterSignature = void 0;

var $jECMB = parcelRequire("jECMB");

var $84nWc = parcelRequire("84nWc");

var $eI1Qq = parcelRequire("eI1Qq");

var $bPRni = parcelRequire("bPRni");
var $690587e0ce3d4794$var$TwitterVerificationAddress = "0x12cfb13522F13a78b650a8bCbFCf50b7CB899d82";
var $690587e0ce3d4794$var$isValidTwitterSignature = function(_a) {
    var tokenId = _a.tokenId, owner = _a.owner, twitterHandle = _a.twitterHandle, validationSignature = _a.validationSignature;
    var tokenIdInDecimals = (0, $bPRni.fromHexStringToDecimals)(tokenId);
    var message = [
        tokenIdInDecimals,
        owner,
        "social.twitter.username",
        twitterHandle
    ].map(function(value) {
        return "0x" + (0, $84nWc.keccak256)(value.startsWith("0x") ? (0, $jECMB.hexToBytes)(value) : value);
    }).reduce(function(message, hashedValue) {
        return message + hashedValue;
    }, "");
    var signerAddress = (0, $eI1Qq.recover)(message, validationSignature);
    return signerAddress === $690587e0ce3d4794$var$TwitterVerificationAddress;
};
module.exports.isValidTwitterSignature = $690587e0ce3d4794$var$isValidTwitterSignature;

});
parcelRegister("84nWc", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $ibaza === "object" && $ibaza.versions && $ibaza.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});


parcelRegister("eI1Qq", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $ab569b08130d91b3$require$Buffer = $N0o3H.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.recover = module.exports.hashMessage = void 0;

var $84nWc = parcelRequire("84nWc");

var $jECMB = parcelRequire("jECMB");

var $7kgn0 = parcelRequire("7kgn0");
var $ab569b08130d91b3$var$secp256k1 = new $7kgn0.ec("secp256k1");
var $ab569b08130d91b3$var$bytesLength = function(a) {
    return (a.length - 2) / 2;
};
var $ab569b08130d91b3$var$bytesSlice = function(i, j, bs) {
    return "0x" + bs.slice(i * 2 + 2, j * 2 + 2);
};
var $ab569b08130d91b3$var$bytesToNumber = function(hex) {
    return parseInt(hex.slice(2), 16);
};
var $ab569b08130d91b3$var$decodeSignature = function(hex) {
    return [
        $ab569b08130d91b3$var$bytesSlice(64, $ab569b08130d91b3$var$bytesLength(hex), hex),
        $ab569b08130d91b3$var$bytesSlice(0, 32, hex),
        $ab569b08130d91b3$var$bytesSlice(32, 64, hex)
    ];
};
var $ab569b08130d91b3$var$toChecksum = function(address) {
    var addressHash = (0, $84nWc.keccak256)(address.slice(2));
    var checksumAddress = "0x";
    for(var i = 0; i < 40; i++)checksumAddress += parseInt(addressHash[i + 2], 16) > 7 ? address[i + 2].toUpperCase() : address[i + 2];
    return checksumAddress;
};
var $ab569b08130d91b3$var$hashMessage = function(message) {
    var messageBytes = (0, $jECMB.hexToBytes)($ab569b08130d91b3$require$Buffer.from(message, "utf8").toString("hex"));
    var messageBuffer = $ab569b08130d91b3$require$Buffer.from(messageBytes);
    var preamble = "\x19Ethereum Signed Message:\n" + messageBytes.length;
    var preambleBuffer = $ab569b08130d91b3$require$Buffer.from(preamble);
    var ethMessage = $ab569b08130d91b3$require$Buffer.concat([
        preambleBuffer,
        messageBuffer
    ]);
    return "0x" + (0, $84nWc.keccak256)(ethMessage.toString());
};
module.exports.hashMessage = $ab569b08130d91b3$var$hashMessage;
var $ab569b08130d91b3$var$recover = function(message, signature) {
    var hash = (0, module.exports.hashMessage)(message);
    var vals = $ab569b08130d91b3$var$decodeSignature(signature);
    var vrs = {
        v: $ab569b08130d91b3$var$bytesToNumber(vals[0]),
        r: vals[1].slice(2),
        s: vals[2].slice(2)
    };
    var ecPublicKey = $ab569b08130d91b3$var$secp256k1.recoverPubKey($ab569b08130d91b3$require$Buffer.from(hash.slice(2), "hex"), vrs, vrs.v < 2 ? vrs.v : 1 - vrs.v % 2);
    var publicKey = "0x" + ecPublicKey.encode("hex", false).slice(2);
    var publicHash = "0x" + (0, $84nWc.keccak256)((0, $jECMB.hexToBytes)(publicKey));
    return $ab569b08130d91b3$var$toChecksum("0x" + publicHash.slice(-40));
};
module.exports.recover = $ab569b08130d91b3$var$recover;

});
parcelRegister("7kgn0", function(module, exports) {
"use strict";
var $55571963976dc5f0$var$elliptic = module.exports;

$55571963976dc5f0$var$elliptic.version = (parcelRequire("iQA2x")).version;

$55571963976dc5f0$var$elliptic.utils = (parcelRequire("36pBX"));

$55571963976dc5f0$var$elliptic.rand = (parcelRequire("2iwIf"));

$55571963976dc5f0$var$elliptic.curve = (parcelRequire("44ON9"));

$55571963976dc5f0$var$elliptic.curves = (parcelRequire("izsNn"));

// Protocols
$55571963976dc5f0$var$elliptic.ec = (parcelRequire("1WfU3"));

$55571963976dc5f0$var$elliptic.eddsa = (parcelRequire("92zjz"));

});
parcelRegister("iQA2x", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("36pBX", function(module, exports) {
"use strict";
var $2425cc77e9f342ae$var$utils = module.exports;

var $lONYJ = parcelRequire("lONYJ");

var $i1Wrq = parcelRequire("i1Wrq");

var $fg9XS = parcelRequire("fg9XS");
$2425cc77e9f342ae$var$utils.assert = $i1Wrq;
$2425cc77e9f342ae$var$utils.toArray = $fg9XS.toArray;
$2425cc77e9f342ae$var$utils.zero2 = $fg9XS.zero2;
$2425cc77e9f342ae$var$utils.toHex = $fg9XS.toHex;
$2425cc77e9f342ae$var$utils.encode = $fg9XS.encode;
// Represent num in a w-NAF form
function $2425cc77e9f342ae$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$2425cc77e9f342ae$var$utils.getNAF = $2425cc77e9f342ae$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $2425cc77e9f342ae$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$2425cc77e9f342ae$var$utils.getJSF = $2425cc77e9f342ae$var$getJSF;
function $2425cc77e9f342ae$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$2425cc77e9f342ae$var$utils.cachedProperty = $2425cc77e9f342ae$var$cachedProperty;
function $2425cc77e9f342ae$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $2425cc77e9f342ae$var$utils.toArray(bytes, "hex") : bytes;
}
$2425cc77e9f342ae$var$utils.parseBytes = $2425cc77e9f342ae$var$parseBytes;
function $2425cc77e9f342ae$var$intFromLE(bytes) {
    return new $lONYJ(bytes, "hex", "le");
}
$2425cc77e9f342ae$var$utils.intFromLE = $2425cc77e9f342ae$var$intFromLE;

});
parcelRegister("i1Wrq", function(module, exports) {
module.exports = $d205a7337b0d47dd$var$assert;
function $d205a7337b0d47dd$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$d205a7337b0d47dd$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("fg9XS", function(module, exports) {
"use strict";
var $b1c0146f37a72dc0$var$utils = module.exports;
function $b1c0146f37a72dc0$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$b1c0146f37a72dc0$var$utils.toArray = $b1c0146f37a72dc0$var$toArray;
function $b1c0146f37a72dc0$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$b1c0146f37a72dc0$var$utils.zero2 = $b1c0146f37a72dc0$var$zero2;
function $b1c0146f37a72dc0$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $b1c0146f37a72dc0$var$zero2(msg[i].toString(16));
    return res;
}
$b1c0146f37a72dc0$var$utils.toHex = $b1c0146f37a72dc0$var$toHex;
$b1c0146f37a72dc0$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $b1c0146f37a72dc0$var$toHex(arr);
    else return arr;
};

});


parcelRegister("2iwIf", function(module, exports) {
var $1ac6a343ba01bd4f$var$r;
module.exports = function rand(len) {
    if (!$1ac6a343ba01bd4f$var$r) $1ac6a343ba01bd4f$var$r = new $1ac6a343ba01bd4f$var$Rand(null);
    return $1ac6a343ba01bd4f$var$r.generate(len);
};
function $1ac6a343ba01bd4f$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $1ac6a343ba01bd4f$var$Rand;
$1ac6a343ba01bd4f$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $1ac6a343ba01bd4f$var$crypto = (parcelRequire("foUwZ"));
    if (typeof $1ac6a343ba01bd4f$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
        return $1ac6a343ba01bd4f$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("44ON9", function(module, exports) {
"use strict";
var $2f7eef4f46648465$var$curve = module.exports;

$2f7eef4f46648465$var$curve.base = (parcelRequire("6dmRQ"));

$2f7eef4f46648465$var$curve.short = (parcelRequire("5aw4j"));

$2f7eef4f46648465$var$curve.mont = (parcelRequire("lkVI7"));

$2f7eef4f46648465$var$curve.edwards = (parcelRequire("9Luck"));

});
parcelRegister("6dmRQ", function(module, exports) {
"use strict";

var $lONYJ = parcelRequire("lONYJ");

var $36pBX = parcelRequire("36pBX");
var $4865b1fb7dacdcbc$var$getNAF = $36pBX.getNAF;
var $4865b1fb7dacdcbc$var$getJSF = $36pBX.getJSF;
var $4865b1fb7dacdcbc$var$assert = $36pBX.assert;
function $4865b1fb7dacdcbc$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $lONYJ(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $lONYJ.red(conf.prime) : $lONYJ.mont(this.p);
    // Useful for many curves
    this.zero = new $lONYJ(0).toRed(this.red);
    this.one = new $lONYJ(1).toRed(this.red);
    this.two = new $lONYJ(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $lONYJ(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $4865b1fb7dacdcbc$var$BaseCurve;
$4865b1fb7dacdcbc$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $4865b1fb7dacdcbc$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $4865b1fb7dacdcbc$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $4865b1fb7dacdcbc$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $4865b1fb7dacdcbc$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $4865b1fb7dacdcbc$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $4865b1fb7dacdcbc$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $4865b1fb7dacdcbc$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $4865b1fb7dacdcbc$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$4865b1fb7dacdcbc$var$BaseCurve.BasePoint = $4865b1fb7dacdcbc$var$BasePoint;
$4865b1fb7dacdcbc$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $36pBX.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $4865b1fb7dacdcbc$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $4865b1fb7dacdcbc$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $36pBX.encode(this._encode(compact), enc);
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("5aw4j", function(module, exports) {
"use strict";

var $36pBX = parcelRequire("36pBX");

var $lONYJ = parcelRequire("lONYJ");

var $ajIeE = parcelRequire("ajIeE");

var $6dmRQ = parcelRequire("6dmRQ");
var $3c36c310abdf7c1b$var$assert = $36pBX.assert;
function $3c36c310abdf7c1b$var$ShortCurve(conf) {
    $6dmRQ.call(this, "short", conf);
    this.a = new $lONYJ(conf.a, 16).toRed(this.red);
    this.b = new $lONYJ(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$ajIeE($3c36c310abdf7c1b$var$ShortCurve, $6dmRQ);
module.exports = $3c36c310abdf7c1b$var$ShortCurve;
$3c36c310abdf7c1b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $lONYJ(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $lONYJ(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $3c36c310abdf7c1b$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $lONYJ(vec.a, 16),
            b: new $lONYJ(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $lONYJ.mont(num);
    var tinv = new $lONYJ(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $lONYJ(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $lONYJ(1);
    var y1 = new $lONYJ(0);
    var x2 = new $lONYJ(0);
    var y2 = new $lONYJ(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$3c36c310abdf7c1b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $lONYJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$3c36c310abdf7c1b$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $3c36c310abdf7c1b$var$Point(curve, x, y, isRed) {
    $6dmRQ.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $lONYJ(x, 16);
        this.y = new $lONYJ(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$ajIeE($3c36c310abdf7c1b$var$Point, $6dmRQ.BasePoint);
$3c36c310abdf7c1b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $3c36c310abdf7c1b$var$Point(this, x, y, isRed);
};
$3c36c310abdf7c1b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $3c36c310abdf7c1b$var$Point.fromJSON(this, obj, red);
};
$3c36c310abdf7c1b$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$3c36c310abdf7c1b$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$3c36c310abdf7c1b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$3c36c310abdf7c1b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$3c36c310abdf7c1b$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$3c36c310abdf7c1b$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$3c36c310abdf7c1b$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$3c36c310abdf7c1b$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$3c36c310abdf7c1b$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$3c36c310abdf7c1b$var$Point.prototype.mul = function mul(k) {
    k = new $lONYJ(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$3c36c310abdf7c1b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$3c36c310abdf7c1b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$3c36c310abdf7c1b$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$3c36c310abdf7c1b$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$3c36c310abdf7c1b$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $3c36c310abdf7c1b$var$JPoint(curve, x, y, z) {
    $6dmRQ.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $lONYJ(0);
    } else {
        this.x = new $lONYJ(x, 16);
        this.y = new $lONYJ(y, 16);
        this.z = new $lONYJ(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$ajIeE($3c36c310abdf7c1b$var$JPoint, $6dmRQ.BasePoint);
$3c36c310abdf7c1b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $3c36c310abdf7c1b$var$JPoint(this, x, y, z);
};
$3c36c310abdf7c1b$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$3c36c310abdf7c1b$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$3c36c310abdf7c1b$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$3c36c310abdf7c1b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $lONYJ(k, kbase);
    return this.curve._wnafMul(this, k);
};
$3c36c310abdf7c1b$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$3c36c310abdf7c1b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$3c36c310abdf7c1b$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$3c36c310abdf7c1b$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});
parcelRegister("ajIeE", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("lkVI7", function(module, exports) {
"use strict";

var $lONYJ = parcelRequire("lONYJ");

var $ajIeE = parcelRequire("ajIeE");

var $6dmRQ = parcelRequire("6dmRQ");

var $36pBX = parcelRequire("36pBX");
function $f8883b579039ee41$var$MontCurve(conf) {
    $6dmRQ.call(this, "mont", conf);
    this.a = new $lONYJ(conf.a, 16).toRed(this.red);
    this.b = new $lONYJ(conf.b, 16).toRed(this.red);
    this.i4 = new $lONYJ(4).toRed(this.red).redInvm();
    this.two = new $lONYJ(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$ajIeE($f8883b579039ee41$var$MontCurve, $6dmRQ);
module.exports = $f8883b579039ee41$var$MontCurve;
$f8883b579039ee41$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $f8883b579039ee41$var$Point(curve, x, z) {
    $6dmRQ.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $lONYJ(x, 16);
        this.z = new $lONYJ(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$ajIeE($f8883b579039ee41$var$Point, $6dmRQ.BasePoint);
$f8883b579039ee41$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($36pBX.toArray(bytes, enc), 1);
};
$f8883b579039ee41$var$MontCurve.prototype.point = function point(x, z) {
    return new $f8883b579039ee41$var$Point(this, x, z);
};
$f8883b579039ee41$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $f8883b579039ee41$var$Point.fromJSON(this, obj);
};
$f8883b579039ee41$var$Point.prototype.precompute = function precompute() {
// No-op
};
$f8883b579039ee41$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$f8883b579039ee41$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $f8883b579039ee41$var$Point(curve, obj[0], obj[1] || curve.one);
};
$f8883b579039ee41$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$f8883b579039ee41$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$f8883b579039ee41$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$f8883b579039ee41$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$f8883b579039ee41$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$f8883b579039ee41$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$f8883b579039ee41$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$f8883b579039ee41$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$f8883b579039ee41$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$f8883b579039ee41$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$f8883b579039ee41$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("9Luck", function(module, exports) {
"use strict";

var $36pBX = parcelRequire("36pBX");

var $lONYJ = parcelRequire("lONYJ");

var $ajIeE = parcelRequire("ajIeE");

var $6dmRQ = parcelRequire("6dmRQ");
var $71bfed7d2474acbf$var$assert = $36pBX.assert;
function $71bfed7d2474acbf$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $6dmRQ.call(this, "edwards", conf);
    this.a = new $lONYJ(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $lONYJ(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $lONYJ(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $71bfed7d2474acbf$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$ajIeE($71bfed7d2474acbf$var$EdwardsCurve, $6dmRQ);
module.exports = $71bfed7d2474acbf$var$EdwardsCurve;
$71bfed7d2474acbf$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$71bfed7d2474acbf$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $lONYJ(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $lONYJ(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $71bfed7d2474acbf$var$Point(curve, x, y, z, t) {
    $6dmRQ.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $lONYJ(x, 16);
        this.y = new $lONYJ(y, 16);
        this.z = z ? new $lONYJ(z, 16) : this.curve.one;
        this.t = t && new $lONYJ(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$ajIeE($71bfed7d2474acbf$var$Point, $6dmRQ.BasePoint);
$71bfed7d2474acbf$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $71bfed7d2474acbf$var$Point.fromJSON(this, obj);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $71bfed7d2474acbf$var$Point(this, x, y, z, t);
};
$71bfed7d2474acbf$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $71bfed7d2474acbf$var$Point(curve, obj[0], obj[1], obj[2]);
};
$71bfed7d2474acbf$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$71bfed7d2474acbf$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$71bfed7d2474acbf$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$71bfed7d2474acbf$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$71bfed7d2474acbf$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$71bfed7d2474acbf$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$71bfed7d2474acbf$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$71bfed7d2474acbf$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$71bfed7d2474acbf$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$71bfed7d2474acbf$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$71bfed7d2474acbf$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$71bfed7d2474acbf$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$71bfed7d2474acbf$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$71bfed7d2474acbf$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$71bfed7d2474acbf$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$71bfed7d2474acbf$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$71bfed7d2474acbf$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$71bfed7d2474acbf$var$Point.prototype.toP = $71bfed7d2474acbf$var$Point.prototype.normalize;
$71bfed7d2474acbf$var$Point.prototype.mixedAdd = $71bfed7d2474acbf$var$Point.prototype.add;

});


parcelRegister("izsNn", function(module, exports) {
"use strict";
var $d851d50bfb4785eb$var$curves = module.exports;

var $dyCsH = parcelRequire("dyCsH");

var $44ON9 = parcelRequire("44ON9");

var $36pBX = parcelRequire("36pBX");
var $d851d50bfb4785eb$var$assert = $36pBX.assert;
function $d851d50bfb4785eb$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $44ON9.short(options);
    else if (options.type === "edwards") this.curve = new $44ON9.edwards(options);
    else this.curve = new $44ON9.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $d851d50bfb4785eb$var$assert(this.g.validate(), "Invalid curve");
    $d851d50bfb4785eb$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$d851d50bfb4785eb$var$curves.PresetCurve = $d851d50bfb4785eb$var$PresetCurve;
function $d851d50bfb4785eb$var$defineCurve(name, options) {
    Object.defineProperty($d851d50bfb4785eb$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $d851d50bfb4785eb$var$PresetCurve(options);
            Object.defineProperty($d851d50bfb4785eb$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$d851d50bfb4785eb$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $dyCsH.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $dyCsH.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$d851d50bfb4785eb$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$d851d50bfb4785eb$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $d851d50bfb4785eb$var$pre;

try {
    $d851d50bfb4785eb$var$pre = (parcelRequire("apL0e"));
} catch (e) {
    $d851d50bfb4785eb$var$pre = undefined;
}
$d851d50bfb4785eb$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $dyCsH.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $d851d50bfb4785eb$var$pre
    ]
});

});
parcelRegister("dyCsH", function(module, exports) {
var $9dec490f984e8399$var$hash = module.exports;

$9dec490f984e8399$var$hash.utils = (parcelRequire("47Ha9"));

$9dec490f984e8399$var$hash.common = (parcelRequire("dkCMM"));

$9dec490f984e8399$var$hash.sha = (parcelRequire("9KjOr"));

$9dec490f984e8399$var$hash.ripemd = (parcelRequire("6xYCQ"));

$9dec490f984e8399$var$hash.hmac = (parcelRequire("2W6lw"));
// Proxy hash functions to the main object
$9dec490f984e8399$var$hash.sha1 = $9dec490f984e8399$var$hash.sha.sha1;
$9dec490f984e8399$var$hash.sha256 = $9dec490f984e8399$var$hash.sha.sha256;
$9dec490f984e8399$var$hash.sha224 = $9dec490f984e8399$var$hash.sha.sha224;
$9dec490f984e8399$var$hash.sha384 = $9dec490f984e8399$var$hash.sha.sha384;
$9dec490f984e8399$var$hash.sha512 = $9dec490f984e8399$var$hash.sha.sha512;
$9dec490f984e8399$var$hash.ripemd160 = $9dec490f984e8399$var$hash.ripemd.ripemd160;

});
parcelRegister("47Ha9", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $30094c111d7673fd$export$69f1b2dcda23c5f8, (v) => $30094c111d7673fd$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $30094c111d7673fd$export$45b10814cc054894, (v) => $30094c111d7673fd$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $30094c111d7673fd$export$7ea66e3774a60b67, (v) => $30094c111d7673fd$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $30094c111d7673fd$export$34a52f00f601f6f1, (v) => $30094c111d7673fd$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $30094c111d7673fd$export$812b0cbd5e8a72ab, (v) => $30094c111d7673fd$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $30094c111d7673fd$export$f24f9e11d63bb314, (v) => $30094c111d7673fd$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $30094c111d7673fd$export$b71357c7e07ca1f1, (v) => $30094c111d7673fd$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $30094c111d7673fd$export$2e58a4b541fdcbe8, (v) => $30094c111d7673fd$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $30094c111d7673fd$export$183b950bde9faab8, (v) => $30094c111d7673fd$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $30094c111d7673fd$export$4785c77169fea59e, (v) => $30094c111d7673fd$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $30094c111d7673fd$export$242a185dfcffac5b, (v) => $30094c111d7673fd$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $30094c111d7673fd$export$58c04ae0ae31877d, (v) => $30094c111d7673fd$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $30094c111d7673fd$export$d058ca695f8c6f11, (v) => $30094c111d7673fd$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $30094c111d7673fd$export$a1efd7fc3e986367, (v) => $30094c111d7673fd$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $30094c111d7673fd$export$bbfea4a2b5abaab4, (v) => $30094c111d7673fd$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $30094c111d7673fd$export$97ad4afc7de86152, (v) => $30094c111d7673fd$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $30094c111d7673fd$export$ce4673d9a79f6a4b, (v) => $30094c111d7673fd$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $30094c111d7673fd$export$786cc99fc6eedc0b, (v) => $30094c111d7673fd$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $30094c111d7673fd$export$45c59b9a1848dd0, (v) => $30094c111d7673fd$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $30094c111d7673fd$export$50d8f613e76d3034, (v) => $30094c111d7673fd$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $30094c111d7673fd$export$b8e83683c60ee162, (v) => $30094c111d7673fd$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $30094c111d7673fd$export$aeeb51790d1bcc4a, (v) => $30094c111d7673fd$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $30094c111d7673fd$export$bb7c616f719ad9c, (v) => $30094c111d7673fd$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $30094c111d7673fd$export$4d63290824f9d7df, (v) => $30094c111d7673fd$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $30094c111d7673fd$export$2f64ceb90ef28ea1, (v) => $30094c111d7673fd$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $30094c111d7673fd$export$8d2089d465f6d10d, (v) => $30094c111d7673fd$export$8d2089d465f6d10d = v);
var $30094c111d7673fd$export$69f1b2dcda23c5f8;
var $30094c111d7673fd$export$45b10814cc054894;
var $30094c111d7673fd$export$7ea66e3774a60b67;
var $30094c111d7673fd$export$34a52f00f601f6f1;
var $30094c111d7673fd$export$812b0cbd5e8a72ab;
var $30094c111d7673fd$export$f24f9e11d63bb314;
var $30094c111d7673fd$export$b71357c7e07ca1f1;
var $30094c111d7673fd$export$2e58a4b541fdcbe8;
var $30094c111d7673fd$export$183b950bde9faab8;
var $30094c111d7673fd$export$4785c77169fea59e;
var $30094c111d7673fd$export$242a185dfcffac5b;
var $30094c111d7673fd$export$58c04ae0ae31877d;
var $30094c111d7673fd$export$d058ca695f8c6f11;
var $30094c111d7673fd$export$a1efd7fc3e986367;
var $30094c111d7673fd$export$bbfea4a2b5abaab4;
var $30094c111d7673fd$export$97ad4afc7de86152;
var $30094c111d7673fd$export$ce4673d9a79f6a4b;
var $30094c111d7673fd$export$786cc99fc6eedc0b;
var $30094c111d7673fd$export$45c59b9a1848dd0;
var $30094c111d7673fd$export$50d8f613e76d3034;
var $30094c111d7673fd$export$b8e83683c60ee162;
var $30094c111d7673fd$export$aeeb51790d1bcc4a;
var $30094c111d7673fd$export$bb7c616f719ad9c;
var $30094c111d7673fd$export$4d63290824f9d7df;
var $30094c111d7673fd$export$2f64ceb90ef28ea1;
var $30094c111d7673fd$export$8d2089d465f6d10d;
"use strict";

var $i1Wrq = parcelRequire("i1Wrq");

var $ajIeE = parcelRequire("ajIeE");
$30094c111d7673fd$export$69f1b2dcda23c5f8 = $ajIeE;
function $30094c111d7673fd$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $30094c111d7673fd$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($30094c111d7673fd$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$30094c111d7673fd$export$45b10814cc054894 = $30094c111d7673fd$var$toArray;
function $30094c111d7673fd$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $30094c111d7673fd$var$zero2(msg[i].toString(16));
    return res;
}
$30094c111d7673fd$export$7ea66e3774a60b67 = $30094c111d7673fd$var$toHex;
function $30094c111d7673fd$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$30094c111d7673fd$export$34a52f00f601f6f1 = $30094c111d7673fd$var$htonl;
function $30094c111d7673fd$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $30094c111d7673fd$var$htonl(w);
        res += $30094c111d7673fd$var$zero8(w.toString(16));
    }
    return res;
}
$30094c111d7673fd$export$812b0cbd5e8a72ab = $30094c111d7673fd$var$toHex32;
function $30094c111d7673fd$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$30094c111d7673fd$export$f24f9e11d63bb314 = $30094c111d7673fd$var$zero2;
function $30094c111d7673fd$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$30094c111d7673fd$export$b71357c7e07ca1f1 = $30094c111d7673fd$var$zero8;
function $30094c111d7673fd$var$join32(msg, start, end, endian) {
    var len = end - start;
    $i1Wrq(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$30094c111d7673fd$export$2e58a4b541fdcbe8 = $30094c111d7673fd$var$join32;
function $30094c111d7673fd$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$30094c111d7673fd$export$183b950bde9faab8 = $30094c111d7673fd$var$split32;
function $30094c111d7673fd$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$30094c111d7673fd$export$4785c77169fea59e = $30094c111d7673fd$var$rotr32;
function $30094c111d7673fd$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$30094c111d7673fd$export$242a185dfcffac5b = $30094c111d7673fd$var$rotl32;
function $30094c111d7673fd$var$sum32(a, b) {
    return a + b >>> 0;
}
$30094c111d7673fd$export$58c04ae0ae31877d = $30094c111d7673fd$var$sum32;
function $30094c111d7673fd$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$30094c111d7673fd$export$d058ca695f8c6f11 = $30094c111d7673fd$var$sum32_3;
function $30094c111d7673fd$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$30094c111d7673fd$export$a1efd7fc3e986367 = $30094c111d7673fd$var$sum32_4;
function $30094c111d7673fd$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$30094c111d7673fd$export$bbfea4a2b5abaab4 = $30094c111d7673fd$var$sum32_5;
function $30094c111d7673fd$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$30094c111d7673fd$export$97ad4afc7de86152 = $30094c111d7673fd$var$sum64;
function $30094c111d7673fd$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$30094c111d7673fd$export$ce4673d9a79f6a4b = $30094c111d7673fd$var$sum64_hi;
function $30094c111d7673fd$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$30094c111d7673fd$export$786cc99fc6eedc0b = $30094c111d7673fd$var$sum64_lo;
function $30094c111d7673fd$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$30094c111d7673fd$export$45c59b9a1848dd0 = $30094c111d7673fd$var$sum64_4_hi;
function $30094c111d7673fd$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$30094c111d7673fd$export$50d8f613e76d3034 = $30094c111d7673fd$var$sum64_4_lo;
function $30094c111d7673fd$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$30094c111d7673fd$export$b8e83683c60ee162 = $30094c111d7673fd$var$sum64_5_hi;
function $30094c111d7673fd$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$30094c111d7673fd$export$aeeb51790d1bcc4a = $30094c111d7673fd$var$sum64_5_lo;
function $30094c111d7673fd$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$30094c111d7673fd$export$bb7c616f719ad9c = $30094c111d7673fd$var$rotr64_hi;
function $30094c111d7673fd$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$30094c111d7673fd$export$4d63290824f9d7df = $30094c111d7673fd$var$rotr64_lo;
function $30094c111d7673fd$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$30094c111d7673fd$export$2f64ceb90ef28ea1 = $30094c111d7673fd$var$shr64_hi;
function $30094c111d7673fd$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$30094c111d7673fd$export$8d2089d465f6d10d = $30094c111d7673fd$var$shr64_lo;

});

parcelRegister("dkCMM", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $9b4b3aa5aeec247d$export$8687658379b577e6, (v) => $9b4b3aa5aeec247d$export$8687658379b577e6 = v);
var $9b4b3aa5aeec247d$export$8687658379b577e6;
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $i1Wrq = parcelRequire("i1Wrq");
function $9b4b3aa5aeec247d$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$9b4b3aa5aeec247d$export$8687658379b577e6 = $9b4b3aa5aeec247d$var$BlockHash;
$9b4b3aa5aeec247d$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $47Ha9.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $47Ha9.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$9b4b3aa5aeec247d$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $i1Wrq(this.pending === null);
    return this._digest(enc);
};
$9b4b3aa5aeec247d$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("9KjOr", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $7187c74c8c77d892$export$5091bdda49ba90f5, (v) => $7187c74c8c77d892$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $7187c74c8c77d892$export$97b70509d4e397ea, (v) => $7187c74c8c77d892$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $7187c74c8c77d892$export$bced8d2aada2d1c9, (v) => $7187c74c8c77d892$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $7187c74c8c77d892$export$612d47d55dedde45, (v) => $7187c74c8c77d892$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $7187c74c8c77d892$export$a888d2532e6dc7bb, (v) => $7187c74c8c77d892$export$a888d2532e6dc7bb = v);
var $7187c74c8c77d892$export$5091bdda49ba90f5;
var $7187c74c8c77d892$export$97b70509d4e397ea;
var $7187c74c8c77d892$export$bced8d2aada2d1c9;
var $7187c74c8c77d892$export$612d47d55dedde45;
var $7187c74c8c77d892$export$a888d2532e6dc7bb;
"use strict";

$7187c74c8c77d892$export$5091bdda49ba90f5 = (parcelRequire("fByOn"));

$7187c74c8c77d892$export$97b70509d4e397ea = (parcelRequire("dcRbx"));

$7187c74c8c77d892$export$bced8d2aada2d1c9 = (parcelRequire("dOBNm"));

$7187c74c8c77d892$export$612d47d55dedde45 = (parcelRequire("ayeNF"));

$7187c74c8c77d892$export$a888d2532e6dc7bb = (parcelRequire("9l5nO"));

});
parcelRegister("fByOn", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");

var $kPVmf = parcelRequire("kPVmf");
var $b5c5508adf6649f2$var$rotl32 = $47Ha9.rotl32;
var $b5c5508adf6649f2$var$sum32 = $47Ha9.sum32;
var $b5c5508adf6649f2$var$sum32_5 = $47Ha9.sum32_5;
var $b5c5508adf6649f2$var$ft_1 = $kPVmf.ft_1;
var $b5c5508adf6649f2$var$BlockHash = $dkCMM.BlockHash;
var $b5c5508adf6649f2$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $b5c5508adf6649f2$var$SHA1() {
    if (!(this instanceof $b5c5508adf6649f2$var$SHA1)) return new $b5c5508adf6649f2$var$SHA1();
    $b5c5508adf6649f2$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$47Ha9.inherits($b5c5508adf6649f2$var$SHA1, $b5c5508adf6649f2$var$BlockHash);
module.exports = $b5c5508adf6649f2$var$SHA1;
$b5c5508adf6649f2$var$SHA1.blockSize = 512;
$b5c5508adf6649f2$var$SHA1.outSize = 160;
$b5c5508adf6649f2$var$SHA1.hmacStrength = 80;
$b5c5508adf6649f2$var$SHA1.padLength = 64;
$b5c5508adf6649f2$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $b5c5508adf6649f2$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $b5c5508adf6649f2$var$sum32_5($b5c5508adf6649f2$var$rotl32(a, 5), $b5c5508adf6649f2$var$ft_1(s, b, c, d), e, W[i], $b5c5508adf6649f2$var$sha1_K[s]);
        e = d;
        d = c;
        c = $b5c5508adf6649f2$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $b5c5508adf6649f2$var$sum32(this.h[0], a);
    this.h[1] = $b5c5508adf6649f2$var$sum32(this.h[1], b);
    this.h[2] = $b5c5508adf6649f2$var$sum32(this.h[2], c);
    this.h[3] = $b5c5508adf6649f2$var$sum32(this.h[3], d);
    this.h[4] = $b5c5508adf6649f2$var$sum32(this.h[4], e);
};
$b5c5508adf6649f2$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "big");
    else return $47Ha9.split32(this.h, "big");
};

});
parcelRegister("kPVmf", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $f2b51028871b9afe$export$5a92649d7ddb9f63, (v) => $f2b51028871b9afe$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $f2b51028871b9afe$export$c6d0d020c3a6269, (v) => $f2b51028871b9afe$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $f2b51028871b9afe$export$eb90c27fca05f956, (v) => $f2b51028871b9afe$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $f2b51028871b9afe$export$14a4a98e063b1999, (v) => $f2b51028871b9afe$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $f2b51028871b9afe$export$d20cecfa1564c686, (v) => $f2b51028871b9afe$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $f2b51028871b9afe$export$44fd472a12fc6db, (v) => $f2b51028871b9afe$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $f2b51028871b9afe$export$1ed238bb6ea1dd47, (v) => $f2b51028871b9afe$export$1ed238bb6ea1dd47 = v);
var $f2b51028871b9afe$export$5a92649d7ddb9f63;
var $f2b51028871b9afe$export$c6d0d020c3a6269;
var $f2b51028871b9afe$export$eb90c27fca05f956;
var $f2b51028871b9afe$export$cc992891a14496a1;
var $f2b51028871b9afe$export$14a4a98e063b1999;
var $f2b51028871b9afe$export$d20cecfa1564c686;
var $f2b51028871b9afe$export$44fd472a12fc6db;
var $f2b51028871b9afe$export$1ed238bb6ea1dd47;
"use strict";

var $47Ha9 = parcelRequire("47Ha9");
var $f2b51028871b9afe$var$rotr32 = $47Ha9.rotr32;
function $f2b51028871b9afe$var$ft_1(s, x, y, z) {
    if (s === 0) return $f2b51028871b9afe$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $f2b51028871b9afe$var$p32(x, y, z);
    if (s === 2) return $f2b51028871b9afe$var$maj32(x, y, z);
}
$f2b51028871b9afe$export$5a92649d7ddb9f63 = $f2b51028871b9afe$var$ft_1;
function $f2b51028871b9afe$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$f2b51028871b9afe$export$c6d0d020c3a6269 = $f2b51028871b9afe$var$ch32;
function $f2b51028871b9afe$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$f2b51028871b9afe$export$eb90c27fca05f956 = $f2b51028871b9afe$var$maj32;
function $f2b51028871b9afe$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$f2b51028871b9afe$export$cc992891a14496a1 = $f2b51028871b9afe$var$p32;
function $f2b51028871b9afe$var$s0_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 2) ^ $f2b51028871b9afe$var$rotr32(x, 13) ^ $f2b51028871b9afe$var$rotr32(x, 22);
}
$f2b51028871b9afe$export$14a4a98e063b1999 = $f2b51028871b9afe$var$s0_256;
function $f2b51028871b9afe$var$s1_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 6) ^ $f2b51028871b9afe$var$rotr32(x, 11) ^ $f2b51028871b9afe$var$rotr32(x, 25);
}
$f2b51028871b9afe$export$d20cecfa1564c686 = $f2b51028871b9afe$var$s1_256;
function $f2b51028871b9afe$var$g0_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 7) ^ $f2b51028871b9afe$var$rotr32(x, 18) ^ x >>> 3;
}
$f2b51028871b9afe$export$44fd472a12fc6db = $f2b51028871b9afe$var$g0_256;
function $f2b51028871b9afe$var$g1_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 17) ^ $f2b51028871b9afe$var$rotr32(x, 19) ^ x >>> 10;
}
$f2b51028871b9afe$export$1ed238bb6ea1dd47 = $f2b51028871b9afe$var$g1_256;

});


parcelRegister("dcRbx", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dOBNm = parcelRequire("dOBNm");
function $99d5a6d1c0c2bec1$var$SHA224() {
    if (!(this instanceof $99d5a6d1c0c2bec1$var$SHA224)) return new $99d5a6d1c0c2bec1$var$SHA224();
    $dOBNm.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$47Ha9.inherits($99d5a6d1c0c2bec1$var$SHA224, $dOBNm);
module.exports = $99d5a6d1c0c2bec1$var$SHA224;
$99d5a6d1c0c2bec1$var$SHA224.blockSize = 512;
$99d5a6d1c0c2bec1$var$SHA224.outSize = 224;
$99d5a6d1c0c2bec1$var$SHA224.hmacStrength = 192;
$99d5a6d1c0c2bec1$var$SHA224.padLength = 64;
$99d5a6d1c0c2bec1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $47Ha9.toHex32(this.h.slice(0, 7), "big");
    else return $47Ha9.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("dOBNm", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");

var $kPVmf = parcelRequire("kPVmf");

var $i1Wrq = parcelRequire("i1Wrq");
var $a0ed43387f1c7a03$var$sum32 = $47Ha9.sum32;
var $a0ed43387f1c7a03$var$sum32_4 = $47Ha9.sum32_4;
var $a0ed43387f1c7a03$var$sum32_5 = $47Ha9.sum32_5;
var $a0ed43387f1c7a03$var$ch32 = $kPVmf.ch32;
var $a0ed43387f1c7a03$var$maj32 = $kPVmf.maj32;
var $a0ed43387f1c7a03$var$s0_256 = $kPVmf.s0_256;
var $a0ed43387f1c7a03$var$s1_256 = $kPVmf.s1_256;
var $a0ed43387f1c7a03$var$g0_256 = $kPVmf.g0_256;
var $a0ed43387f1c7a03$var$g1_256 = $kPVmf.g1_256;
var $a0ed43387f1c7a03$var$BlockHash = $dkCMM.BlockHash;
var $a0ed43387f1c7a03$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $a0ed43387f1c7a03$var$SHA256() {
    if (!(this instanceof $a0ed43387f1c7a03$var$SHA256)) return new $a0ed43387f1c7a03$var$SHA256();
    $a0ed43387f1c7a03$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $a0ed43387f1c7a03$var$sha256_K;
    this.W = new Array(64);
}
$47Ha9.inherits($a0ed43387f1c7a03$var$SHA256, $a0ed43387f1c7a03$var$BlockHash);
module.exports = $a0ed43387f1c7a03$var$SHA256;
$a0ed43387f1c7a03$var$SHA256.blockSize = 512;
$a0ed43387f1c7a03$var$SHA256.outSize = 256;
$a0ed43387f1c7a03$var$SHA256.hmacStrength = 192;
$a0ed43387f1c7a03$var$SHA256.padLength = 64;
$a0ed43387f1c7a03$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $a0ed43387f1c7a03$var$sum32_4($a0ed43387f1c7a03$var$g1_256(W[i - 2]), W[i - 7], $a0ed43387f1c7a03$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $i1Wrq(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $a0ed43387f1c7a03$var$sum32_5(h, $a0ed43387f1c7a03$var$s1_256(e), $a0ed43387f1c7a03$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $a0ed43387f1c7a03$var$sum32($a0ed43387f1c7a03$var$s0_256(a), $a0ed43387f1c7a03$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $a0ed43387f1c7a03$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $a0ed43387f1c7a03$var$sum32(T1, T2);
    }
    this.h[0] = $a0ed43387f1c7a03$var$sum32(this.h[0], a);
    this.h[1] = $a0ed43387f1c7a03$var$sum32(this.h[1], b);
    this.h[2] = $a0ed43387f1c7a03$var$sum32(this.h[2], c);
    this.h[3] = $a0ed43387f1c7a03$var$sum32(this.h[3], d);
    this.h[4] = $a0ed43387f1c7a03$var$sum32(this.h[4], e);
    this.h[5] = $a0ed43387f1c7a03$var$sum32(this.h[5], f);
    this.h[6] = $a0ed43387f1c7a03$var$sum32(this.h[6], g);
    this.h[7] = $a0ed43387f1c7a03$var$sum32(this.h[7], h);
};
$a0ed43387f1c7a03$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "big");
    else return $47Ha9.split32(this.h, "big");
};

});


parcelRegister("ayeNF", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $9l5nO = parcelRequire("9l5nO");
function $7ae88f57acc3df9f$var$SHA384() {
    if (!(this instanceof $7ae88f57acc3df9f$var$SHA384)) return new $7ae88f57acc3df9f$var$SHA384();
    $9l5nO.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$47Ha9.inherits($7ae88f57acc3df9f$var$SHA384, $9l5nO);
module.exports = $7ae88f57acc3df9f$var$SHA384;
$7ae88f57acc3df9f$var$SHA384.blockSize = 1024;
$7ae88f57acc3df9f$var$SHA384.outSize = 384;
$7ae88f57acc3df9f$var$SHA384.hmacStrength = 192;
$7ae88f57acc3df9f$var$SHA384.padLength = 128;
$7ae88f57acc3df9f$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h.slice(0, 12), "big");
    else return $47Ha9.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("9l5nO", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");

var $i1Wrq = parcelRequire("i1Wrq");
var $6cca402b55dff2d4$var$rotr64_hi = $47Ha9.rotr64_hi;
var $6cca402b55dff2d4$var$rotr64_lo = $47Ha9.rotr64_lo;
var $6cca402b55dff2d4$var$shr64_hi = $47Ha9.shr64_hi;
var $6cca402b55dff2d4$var$shr64_lo = $47Ha9.shr64_lo;
var $6cca402b55dff2d4$var$sum64 = $47Ha9.sum64;
var $6cca402b55dff2d4$var$sum64_hi = $47Ha9.sum64_hi;
var $6cca402b55dff2d4$var$sum64_lo = $47Ha9.sum64_lo;
var $6cca402b55dff2d4$var$sum64_4_hi = $47Ha9.sum64_4_hi;
var $6cca402b55dff2d4$var$sum64_4_lo = $47Ha9.sum64_4_lo;
var $6cca402b55dff2d4$var$sum64_5_hi = $47Ha9.sum64_5_hi;
var $6cca402b55dff2d4$var$sum64_5_lo = $47Ha9.sum64_5_lo;
var $6cca402b55dff2d4$var$BlockHash = $dkCMM.BlockHash;
var $6cca402b55dff2d4$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $6cca402b55dff2d4$var$SHA512() {
    if (!(this instanceof $6cca402b55dff2d4$var$SHA512)) return new $6cca402b55dff2d4$var$SHA512();
    $6cca402b55dff2d4$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $6cca402b55dff2d4$var$sha512_K;
    this.W = new Array(160);
}
$47Ha9.inherits($6cca402b55dff2d4$var$SHA512, $6cca402b55dff2d4$var$BlockHash);
module.exports = $6cca402b55dff2d4$var$SHA512;
$6cca402b55dff2d4$var$SHA512.blockSize = 1024;
$6cca402b55dff2d4$var$SHA512.outSize = 512;
$6cca402b55dff2d4$var$SHA512.hmacStrength = 192;
$6cca402b55dff2d4$var$SHA512.padLength = 128;
$6cca402b55dff2d4$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $6cca402b55dff2d4$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $6cca402b55dff2d4$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $6cca402b55dff2d4$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $6cca402b55dff2d4$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $6cca402b55dff2d4$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $6cca402b55dff2d4$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$6cca402b55dff2d4$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $i1Wrq(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $6cca402b55dff2d4$var$s1_512_hi(eh, el);
        var c1_lo = $6cca402b55dff2d4$var$s1_512_lo(eh, el);
        var c2_hi = $6cca402b55dff2d4$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $6cca402b55dff2d4$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $6cca402b55dff2d4$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $6cca402b55dff2d4$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $6cca402b55dff2d4$var$s0_512_hi(ah, al);
        c0_lo = $6cca402b55dff2d4$var$s0_512_lo(ah, al);
        c1_hi = $6cca402b55dff2d4$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $6cca402b55dff2d4$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $6cca402b55dff2d4$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $6cca402b55dff2d4$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $6cca402b55dff2d4$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $6cca402b55dff2d4$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $6cca402b55dff2d4$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $6cca402b55dff2d4$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $6cca402b55dff2d4$var$sum64(this.h, 0, ah, al);
    $6cca402b55dff2d4$var$sum64(this.h, 2, bh, bl);
    $6cca402b55dff2d4$var$sum64(this.h, 4, ch, cl);
    $6cca402b55dff2d4$var$sum64(this.h, 6, dh, dl);
    $6cca402b55dff2d4$var$sum64(this.h, 8, eh, el);
    $6cca402b55dff2d4$var$sum64(this.h, 10, fh, fl);
    $6cca402b55dff2d4$var$sum64(this.h, 12, gh, gl);
    $6cca402b55dff2d4$var$sum64(this.h, 14, hh, hl);
};
$6cca402b55dff2d4$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "big");
    else return $47Ha9.split32(this.h, "big");
};
function $6cca402b55dff2d4$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s0_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s0_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s1_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s1_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g0_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $6cca402b55dff2d4$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g0_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $6cca402b55dff2d4$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g1_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $6cca402b55dff2d4$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g1_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $6cca402b55dff2d4$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("6xYCQ", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $4c44da224496b72f$export$d1cea0ee4e3f0d3e, (v) => $4c44da224496b72f$export$d1cea0ee4e3f0d3e = v);
var $4c44da224496b72f$export$d1cea0ee4e3f0d3e;
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");
var $4c44da224496b72f$var$rotl32 = $47Ha9.rotl32;
var $4c44da224496b72f$var$sum32 = $47Ha9.sum32;
var $4c44da224496b72f$var$sum32_3 = $47Ha9.sum32_3;
var $4c44da224496b72f$var$sum32_4 = $47Ha9.sum32_4;
var $4c44da224496b72f$var$BlockHash = $dkCMM.BlockHash;
function $4c44da224496b72f$var$RIPEMD160() {
    if (!(this instanceof $4c44da224496b72f$var$RIPEMD160)) return new $4c44da224496b72f$var$RIPEMD160();
    $4c44da224496b72f$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$47Ha9.inherits($4c44da224496b72f$var$RIPEMD160, $4c44da224496b72f$var$BlockHash);
$4c44da224496b72f$export$d1cea0ee4e3f0d3e = $4c44da224496b72f$var$RIPEMD160;
$4c44da224496b72f$var$RIPEMD160.blockSize = 512;
$4c44da224496b72f$var$RIPEMD160.outSize = 160;
$4c44da224496b72f$var$RIPEMD160.hmacStrength = 192;
$4c44da224496b72f$var$RIPEMD160.padLength = 64;
$4c44da224496b72f$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $4c44da224496b72f$var$sum32($4c44da224496b72f$var$rotl32($4c44da224496b72f$var$sum32_4(A, $4c44da224496b72f$var$f(j, B, C, D), msg[$4c44da224496b72f$var$r[j] + start], $4c44da224496b72f$var$K(j)), $4c44da224496b72f$var$s[j]), E);
        A = E;
        E = D;
        D = $4c44da224496b72f$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $4c44da224496b72f$var$sum32($4c44da224496b72f$var$rotl32($4c44da224496b72f$var$sum32_4(Ah, $4c44da224496b72f$var$f(79 - j, Bh, Ch, Dh), msg[$4c44da224496b72f$var$rh[j] + start], $4c44da224496b72f$var$Kh(j)), $4c44da224496b72f$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $4c44da224496b72f$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $4c44da224496b72f$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $4c44da224496b72f$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $4c44da224496b72f$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $4c44da224496b72f$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $4c44da224496b72f$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$4c44da224496b72f$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "little");
    else return $47Ha9.split32(this.h, "little");
};
function $4c44da224496b72f$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $4c44da224496b72f$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $4c44da224496b72f$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $4c44da224496b72f$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4c44da224496b72f$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4c44da224496b72f$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4c44da224496b72f$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("2W6lw", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $i1Wrq = parcelRequire("i1Wrq");
function $2235ebc0e5a6911c$var$Hmac(hash, key, enc) {
    if (!(this instanceof $2235ebc0e5a6911c$var$Hmac)) return new $2235ebc0e5a6911c$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($47Ha9.toArray(key, enc));
}
module.exports = $2235ebc0e5a6911c$var$Hmac;
$2235ebc0e5a6911c$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $i1Wrq(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$2235ebc0e5a6911c$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$2235ebc0e5a6911c$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("apL0e", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("1WfU3", function(module, exports) {
"use strict";

var $lONYJ = parcelRequire("lONYJ");

var $ceJ7V = parcelRequire("ceJ7V");

var $36pBX = parcelRequire("36pBX");

var $izsNn = parcelRequire("izsNn");

var $2iwIf = parcelRequire("2iwIf");
var $16978b404b64dbd7$var$assert = $36pBX.assert;

var $jI9Ts = parcelRequire("jI9Ts");

var $3OEw3 = parcelRequire("3OEw3");
function $16978b404b64dbd7$var$EC(options) {
    if (!(this instanceof $16978b404b64dbd7$var$EC)) return new $16978b404b64dbd7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $16978b404b64dbd7$var$assert(Object.prototype.hasOwnProperty.call($izsNn, options), "Unknown curve " + options);
        options = $izsNn[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $izsNn.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $16978b404b64dbd7$var$EC;
$16978b404b64dbd7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $jI9Ts(this, options);
};
$16978b404b64dbd7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $jI9Ts.fromPrivate(this, priv, enc);
};
$16978b404b64dbd7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $jI9Ts.fromPublic(this, pub, enc);
};
$16978b404b64dbd7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $ceJ7V({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $2iwIf(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $lONYJ(2));
    for(;;){
        var priv = new $lONYJ(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$16978b404b64dbd7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$16978b404b64dbd7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $lONYJ(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $ceJ7V({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $lONYJ(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $lONYJ(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3OEw3({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$16978b404b64dbd7$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $lONYJ(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $3OEw3(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$16978b404b64dbd7$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $16978b404b64dbd7$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $3OEw3(signature, enc);
    var n = this.n;
    var e = new $lONYJ(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$16978b404b64dbd7$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3OEw3(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("ceJ7V", function(module, exports) {
"use strict";

var $dyCsH = parcelRequire("dyCsH");

var $fg9XS = parcelRequire("fg9XS");

var $i1Wrq = parcelRequire("i1Wrq");
function $8e89cc172437d525$var$HmacDRBG(options) {
    if (!(this instanceof $8e89cc172437d525$var$HmacDRBG)) return new $8e89cc172437d525$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $fg9XS.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $fg9XS.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $fg9XS.toArray(options.pers, options.persEnc || "hex");
    $i1Wrq(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $8e89cc172437d525$var$HmacDRBG;
$8e89cc172437d525$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$8e89cc172437d525$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $dyCsH.hmac(this.hash, this.K);
};
$8e89cc172437d525$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$8e89cc172437d525$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $fg9XS.toArray(entropy, entropyEnc);
    add = $fg9XS.toArray(add, addEnc);
    $i1Wrq(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$8e89cc172437d525$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $fg9XS.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $fg9XS.encode(res, enc);
};

});

parcelRegister("jI9Ts", function(module, exports) {
"use strict";

var $lONYJ = parcelRequire("lONYJ");

var $36pBX = parcelRequire("36pBX");
var $e599cd09ab6c1c14$var$assert = $36pBX.assert;
function $e599cd09ab6c1c14$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $e599cd09ab6c1c14$var$KeyPair;
$e599cd09ab6c1c14$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $e599cd09ab6c1c14$var$KeyPair) return pub;
    return new $e599cd09ab6c1c14$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$e599cd09ab6c1c14$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $e599cd09ab6c1c14$var$KeyPair) return priv;
    return new $e599cd09ab6c1c14$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$e599cd09ab6c1c14$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$e599cd09ab6c1c14$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$e599cd09ab6c1c14$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$e599cd09ab6c1c14$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $lONYJ(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$e599cd09ab6c1c14$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $e599cd09ab6c1c14$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $e599cd09ab6c1c14$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$e599cd09ab6c1c14$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $e599cd09ab6c1c14$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$e599cd09ab6c1c14$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$e599cd09ab6c1c14$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$e599cd09ab6c1c14$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("3OEw3", function(module, exports) {
"use strict";

var $lONYJ = parcelRequire("lONYJ");

var $36pBX = parcelRequire("36pBX");
var $2c75783bdfa2c803$var$assert = $36pBX.assert;
function $2c75783bdfa2c803$var$Signature(options, enc) {
    if (options instanceof $2c75783bdfa2c803$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2c75783bdfa2c803$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $lONYJ(options.r, 16);
    this.s = new $lONYJ(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2c75783bdfa2c803$var$Signature;
function $2c75783bdfa2c803$var$Position() {
    this.place = 0;
}
function $2c75783bdfa2c803$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2c75783bdfa2c803$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2c75783bdfa2c803$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $36pBX.toArray(data, enc);
    var p = new $2c75783bdfa2c803$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2c75783bdfa2c803$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2c75783bdfa2c803$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2c75783bdfa2c803$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $lONYJ(r);
    this.s = new $lONYJ(s);
    this.recoveryParam = null;
    return true;
};
function $2c75783bdfa2c803$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2c75783bdfa2c803$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2c75783bdfa2c803$var$rmPadding(r);
    s = $2c75783bdfa2c803$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2c75783bdfa2c803$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2c75783bdfa2c803$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2c75783bdfa2c803$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $36pBX.encode(res, enc);
};

});


parcelRegister("92zjz", function(module, exports) {
"use strict";

var $dyCsH = parcelRequire("dyCsH");

var $izsNn = parcelRequire("izsNn");

var $36pBX = parcelRequire("36pBX");
var $694fb1b2156dae42$var$assert = $36pBX.assert;
var $694fb1b2156dae42$var$parseBytes = $36pBX.parseBytes;

var $4yLDU = parcelRequire("4yLDU");

var $eydmk = parcelRequire("eydmk");
function $694fb1b2156dae42$var$EDDSA(curve) {
    $694fb1b2156dae42$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $694fb1b2156dae42$var$EDDSA)) return new $694fb1b2156dae42$var$EDDSA(curve);
    curve = $izsNn[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $dyCsH.sha512;
}
module.exports = $694fb1b2156dae42$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $694fb1b2156dae42$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $694fb1b2156dae42$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $694fb1b2156dae42$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $694fb1b2156dae42$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$694fb1b2156dae42$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $36pBX.intFromLE(hash.digest()).umod(this.curve.n);
};
$694fb1b2156dae42$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $4yLDU.fromPublic(this, pub);
};
$694fb1b2156dae42$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $4yLDU.fromSecret(this, secret);
};
$694fb1b2156dae42$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $eydmk) return sig;
    return new $eydmk(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $694fb1b2156dae42$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$694fb1b2156dae42$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $36pBX.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $36pBX.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$694fb1b2156dae42$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$694fb1b2156dae42$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $36pBX.intFromLE(bytes);
};
$694fb1b2156dae42$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("4yLDU", function(module, exports) {
"use strict";

var $36pBX = parcelRequire("36pBX");
var $351f4b3a682f8cc4$var$assert = $36pBX.assert;
var $351f4b3a682f8cc4$var$parseBytes = $36pBX.parseBytes;
var $351f4b3a682f8cc4$var$cachedProperty = $36pBX.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $351f4b3a682f8cc4$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $351f4b3a682f8cc4$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $351f4b3a682f8cc4$var$parseBytes(params.pub);
}
$351f4b3a682f8cc4$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $351f4b3a682f8cc4$var$KeyPair) return pub;
    return new $351f4b3a682f8cc4$var$KeyPair(eddsa, {
        pub: pub
    });
};
$351f4b3a682f8cc4$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $351f4b3a682f8cc4$var$KeyPair) return secret;
    return new $351f4b3a682f8cc4$var$KeyPair(eddsa, {
        secret: secret
    });
};
$351f4b3a682f8cc4$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$351f4b3a682f8cc4$var$KeyPair.prototype.sign = function sign(message) {
    $351f4b3a682f8cc4$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$351f4b3a682f8cc4$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$351f4b3a682f8cc4$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $351f4b3a682f8cc4$var$assert(this._secret, "KeyPair is public only");
    return $36pBX.encode(this.secret(), enc);
};
$351f4b3a682f8cc4$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $36pBX.encode(this.pubBytes(), enc);
};
module.exports = $351f4b3a682f8cc4$var$KeyPair;

});

parcelRegister("eydmk", function(module, exports) {
"use strict";

var $lONYJ = parcelRequire("lONYJ");

var $36pBX = parcelRequire("36pBX");
var $a97e9a82228c997a$var$assert = $36pBX.assert;
var $a97e9a82228c997a$var$cachedProperty = $36pBX.cachedProperty;
var $a97e9a82228c997a$var$parseBytes = $36pBX.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $a97e9a82228c997a$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $a97e9a82228c997a$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $a97e9a82228c997a$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $lONYJ) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$a97e9a82228c997a$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$a97e9a82228c997a$var$Signature.prototype.toHex = function toHex() {
    return $36pBX.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $a97e9a82228c997a$var$Signature;

});





parcelRegister("1Avfp", function(module, exports) {
"use strict";
var $1281645d7639d00d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1281645d7639d00d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1281645d7639d00d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1281645d7639d00d$var$__createBinding(result, mod, k);
    }
    $1281645d7639d00d$var$__setModuleDefault(result, mod);
    return result;
};
var $1281645d7639d00d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1281645d7639d00d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1281645d7639d00d$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1281645d7639d00d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hRv97 = parcelRequire("hRv97");

var $1281645d7639d00d$var$configurationError_1 = $1281645d7639d00d$var$__importDefault((parcelRequire("6yp4P")));


var $jECMB = parcelRequire("jECMB");

var $1281645d7639d00d$var$FetchProvider_1 = $1281645d7639d00d$var$__importDefault((parcelRequire("2rLlp")));

var $1281645d7639d00d$var$EthereumContract_1 = $1281645d7639d00d$var$__importDefault((parcelRequire("eZ6xg")));

var $1281645d7639d00d$var$proxyReader_1 = $1281645d7639d00d$var$__importDefault((parcelRequire("gsc1u")));

var $1281645d7639d00d$var$uns_config_json_1 = $1281645d7639d00d$var$__importDefault((parcelRequire("4ZZTu")));

var $1281645d7639d00d$var$resolutionError_1 = $1281645d7639d00d$var$__importStar((parcelRequire("anKpg")));

var $bPRni = parcelRequire("bPRni");
var $1281645d7639d00d$var$UnsInternal = /** @class */ function() {
    function UnsInternal(unsLocation, source, blockchain) {
        this.unsLocation = unsLocation;
        this.checkNetworkConfig(unsLocation, source);
        this.network = source.network;
        this.blockchain = blockchain;
        this.url = source["url"] || UnsInternal.UrlMap[this.network];
        this.provider = source["provider"] || new $1281645d7639d00d$var$FetchProvider_1.default(this.unsLocation, this.url);
        this.readerContract = new $1281645d7639d00d$var$EthereumContract_1.default($1281645d7639d00d$var$proxyReader_1.default, source.proxyReaderAddress || UnsInternal.ProxyReaderMap[$jECMB.EthereumNetworks[this.network]], this.provider);
    }
    UnsInternal.prototype.exists = function(domain) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var exists;
            return $1281645d7639d00d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.readerContract.call("exists", [
                                this.namehash(domain)
                            ])
                        ];
                    case 1:
                        exists = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            exists
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.reverseOf = function(addr) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var reverseHash;
            return $1281645d7639d00d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.readerContract.call("reverseOf", [
                                addr
                            ])
                        ];
                    case 1:
                        reverseHash = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            reverseHash
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.getTokenUri = function(tokenId) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var tokenURI;
            return $1281645d7639d00d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.readerContract.call("tokenURI", [
                                tokenId
                            ])
                        ];
                    case 1:
                        tokenURI = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            tokenURI
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.registryAddress = function(domainOrNamehash) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var isNamehash, namehash, address;
            return $1281645d7639d00d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        isNamehash = !domainOrNamehash.includes(".");
                        if (!this.checkDomain(domainOrNamehash, isNamehash)) throw new $1281645d7639d00d$var$resolutionError_1.default($1281645d7639d00d$var$resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
                            domain: domainOrNamehash
                        });
                        namehash = isNamehash ? domainOrNamehash : this.namehash(domainOrNamehash);
                        return [
                            4 /*yield*/ ,
                            this.readerContract.call("registryOf", [
                                namehash
                            ])
                        ];
                    case 1:
                        address = _a.sent()[0];
                        if ((0, $jECMB.isNullAddress)(address)) throw new $1281645d7639d00d$var$resolutionError_1.default($1281645d7639d00d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domainOrNamehash
                        });
                        return [
                            2 /*return*/ ,
                            address
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.resolver = function(domain) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            return $1281645d7639d00d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getVerifiedData(domain)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent().resolver
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.get = function(tokenId, keys) {
        if (keys === void 0) keys = [];
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var _a, resolver, owner, values;
            return $1281645d7639d00d$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.readerContract.call("getData", [
                                keys,
                                tokenId
                            ])
                        ];
                    case 1:
                        _a = _b.sent(), resolver = _a[0], owner = _a[1], values = _a[2];
                        return [
                            2 /*return*/ ,
                            {
                                owner: owner,
                                resolver: resolver,
                                records: (0, $jECMB.constructRecords)(keys, values),
                                location: this.unsLocation
                            }
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.locations = function(domains) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var tokenIds, _a, _b, resolvers, owners, registries, locations;
            var _this = this;
            return $1281645d7639d00d$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        tokenIds = domains.map(function(d) {
                            return _this.namehash(d);
                        });
                        return [
                            4 /*yield*/ ,
                            this.readerContract.multicall($1281645d7639d00d$var$__spreadArray([
                                {
                                    method: "getDataForMany",
                                    args: [
                                        [],
                                        tokenIds
                                    ]
                                }
                            ], tokenIds.map(function(id) {
                                return {
                                    method: "registryOf",
                                    args: [
                                        id
                                    ]
                                };
                            }), true))
                        ];
                    case 1:
                        _a = _c.sent(), _b = _a[0], resolvers = _b[0], owners = _b[1], registries = _a.slice(1);
                        locations = domains.reduce(function(locations, domain, i) {
                            locations[domain] = null;
                            if (owners && owners[i] !== $hRv97.NullAddress) locations[domain] = {
                                resolverAddress: resolvers[i],
                                registryAddress: registries[i][0],
                                ownerAddress: owners[i],
                                networkId: $jECMB.EthereumNetworks[_this.network],
                                blockchain: _this.blockchain,
                                blockchainProviderUrl: _this.url
                            };
                            return locations;
                        }, {});
                        return [
                            2 /*return*/ ,
                            locations
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.namehash = function(domain) {
        if (!this.checkDomain(domain)) throw new $1281645d7639d00d$var$resolutionError_1.default($1281645d7639d00d$var$resolutionError_1.ResolutionErrorCode.UnsupportedDomain, {
            domain: domain
        });
        return (0, $bPRni.eip137Namehash)(domain);
    };
    UnsInternal.prototype.checkDomain = function(domain, passIfTokenID) {
        if (passIfTokenID === void 0) passIfTokenID = false;
        if (passIfTokenID) return true;
        var tokens = domain.split(".");
        return !!tokens.length && !(domain === "eth" || /^[^-]*[^-]*\.(eth|luxe|xyz|kred|addr\.reverse)$/.test(domain)) && tokens.every(function(v) {
            return !!v.length;
        });
    };
    UnsInternal.prototype.getVerifiedData = function(domain, keys) {
        return $1281645d7639d00d$var$__awaiter(this, void 0, void 0, function() {
            var tokenId, data;
            return $1281645d7639d00d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenId = this.namehash(domain);
                        return [
                            4 /*yield*/ ,
                            this.get(tokenId, keys)
                        ];
                    case 1:
                        data = _a.sent();
                        if ((0, $jECMB.isNullAddress)(data.resolver)) {
                            if ((0, $jECMB.isNullAddress)(data.owner)) throw new $1281645d7639d00d$var$resolutionError_1.default($1281645d7639d00d$var$resolutionError_1.ResolutionErrorCode.UnregisteredDomain, {
                                domain: domain
                            });
                            throw new $1281645d7639d00d$var$resolutionError_1.default($1281645d7639d00d$var$resolutionError_1.ResolutionErrorCode.UnspecifiedResolver, {
                                location: this.unsLocation,
                                domain: domain
                            });
                        }
                        return [
                            2 /*return*/ ,
                            data
                        ];
                }
            });
        });
    };
    UnsInternal.prototype.checkNetworkConfig = function(location, source) {
        if (!source.network) throw new $1281645d7639d00d$var$configurationError_1.default((parcelRequire("6yp4P")).ConfigurationErrorCode.UnsupportedNetwork, {
            method: location
        });
        if (source.proxyReaderAddress && !this.isValidProxyReader(source.proxyReaderAddress)) throw new $1281645d7639d00d$var$configurationError_1.default((parcelRequire("6yp4P")).ConfigurationErrorCode.InvalidConfigurationField, {
            method: this.unsLocation,
            field: "proxyReaderAddress"
        });
        if (!$hRv97.UnsSupportedNetwork.guard(source.network)) this.checkCustomNetworkConfig(source);
    };
    UnsInternal.prototype.checkCustomNetworkConfig = function(source) {
        if (!this.isValidProxyReader(source.proxyReaderAddress)) throw new $1281645d7639d00d$var$configurationError_1.default((parcelRequire("6yp4P")).ConfigurationErrorCode.InvalidConfigurationField, {
            method: this.unsLocation,
            field: "proxyReaderAddress"
        });
        if (!source["url"] && !source["provider"]) throw new $1281645d7639d00d$var$configurationError_1.default((parcelRequire("6yp4P")).ConfigurationErrorCode.CustomNetworkConfigMissing, {
            method: this.unsLocation,
            config: "url or provider"
        });
    };
    UnsInternal.prototype.isValidProxyReader = function(address) {
        if (!address) throw new $1281645d7639d00d$var$configurationError_1.default((parcelRequire("6yp4P")).ConfigurationErrorCode.CustomNetworkConfigMissing, {
            method: this.unsLocation,
            config: "proxyReaderAddress"
        });
        var ethLikePattern = new RegExp("^0x[a-fA-F0-9]{40}$");
        return ethLikePattern.test(address);
    };
    UnsInternal.ProxyReaderMap = $1281645d7639d00d$var$getProxyReaderMap();
    UnsInternal.UrlMap = {
        mainnet: "https://mainnet.infura.io/v3/c4bb906ed6904c42b19c95825fe55f39",
        rinkeby: "https://eth-rinkeby.alchemyapi.io/v2/ZDERxOLIj120dh2-Io2Q9RTh9RfWEssT",
        goerli: "https://goerli.infura.io/v3/c4bb906ed6904c42b19c95825fe55f39",
        "polygon-mainnet": "https://polygon-mainnet.infura.io/v3/c4bb906ed6904c42b19c95825fe55f39",
        "polygon-mumbai": "https://polygon-mumbai.infura.io/v3/c4bb906ed6904c42b19c95825fe55f39"
    };
    return UnsInternal;
}();
module.exports.default = $1281645d7639d00d$var$UnsInternal;
function $1281645d7639d00d$var$getProxyReaderMap() {
    var map = {};
    for(var _i = 0, _a = Object.keys($1281645d7639d00d$var$uns_config_json_1.default.networks); _i < _a.length; _i++){
        var id = _a[_i];
        map[id] = $1281645d7639d00d$var$uns_config_json_1.default.networks[id].contracts.ProxyReader.address.toLowerCase();
    }
    return map;
}

});
parcelRegister("eZ6xg", function(module, exports) {
"use strict";
var $ae8bd4fcd2f5b096$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ae8bd4fcd2f5b096$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9sdVO = parcelRequire("9sdVO");
var $ae8bd4fcd2f5b096$var$EthereumContract = /** @class */ function() {
    function EthereumContract(abi, address, provider) {
        this.abi = abi;
        this.address = address;
        this.provider = provider;
        this.coder = new $9sdVO.Interface(this.abi);
    }
    EthereumContract.prototype.call = function(method, args) {
        return $ae8bd4fcd2f5b096$var$__awaiter(this, void 0, void 0, function() {
            var inputParam, response;
            return $ae8bd4fcd2f5b096$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        inputParam = this.coder.encodeFunctionData(method, args);
                        return [
                            4 /*yield*/ ,
                            this.callEth(inputParam)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response || response === "0x") return [
                            2 /*return*/ ,
                            []
                        ];
                        return [
                            2 /*return*/ ,
                            this.coder.decodeFunctionResult(method, response)
                        ];
                }
            });
        });
    };
    EthereumContract.prototype.multicall = function(callArgs) {
        return $ae8bd4fcd2f5b096$var$__awaiter(this, void 0, void 0, function() {
            var methods, _i, callArgs_1, call, inputParam, response, multicallResult, results, i;
            return $ae8bd4fcd2f5b096$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        methods = [];
                        for(_i = 0, callArgs_1 = callArgs; _i < callArgs_1.length; _i++){
                            call = callArgs_1[_i];
                            methods.push(this.coder.encodeFunctionData(call.method, call.args));
                        }
                        inputParam = this.coder.encodeFunctionData("multicall", [
                            methods
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.callEth(inputParam)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response || response === "0x") return [
                            2 /*return*/ ,
                            []
                        ];
                        multicallResult = this.coder.decodeFunctionResult("multicall", response);
                        results = [];
                        for(i = 0; i < multicallResult.results.length; i++)results.push(this.coder.decodeFunctionResult(callArgs[i].method, multicallResult.results[i]));
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    EthereumContract.prototype.fetchLogs = function(eventName, tokenId, fromBlock) {
        if (fromBlock === void 0) fromBlock = "earliest";
        return $ae8bd4fcd2f5b096$var$__awaiter(this, void 0, void 0, function() {
            var topic, params, request;
            return $ae8bd4fcd2f5b096$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        topic = this.coder.getEventTopic(eventName);
                        params = [
                            {
                                fromBlock: fromBlock,
                                toBlock: "latest",
                                address: this.address,
                                topics: [
                                    topic,
                                    tokenId
                                ]
                            }
                        ];
                        request = {
                            method: "eth_getLogs",
                            params: params
                        };
                        return [
                            4 /*yield*/ ,
                            this.provider.request(request)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    EthereumContract.prototype.callEth = function(data) {
        return $ae8bd4fcd2f5b096$var$__awaiter(this, void 0, void 0, function() {
            var params, request;
            return $ae8bd4fcd2f5b096$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        params = [
                            {
                                data: data,
                                to: this.address
                            },
                            "latest"
                        ];
                        request = {
                            method: "eth_call",
                            params: params
                        };
                        return [
                            4 /*yield*/ ,
                            this.provider.request(request)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return EthereumContract;
}();
module.exports.default = $ae8bd4fcd2f5b096$var$EthereumContract;

});
parcelRegister("9sdVO", function(module, exports) {

$parcel$export(module.exports, "Interface", () => $6e21891002e7f2f8$export$48cefb51a4e315b2);

var $81UJJ = parcelRequire("81UJJ");

var $3HDBd = parcelRequire("3HDBd");

var $2Zz8l = parcelRequire("2Zz8l");

var $6VDHX = parcelRequire("6VDHX");

var $Jhr88 = parcelRequire("Jhr88");

var $cj2Wy = parcelRequire("cj2Wy");

var $9p0py = parcelRequire("9p0py");


var $cidoA = parcelRequire("cidoA");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $8B4xQ = parcelRequire("8B4xQ");
"use strict";
const $6e21891002e7f2f8$var$logger = new (0, $l1ZqZ.Logger)((0, $8B4xQ.version));
class $6e21891002e7f2f8$export$c2ab6499be98b3c5 extends (0, $cj2Wy.Description) {
}
class $6e21891002e7f2f8$export$7a3223b0fadb690b extends (0, $cj2Wy.Description) {
}
class $6e21891002e7f2f8$export$cfba08fc0e40e2ab extends (0, $cj2Wy.Description) {
}
class $6e21891002e7f2f8$export$8ef99100a3c56f8c extends (0, $cj2Wy.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $6e21891002e7f2f8$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $6e21891002e7f2f8$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $6e21891002e7f2f8$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $cj2Wy.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $cidoA.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $cj2Wy.defineReadOnly)(this, "_abiCoder", (0, $cj2Wy.getStatic)(new.target, "getAbiCoder")());
        (0, $cj2Wy.defineReadOnly)(this, "functions", {});
        (0, $cj2Wy.defineReadOnly)(this, "errors", {});
        (0, $cj2Wy.defineReadOnly)(this, "events", {});
        (0, $cj2Wy.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $6e21891002e7f2f8$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $cj2Wy.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $6e21891002e7f2f8$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $cj2Wy.defineReadOnly)(this, "deploy", (0, $cidoA.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $cj2Wy.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $cidoA.FormatTypes).full;
        if (format === (0, $cidoA.FormatTypes).sighash) $6e21891002e7f2f8$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $cidoA.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $9p0py.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $81UJJ.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $2Zz8l.hexDataSlice)((0, $6VDHX.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $6VDHX.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $2Zz8l.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $6e21891002e7f2f8$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6e21891002e7f2f8$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $6e21891002e7f2f8$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $cidoA.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6e21891002e7f2f8$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $2Zz8l.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $6e21891002e7f2f8$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6e21891002e7f2f8$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $6e21891002e7f2f8$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $cidoA.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $6e21891002e7f2f8$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $2Zz8l.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $cj2Wy.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $6e21891002e7f2f8$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6e21891002e7f2f8$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $6e21891002e7f2f8$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $cidoA.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6e21891002e7f2f8$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $cj2Wy.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $cj2Wy.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $2Zz8l.arrayify)(data);
        if ((0, $2Zz8l.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $6e21891002e7f2f8$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $2Zz8l.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $2Zz8l.hexlify)((0, $2Zz8l.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $2Zz8l.arrayify)(data);
        if ((0, $2Zz8l.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $6e21891002e7f2f8$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $2Zz8l.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $2Zz8l.hexlify)((0, $2Zz8l.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $2Zz8l.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $2Zz8l.hexlify)(bytes.slice(0, 4));
                    const builtin = $6e21891002e7f2f8$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $6e21891002e7f2f8$var$logger.throwError("call revert exception" + message, (0, $l1ZqZ.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $2Zz8l.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $2Zz8l.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $6e21891002e7f2f8$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $l1ZqZ.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $6VDHX.id)(value);
            else if (param.type === "bytes") return (0, $Jhr88.keccak256)((0, $2Zz8l.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $3HDBd.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $2Zz8l.hexZeroPad)((0, $2Zz8l.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $6e21891002e7f2f8$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $6e21891002e7f2f8$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $6e21891002e7f2f8$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $6VDHX.id)(value));
                else if (param.type === "bytes") topics.push((0, $Jhr88.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $2Zz8l.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $6e21891002e7f2f8$var$logger.throwError("fragment/topic mismatch", (0, $l1ZqZ.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $cidoA.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $2Zz8l.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $6e21891002e7f2f8$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $6e21891002e7f2f8$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $6e21891002e7f2f8$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $6e21891002e7f2f8$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6e21891002e7f2f8$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $3HDBd.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $6e21891002e7f2f8$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $2Zz8l.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6e21891002e7f2f8$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("81UJJ", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $5d8a6d6ebd6b6bfd$export$88411125f012957a);

var $2Zz8l = parcelRequire("2Zz8l");

var $3HDBd = parcelRequire("3HDBd");

var $Jhr88 = parcelRequire("Jhr88");

var $1iei8 = parcelRequire("1iei8");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $eFlRV = parcelRequire("eFlRV");
"use strict";
const $5d8a6d6ebd6b6bfd$var$logger = new (0, $l1ZqZ.Logger)((0, $eFlRV.version));
function $5d8a6d6ebd6b6bfd$var$getChecksumAddress(address) {
    if (!(0, $2Zz8l.isHexString)(address, 20)) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $2Zz8l.arrayify)((0, $Jhr88.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $5d8a6d6ebd6b6bfd$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5d8a6d6ebd6b6bfd$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $5d8a6d6ebd6b6bfd$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$5d8a6d6ebd6b6bfd$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$5d8a6d6ebd6b6bfd$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $5d8a6d6ebd6b6bfd$var$safeDigits = Math.floor($5d8a6d6ebd6b6bfd$var$log10($5d8a6d6ebd6b6bfd$var$MAX_SAFE_INTEGER));
function $5d8a6d6ebd6b6bfd$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $5d8a6d6ebd6b6bfd$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5d8a6d6ebd6b6bfd$var$safeDigits){
        let block = expanded.substring(0, $5d8a6d6ebd6b6bfd$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5d8a6d6ebd6b6bfd$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5d8a6d6ebd6b6bfd$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5d8a6d6ebd6b6bfd$var$ibanChecksum(address)) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $3HDBd._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5d8a6d6ebd6b6bfd$var$getChecksumAddress("0x" + result);
    } else $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5d8a6d6ebd6b6bfd$export$977e255126d763d6(address) {
    try {
        $5d8a6d6ebd6b6bfd$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5d8a6d6ebd6b6bfd$export$962c4ddada9f668f(address) {
    let base36 = (0, $3HDBd._base16To36)($5d8a6d6ebd6b6bfd$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5d8a6d6ebd6b6bfd$var$ibanChecksum("XE00" + base36) + base36;
}
function $5d8a6d6ebd6b6bfd$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $5d8a6d6ebd6b6bfd$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $2Zz8l.stripZeros)((0, $2Zz8l.arrayify)((0, $3HDBd.BigNumber).from(transaction.nonce).toHexString()));
    return $5d8a6d6ebd6b6bfd$export$88411125f012957a((0, $2Zz8l.hexDataSlice)((0, $Jhr88.keccak256)((0, $1iei8.encode)([
        from,
        nonce
    ])), 12));
}
function $5d8a6d6ebd6b6bfd$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $2Zz8l.hexDataLength)(salt) !== 32) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $2Zz8l.hexDataLength)(initCodeHash) !== 32) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5d8a6d6ebd6b6bfd$export$88411125f012957a((0, $2Zz8l.hexDataSlice)((0, $Jhr88.keccak256)((0, $2Zz8l.concat)([
        "0xff",
        $5d8a6d6ebd6b6bfd$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("2Zz8l", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $22dc881190706dd3$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $22dc881190706dd3$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $22dc881190706dd3$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $22dc881190706dd3$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $22dc881190706dd3$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $22dc881190706dd3$export$a8f4574d0e56446c);
$parcel$export(module.exports, "hexlify", () => $22dc881190706dd3$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $22dc881190706dd3$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $22dc881190706dd3$export$15da666eba198c18);
$parcel$export(module.exports, "hexConcat", () => $22dc881190706dd3$export$6d4b99629b38754a);
$parcel$export(module.exports, "hexZeroPad", () => $22dc881190706dd3$export$e9c46a54370b47e8);

var $l1ZqZ = parcelRequire("l1ZqZ");

var $d446Z = parcelRequire("d446Z");
"use strict";
const $22dc881190706dd3$var$logger = new (0, $l1ZqZ.Logger)((0, $d446Z.version));
///////////////////////////////
function $22dc881190706dd3$var$isHexable(value) {
    return !!value.toHexString;
}
function $22dc881190706dd3$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $22dc881190706dd3$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $22dc881190706dd3$export$9a14abb1a440cd5e(value) {
    return $22dc881190706dd3$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $22dc881190706dd3$export$c6fabfbfd097fc30(value);
}
function $22dc881190706dd3$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $22dc881190706dd3$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$22dc881190706dd3$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$22dc881190706dd3$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $22dc881190706dd3$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $22dc881190706dd3$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $22dc881190706dd3$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($22dc881190706dd3$var$isHexable(value)) value = value.toHexString();
    if ($22dc881190706dd3$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $22dc881190706dd3$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $22dc881190706dd3$var$addSlice(new Uint8Array(result));
    }
    if ($22dc881190706dd3$export$c6fabfbfd097fc30(value)) return $22dc881190706dd3$var$addSlice(new Uint8Array(value));
    return $22dc881190706dd3$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $22dc881190706dd3$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$22dc881190706dd3$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $22dc881190706dd3$var$addSlice(result);
}
function $22dc881190706dd3$export$a8f4574d0e56446c(value) {
    let result = $22dc881190706dd3$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $22dc881190706dd3$export$3cdc770bf8b2ed3d(value, length) {
    value = $22dc881190706dd3$export$3131421a7d01b4fb(value);
    if (value.length > length) $22dc881190706dd3$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $22dc881190706dd3$var$addSlice(result);
}
function $22dc881190706dd3$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $22dc881190706dd3$var$HexCharacters = "0123456789abcdef";
function $22dc881190706dd3$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $22dc881190706dd3$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $22dc881190706dd3$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($22dc881190706dd3$var$isHexable(value)) return value.toHexString();
    if ($22dc881190706dd3$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $22dc881190706dd3$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($22dc881190706dd3$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $22dc881190706dd3$var$HexCharacters[(v & 0xf0) >> 4] + $22dc881190706dd3$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $22dc881190706dd3$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $22dc881190706dd3$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $22dc881190706dd3$export$2b0d6b5fbe698c70(data);
    else if (!$22dc881190706dd3$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $22dc881190706dd3$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $22dc881190706dd3$export$2b0d6b5fbe698c70(data);
    else if (!$22dc881190706dd3$export$b02a40aff8e4ad18(data) || data.length % 2) $22dc881190706dd3$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $22dc881190706dd3$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $22dc881190706dd3$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $22dc881190706dd3$export$6916af760a341dd3(value) {
    const trimmed = $22dc881190706dd3$export$967bc0082a978949($22dc881190706dd3$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $22dc881190706dd3$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $22dc881190706dd3$export$2b0d6b5fbe698c70(value);
    if (!$22dc881190706dd3$export$b02a40aff8e4ad18(value)) $22dc881190706dd3$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $22dc881190706dd3$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $22dc881190706dd3$export$2b0d6b5fbe698c70(value);
    else if (!$22dc881190706dd3$export$b02a40aff8e4ad18(value)) $22dc881190706dd3$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $22dc881190706dd3$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $22dc881190706dd3$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($22dc881190706dd3$export$9a14abb1a440cd5e(signature)) {
        let bytes = $22dc881190706dd3$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $22dc881190706dd3$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $22dc881190706dd3$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $22dc881190706dd3$export$3cdc770bf8b2ed3d($22dc881190706dd3$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $22dc881190706dd3$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $22dc881190706dd3$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $22dc881190706dd3$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $22dc881190706dd3$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $22dc881190706dd3$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $22dc881190706dd3$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$22dc881190706dd3$export$b02a40aff8e4ad18(result.r)) $22dc881190706dd3$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $22dc881190706dd3$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$22dc881190706dd3$export$b02a40aff8e4ad18(result.s)) $22dc881190706dd3$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $22dc881190706dd3$export$e9c46a54370b47e8(result.s, 32);
        const vs = $22dc881190706dd3$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $22dc881190706dd3$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $22dc881190706dd3$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$22dc881190706dd3$export$b02a40aff8e4ad18(result._vs)) $22dc881190706dd3$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $22dc881190706dd3$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $22dc881190706dd3$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $22dc881190706dd3$export$71bb9d78a59bbe25(signature) {
    signature = $22dc881190706dd3$export$7fb170f1e457988f(signature);
    return $22dc881190706dd3$export$2b0d6b5fbe698c70($22dc881190706dd3$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("l1ZqZ", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $f4f9588d0bf57552$export$efa9a398d6368992);

var $lApts = parcelRequire("lApts");
"use strict";
let $f4f9588d0bf57552$var$_permanentCensorErrors = false;
let $f4f9588d0bf57552$var$_censorErrors = false;
const $f4f9588d0bf57552$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $f4f9588d0bf57552$var$_logLevel = $f4f9588d0bf57552$var$LogLevels["default"];
let $f4f9588d0bf57552$var$_globalLogger = null;
function $f4f9588d0bf57552$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $f4f9588d0bf57552$var$_normalizeError = $f4f9588d0bf57552$var$_checkNormalize();
var $f4f9588d0bf57552$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($f4f9588d0bf57552$export$243e62d78d3b544d || ($f4f9588d0bf57552$export$243e62d78d3b544d = {}));
var $f4f9588d0bf57552$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($f4f9588d0bf57552$export$d4e71bc0b80dc0fb || ($f4f9588d0bf57552$export$d4e71bc0b80dc0fb = {}));
const $f4f9588d0bf57552$var$HEX = "0123456789abcdef";
class $f4f9588d0bf57552$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($f4f9588d0bf57552$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($f4f9588d0bf57552$var$_logLevel > $f4f9588d0bf57552$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($f4f9588d0bf57552$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($f4f9588d0bf57552$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($f4f9588d0bf57552$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($f4f9588d0bf57552$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $f4f9588d0bf57552$var$HEX[value[i] >> 4];
                        hex += $f4f9588d0bf57552$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($f4f9588d0bf57552$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $f4f9588d0bf57552$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $f4f9588d0bf57552$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $f4f9588d0bf57552$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$f4f9588d0bf57552$var$_globalLogger) $f4f9588d0bf57552$var$_globalLogger = new $f4f9588d0bf57552$export$efa9a398d6368992((0, $lApts.version));
        return $f4f9588d0bf57552$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($f4f9588d0bf57552$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $f4f9588d0bf57552$var$_censorErrors = !!censorship;
        $f4f9588d0bf57552$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $f4f9588d0bf57552$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $f4f9588d0bf57552$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $f4f9588d0bf57552$var$_logLevel = level;
    }
    static from(version) {
        return new $f4f9588d0bf57552$export$efa9a398d6368992(version);
    }
}
$f4f9588d0bf57552$export$efa9a398d6368992.errors = $f4f9588d0bf57552$export$d4e71bc0b80dc0fb;
$f4f9588d0bf57552$export$efa9a398d6368992.levels = $f4f9588d0bf57552$export$243e62d78d3b544d;

});
parcelRegister("lApts", function(module, exports) {

$parcel$export(module.exports, "version", () => $fb70b861ac0868f7$export$83d89fbfd8236492);
const $fb70b861ac0868f7$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("d446Z", function(module, exports) {

$parcel$export(module.exports, "version", () => $982ed69cee193712$export$83d89fbfd8236492);
const $982ed69cee193712$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("3HDBd", function(module, exports) {

$parcel$export(module.exports, "BigNumber", () => $2b241ad9f2c98830$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $2b241ad9f2c98830$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $2b241ad9f2c98830$export$1293db5d29c264ff);

var $fwffq = parcelRequire("fwffq");

var $2Zz8l = parcelRequire("2Zz8l");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $7d92x = parcelRequire("7d92x");
"use strict";
var $2b241ad9f2c98830$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($fwffq))).BN;
const $2b241ad9f2c98830$var$logger = new (0, $l1ZqZ.Logger)((0, $7d92x.version));
const $2b241ad9f2c98830$var$_constructorGuard = {};
const $2b241ad9f2c98830$var$MAX_SAFE = 0x1fffffffffffff;
function $2b241ad9f2c98830$export$a3d0a7fa9b65683b(value) {
    return value != null && ($2b241ad9f2c98830$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $2Zz8l.isHexString)(value) || typeof value === "bigint" || (0, $2Zz8l.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $2b241ad9f2c98830$var$_warnedToStringRadix = false;
class $2b241ad9f2c98830$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $2b241ad9f2c98830$var$_constructorGuard) $2b241ad9f2c98830$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $2b241ad9f2c98830$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).add($2b241ad9f2c98830$var$toBN(other)));
    }
    sub(other) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).sub($2b241ad9f2c98830$var$toBN(other)));
    }
    div(other) {
        const o = $2b241ad9f2c98830$export$d97aa349ed20696.from(other);
        if (o.isZero()) $2b241ad9f2c98830$var$throwFault("division-by-zero", "div");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).div($2b241ad9f2c98830$var$toBN(other)));
    }
    mul(other) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).mul($2b241ad9f2c98830$var$toBN(other)));
    }
    mod(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (value.isNeg()) $2b241ad9f2c98830$var$throwFault("division-by-zero", "mod");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (value.isNeg()) $2b241ad9f2c98830$var$throwFault("negative-power", "pow");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $2b241ad9f2c98830$var$throwFault("unbound-bitwise-result", "and");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).and(value));
    }
    or(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $2b241ad9f2c98830$var$throwFault("unbound-bitwise-result", "or");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $2b241ad9f2c98830$var$throwFault("unbound-bitwise-result", "xor");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $2b241ad9f2c98830$var$throwFault("negative-width", "mask");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $2b241ad9f2c98830$var$throwFault("negative-width", "shl");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $2b241ad9f2c98830$var$throwFault("negative-width", "shr");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $2b241ad9f2c98830$var$toBN(this).eq($2b241ad9f2c98830$var$toBN(other));
    }
    lt(other) {
        return $2b241ad9f2c98830$var$toBN(this).lt($2b241ad9f2c98830$var$toBN(other));
    }
    lte(other) {
        return $2b241ad9f2c98830$var$toBN(this).lte($2b241ad9f2c98830$var$toBN(other));
    }
    gt(other) {
        return $2b241ad9f2c98830$var$toBN(this).gt($2b241ad9f2c98830$var$toBN(other));
    }
    gte(other) {
        return $2b241ad9f2c98830$var$toBN(this).gte($2b241ad9f2c98830$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $2b241ad9f2c98830$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $2b241ad9f2c98830$var$toBN(this).toNumber();
        } catch (error) {
            $2b241ad9f2c98830$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $2b241ad9f2c98830$var$logger.throwError("this platform does not support BigInt", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$2b241ad9f2c98830$var$_warnedToStringRadix) {
                    $2b241ad9f2c98830$var$_warnedToStringRadix = true;
                    $2b241ad9f2c98830$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $2b241ad9f2c98830$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $l1ZqZ.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $2b241ad9f2c98830$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $l1ZqZ.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $2b241ad9f2c98830$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $2b241ad9f2c98830$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $2b241ad9f2c98830$export$d97aa349ed20696($2b241ad9f2c98830$var$_constructorGuard, $2b241ad9f2c98830$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $2b241ad9f2c98830$export$d97aa349ed20696($2b241ad9f2c98830$var$_constructorGuard, $2b241ad9f2c98830$var$toHex(new $2b241ad9f2c98830$var$BN(value)));
            return $2b241ad9f2c98830$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $2b241ad9f2c98830$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $2b241ad9f2c98830$var$MAX_SAFE || value <= -$2b241ad9f2c98830$var$MAX_SAFE) $2b241ad9f2c98830$var$throwFault("overflow", "BigNumber.from", value);
            return $2b241ad9f2c98830$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $2b241ad9f2c98830$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $2Zz8l.isBytes)(anyValue)) return $2b241ad9f2c98830$export$d97aa349ed20696.from((0, $2Zz8l.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $2b241ad9f2c98830$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $2Zz8l.isHexString)(hex) || hex[0] === "-" && (0, $2Zz8l.isHexString)(hex.substring(1))) return $2b241ad9f2c98830$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $2b241ad9f2c98830$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $2b241ad9f2c98830$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $2b241ad9f2c98830$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $2b241ad9f2c98830$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $2b241ad9f2c98830$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $2b241ad9f2c98830$var$toBigNumber(value) {
    return $2b241ad9f2c98830$export$d97aa349ed20696.from($2b241ad9f2c98830$var$toHex(value));
}
function $2b241ad9f2c98830$var$toBN(value) {
    const hex = $2b241ad9f2c98830$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $2b241ad9f2c98830$var$BN("-" + hex.substring(3), 16);
    return new $2b241ad9f2c98830$var$BN(hex.substring(2), 16);
}
function $2b241ad9f2c98830$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $2b241ad9f2c98830$var$logger.throwError(fault, (0, $l1ZqZ.Logger).errors.NUMERIC_FAULT, params);
}
function $2b241ad9f2c98830$export$51e4a08295f7770f(value) {
    return new $2b241ad9f2c98830$var$BN(value, 36).toString(16);
}
function $2b241ad9f2c98830$export$1293db5d29c264ff(value) {
    return new $2b241ad9f2c98830$var$BN(value, 16).toString(36);
}

});
parcelRegister("fwffq", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7d92x", function(module, exports) {

$parcel$export(module.exports, "version", () => $5400c274fe28c47d$export$83d89fbfd8236492);
const $5400c274fe28c47d$export$83d89fbfd8236492 = "bignumber/5.7.0";

});


parcelRegister("Jhr88", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $0881baa05d30c22b$export$f8151fce47ad1c35);

var $84nWc = parcelRequire("84nWc");

var $2Zz8l = parcelRequire("2Zz8l");
"use strict";
function $0881baa05d30c22b$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($84nWc))).keccak_256((0, $2Zz8l.arrayify)(data));
}

});

parcelRegister("1iei8", function(module, exports) {

$parcel$export(module.exports, "encode", () => $0f128edc33e88c02$export$c564cdbbe6da493);

var $2Zz8l = parcelRequire("2Zz8l");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $47e13 = parcelRequire("47e13");
"use strict";
const $0f128edc33e88c02$var$logger = new (0, $l1ZqZ.Logger)((0, $47e13.version));
function $0f128edc33e88c02$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $0f128edc33e88c02$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $0f128edc33e88c02$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($0f128edc33e88c02$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $0f128edc33e88c02$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $2Zz8l.isBytesLike)(object)) $0f128edc33e88c02$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $2Zz8l.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $0f128edc33e88c02$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $0f128edc33e88c02$export$c564cdbbe6da493(object) {
    return (0, $2Zz8l.hexlify)($0f128edc33e88c02$var$_encode(object));
}
function $0f128edc33e88c02$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $0f128edc33e88c02$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $0f128edc33e88c02$var$logger.throwError("child data too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $0f128edc33e88c02$var$_decode(data, offset) {
    if (data.length === 0) $0f128edc33e88c02$var$logger.throwError("data too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $0f128edc33e88c02$var$logger.throwError("data short segment too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const length = $0f128edc33e88c02$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $0f128edc33e88c02$var$logger.throwError("data long segment too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        return $0f128edc33e88c02$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $0f128edc33e88c02$var$logger.throwError("data array too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        return $0f128edc33e88c02$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $0f128edc33e88c02$var$logger.throwError("data array too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const length = $0f128edc33e88c02$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $0f128edc33e88c02$var$logger.throwError("data array too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $2Zz8l.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $0f128edc33e88c02$var$logger.throwError("data too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $2Zz8l.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $2Zz8l.hexlify)(data[offset])
    };
}
function $0f128edc33e88c02$export$2f872c0f2117be69(data) {
    const bytes = (0, $2Zz8l.arrayify)(data);
    const decoded = $0f128edc33e88c02$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $0f128edc33e88c02$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("47e13", function(module, exports) {

$parcel$export(module.exports, "version", () => $2ff2b023187d1738$export$83d89fbfd8236492);
const $2ff2b023187d1738$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("eFlRV", function(module, exports) {

$parcel$export(module.exports, "version", () => $aad5dbb91a9116b2$export$83d89fbfd8236492);
const $aad5dbb91a9116b2$export$83d89fbfd8236492 = "address/5.7.0";

});


parcelRegister("6VDHX", function(module, exports) {

$parcel$export(module.exports, "id", () => $50b6de240f04bd57$export$d560c7e4a29451c2);

var $Jhr88 = parcelRequire("Jhr88");

var $2BIyO = parcelRequire("2BIyO");
function $50b6de240f04bd57$export$d560c7e4a29451c2(text) {
    return (0, $Jhr88.keccak256)((0, $2BIyO.toUtf8Bytes)(text));
}

});
parcelRegister("2BIyO", function(module, exports) {

$parcel$export(module.exports, "toUtf8Bytes", () => $1e619a46fea3ee3a$export$8feeb310b4b4752f);
$parcel$export(module.exports, "toUtf8String", () => $1e619a46fea3ee3a$export$7643a1dc2c38d5eb);

var $2Zz8l = parcelRequire("2Zz8l");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $fUa0V = parcelRequire("fUa0V");
"use strict";
const $1e619a46fea3ee3a$var$logger = new (0, $l1ZqZ.Logger)((0, $fUa0V.version));
var $1e619a46fea3ee3a$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($1e619a46fea3ee3a$export$c6986442964129f5 || ($1e619a46fea3ee3a$export$c6986442964129f5 = {}));
var $1e619a46fea3ee3a$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($1e619a46fea3ee3a$export$c285fa6ac15ff6a6 || ($1e619a46fea3ee3a$export$c285fa6ac15ff6a6 = {}));
function $1e619a46fea3ee3a$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $1e619a46fea3ee3a$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $1e619a46fea3ee3a$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $1e619a46fea3ee3a$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $1e619a46fea3ee3a$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $1e619a46fea3ee3a$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $1e619a46fea3ee3a$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $1e619a46fea3ee3a$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $1e619a46fea3ee3a$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $1e619a46fea3ee3a$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $1e619a46fea3ee3a$var$errorFunc,
    ignore: $1e619a46fea3ee3a$var$ignoreFunc,
    replace: $1e619a46fea3ee3a$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $1e619a46fea3ee3a$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $1e619a46fea3ee3a$export$c6e2180c5bb5bc05.error;
    bytes = (0, $2Zz8l.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($1e619a46fea3ee3a$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $1e619a46fea3ee3a$export$8feeb310b4b4752f(str, form = $1e619a46fea3ee3a$export$c6986442964129f5.current) {
    if (form != $1e619a46fea3ee3a$export$c6986442964129f5.current) {
        $1e619a46fea3ee3a$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $2Zz8l.arrayify)(result);
}
function $1e619a46fea3ee3a$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $1e619a46fea3ee3a$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $1e619a46fea3ee3a$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $1e619a46fea3ee3a$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $1e619a46fea3ee3a$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $1e619a46fea3ee3a$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $1e619a46fea3ee3a$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $1e619a46fea3ee3a$export$7643a1dc2c38d5eb(bytes, onError) {
    return $1e619a46fea3ee3a$export$232e1dab03132235($1e619a46fea3ee3a$var$getUtf8CodePoints(bytes, onError));
}
function $1e619a46fea3ee3a$export$ae470a36a31b28c2(str, form = $1e619a46fea3ee3a$export$c6986442964129f5.current) {
    return $1e619a46fea3ee3a$var$getUtf8CodePoints($1e619a46fea3ee3a$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("fUa0V", function(module, exports) {

$parcel$export(module.exports, "version", () => $b943da8b53345987$export$83d89fbfd8236492);
const $b943da8b53345987$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRegister("cj2Wy", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", () => $8f598ae2b9038832$export$104236534534f9be);
$parcel$export(module.exports, "getStatic", () => $8f598ae2b9038832$export$f695fbbf3cdaaf47);
$parcel$export(module.exports, "Description", () => $8f598ae2b9038832$export$393edc798c47379d);

var $l1ZqZ = parcelRequire("l1ZqZ");

var $j1RB3 = parcelRequire("j1RB3");
"use strict";
var $8f598ae2b9038832$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8f598ae2b9038832$var$logger = new (0, $l1ZqZ.Logger)((0, $j1RB3.version));
function $8f598ae2b9038832$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $8f598ae2b9038832$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $8f598ae2b9038832$export$d503dd157d963b60(object) {
    return $8f598ae2b9038832$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $8f598ae2b9038832$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $8f598ae2b9038832$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $8f598ae2b9038832$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $8f598ae2b9038832$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $8f598ae2b9038832$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $8f598ae2b9038832$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $8f598ae2b9038832$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$8f598ae2b9038832$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $8f598ae2b9038832$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $8f598ae2b9038832$var$_deepCopy(object) {
    if ($8f598ae2b9038832$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$8f598ae2b9038832$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $8f598ae2b9038832$export$104236534534f9be(result, key, $8f598ae2b9038832$export$6c40052bed430212(value));
        }
        return result;
    }
    return $8f598ae2b9038832$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $8f598ae2b9038832$export$6c40052bed430212(object) {
    return $8f598ae2b9038832$var$_deepCopy(object);
}
class $8f598ae2b9038832$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $8f598ae2b9038832$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("j1RB3", function(module, exports) {

$parcel$export(module.exports, "version", () => $dda7af832c6311a0$export$83d89fbfd8236492);
const $dda7af832c6311a0$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRegister("9p0py", function(module, exports) {

$parcel$export(module.exports, "defaultAbiCoder", () => $6d86c487a26d6257$export$51d1cfcdb913adff);

var $2Zz8l = parcelRequire("2Zz8l");

var $cj2Wy = parcelRequire("cj2Wy");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $8B4xQ = parcelRequire("8B4xQ");

var $lCz9i = parcelRequire("lCz9i");

var $8qDq3 = parcelRequire("8qDq3");

var $iFROp = parcelRequire("iFROp");

var $gBTCa = parcelRequire("gBTCa");

var $iAsNl = parcelRequire("iAsNl");

var $4YUsz = parcelRequire("4YUsz");

var $4aEr3 = parcelRequire("4aEr3");

var $glPOg = parcelRequire("glPOg");

var $k6iHw = parcelRequire("k6iHw");

var $4cGep = parcelRequire("4cGep");

var $cidoA = parcelRequire("cidoA");
"use strict";
const $6d86c487a26d6257$var$logger = new (0, $l1ZqZ.Logger)((0, $8B4xQ.version));
const $6d86c487a26d6257$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $6d86c487a26d6257$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $6d86c487a26d6257$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $cj2Wy.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $8qDq3.AddressCoder)(param.name);
            case "bool":
                return new (0, $gBTCa.BooleanCoder)(param.name);
            case "string":
                return new (0, $k6iHw.StringCoder)(param.name);
            case "bytes":
                return new (0, $iAsNl.BytesCoder)(param.name);
            case "array":
                return new (0, $iFROp.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $4cGep.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $4aEr3.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($6d86c487a26d6257$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $6d86c487a26d6257$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $glPOg.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($6d86c487a26d6257$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $6d86c487a26d6257$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $4YUsz.FixedBytesCoder)(size, param.name);
        }
        return $6d86c487a26d6257$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $lCz9i.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $lCz9i.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $cidoA.ParamType).from(type)));
        const coder = new (0, $4cGep.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $6d86c487a26d6257$var$logger.throwError("types/values length mismatch", (0, $l1ZqZ.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $cidoA.ParamType).from(type)));
        const coder = new (0, $4cGep.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $cidoA.ParamType).from(type)));
        const coder = new (0, $4cGep.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $2Zz8l.arrayify)(data), loose));
    }
}
const $6d86c487a26d6257$export$51d1cfcdb913adff = new $6d86c487a26d6257$export$fe041e1a83d3efc6();

});
parcelRegister("8B4xQ", function(module, exports) {

$parcel$export(module.exports, "version", () => $64254df2c572f8e6$export$83d89fbfd8236492);
const $64254df2c572f8e6$export$83d89fbfd8236492 = "abi/5.7.0";

});

parcelRegister("lCz9i", function(module, exports) {

$parcel$export(module.exports, "Coder", () => $fbd8696e7e725da8$export$2c0c39526f8bad46);
$parcel$export(module.exports, "Writer", () => $fbd8696e7e725da8$export$d7a960146e1a269e);
$parcel$export(module.exports, "Reader", () => $fbd8696e7e725da8$export$2f7a2f0e90c07dc4);

var $2Zz8l = parcelRequire("2Zz8l");

var $3HDBd = parcelRequire("3HDBd");

var $cj2Wy = parcelRequire("cj2Wy");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $8B4xQ = parcelRequire("8B4xQ");
"use strict";
const $fbd8696e7e725da8$var$logger = new (0, $l1ZqZ.Logger)((0, $8B4xQ.version));
function $fbd8696e7e725da8$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $fbd8696e7e725da8$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $fbd8696e7e725da8$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $fbd8696e7e725da8$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $cj2Wy.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $2Zz8l.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $2Zz8l.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $2Zz8l.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $2Zz8l.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $2Zz8l.arrayify)((0, $3HDBd.BigNumber).from(value));
        if (bytes.length > this.wordSize) $fbd8696e7e725da8$var$logger.throwError("value out-of-bounds", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $2Zz8l.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $fbd8696e7e725da8$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $cj2Wy.defineReadOnly)(this, "_data", (0, $2Zz8l.arrayify)(data));
        (0, $cj2Wy.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $cj2Wy.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $cj2Wy.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $2Zz8l.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $fbd8696e7e725da8$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $fbd8696e7e725da8$var$logger.throwError("data out-of-bounds", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $fbd8696e7e725da8$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $3HDBd.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});

parcelRegister("8qDq3", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", () => $622f54442445bc9a$export$59dbbded7775bfe7);

var $81UJJ = parcelRequire("81UJJ");

var $2Zz8l = parcelRequire("2Zz8l");

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $622f54442445bc9a$export$59dbbded7775bfe7 extends (0, $lCz9i.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $81UJJ.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $81UJJ.getAddress)((0, $2Zz8l.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("iFROp", function(module, exports) {

$parcel$export(module.exports, "pack", () => $d985cc47d4fd874f$export$2a703dbb0cb35339);
$parcel$export(module.exports, "unpack", () => $d985cc47d4fd874f$export$417857010dc9287f);
$parcel$export(module.exports, "ArrayCoder", () => $d985cc47d4fd874f$export$88bc419d2df11f54);

var $l1ZqZ = parcelRequire("l1ZqZ");

var $8B4xQ = parcelRequire("8B4xQ");

var $lCz9i = parcelRequire("lCz9i");

var $5cCOz = parcelRequire("5cCOz");
"use strict";
const $d985cc47d4fd874f$var$logger = new (0, $l1ZqZ.Logger)((0, $8B4xQ.version));
function $d985cc47d4fd874f$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $d985cc47d4fd874f$var$logger.throwError("cannot encode object for signature with missing names", (0, $l1ZqZ.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $d985cc47d4fd874f$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $l1ZqZ.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $d985cc47d4fd874f$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $d985cc47d4fd874f$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $lCz9i.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $lCz9i.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $d985cc47d4fd874f$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $d985cc47d4fd874f$export$88bc419d2df11f54 extends (0, $lCz9i.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $d985cc47d4fd874f$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $d985cc47d4fd874f$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $d985cc47d4fd874f$var$logger.throwError("insufficient data length", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $5cCOz.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $d985cc47d4fd874f$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("5cCOz", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", () => $3c9c2e80bc60d9b5$export$87c41d1139a03fa2);

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $3c9c2e80bc60d9b5$export$87c41d1139a03fa2 extends (0, $lCz9i.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("gBTCa", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", () => $c17b3df3073094eb$export$fe9118d6c093150c);

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $c17b3df3073094eb$export$fe9118d6c093150c extends (0, $lCz9i.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("iAsNl", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", () => $d881ecd3fa2449a0$export$db9eadd8df12ad2e);
$parcel$export(module.exports, "BytesCoder", () => $d881ecd3fa2449a0$export$e5823e9574df18d2);

var $2Zz8l = parcelRequire("2Zz8l");

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $d881ecd3fa2449a0$export$db9eadd8df12ad2e extends (0, $lCz9i.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $2Zz8l.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $d881ecd3fa2449a0$export$e5823e9574df18d2 extends $d881ecd3fa2449a0$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $2Zz8l.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("4YUsz", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", () => $3a088fbf22cf4654$export$7dec9db68e6bcf5a);

var $2Zz8l = parcelRequire("2Zz8l");

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $3a088fbf22cf4654$export$7dec9db68e6bcf5a extends (0, $lCz9i.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $2Zz8l.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $2Zz8l.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("4aEr3", function(module, exports) {

$parcel$export(module.exports, "NullCoder", () => $3097763a0ca7eec6$export$70982cadf2d6b4ec);

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $3097763a0ca7eec6$export$70982cadf2d6b4ec extends (0, $lCz9i.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("glPOg", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", () => $be76cbdb030e674f$export$b934dc8cfe13938c);

var $3HDBd = parcelRequire("3HDBd");

var $3hWJH = parcelRequire("3hWJH");

var $lCz9i = parcelRequire("lCz9i");
"use strict";
class $be76cbdb030e674f$export$b934dc8cfe13938c extends (0, $lCz9i.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $3HDBd.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $3hWJH.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $3hWJH.One)).mul((0, $3hWJH.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $3hWJH.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});
parcelRegister("3hWJH", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", () => $265085646a14bc8b$export$c83ef0909a6ddeec);
$parcel$export(module.exports, "Zero", () => $265085646a14bc8b$export$aaef8a3eae948f03);
$parcel$export(module.exports, "One", () => $265085646a14bc8b$export$9aa05a5866350bcf);
$parcel$export(module.exports, "MaxUint256", () => $265085646a14bc8b$export$1b53890de5aabdd0);

var $3HDBd = parcelRequire("3HDBd");
const $265085646a14bc8b$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $3HDBd.BigNumber).from(-1);
const $265085646a14bc8b$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $3HDBd.BigNumber).from(0);
const $265085646a14bc8b$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $3HDBd.BigNumber).from(1);
const $265085646a14bc8b$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $3HDBd.BigNumber).from(2);
const $265085646a14bc8b$export$c8db55bd7405209e = /*#__PURE__*/ (0, $3HDBd.BigNumber).from("1000000000000000000");
const $265085646a14bc8b$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $3HDBd.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $265085646a14bc8b$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $3HDBd.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $265085646a14bc8b$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $3HDBd.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("k6iHw", function(module, exports) {

$parcel$export(module.exports, "StringCoder", () => $ea22dfd4e016e04b$export$2d1b854518731426);

var $2BIyO = parcelRequire("2BIyO");

var $iAsNl = parcelRequire("iAsNl");
"use strict";
class $ea22dfd4e016e04b$export$2d1b854518731426 extends (0, $iAsNl.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $2BIyO.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $2BIyO.toUtf8String)(super.decode(reader));
    }
}

});

parcelRegister("4cGep", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", () => $30f90ab006732811$export$e9fceba8f110fea6);

var $lCz9i = parcelRequire("lCz9i");

var $iFROp = parcelRequire("iFROp");
"use strict";
class $30f90ab006732811$export$e9fceba8f110fea6 extends (0, $lCz9i.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $iFROp.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $iFROp.unpack)(reader, this.coders));
    }
}

});

parcelRegister("cidoA", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", () => $8f318e93e5ef7558$export$f010f239efc4d445);
$parcel$export(module.exports, "ParamType", () => $8f318e93e5ef7558$export$426dc07f493a4c47);
$parcel$export(module.exports, "Fragment", () => $8f318e93e5ef7558$export$ffb0004e005737fa);
$parcel$export(module.exports, "FunctionFragment", () => $8f318e93e5ef7558$export$8d576c928b93668f);
$parcel$export(module.exports, "EventFragment", () => $8f318e93e5ef7558$export$958548f08bac2833);
$parcel$export(module.exports, "ConstructorFragment", () => $8f318e93e5ef7558$export$3ac5c9504f801ea4);

var $3HDBd = parcelRequire("3HDBd");

var $cj2Wy = parcelRequire("cj2Wy");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $8B4xQ = parcelRequire("8B4xQ");
"use strict";
const $8f318e93e5ef7558$var$logger = new (0, $l1ZqZ.Logger)((0, $8B4xQ.version));
const $8f318e93e5ef7558$var$_constructorGuard = {};
let $8f318e93e5ef7558$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $8f318e93e5ef7558$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $8f318e93e5ef7558$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($8f318e93e5ef7558$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($8f318e93e5ef7558$var$ModifiersNest[name]) return true;
    }
    if ($8f318e93e5ef7558$var$ModifiersBytes[name] || name === "payable") $8f318e93e5ef7558$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $8f318e93e5ef7558$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $8f318e93e5ef7558$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $8f318e93e5ef7558$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($8f318e93e5ef7558$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $8f318e93e5ef7558$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($8f318e93e5ef7558$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $8f318e93e5ef7558$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $8f318e93e5ef7558$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($8f318e93e5ef7558$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $8f318e93e5ef7558$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($8f318e93e5ef7558$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $8f318e93e5ef7558$var$verifyType(parent.type);
    return parent;
}
function $8f318e93e5ef7558$var$populate(object, params) {
    for(let key in params)(0, $cj2Wy.defineReadOnly)(object, key, params[key]);
}
const $8f318e93e5ef7558$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $8f318e93e5ef7558$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $8f318e93e5ef7558$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $8f318e93e5ef7558$var$_constructorGuard) $8f318e93e5ef7558$var$logger.throwError("use fromString", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $8f318e93e5ef7558$var$populate(this, params);
        let match = this.type.match($8f318e93e5ef7558$var$paramTypeArray);
        if (match) $8f318e93e5ef7558$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $8f318e93e5ef7558$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $8f318e93e5ef7558$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $8f318e93e5ef7558$export$f010f239efc4d445.sighash;
        if (!$8f318e93e5ef7558$export$f010f239efc4d445[format]) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $8f318e93e5ef7558$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $8f318e93e5ef7558$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $8f318e93e5ef7558$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $8f318e93e5ef7558$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $8f318e93e5ef7558$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($8f318e93e5ef7558$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $8f318e93e5ef7558$export$426dc07f493a4c47($8f318e93e5ef7558$var$_constructorGuard, {
            name: value.name || null,
            type: $8f318e93e5ef7558$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($8f318e93e5ef7558$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $8f318e93e5ef7558$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($8f318e93e5ef7558$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $8f318e93e5ef7558$var$parseParams(value, allowIndex) {
    return $8f318e93e5ef7558$var$splitNesting(value).map((param)=>$8f318e93e5ef7558$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $8f318e93e5ef7558$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $8f318e93e5ef7558$var$_constructorGuard) $8f318e93e5ef7558$var$logger.throwError("use a static from method", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $8f318e93e5ef7558$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($8f318e93e5ef7558$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $8f318e93e5ef7558$export$ffb0004e005737fa.fromString(value);
        return $8f318e93e5ef7558$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($8f318e93e5ef7558$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $8f318e93e5ef7558$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $8f318e93e5ef7558$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $8f318e93e5ef7558$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $8f318e93e5ef7558$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $8f318e93e5ef7558$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $8f318e93e5ef7558$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $8f318e93e5ef7558$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $8f318e93e5ef7558$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $8f318e93e5ef7558$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $8f318e93e5ef7558$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $8f318e93e5ef7558$export$958548f08bac2833 extends $8f318e93e5ef7558$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $8f318e93e5ef7558$export$f010f239efc4d445.sighash;
        if (!$8f318e93e5ef7558$export$f010f239efc4d445[format]) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $8f318e93e5ef7558$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $8f318e93e5ef7558$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $8f318e93e5ef7558$export$958548f08bac2833.fromString(value);
        return $8f318e93e5ef7558$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($8f318e93e5ef7558$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $8f318e93e5ef7558$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $8f318e93e5ef7558$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($8f318e93e5ef7558$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $8f318e93e5ef7558$export$958548f08bac2833($8f318e93e5ef7558$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($8f318e93e5ef7558$var$regexParen);
        if (!match) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $8f318e93e5ef7558$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $8f318e93e5ef7558$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $8f318e93e5ef7558$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $8f318e93e5ef7558$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $3HDBd.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $8f318e93e5ef7558$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $8f318e93e5ef7558$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $8f318e93e5ef7558$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $8f318e93e5ef7558$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $8f318e93e5ef7558$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $8f318e93e5ef7558$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $8f318e93e5ef7558$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $8f318e93e5ef7558$export$3ac5c9504f801ea4 extends $8f318e93e5ef7558$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $8f318e93e5ef7558$export$f010f239efc4d445.sighash;
        if (!$8f318e93e5ef7558$export$f010f239efc4d445[format]) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $8f318e93e5ef7558$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $8f318e93e5ef7558$export$f010f239efc4d445.sighash) $8f318e93e5ef7558$var$logger.throwError("cannot format a constructor for sighash", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $8f318e93e5ef7558$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $8f318e93e5ef7558$export$3ac5c9504f801ea4.fromString(value);
        return $8f318e93e5ef7558$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($8f318e93e5ef7558$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $8f318e93e5ef7558$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $8f318e93e5ef7558$var$verifyState(value);
        if (state.constant) $8f318e93e5ef7558$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($8f318e93e5ef7558$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $3HDBd.BigNumber).from(value.gas) : null
        };
        return new $8f318e93e5ef7558$export$3ac5c9504f801ea4($8f318e93e5ef7558$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $8f318e93e5ef7558$var$parseGas(value, params);
        let parens = value.match($8f318e93e5ef7558$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $8f318e93e5ef7558$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $8f318e93e5ef7558$var$parseParams(parens[2].trim(), false);
        $8f318e93e5ef7558$var$parseModifiers(parens[3].trim(), params);
        return $8f318e93e5ef7558$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $8f318e93e5ef7558$export$8d576c928b93668f extends $8f318e93e5ef7558$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $8f318e93e5ef7558$export$f010f239efc4d445.sighash;
        if (!$8f318e93e5ef7558$export$f010f239efc4d445[format]) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $8f318e93e5ef7558$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $8f318e93e5ef7558$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $8f318e93e5ef7558$export$8d576c928b93668f.fromString(value);
        return $8f318e93e5ef7558$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($8f318e93e5ef7558$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $8f318e93e5ef7558$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $8f318e93e5ef7558$var$verifyState(value);
        const params = {
            type: value.type,
            name: $8f318e93e5ef7558$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($8f318e93e5ef7558$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($8f318e93e5ef7558$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $3HDBd.BigNumber).from(value.gas) : null
        };
        return new $8f318e93e5ef7558$export$8d576c928b93668f($8f318e93e5ef7558$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $8f318e93e5ef7558$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($8f318e93e5ef7558$var$regexParen);
        if (!parens) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $8f318e93e5ef7558$var$verifyIdentifier(params.name);
        params.inputs = $8f318e93e5ef7558$var$parseParams(parens[2], false);
        $8f318e93e5ef7558$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($8f318e93e5ef7558$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $8f318e93e5ef7558$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $8f318e93e5ef7558$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $8f318e93e5ef7558$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $8f318e93e5ef7558$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $8f318e93e5ef7558$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $8f318e93e5ef7558$export$2c42c6d543aa9b59 extends $8f318e93e5ef7558$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $8f318e93e5ef7558$export$f010f239efc4d445.sighash;
        if (!$8f318e93e5ef7558$export$f010f239efc4d445[format]) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $8f318e93e5ef7558$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $8f318e93e5ef7558$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $8f318e93e5ef7558$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $8f318e93e5ef7558$export$2c42c6d543aa9b59.fromString(value);
        return $8f318e93e5ef7558$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($8f318e93e5ef7558$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $8f318e93e5ef7558$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $8f318e93e5ef7558$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($8f318e93e5ef7558$export$426dc07f493a4c47.fromObject) : []
        };
        return $8f318e93e5ef7558$var$checkForbidden(new $8f318e93e5ef7558$export$2c42c6d543aa9b59($8f318e93e5ef7558$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($8f318e93e5ef7558$var$regexParen);
        if (!parens) $8f318e93e5ef7558$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $8f318e93e5ef7558$var$verifyIdentifier(params.name);
        params.inputs = $8f318e93e5ef7558$var$parseParams(parens[2], false);
        return $8f318e93e5ef7558$var$checkForbidden($8f318e93e5ef7558$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $8f318e93e5ef7558$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $8f318e93e5ef7558$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $8f318e93e5ef7558$var$verifyIdentifier(value) {
    if (!value || !value.match($8f318e93e5ef7558$var$regexIdentifier)) $8f318e93e5ef7558$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $8f318e93e5ef7558$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $8f318e93e5ef7558$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $8f318e93e5ef7558$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});




parcelRegister("gsc1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = [
    {
        inputs: [
            {
                internalType: "contract IUNSRegistry",
                name: "unsRegistry",
                type: "address"
            },
            {
                internalType: "contract ICNSRegistry",
                name: "cnsRegistry",
                type: "address"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "string",
                name: "label",
                type: "string"
            }
        ],
        name: "childIdOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "exists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "key",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "get",
        outputs: [
            {
                internalType: "string",
                name: "value",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "keyHash",
                type: "uint256"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getByHash",
        outputs: [
            {
                internalType: "string",
                name: "key",
                type: "string"
            },
            {
                internalType: "string",
                name: "value",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "keys",
                type: "string[]"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getData",
        outputs: [
            {
                internalType: "address",
                name: "resolver",
                type: "address"
            },
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "string[]",
                name: "values",
                type: "string[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "keyHashes",
                type: "uint256[]"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getDataByHash",
        outputs: [
            {
                internalType: "address",
                name: "resolver",
                type: "address"
            },
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "string[]",
                name: "keys",
                type: "string[]"
            },
            {
                internalType: "string[]",
                name: "values",
                type: "string[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "keyHashes",
                type: "uint256[]"
            },
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]"
            }
        ],
        name: "getDataByHashForMany",
        outputs: [
            {
                internalType: "address[]",
                name: "resolvers",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "owners",
                type: "address[]"
            },
            {
                internalType: "string[][]",
                name: "keys",
                type: "string[][]"
            },
            {
                internalType: "string[][]",
                name: "values",
                type: "string[][]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "keys",
                type: "string[]"
            },
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]"
            }
        ],
        name: "getDataForMany",
        outputs: [
            {
                internalType: "address[]",
                name: "resolvers",
                type: "address[]"
            },
            {
                internalType: "address[]",
                name: "owners",
                type: "address[]"
            },
            {
                internalType: "string[][]",
                name: "values",
                type: "string[][]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "keys",
                type: "string[]"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getMany",
        outputs: [
            {
                internalType: "string[]",
                name: "values",
                type: "string[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "keyHashes",
                type: "uint256[]"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getManyByHash",
        outputs: [
            {
                internalType: "string[]",
                name: "keys",
                type: "string[]"
            },
            {
                internalType: "string[]",
                name: "values",
                type: "string[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "pure",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "isApprovedOrOwner",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]"
            }
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "results",
                type: "bytes[]"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]"
            }
        ],
        name: "ownerOfForMany",
        outputs: [
            {
                internalType: "address[]",
                name: "owners",
                type: "address[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "registryOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "resolverOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address"
            }
        ],
        name: "reverseOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];

});

parcelRegister("4ZZTu", function(module, exports) {
module.exports = JSON.parse('{"version":"0.4.0","networks":{"1":{"contracts":{"UNSRegistry":{"address":"0x049aba7510f45BA5b64ea9E658E342F904DB358D","implementation":"0xa715562307AA8AEDCba976b3793b3337F371c14a","legacyAddresses":[],"deploymentBlock":"0xd62e9d","forwarder":"0x049aba7510f45BA5b64ea9E658E342F904DB358D"},"CNSRegistry":{"address":"0xD1E5b0FF1287aA9f9A268759062E4Ab08b9Dacbe","legacyAddresses":[],"deploymentBlock":"0x8a958b","forwarder":"0x97B0E89fC1B7eD4A8B237D9d8Fcce9b234f25A37"},"MintingManager":{"address":"0x2a7084870bB724175a3C96Da8FaA55128fa3E19D","implementation":"0x8caAeaD19aab5f54C94BB9F4be32e200E54AC8D7","legacyAddresses":[],"deploymentBlock":"0xc2fee0","forwarder":"0xb970fbCF52cd8111c76c379D4f2FE12E7f8AE7fb"},"ProxyAdmin":{"address":"0xAA16DA78110D9A9742c760a1a064F28654Ab93de","legacyAddresses":[],"deploymentBlock":"0xc2fedc"},"SignatureController":{"address":"0x82EF94294C95aD0930055f31e53A34509227c5f7","legacyAddresses":[],"deploymentBlock":"0x8a95a6"},"MintingController":{"address":"0xb0EE56339C3253361730F50c08d3d7817ecD60Ca","legacyAddresses":[],"deploymentBlock":"0x8a95aa","deprecated":true},"WhitelistedMinter":{"address":"0xd3fF3377b0ceade1303dAF9Db04068ef8a650757","legacyAddresses":[],"deploymentBlock":"0xa76ad3","deprecated":true},"URIPrefixController":{"address":"0x09B091492759737C03da9dB7eDF1CD6BCC3A9d91","legacyAddresses":[],"deploymentBlock":"0x8a95ae","deprecated":true},"DomainZoneController":{"address":"0xeA70777e28E00E81f58b8921fC47F78B8a72eFE7","legacyAddresses":[],"deploymentBlock":"0x98ca20","deprecated":true},"Resolver":{"address":"0xb66DcE2DA6afAAa98F2013446dBCB0f4B0ab2842","legacyAddresses":["0xa1cac442be6673c49f8e74ffc7c4fd746f3cbd0d","0x878bc2f3f717766ab69c0a5f9a6144931e61aed3"],"deploymentBlock":"0x960844","forwarder":"0x486eb10E4F48C038513ECAf11585Ca2779768CF2"},"ProxyReader":{"address":"0x1BDc0fD4fbABeed3E611fd6195fCd5d41dcEF393","legacyAddresses":["0x58034A288D2E56B661c9056A0C27273E5460B63c","0xc3C2BAB5e3e52DBF311b2aAcEf2e40344f19494E","0xfEe4D4F0aDFF8D84c12170306507554bC7045878","0xa6E7cEf2EDDEA66352Fd68E5915b60BDbb7309f5","0x7ea9Ee21077F84339eDa9C80048ec6db678642B1"],"deploymentBlock":"0xde71cd"},"TwitterValidationOperator":{"address":"0x2F659766E3D08561CA3408FbAba7C0749ab2c402","legacyAddresses":["0xbb486C6E9cF1faA86a6E3eAAFE2e5665C0507855"],"deploymentBlock":"0xc300b5"},"FreeMinter":{"address":"0x1fC985cAc641ED5846b631f96F35d9b48Bc3b834","legacyAddresses":[],"deploymentBlock":"0xacc390","deprecated":true},"MintableERC721Predicate":{"address":"0x932532aA4c0174b8453839A6E44eE09Cc615F2b7","legacyAddresses":[],"deploymentBlock":"0xa3cf69"},"RootChainManager":{"address":"0xA0c68C638235ee32657e8f720a23ceC1bFc77C77","legacyAddresses":[],"deploymentBlock":"0xa3cf4d"}}},"4":{"contracts":{"UNSRegistry":{"address":"0x7fb83000B8eD59D3eAD22f0D584Df3a85fBC0086","implementation":"0xc479D7A65243f7Eb1641F06a6C04E5F06cb5c4F7","legacyAddresses":[],"deploymentBlock":"0x85e628","forwarder":"0x7fb83000B8eD59D3eAD22f0D584Df3a85fBC0086"},"CNSRegistry":{"address":"0xAad76bea7CFEc82927239415BB18D2e93518ecBB","legacyAddresses":[],"deploymentBlock":"0x7232bc","forwarder":"0xdf5CC97216785398D5C77348e68fc9461108f85d"},"MintingManager":{"address":"0xdAAf99A920D31F4f5720e4667b12b24e54A03070","implementation":"0x38Fa95a0AC0E59D6e2845eFADBc17aF0FF9c7089","legacyAddresses":[],"deploymentBlock":"0x85e629","forwarder":"0xfB13e29C4D31a48B4Cd61131Cf3b681416e11681"},"ProxyAdmin":{"address":"0xaf9815005A208d1460b6fC60B4f90B9f2185E88c","legacyAddresses":[],"deploymentBlock":"0x85e627"},"SignatureController":{"address":"0x66a5e3e2C27B4ce4F46BBd975270BE154748D164","legacyAddresses":[],"deploymentBlock":"0x7232be"},"MintingController":{"address":"0x51765307AeB3Df2E647014a2C501d5324212467c","legacyAddresses":[],"deploymentBlock":"0x7232bf","deprecated":true},"WhitelistedMinter":{"address":"0xbcB32f13f90978a9e059E8Cb40FaA9e6619d98e7","legacyAddresses":[],"deploymentBlock":"0x7232c6","deprecated":true},"URIPrefixController":{"address":"0xe1d2e4B9f0518CA5c803073C3dFa886470627237","legacyAddresses":[],"deploymentBlock":"0x7232c0","deprecated":true},"DomainZoneController":{"address":"0x6f8F96A566663C1d4fEe70edD37E9b62Fe39dE5D","legacyAddresses":[],"deploymentBlock":"0x7232c2","deprecated":true},"Resolver":{"address":"0x95AE1515367aa64C462c71e87157771165B1287A","legacyAddresses":[],"deploymentBlock":"0x7232cf","forwarder":"0xE172D8557d6F342b1b2976dE784F6Dff6ABC0a37"},"ProxyReader":{"address":"0xE6729D224D00b3dd4FC731C4Ee3274E35Da06578","legacyAddresses":["0x299974AeD8911bcbd2C61262605b89F591a53E83","0x9F19473F6a98a715176291c930558E1954fd3D1e","0x3A2e74CF832cbA3d77E72708d55370119E4323a6"],"deploymentBlock":"0x8dc79a"},"TwitterValidationOperator":{"address":"0x9ea4A63184ebE9CBA55CD1af473D98075Aa02b4C","legacyAddresses":["0x1CB337b3b208dc29a6AcE8d11Bb591b66c5Dd83d"],"deploymentBlock":"0x86935e"},"FreeMinter":{"address":"0x84214215904cDEbA9044ECf95F3eBF009185AAf4","legacyAddresses":[],"deploymentBlock":"0x740d93","deprecated":true}}},"5":{"contracts":{"UNSRegistry":{"address":"0x070e83FCed225184E67c86302493ffFCDB953f71","implementation":"0x4473e84898E3F58feEFb7529dfF9E83Ff26CCae9","legacyAddresses":[],"deploymentBlock":"0x5b57ea","forwarder":"0x070e83FCed225184E67c86302493ffFCDB953f71"},"CNSRegistry":{"address":"0x801452cFAC27e79a11c6b185986fdE09e8637589","legacyAddresses":[],"deploymentBlock":"0x5b57d7","forwarder":"0x00443017FFaa4C840Caf5Dc7d3CB59147f363080"},"MintingManager":{"address":"0x9ee42D3EB042e06F8Cd241890C4fA0d51e4DA345","implementation":"0xFB11410f3067BB6Db61bC335f0de23bE87A1767e","legacyAddresses":[],"deploymentBlock":"0x5b57ec","forwarder":"0x7F9F48cF94C69ce91D4b442DA186F31118ac0185"},"ProxyAdmin":{"address":"0xf4906E210523F9dA79E33811A44EE000441F4E04","legacyAddresses":[],"deploymentBlock":"0x5b57e8"},"SignatureController":{"address":"0x5199dAE4B24B987ba18FcE1b64664D1B798d372B","legacyAddresses":[],"deploymentBlock":"0x5b57d8"},"MintingController":{"address":"0xCEC41677be322049cC885c0DAe2fE0D52CA195ca","legacyAddresses":[],"deploymentBlock":"0x5b57d9","deprecated":true},"WhitelistedMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"URIPrefixController":{"address":"0x29465e3d2daA588E62375977bCe9b3f51406a794","legacyAddresses":[],"deploymentBlock":"0x5b57da","deprecated":true},"DomainZoneController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"Resolver":{"address":"0x0555344A5F440Bd1d8cb6B42db46c5e5D4070437","legacyAddresses":[],"deploymentBlock":"0x5b57dc","forwarder":"0xFCc1A95B7287Ae7a8B7cA813F12991dF5714d4C7"},"ProxyReader":{"address":"0xE3b961856C417d081a02cBa0161a051268F52677","legacyAddresses":["0x9A70ff906D422C2FD0F7B94244D6b36DB62Ee982","0xFc5f608149f4D9e2Ed0733efFe9DD57ee24BCF68"],"deploymentBlock":"0x65bdfe"},"TwitterValidationOperator":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"FreeMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"MintableERC721Predicate":{"address":"0x56E14C4C1748a818a5564D33cF774c59EB3eDF59","legacyAddresses":[],"deploymentBlock":"0x2fc240"},"RootChainManager":{"address":"0xBbD7cBFA79faee899Eaf900F13C9065bF03B1A74","legacyAddresses":[],"deploymentBlock":"0x2dc9b9"}}},"137":{"contracts":{"UNSRegistry":{"address":"0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f","legacyAddresses":[],"deploymentBlock":"0x019d6188","implementation":"0x5442953b0BFFf69FC945f5f1387cbFD2e2673447","forwarder":"0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f"},"CNSRegistry":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","forwarder":"0x0000000000000000000000000000000000000000"},"MintingManager":{"address":"0x7be83293BeeDc9Eba1bd76c66A65F10F3efaeC26","legacyAddresses":[],"deploymentBlock":"0x01272f41","implementation":"0xBb45a6E10224Aa36EAcd812205F3763D353e9783","forwarder":"0xC37d3c4326ab0E1D2b9D8b916bBdf5715f780fcF"},"ProxyAdmin":{"address":"0xe1D668052D52388F52b90f4d1798DB2b04bC3b88","legacyAddresses":[],"deploymentBlock":"0x01272d15"},"SignatureController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"MintingController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"WhitelistedMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"URIPrefixController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"DomainZoneController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"Resolver":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","forwarder":"0x0000000000000000000000000000000000000000"},"ProxyReader":{"address":"0x3E67b8c702a1292d1CEb025494C84367fcb12b45","legacyAddresses":["0x423F2531bd5d3C3D4EF7C318c2D1d9BEDE67c680","0xA3f32c8cd786dc089Bd1fC175F2707223aeE5d00"],"deploymentBlock":"0x019d61a9"},"TwitterValidationOperator":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"FreeMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"MintableERC721Predicate":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"RootChainManager":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"}}},"1337":{"contracts":{"UNSRegistry":{"address":"0x58a175BEbc8ec21A94ea63Aa5a28743945940EE6","legacyAddresses":[],"deploymentBlock":"0x0d","implementation":"0xe0aFC4e9E03e4aa67257Df7A2Eca77454309789D","forwarder":"0x58a175BEbc8ec21A94ea63Aa5a28743945940EE6"},"CNSRegistry":{"address":"0xC58206842E4030a3B2CaBC78780Ae7635173C533","legacyAddresses":[],"deploymentBlock":"0x01","forwarder":"0xAc52F68f31577E44aE0C7E95A42dC9eb574B9383"},"MintingManager":{"address":"0x27935e7e85db3c4e7885eB828B9e889BA69a4e7f","legacyAddresses":[],"deploymentBlock":"0x0f","implementation":"0xa1A2114B0C4bDF9AEe05fdd80801e6267639FAd9","forwarder":"0xC20631145b77a58018E2b10f2282Dd048E12fC81"},"ProxyAdmin":{"address":"0xbE5dEAC45dd1ca4ee18Dc2D585D84D3d3CB82B0D","legacyAddresses":[],"deploymentBlock":"0x01"},"SignatureController":{"address":"0x7bB6Cd9be29fab783c0b494A06FED8b2E2596B7a","legacyAddresses":[],"deploymentBlock":"0x02"},"MintingController":{"address":"0x4a3C194eB88966178bfDD81744ddDafED611B830","legacyAddresses":[],"deploymentBlock":"0x03","deprecated":true},"WhitelistedMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"URIPrefixController":{"address":"0x4872CC1be60A9DB9c880A0A437Da7a6AF134F08f","legacyAddresses":[],"deploymentBlock":"0x04","deprecated":true},"DomainZoneController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"Resolver":{"address":"0xF8C26340C1eAeA6c7fF1760B25005e1306953572","legacyAddresses":[],"deploymentBlock":"0x08","forwarder":"0x11dD97b7Ca847DfB6504e61B7B9Eb30F55E554a0"},"ProxyReader":{"address":"0x4e44E79e0cEc05D9e62e952B2088c02A3C450aeC","legacyAddresses":[],"deploymentBlock":"0x14"},"TwitterValidationOperator":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"FreeMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"MintableERC721Predicate":{"address":"0x7c3c91245769c8B7450aD522792deC4bd4bf797f","legacyAddresses":[],"deploymentBlock":"0x1b"},"RootChainManager":{"address":"0x2f5e6eed50C839835BD2873d428E1683793Ad09D","legacyAddresses":[],"deploymentBlock":"0x1d"}}},"80001":{"contracts":{"UNSRegistry":{"address":"0x2a93C52E7B6E7054870758e15A1446E769EdfB93","legacyAddresses":[],"deploymentBlock":"0x0189f713","implementation":"0xAc1a1F2136BfDe3a353a95C0676Cd0d55f311ee3","forwarder":"0x2a93C52E7B6E7054870758e15A1446E769EdfB93"},"CNSRegistry":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","forwarder":"0x0000000000000000000000000000000000000000"},"MintingManager":{"address":"0x428189346bb3CC52f031A1092fd47C919AC30A9f","legacyAddresses":[],"deploymentBlock":"0x01213f4a","implementation":"0xCC17E698bA21bae4277579F22cA51135AaF00777","forwarder":"0xEf3a491A8750BEC2Dff5339CF6Df94436d432C4d"},"ProxyAdmin":{"address":"0x460d63117c7Ab1624b7474C45BF46eC6702f57ce","legacyAddresses":[],"deploymentBlock":"0x01213b22"},"SignatureController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"MintingController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"WhitelistedMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"URIPrefixController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"DomainZoneController":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"Resolver":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","forwarder":"0x0000000000000000000000000000000000000000"},"ProxyReader":{"address":"0x6fe7c857C1B0E54492C8762f27e0a45CA7ff264B","legacyAddresses":["0xbd9e01F6513E7C05f71Bf21d419a3bDF1EA9104b","0x332A8191905fA8E6eeA7350B5799F225B8ed30a9"],"deploymentBlock":"0x0189f72d"},"TwitterValidationOperator":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"FreeMinter":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0","deprecated":true},"MintableERC721Predicate":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"},"RootChainManager":{"address":"0x0000000000000000000000000000000000000000","legacyAddresses":[],"deploymentBlock":"0x0"}}}}}');

});


parcelRegister("d7bnB", function(module, exports) {
module.exports = JSON.parse('{"version":"2.1.1","information":{"description":"This file desribes all resolver keys with a defined meaning and related metadata used by Unstoppable Domains UNS Registry","documentation":"https://docs.unstoppabledomains.com/domain-registry-essentials/records-reference","contribution":"https://github.com/unstoppabledomains/uns/blob/main/resolver-keys.json"},"keys":{"crypto.BTC.address":{"deprecatedKeyName":"BTC","deprecated":false,"validationRegex":"^bc1[ac-hj-np-z02-9]{6,87}$|^[13][a-km-zA-HJ-NP-Z1-9]{25,39}$"},"crypto.ETH.address":{"deprecatedKeyName":"ETH","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.ZIL.address":{"deprecatedKeyName":"ZIL","deprecated":false,"validationRegex":"^zil1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]{38}$"},"crypto.LTC.address":{"deprecatedKeyName":"LTC","deprecated":false,"validationRegex":"^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$|^ltc1[a-zA-HJ-NP-Z0-9]{25,39}$"},"crypto.ETC.address":{"deprecatedKeyName":"ETC","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.EQL.address":{"deprecatedKeyName":"EQL","deprecated":false,"validationRegex":"^bnb[0-9a-z]{39}$"},"crypto.LINK.address":{"deprecatedKeyName":"LINK","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.USDC.address":{"deprecatedKeyName":"USDC","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.BAT.address":{"deprecatedKeyName":"BAT","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.REP.address":{"deprecatedKeyName":"REP","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.ZRX.address":{"deprecatedKeyName":"ZRX","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.DAI.address":{"deprecatedKeyName":"DAI","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.BCH.address":{"deprecatedKeyName":"BCH","deprecated":false,"validationRegex":"^[13][a-km-zA-HJ-NP-Z1-9]{33}$|^((bitcoincash|bchreg|bchtest):)?(q|p)[a-z0-9]{41}$|^((BITCOINCASH:)?(Q|P)[A-Z0-9]{41})$"},"crypto.XMR.address":{"deprecatedKeyName":"XMR","deprecated":false,"validationRegex":"^[48]{1}[0-9AB][1-9A-HJ-NP-Za-km-z]{93}$"},"crypto.DASH.address":{"deprecatedKeyName":"DASH","deprecated":false,"validationRegex":"^X[1-9A-HJ-NP-Za-km-z]{33}$"},"crypto.NEO.address":{"deprecatedKeyName":"NEO","deprecated":false,"validationRegex":"^A[0-9a-zA-Z]{33}$"},"crypto.SWTH.address":{"deprecatedKeyName":"SWTH","deprecated":false,"validationRegex":"^A[0-9a-zA-Z]{33}$"},"crypto.DOGE.address":{"deprecatedKeyName":"DOGE","deprecated":false,"validationRegex":"^D[5-9A-HJ-NP-U]{1}[1-9A-HJ-NP-Za-km-z]{32}$"},"crypto.XRP.address":{"deprecatedKeyName":"XRP","deprecated":false,"validationRegex":"^r[1-9a-km-zA-HJ-NP-Z]{24,34}$"},"crypto.ZEC.address":{"deprecatedKeyName":"ZEC","deprecated":false,"validationRegex":"^z([a-zA-Z0-9]){94}$|^zs1([a-zA-Z0-9]){75}$|^t([a-zA-Z0-9]){34}$"},"crypto.YEC.address":{"deprecatedKeyName":"YEC","deprecated":false,"validationRegex":"^y([a-zA-Z0-9]){94}$|^ys1([a-zA-Z0-9]){75}$|^s([a-zA-Z0-9]){34}$"},"crypto.ADA.address":{"deprecatedKeyName":"ADA","deprecated":false,"validationRegex":"^[1-9a-km-zA-HJ-NP-Z]{104}$|^A[1-9A-HJ-NP-Za-km-z]{58}$|^addr[0-9a-zA-Z]{99}$"},"crypto.EOS.address":{"deprecatedKeyName":"EOS","deprecated":false,"validationRegex":"^[a-z][a-z1-5.]{10}[a-z1-5]$"},"crypto.XLM.address":{"deprecatedKeyName":"XLM","deprecated":false,"validationRegex":"^G[A-Z2-7]{55}$"},"crypto.BNB.address":{"deprecatedKeyName":"BNB","deprecated":false,"validationRegex":"^bnb[0-9a-z]{39}$"},"crypto.BTG.address":{"deprecatedKeyName":"BTG","deprecated":false,"validationRegex":"^[GA][a-km-zA-HJ-NP-Z1-9]{33}$"},"crypto.NANO.address":{"deprecatedKeyName":"NANO","deprecated":false,"validationRegex":"^nano_[1-9a-z]{60}$"},"crypto.WAVES.address":{"deprecatedKeyName":"WAVES","deprecated":false,"validationRegex":"^3[a-km-zA-HJ-NP-Z1-9]{34}$"},"crypto.KMD.address":{"deprecatedKeyName":"KMD","deprecated":false,"validationRegex":"^R[a-km-zA-Z1-9]{33}$"},"crypto.AE.address":{"deprecatedKeyName":"AE","deprecated":false,"validationRegex":"^ak_[a-km-zA-Z1-9]{48,52}$"},"crypto.RSK.address":{"deprecatedKeyName":"RSK","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.WAN.address":{"deprecatedKeyName":"WAN","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.STRAT.address":{"deprecatedKeyName":"STRAT","deprecated":false,"validationRegex":"^S[a-km-zA-HJ-NP-Z1-9]{33}$"},"crypto.UBQ.address":{"deprecatedKeyName":"UBQ","deprecated":false,"validationRegex":"^0x[a-km-zA-HJ-NP-Z0-9]{40}$"},"crypto.XTZ.address":{"deprecatedKeyName":"XTZ","deprecated":false,"validationRegex":"^(tz|KT)[a-km-zA-HJ-NP-Z1-9]{34}$"},"crypto.IOTA.address":{"deprecatedKeyName":"IOTA","deprecated":false,"validationRegex":"^[A-Z0-9]{90}$|^iota1[a-z0-9]{59}$"},"crypto.VET.address":{"deprecatedKeyName":"VET","deprecated":false,"validationRegex":"^0x[a-km-zA-HJ-NP-Z0-9]{40}$"},"crypto.QTUM.address":{"deprecatedKeyName":"QTUM","deprecated":false,"validationRegex":"^Q[a-km-zA-HJ-NP-Z1-9]{33}$"},"crypto.ICX.address":{"deprecatedKeyName":"ICX","deprecated":false,"validationRegex":"^[a-km-zA-HJ-NP-Z0-9]{42}$"},"crypto.DGB.address":{"deprecatedKeyName":"DGB","deprecated":false,"validationRegex":"(^[a-km-zA-HJ-NP-Z1-9]{34}$)|(^[a-zA-Z1-9]{42}$)|(^dgb1[a-zA-Z0-9]{39}$)"},"crypto.XZC.address":{"deprecatedKeyName":"XZC","deprecated":false,"validationRegex":"^[a-km-zA-HJ-NP-Z1-9]{34}$"},"crypto.BURST.address":{"deprecatedKeyName":"BURST","deprecated":false,"validationRegex":"^BURST-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{5}"},"crypto.DCR.address":{"deprecatedKeyName":"DCR","deprecated":false,"validationRegex":null},"crypto.XEM.address":{"deprecatedKeyName":"XEM","deprecated":false,"validationRegex":"^N[ABCDEFGHIJKLMNOPQRSTUVWXYZ234567]{39}$"},"crypto.LSK.address":{"deprecatedKeyName":"LSK","deprecated":false,"validationRegex":"^\\\\d{1,21}[L]$"},"crypto.ATOM.address":{"deprecatedKeyName":"ATOM","deprecated":false,"validationRegex":"^(cosmos)1([qpzry9x8gf2tvdw0s3jn54khce6mua7l]+)$"},"crypto.ONG.address":{"deprecatedKeyName":"ONG","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.ONT.address":{"deprecatedKeyName":"ONT","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.SMART.address":{"deprecatedKeyName":"SMART","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.TPAY.address":{"deprecatedKeyName":"TPAY","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.GRS.address":{"deprecatedKeyName":"GRS","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.BSV.address":{"deprecatedKeyName":"BSV","deprecated":false,"validationRegex":"^bitcoincash:[a-zA-Z0-9]{42}$"},"crypto.GAS.address":{"deprecatedKeyName":"GAS","deprecated":false,"validationRegex":null},"crypto.TRX.address":{"deprecatedKeyName":"TRX","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.VTHO.address":{"deprecatedKeyName":"VTHO","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{42}$"},"crypto.BCD.address":{"deprecatedKeyName":"BCD","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.BTT.address":{"deprecatedKeyName":"BTT","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.KIN.address":{"deprecatedKeyName":"KIN","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{56}$"},"crypto.RVN.address":{"deprecatedKeyName":"RVN","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.ARK.address":{"deprecatedKeyName":"ARK","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.XVG.address":{"deprecatedKeyName":"XVG","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.ALGO.address":{"deprecatedKeyName":"ALGO","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{58}$"},"crypto.NEBL.address":{"deprecatedKeyName":"NEBL","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.XPM.address":{"deprecatedKeyName":"XPM","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.ONE.address":{"deprecatedKeyName":"ONE","deprecated":false,"validationRegex":"^one[a-zA-Z0-9]{39}$"},"crypto.BNTY.address":{"deprecatedKeyName":"BNTY","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.CRO.address":{"deprecatedKeyName":"CRO","deprecated":false,"validationRegex":"^0x[a-fA-F0-9]{40}$"},"crypto.TWT.address":{"deprecatedKeyName":"TWT","deprecated":false,"validationRegex":"^bnb[0-9a-z]{39}$"},"crypto.SIERRA.address":{"deprecatedKeyName":"SIERRA","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{34}$"},"crypto.VSYS.address":{"deprecatedKeyName":"VSYS","deprecated":false,"validationRegex":"^[a-zA-Z0-9]{35}$"},"crypto.HIVE.address":{"deprecatedKeyName":"HIVE","validationRegex":"^(?!s*$).+","deprecated":false},"crypto.HT.address":{"deprecatedKeyName":"HT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ENJ.address":{"deprecatedKeyName":"ENJ","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.YFI.address":{"deprecatedKeyName":"YFI","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MTA.address":{"deprecatedKeyName":"MTA","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.COMP.address":{"deprecatedKeyName":"COMP","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BAL.address":{"deprecatedKeyName":"BAL","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AMPL.address":{"deprecatedKeyName":"AMPL","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.LEND.address":{"deprecatedKeyName":"LEND","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TLOS.address":{"deprecatedKeyName":"TLOS","validationRegex":"^[a-z][a-z1-5.]{10}[a-z1-5]$","deprecated":false},"crypto.XDC.address":{"deprecatedKeyName":"XDC","validationRegex":"^xdc[a-fA-F0-9]{40}$","deprecated":false},"crypto.XST.address":{"deprecatedKeyName":"XST","validationRegex":"(?:RwxQ3jUs2BjKhseNX1em4msn2GyV5XAec[PQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]|RwxQ3jUs2BjKhseNX1em4msn2GyV5XAe[defghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]|RwxQ3jUs2BjKhseNX1em4msn2GyV5XA[fghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{2}|RwxQ3jUs2BjKhseNX1em4msn2GyV5X[BCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{3}|RwxQ3jUs2BjKhseNX1em4msn2GyV5[YZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{4}|RwxQ3jUs2BjKhseNX1em4msn2GyV[6789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{5}|RwxQ3jUs2BjKhseNX1em4msn2Gy[WXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{6}|RwxQ3jUs2BjKhseNX1em4msn2G[z][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{7}|RwxQ3jUs2BjKhseNX1em4msn2[HJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{8}|RwxQ3jUs2BjKhseNX1em4msn[3456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{9}|RwxQ3jUs2BjKhseNX1em4ms[opqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{10}|RwxQ3jUs2BjKhseNX1em4m[tuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{11}|RwxQ3jUs2BjKhseNX1em4[nopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{12}|RwxQ3jUs2BjKhseNX1em[56789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{13}|RwxQ3jUs2BjKhseNX1e[nopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{14}|RwxQ3jUs2BjKhseNX1[fghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{15}|RwxQ3jUs2BjKhseNX[23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{16}|RwxQ3jUs2BjKhseN[YZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{17}|RwxQ3jUs2BjKhse[PQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{18}|RwxQ3jUs2BjKhs[fghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{19}|RwxQ3jUs2BjKh[tuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{20}|RwxQ3jUs2BjK[ijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{21}|RwxQ3jUs2Bj[LMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{22}|RwxQ3jUs2B[kmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{23}|RwxQ3jUs2[CDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{24}|RwxQ3jUs[3456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{25}|RwxQ3jU[tuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{26}|RwxQ3j[VWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{27}|RwxQ3[kmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{28}|RwxQ[456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{29}|Rwx[RSTUVWXYZabcdefghijkmnopqrstuvwxyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{30}|Rw[yz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{31}|R[xyz][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{32}|S[123456789ABCDEFGHJKL][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{32}|SM[123456789ABCDEFGH][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{31}|SMJ11[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{29}|SMJ11[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{29}|SMJ12[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnop][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{28}|SMJ12q[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{27}|SMJ12qn[12345678][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{26}|SMJ12qn9[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghi][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{25}|SMJ12qn9j[123456789ABCDEFGHJKLM][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{24}|SMJ12qn9jN[123456789AB][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{23}|SMJ12qn9jNC[123456789AB][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{22}|SMJ12qn9jNCC[123456789ABCDEFGHJKLMNPQRSTUVW][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{21}|SMJ12qn9jNCCX[123456789ABCDEFGH][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{20}|SMJ12qn9jNCCXJ[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{19}|SMJ12qn9jNCCXJn[123456789ABCDEFGHJKLMNPQRS][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{18}|SMJ12qn9jNCCXJnT[123456789ABCDEFGHJKLMNPQRSTUVWX][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{17}|SMJ12qn9jNCCXJnTY[123456789ABCDEFGHJKLMNPQ][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{16}|SMJ12qn9jNCCXJnTYR[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxy][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{15}|SMJ12qn9jNCCXJnTYRz[1234][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{14}|SMJ12qn9jNCCXJnTYRz5[123456789ABCDEFGHJKLMNPQRSTUVWX][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{13}|SMJ12qn9jNCCXJnTYRz5Y[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrst][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{12}|SMJ12qn9jNCCXJnTYRz5Yu[12345678][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{11}|SMJ12qn9jNCCXJnTYRz5Yu9[123456789ABCDEFGHJKLMNPQRSTUVWXY][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{10}|SMJ12qn9jNCCXJnTYRz5Yu9Z[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcd][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{9}|SMJ12qn9jNCCXJnTYRz5Yu9Ze[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{8}|SMJ12qn9jNCCXJnTYRz5Yu9Zen[123456789ABCD][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{7}|SMJ12qn9jNCCXJnTYRz5Yu9ZenE[123456789ABCDEFGHJKLMNPQ][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{6}|SMJ12qn9jNCCXJnTYRz5Yu9ZenER[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkm][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{5}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERn[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghij][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{4}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnk[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghij][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{3}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnkk[123456789ABCDEFGHJKLMNPQRST][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{2}|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnkkU[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstu][123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]|SMJ12qn9jNCCXJnTYRz5Yu9ZenERnkkUv[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghi])","deprecated":false},"crypto.STRAX.address":{"deprecatedKeyName":"STRAX","validationRegex":"^X[a-km-zA-HJ-NP-Z1-9]{33}$","deprecated":false},"crypto.SIGNA.address":{"deprecatedKeyName":"SIGNA","validationRegex":"^S-((?=[A-Z2-9]{4})(?:[^IO]{4})-){3}(?=[A-Z2-9]{5})(?:[^IO]{5})$","deprecated":false},"crypto.NIM.address":{"deprecatedKeyName":"NIM","validationRegex":"^NQ[0-9]{2} ([A-Z0-9]{4} ){7}[A-Z0-9]{4}$","deprecated":false},"crypto.GUAP.address":{"deprecatedKeyName":"GUAP","validationRegex":"^(G|P)[a-zA-HJ-NP-Z0-9]{25,39}$","deprecated":false},"crypto.ELA.version.ELA.address":{"deprecatedKeyName":"ELA_ELA","validationRegex":"E[a-zA-HJ-NP-Z0-9]{33}","deprecated":false},"crypto.ELA.version.ESC.address":{"deprecatedKeyName":"ELA_ESC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.USDT.version.ERC20.address":{"deprecatedKeyName":"USDT_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.USDT.version.TRON.address":{"deprecatedKeyName":"USDT_TRON","validationRegex":"^[T][a-zA-HJ-NP-Z0-9]{33}$","deprecated":false},"crypto.USDT.version.EOS.address":{"deprecatedKeyName":"USDT_EOS","validationRegex":"^[a-z][a-z1-5.]{10}[a-z1-5]$","deprecated":false},"crypto.USDT.version.OMNI.address":{"deprecatedKeyName":"USDT_OMNI","validationRegex":"^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$","deprecated":false},"crypto.FTM.version.ERC20.address":{"deprecatedKeyName":"FTM_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FTM.version.BEP2.address":{"deprecatedKeyName":"FTM_BEP2","validationRegex":"^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$","deprecated":false},"crypto.FTM.version.OPERA.address":{"deprecatedKeyName":"FTM_OPERA","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FUSE.version.ERC20.address":{"deprecatedKeyName":"FUSE_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FUSE.version.FUSE.address":{"deprecatedKeyName":"FUSE_FUSE","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MATIC.version.MATIC.address":{"deprecatedKeyName":"MATIC_MATIC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MATIC.version.BEP20.address":{"deprecatedKeyName":"MATIC_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MATIC.version.ERC20.address":{"deprecatedKeyName":"MATIC_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"social.payid.name":{"deprecatedKeyName":"payid","validationRegex":"^[0-9a-zA-Z]+\\\\$[0-9a-zA-Z]+\\\\.[0-9a-zA-Z]+$","deprecated":false},"social.picture.value":{"deprecatedKeyName":"picture","validationRegex":null,"deprecated":false},"whois.email.value":{"deprecatedKeyName":"email","validationRegex":"^[^@]+@[^\\\\.]+\\\\..+$","deprecated":false},"whois.for_sale.value":{"deprecatedKeyName":"for_sale","validationRegex":"(true)|(false)","deprecated":false},"ipfs.html.value":{"deprecatedKeyName":"html","validationRegex":".{0,100}","deprecated":false},"ipfs.redirect_domain.value":{"deprecatedKeyName":"redirect_domain","validationRegex":".{0,253}","deprecated":false},"dweb.ipfs.hash":{"deprecatedKeyName":"dweb_hash","validationRegex":".{0,100}","deprecated":false},"browser.redirect_url":{"deprecatedKeyName":"browser_redirect","validationRegex":".{0,253}","deprecated":false},"browser.preferred_protocols":{"deprecatedKeyName":"browser_preferred_protocols","validationRegex":null,"deprecated":false},"gundb.username.value":{"deprecatedKeyName":"gundb_username","validationRegex":null,"deprecated":false},"gundb.public_key.value":{"deprecatedKeyName":"gundb_public_key","validationRegex":null,"deprecated":false},"social.image.value":{"deprecatedKeyName":"image","validationRegex":null,"deprecated":false},"social.twitter.username":{"deprecatedKeyName":"twitter_username","validationRegex":null,"deprecated":false},"validation.social.twitter.username":{"deprecatedKeyName":"validation_twitter_username","validationRegex":null,"deprecated":false},"forwarding.url":{"deprecatedKeyName":"forwarding_url","validationRegex":"^(https?)://[^\\\\s/$.?#].[^\\\\s]*$","deprecated":false},"dns.ttl":{"deprecatedKeyName":"dns_ttl","validationRegex":null,"deprecated":false},"dns.A":{"deprecatedKeyName":"dns_A","validationRegex":null,"deprecated":false},"dns.A.ttl":{"deprecatedKeyName":"dns_A_ttl","validationRegex":null,"deprecated":false},"dns.AAAA":{"deprecatedKeyName":"dns_AAAA","validationRegex":null,"deprecated":false},"dns.AAAA.ttl":{"deprecatedKeyName":"dns_AAAA_ttl","validationRegex":null,"deprecated":false},"dns.AFSDB":{"deprecatedKeyName":"dns_AFSDB","validationRegex":null,"deprecated":false},"dns.AFSDB.ttl":{"deprecatedKeyName":"dns_AFSDB_ttl","validationRegex":null,"deprecated":false},"dns.APL":{"deprecatedKeyName":"dns_APL","validationRegex":null,"deprecated":false},"dns.APL.ttl":{"deprecatedKeyName":"dns_APL_ttl","validationRegex":null,"deprecated":false},"dns.CAA":{"deprecatedKeyName":"dns_CAA","validationRegex":null,"deprecated":false},"dns.CAA.ttl":{"deprecatedKeyName":"dns_CAA_ttl","validationRegex":null,"deprecated":false},"dns.CDNSKEY":{"deprecatedKeyName":"dns_CDNSKEY","validationRegex":null,"deprecated":false},"dns.CDNSKEY.ttl":{"deprecatedKeyName":"dns_CDNSKEY_ttl","validationRegex":null,"deprecated":false},"dns.CDS":{"deprecatedKeyName":"dns_CDS","validationRegex":null,"deprecated":false},"dns.CDS.ttl":{"deprecatedKeyName":"dns_CDS_ttl","validationRegex":null,"deprecated":false},"dns.CERT":{"deprecatedKeyName":"dns_CERT","validationRegex":null,"deprecated":false},"dns.CERT.ttl":{"deprecatedKeyName":"dns_CERT_ttl","validationRegex":null,"deprecated":false},"dns.CNAME":{"deprecatedKeyName":"dns_CNAME","validationRegex":null,"deprecated":false},"dns.CNAME.ttl":{"deprecatedKeyName":"dns_CNAME_ttl","validationRegex":null,"deprecated":false},"dns.CSYNC":{"deprecatedKeyName":"dns_CSYNC","validationRegex":null,"deprecated":false},"dns.CSYNC.ttl":{"deprecatedKeyName":"dns_CSYNC_ttl","validationRegex":null,"deprecated":false},"dns.DHCID":{"deprecatedKeyName":"dns_DHCID","validationRegex":null,"deprecated":false},"dns.DHCID.ttl":{"deprecatedKeyName":"dns_DHCID_ttl","validationRegex":null,"deprecated":false},"dns.DLV":{"deprecatedKeyName":"dns_DLV","validationRegex":null,"deprecated":false},"dns.DLV.ttl":{"deprecatedKeyName":"dns_DLV_ttl","validationRegex":null,"deprecated":false},"dns.DNAME":{"deprecatedKeyName":"dns_DNAME","validationRegex":null,"deprecated":false},"dns.DNAME.ttl":{"deprecatedKeyName":"dns_DNAME_ttl","validationRegex":null,"deprecated":false},"dns.DNSKEY":{"deprecatedKeyName":"dns_DNSKEY","validationRegex":null,"deprecated":false},"dns.DNSKEY.ttl":{"deprecatedKeyName":"dns_DNSKEY_ttl","validationRegex":null,"deprecated":false},"dns.DS":{"deprecatedKeyName":"dns_DS","validationRegex":null,"deprecated":false},"dns.DS.ttl":{"deprecatedKeyName":"dns_DS_ttl","validationRegex":null,"deprecated":false},"dns.EUI48":{"deprecatedKeyName":"dns_EUI48","validationRegex":null,"deprecated":false},"dns.EUI48.ttl":{"deprecatedKeyName":"dns_EUI48_ttl","validationRegex":null,"deprecated":false},"dns.EUI64":{"deprecatedKeyName":"dns_EUI64","validationRegex":null,"deprecated":false},"dns.EUI64.ttl":{"deprecatedKeyName":"dns_EUI64_ttl","validationRegex":null,"deprecated":false},"dns.HINFO":{"deprecatedKeyName":"dns_HINFO","validationRegex":null,"deprecated":false},"dns.HINFO.ttl":{"deprecatedKeyName":"dns_HINFO_ttl","validationRegex":null,"deprecated":false},"dns.HIP":{"deprecatedKeyName":"dns_HIP","validationRegex":null,"deprecated":false},"dns.HIP.ttl":{"deprecatedKeyName":"dns_HIP_ttl","validationRegex":null,"deprecated":false},"dns.HTTPS":{"deprecatedKeyName":"dns_HTTPS","validationRegex":null,"deprecated":false},"dns.HTTPS.ttl":{"deprecatedKeyName":"dns_HTTPS_ttl","validationRegex":null,"deprecated":false},"dns.IPSECKEY":{"deprecatedKeyName":"dns_IPSECKEY","validationRegex":null,"deprecated":false},"dns.IPSECKEY.ttl":{"deprecatedKeyName":"dns_IPSECKEY_ttl","validationRegex":null,"deprecated":false},"dns.KEY":{"deprecatedKeyName":"dns_KEY","validationRegex":null,"deprecated":false},"dns.KEY.ttl":{"deprecatedKeyName":"dns_KEY_ttl","validationRegex":null,"deprecated":false},"dns.KX":{"deprecatedKeyName":"dns_KX","validationRegex":null,"deprecated":false},"dns.KX.ttl":{"deprecatedKeyName":"dns_KX_ttl","validationRegex":null,"deprecated":false},"dns.LOC":{"deprecatedKeyName":"dns_LOC","validationRegex":null,"deprecated":false},"dns.LOC.ttl":{"deprecatedKeyName":"dns_LOC_ttl","validationRegex":null,"deprecated":false},"dns.MX":{"deprecatedKeyName":"dns_MX","validationRegex":null,"deprecated":false},"dns.MX.ttl":{"deprecatedKeyName":"dns_MX_ttl","validationRegex":null,"deprecated":false},"dns.NAPTR":{"deprecatedKeyName":"dns_NAPTR","validationRegex":null,"deprecated":false},"dns.NAPTR.ttl":{"deprecatedKeyName":"dns_NAPTR_ttl","validationRegex":null,"deprecated":false},"dns.NS":{"deprecatedKeyName":"dns_NS","validationRegex":null,"deprecated":false},"dns.NS.ttl":{"deprecatedKeyName":"dns_NS_ttl","validationRegex":null,"deprecated":false},"dns.NSEC":{"deprecatedKeyName":"dns_NSEC","validationRegex":null,"deprecated":false},"dns.NSEC.ttl":{"deprecatedKeyName":"dns_NSEC_ttl","validationRegex":null,"deprecated":false},"dns.NSEC3":{"deprecatedKeyName":"dns_NSEC3","validationRegex":null,"deprecated":false},"dns.NSEC3.ttl":{"deprecatedKeyName":"dns_NSEC3_ttl","validationRegex":null,"deprecated":false},"dns.NSEC3PARAM":{"deprecatedKeyName":"dns_NSEC3PARAM","validationRegex":null,"deprecated":false},"dns.NSEC3PARAM.ttl":{"deprecatedKeyName":"dns_NSEC3PARAM_ttl","validationRegex":null,"deprecated":false},"dns.OPENPGPKEY":{"deprecatedKeyName":"dns_OPENPGPKEY","validationRegex":null,"deprecated":false},"dns.OPENPGPKEY.ttl":{"deprecatedKeyName":"dns_OPENPGPKEY_ttl","validationRegex":null,"deprecated":false},"dns.PTR":{"deprecatedKeyName":"dns_PTR","validationRegex":null,"deprecated":false},"dns.PTR.ttl":{"deprecatedKeyName":"dns_PTR_ttl","validationRegex":null,"deprecated":false},"dns.RP":{"deprecatedKeyName":"dns_RP","validationRegex":null,"deprecated":false},"dns.RP.ttl":{"deprecatedKeyName":"dns_RP_ttl","validationRegex":null,"deprecated":false},"dns.RRSIG":{"deprecatedKeyName":"dns_RRSIG","validationRegex":null,"deprecated":false},"dns.RRSIG.ttl":{"deprecatedKeyName":"dns_RRSIG_ttl","validationRegex":null,"deprecated":false},"dns.SIG":{"deprecatedKeyName":"dns_SIG","validationRegex":null,"deprecated":false},"dns.SIG.ttl":{"deprecatedKeyName":"dns_SIG_ttl","validationRegex":null,"deprecated":false},"dns.SMIMEA":{"deprecatedKeyName":"dns_SMIMEA","validationRegex":null,"deprecated":false},"dns.SMIMEA.ttl":{"deprecatedKeyName":"dns_SMIMEA_ttl","validationRegex":null,"deprecated":false},"dns.SOA":{"deprecatedKeyName":"dns_SOA","validationRegex":null,"deprecated":false},"dns.SOA.ttl":{"deprecatedKeyName":"dns_SOA_ttl","validationRegex":null,"deprecated":false},"dns.SRV":{"deprecatedKeyName":"dns_SRV","validationRegex":null,"deprecated":false},"dns.SRV.ttl":{"deprecatedKeyName":"dns_SRV_ttl","validationRegex":null,"deprecated":false},"dns.SSHFP":{"deprecatedKeyName":"dns_SSHFP","validationRegex":null,"deprecated":false},"dns.SSHFP.ttl":{"deprecatedKeyName":"dns_SSHFP_ttl","validationRegex":null,"deprecated":false},"dns.SVCB":{"deprecatedKeyName":"dns_SVCB","validationRegex":null,"deprecated":false},"dns.SVCB.ttl":{"deprecatedKeyName":"dns_SVCB_ttl","validationRegex":null,"deprecated":false},"dns.TA":{"deprecatedKeyName":"dns_TA","validationRegex":null,"deprecated":false},"dns.TA.ttl":{"deprecatedKeyName":"dns_TA_ttl","validationRegex":null,"deprecated":false},"dns.TKEY":{"deprecatedKeyName":"dns_TKEY","validationRegex":null,"deprecated":false},"dns.TKEY.ttl":{"deprecatedKeyName":"dns_TKEY_ttl","validationRegex":null,"deprecated":false},"dns.TLSA":{"deprecatedKeyName":"dns_TLSA","validationRegex":null,"deprecated":false},"dns.TLSA.ttl":{"deprecatedKeyName":"dns_TLSA_ttl","validationRegex":null,"deprecated":false},"dns.TSIG":{"deprecatedKeyName":"dns_TSIG","validationRegex":null,"deprecated":false},"dns.TSIG.ttl":{"deprecatedKeyName":"dns_TSIG_ttl","validationRegex":null,"deprecated":false},"dns.TXT":{"deprecatedKeyName":"dns_TXT","validationRegex":null,"deprecated":false},"dns.TXT.ttl":{"deprecatedKeyName":"dns_TXT_ttl","validationRegex":null,"deprecated":false},"dns.URI":{"deprecatedKeyName":"dns_URI","validationRegex":null,"deprecated":false},"dns.URI.ttl":{"deprecatedKeyName":"dns_URI_ttl","validationRegex":null,"deprecated":false},"dns.ZONEMD":{"deprecatedKeyName":"dns_ZONEMD","validationRegex":null,"deprecated":false},"dns.ZONEMD.ttl":{"deprecatedKeyName":"dns_ZONEMD_ttl","validationRegex":null,"deprecated":false},"crypto.DOT.address":{"deprecatedKeyName":"DOT","validationRegex":null,"deprecated":false},"crypto.UNI.version.ERC20.address":{"deprecatedKeyName":"UNI_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.UNI.version.BEP20.address":{"deprecatedKeyName":"UNI_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.UNI.version.MATIC.address":{"deprecatedKeyName":"UNI_MATIC","validationRegex":null,"deprecated":false},"crypto.UNI.version.HRC20.address":{"deprecatedKeyName":"UNI_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.UNI.version.XDAI.address":{"deprecatedKeyName":"UNI_XDAI","validationRegex":null,"deprecated":false},"crypto.SOL.address":{"deprecatedKeyName":"SOL","validationRegex":null,"deprecated":false},"crypto.BUSD.version.ERC20.address":{"deprecatedKeyName":"BUSD_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BUSD.version.BEP20.address":{"deprecatedKeyName":"BUSD_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BUSD.version.HRC20.address":{"deprecatedKeyName":"BUSD_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ICP.address":{"deprecatedKeyName":"ICP","validationRegex":null,"deprecated":false},"crypto.THETA.address":{"deprecatedKeyName":"THETA","validationRegex":null,"deprecated":false},"crypto.WBTC.version.ERC20.address":{"deprecatedKeyName":"WBTC_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.WBTC.version.MATIC.address":{"deprecatedKeyName":"WBTC_MATIC","validationRegex":null,"deprecated":false},"crypto.WBTC.version.FANTOM.address":{"deprecatedKeyName":"WBTC_FANTOM","validationRegex":null,"deprecated":false},"crypto.WBTC.version.HRC20.address":{"deprecatedKeyName":"WBTC_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.WBTC.version.XDAI.address":{"deprecatedKeyName":"WBTC_XDAI","validationRegex":null,"deprecated":false},"crypto.FIL.address":{"deprecatedKeyName":"FIL","validationRegex":null,"deprecated":false},"crypto.CDAI.address":{"deprecatedKeyName":"CDAI","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KSM.address":{"deprecatedKeyName":"KSM","validationRegex":null,"deprecated":false},"crypto.OKB.address":{"deprecatedKeyName":"OKB","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AAVE.version.ERC20.address":{"deprecatedKeyName":"AAVE_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AAVE.version.MATIC.address":{"deprecatedKeyName":"AAVE_MATIC","validationRegex":null,"deprecated":false},"crypto.AAVE.version.FANTOM.address":{"deprecatedKeyName":"AAVE_FANTOM","validationRegex":null,"deprecated":false},"crypto.AAVE.version.HRC20.address":{"deprecatedKeyName":"AAVE_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SHIB.version.ERC20.address":{"deprecatedKeyName":"SHIB_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SHIB.version.MATIC.address":{"deprecatedKeyName":"SHIB_MATIC","validationRegex":null,"deprecated":false},"crypto.SHIB.version.FANTOM.address":{"deprecatedKeyName":"SHIB_FANTOM","validationRegex":null,"deprecated":false},"crypto.CEL.version.ERC20.address":{"deprecatedKeyName":"CEL_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CEL.version.MATIC.address":{"deprecatedKeyName":"CEL_MATIC","validationRegex":null,"deprecated":false},"crypto.CEL.version.FANTOM.address":{"deprecatedKeyName":"CEL_FANTOM","validationRegex":null,"deprecated":false},"crypto.CEL.version.HRC20.address":{"deprecatedKeyName":"CEL_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CUSDC.address":{"deprecatedKeyName":"CUSDC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CETH.address":{"deprecatedKeyName":"CETH","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AMP.address":{"deprecatedKeyName":"AMP","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CAKE.version.BEP20.address":{"deprecatedKeyName":"CAKE_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CAKE.version.HRC20.address":{"deprecatedKeyName":"CAKE_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MIOTA.address":{"deprecatedKeyName":"MIOTA","validationRegex":null,"deprecated":false},"crypto.FTT.address":{"deprecatedKeyName":"FTT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MKR.address":{"deprecatedKeyName":"MKR","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TFUEL.address":{"deprecatedKeyName":"TFUEL","validationRegex":null,"deprecated":false},"crypto.KLAY.address":{"deprecatedKeyName":"KLAY","validationRegex":null,"deprecated":false},"crypto.LUNA.address":{"deprecatedKeyName":"LUNA","validationRegex":null,"deprecated":false},"crypto.AVAX.address":{"deprecatedKeyName":"AVAX","validationRegex":null,"deprecated":false},"crypto.LEO.address":{"deprecatedKeyName":"LEO","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SAFEMOON.version.BEP20.address":{"deprecatedKeyName":"SAFEMOON_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SAFEMOON.version.HRC20.address":{"deprecatedKeyName":"SAFEMOON_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.UST.address":{"deprecatedKeyName":"UST","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.RUNE.address":{"deprecatedKeyName":"RUNE","validationRegex":"^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$","deprecated":false},"crypto.HBAR.address":{"deprecatedKeyName":"HBAR","validationRegex":null,"deprecated":false},"crypto.TEL.version.ERC20.address":{"deprecatedKeyName":"TEL_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TEL.version.MATIC.address":{"deprecatedKeyName":"TEL_MATIC","validationRegex":null,"deprecated":false},"crypto.CHZ.address":{"deprecatedKeyName":"CHZ","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SUSHI.version.ERC20.address":{"deprecatedKeyName":"SUSHI_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SUSHI.version.BEP20.address":{"deprecatedKeyName":"SUSHI_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SUSHI.version.MATIC.address":{"deprecatedKeyName":"SUSHI_MATIC","validationRegex":null,"deprecated":false},"crypto.SUSHI.version.FANTOM.address":{"deprecatedKeyName":"SUSHI_FANTOM","validationRegex":null,"deprecated":false},"crypto.SUSHI.version.HRC20.address":{"deprecatedKeyName":"SUSHI_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.EGLD.address":{"deprecatedKeyName":"EGLD","validationRegex":null,"deprecated":false},"crypto.TUSD.version.ERC20.address":{"deprecatedKeyName":"TUSD_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TUSD.version.BEP20.address":{"deprecatedKeyName":"TUSD_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TUSD.version.AVAX.address":{"deprecatedKeyName":"TUSD_AVAX","validationRegex":null,"deprecated":false},"crypto.TUSD.version.HRC20.address":{"deprecatedKeyName":"TUSD_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TUSD.version.BEP2.address":{"deprecatedKeyName":"TUSD_BEP2","validationRegex":"^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$","deprecated":false},"crypto.TUSD.version.TRON.address":{"deprecatedKeyName":"TUSD_TRON","validationRegex":"^[T][a-zA-HJ-NP-Z0-9]{33}$","deprecated":false},"crypto.HBTC.version.ERC20.address":{"deprecatedKeyName":"HBTC_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HBTC.version.HRC20.address":{"deprecatedKeyName":"HBTC_HRC20","validationRegex":null,"deprecated":false},"crypto.SNX.version.ERC20.address":{"deprecatedKeyName":"SNX_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SNX.version.MATIC.address":{"deprecatedKeyName":"SNX_MATIC","validationRegex":null,"deprecated":false},"crypto.SNX.version.FANTOM.address":{"deprecatedKeyName":"SNX_FANTOM","validationRegex":null,"deprecated":false},"crypto.SNX.version.HRC20.address":{"deprecatedKeyName":"SNX_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HOT.version.ERC20.address":{"deprecatedKeyName":"HOT_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HOT.version.HRC20.address":{"deprecatedKeyName":"HOT_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.NEAR.address":{"deprecatedKeyName":"NEAR","validationRegex":null,"deprecated":false},"crypto.HNT.address":{"deprecatedKeyName":"HNT","validationRegex":null,"deprecated":false},"crypto.STETH.address":{"deprecatedKeyName":"STETH","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.NEXO.version.ERC20.address":{"deprecatedKeyName":"NEXO_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.NEXO.version.FANTOM.address":{"deprecatedKeyName":"NEXO_FANTOM","validationRegex":null,"deprecated":false},"crypto.PAX.address":{"deprecatedKeyName":"PAX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.STX.address":{"deprecatedKeyName":"STX","validationRegex":null,"deprecated":false},"crypto.MANA.version.ERC20.address":{"deprecatedKeyName":"MANA_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MANA.version.MATIC.address":{"deprecatedKeyName":"MANA_MATIC","validationRegex":null,"deprecated":false},"crypto.MDX.version.HRC20.address":{"deprecatedKeyName":"MDX_HRC20","validationRegex":null,"deprecated":false},"crypto.MDX.version.BEP20.address":{"deprecatedKeyName":"MDX_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ZEN.address":{"deprecatedKeyName":"ZEN","validationRegex":null,"deprecated":false},"crypto.ARRR.address":{"deprecatedKeyName":"ARRR","validationRegex":null,"deprecated":false},"crypto.BNT.address":{"deprecatedKeyName":"BNT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.LUSD.version.ERC20.address":{"deprecatedKeyName":"LUSD_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.LUSD.version.MATIC.address":{"deprecatedKeyName":"LUSD_MATIC","validationRegex":null,"deprecated":false},"crypto.GRT.version.ERC20.address":{"deprecatedKeyName":"GRT_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.GRT.version.MATIC.address":{"deprecatedKeyName":"GRT_MATIC","validationRegex":null,"deprecated":false},"crypto.GRT.version.HRC20.address":{"deprecatedKeyName":"GRT_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SC.address":{"deprecatedKeyName":"SC","validationRegex":null,"deprecated":false},"crypto.HUSD.version.ERC20.address":{"deprecatedKeyName":"HUSD_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HUSD.version.HRC20.address":{"deprecatedKeyName":"HUSD_HRC20","validationRegex":null,"deprecated":false},"crypto.CRV.version.ERC20.address":{"deprecatedKeyName":"CRV_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CRV.version.MATIC.address":{"deprecatedKeyName":"CRV_MATIC","validationRegex":null,"deprecated":false},"crypto.CRV.version.FANTOM.address":{"deprecatedKeyName":"CRV_FANTOM","validationRegex":null,"deprecated":false},"crypto.UMA.address":{"deprecatedKeyName":"UMA","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.WRX.version.BEP2.address":{"deprecatedKeyName":"WRX_BEP2","validationRegex":"^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$","deprecated":false},"crypto.WRX.version.MATIC.address":{"deprecatedKeyName":"WRX_MATIC","validationRegex":null,"deprecated":false},"crypto.AR.address":{"deprecatedKeyName":"AR","validationRegex":null,"deprecated":false},"crypto.OMG.address":{"deprecatedKeyName":"OMG","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.GT.address":{"deprecatedKeyName":"GT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.QNT.address":{"deprecatedKeyName":"QNT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CHSB.address":{"deprecatedKeyName":"CHSB","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.IOST.address":{"deprecatedKeyName":"IOST","validationRegex":null,"deprecated":false},"crypto.NXM.address":{"deprecatedKeyName":"NXM","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KCS.address":{"deprecatedKeyName":"KCS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.LPT.version.ERC20.address":{"deprecatedKeyName":"LPT_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.LPT.version.HRC20.address":{"deprecatedKeyName":"LPT_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.XSUSHI.address":{"deprecatedKeyName":"XSUSHI","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CUSDT.address":{"deprecatedKeyName":"CUSDT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FLOW.address":{"deprecatedKeyName":"FLOW","validationRegex":null,"deprecated":false},"crypto.ANKR.address":{"deprecatedKeyName":"ANKR","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HBC.address":{"deprecatedKeyName":"HBC","validationRegex":null,"deprecated":false},"crypto.VGX.address":{"deprecatedKeyName":"VGX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FEI.address":{"deprecatedKeyName":"FEI","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BAKE.version.BEP20.address":{"deprecatedKeyName":"BAKE_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BAKE.version.HRC20.address":{"deprecatedKeyName":"BAKE_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.1INCH.version.ERC20.address":{"deprecatedKeyName":"1INCH_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.1INCH.version.BEP20.address":{"deprecatedKeyName":"1INCH_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.1INCH.version.MATIC.address":{"deprecatedKeyName":"1INCH_MATIC","validationRegex":null,"deprecated":false},"crypto.1INCH.version.HRC20.address":{"deprecatedKeyName":"1INCH_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CKB.address":{"deprecatedKeyName":"CKB","validationRegex":null,"deprecated":false},"crypto.WOO.version.ERC20.address":{"deprecatedKeyName":"WOO_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.WOO.version.HRC20.address":{"deprecatedKeyName":"WOO_HRC20","validationRegex":null,"deprecated":false},"crypto.TITAN.address":{"deprecatedKeyName":"TITAN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.OMI.address":{"deprecatedKeyName":"OMI","validationRegex":null,"deprecated":false},"crypto.MINA.address":{"deprecatedKeyName":"MINA","validationRegex":null,"deprecated":false},"crypto.SETH.address":{"deprecatedKeyName":"SETH","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.RSR.address":{"deprecatedKeyName":"RSR","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.OXY.version.SOLANA.address":{"deprecatedKeyName":"OXY_SOLANA","validationRegex":null,"deprecated":false},"crypto.OXY.version.ERC20.address":{"deprecatedKeyName":"OXY_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.REN.version.ERC20.address":{"deprecatedKeyName":"REN_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.REN.version.HRC20.address":{"deprecatedKeyName":"REN_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.XCH.address":{"deprecatedKeyName":"XCH","validationRegex":null,"deprecated":false},"crypto.RENBTC.version.ERC20.address":{"deprecatedKeyName":"RENBTC_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.RENBTC.version.BEP20.address":{"deprecatedKeyName":"RENBTC_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.RENBTC.version.HRC20.address":{"deprecatedKeyName":"RENBTC_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.USDN.address":{"deprecatedKeyName":"USDN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BCHA.address":{"deprecatedKeyName":"BCHA","validationRegex":null,"deprecated":false},"crypto.LRC.address":{"deprecatedKeyName":"LRC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.PUNDIX.address":{"deprecatedKeyName":"PUNDIX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ERG.address":{"deprecatedKeyName":"ERG","validationRegex":null,"deprecated":false},"crypto.WIN.address":{"deprecatedKeyName":"WIN","validationRegex":"^[T][a-zA-HJ-NP-Z0-9]{33}$","deprecated":false},"crypto.NPXS.address":{"deprecatedKeyName":"NPXS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TRIBE.address":{"deprecatedKeyName":"TRIBE","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MAID.address":{"deprecatedKeyName":"MAID","validationRegex":"^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$","deprecated":false},"crypto.ASD.address":{"deprecatedKeyName":"ASD","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CUNI.address":{"deprecatedKeyName":"CUNI","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CELO.address":{"deprecatedKeyName":"CELO","validationRegex":null,"deprecated":false},"crypto.DENT.address":{"deprecatedKeyName":"DENT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SNT.address":{"deprecatedKeyName":"SNT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FEG.version.ERC20.address":{"deprecatedKeyName":"FEG_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FEG.version.HRC20.address":{"deprecatedKeyName":"FEG_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SKL.address":{"deprecatedKeyName":"SKL","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ALUSD.address":{"deprecatedKeyName":"ALUSD","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MIR.version.ERC20.address":{"deprecatedKeyName":"MIR_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MIR.version.BEP20.address":{"deprecatedKeyName":"MIR_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.GLM.address":{"deprecatedKeyName":"GLM","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.PAXG.version.ERC20.address":{"deprecatedKeyName":"PAXG_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.PAXG.version.HRC20.address":{"deprecatedKeyName":"PAXG_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CFX.address":{"deprecatedKeyName":"CFX","validationRegex":null,"deprecated":false},"crypto.UOS.address":{"deprecatedKeyName":"UOS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SVCS.address":{"deprecatedKeyName":"SVCS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.REEF.version.ERC20.address":{"deprecatedKeyName":"REEF_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.REEF.version.BEP20.address":{"deprecatedKeyName":"REEF_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.REEF.version.HRC20.address":{"deprecatedKeyName":"REEF_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.GNO.address":{"deprecatedKeyName":"GNO","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.USDP.address":{"deprecatedKeyName":"USDP","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KAVA.address":{"deprecatedKeyName":"KAVA","validationRegex":null,"deprecated":false},"crypto.ALCX.address":{"deprecatedKeyName":"ALCX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.EWT.address":{"deprecatedKeyName":"EWT","validationRegex":null,"deprecated":false},"crypto.TON.address":{"deprecatedKeyName":"TON","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.RLC.address":{"deprecatedKeyName":"RLC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AXS.address":{"deprecatedKeyName":"AXS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AUDIO.address":{"deprecatedKeyName":"AUDIO","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.XVS.address":{"deprecatedKeyName":"XVS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BAND.version.ERC20.address":{"deprecatedKeyName":"BAND_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.BAND.version.FANTOM.address":{"deprecatedKeyName":"BAND_FANTOM","validationRegex":null,"deprecated":false},"crypto.NMR.address":{"deprecatedKeyName":"NMR","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.INJ.version.ERC20.address":{"deprecatedKeyName":"INJ_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.INJ.version.BEP20.address":{"deprecatedKeyName":"INJ_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.WAXP.address":{"deprecatedKeyName":"WAXP","validationRegex":null,"deprecated":false},"crypto.UQC.address":{"deprecatedKeyName":"UQC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.IOTX.address":{"deprecatedKeyName":"IOTX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FUN.address":{"deprecatedKeyName":"FUN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.OCEAN.address":{"deprecatedKeyName":"OCEAN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SAND.version.ERC20.address":{"deprecatedKeyName":"SAND_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SAND.version.HRC20.address":{"deprecatedKeyName":"SAND_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CTSI.version.ERC20.address":{"deprecatedKeyName":"CTSI_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CTSI.version.BEP20.address":{"deprecatedKeyName":"CTSI_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CTSI.version.MATIC.address":{"deprecatedKeyName":"CTSI_MATIC","validationRegex":null,"deprecated":false},"crypto.RAY.address":{"deprecatedKeyName":"RAY","validationRegex":null,"deprecated":false},"crypto.ANC.version.TERRA.address":{"deprecatedKeyName":"ANC_TERRA","validationRegex":null,"deprecated":false},"crypto.ANC.version.ERC20.address":{"deprecatedKeyName":"ANC_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.IQ.version.ERC20.address":{"deprecatedKeyName":"IQ_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.IQ.version.BEP20.address":{"deprecatedKeyName":"IQ_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.IQ.version.MATIC.address":{"deprecatedKeyName":"IQ_MATIC","validationRegex":null,"deprecated":false},"crypto.SUSD.version.ERC20.address":{"deprecatedKeyName":"SUSD_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SUSD.version.FANTOM.address":{"deprecatedKeyName":"SUSD_FANTOM","validationRegex":null,"deprecated":false},"crypto.KLV.address":{"deprecatedKeyName":"KLV","validationRegex":"^[T][a-zA-HJ-NP-Z0-9]{33}$","deprecated":false},"crypto.BTCST.address":{"deprecatedKeyName":"BTCST","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TLM.address":{"deprecatedKeyName":"TLM","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AKT.address":{"deprecatedKeyName":"AKT","validationRegex":null,"deprecated":false},"crypto.STMX.address":{"deprecatedKeyName":"STMX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.PROM.address":{"deprecatedKeyName":"PROM","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.XPRT.address":{"deprecatedKeyName":"XPRT","validationRegex":null,"deprecated":false},"crypto.SRM.version.ERC20.address":{"deprecatedKeyName":"SRM_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SRM.version.SOLANA.address":{"deprecatedKeyName":"SRM_SOLANA","validationRegex":null,"deprecated":false},"crypto.RPL.address":{"deprecatedKeyName":"RPL","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AGIX.address":{"deprecatedKeyName":"AGIX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CELR.address":{"deprecatedKeyName":"CELR","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.FET.address":{"deprecatedKeyName":"FET","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.OXT.address":{"deprecatedKeyName":"OXT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ARDR.address":{"deprecatedKeyName":"ARDR","validationRegex":null,"deprecated":false},"crypto.MATH.address":{"deprecatedKeyName":"MATH","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.10SET.address":{"deprecatedKeyName":"10SET","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.POLY.address":{"deprecatedKeyName":"POLY","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.GUSD.address":{"deprecatedKeyName":"GUSD","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.NKN.address":{"deprecatedKeyName":"NKN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CVC.address":{"deprecatedKeyName":"CVC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.GTC.address":{"deprecatedKeyName":"GTC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.STEEM.address":{"deprecatedKeyName":"STEEM","validationRegex":null,"deprecated":false},"crypto.ORN.address":{"deprecatedKeyName":"ORN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KEEP.version.ERC20.address":{"deprecatedKeyName":"KEEP_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KEEP.version.HRC20.address":{"deprecatedKeyName":"KEEP_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HXRO.address":{"deprecatedKeyName":"HXRO","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ORBS.address":{"deprecatedKeyName":"ORBS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ALPHA.version.ERC20.address":{"deprecatedKeyName":"ALPHA_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ALPHA.version.BEP20.address":{"deprecatedKeyName":"ALPHA_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.DODO.version.ERC20.address":{"deprecatedKeyName":"DODO_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.DODO.version.BEP20.address":{"deprecatedKeyName":"DODO_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.OGN.address":{"deprecatedKeyName":"OGN","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KNCL.version.ERC20.address":{"deprecatedKeyName":"KNCL_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KNCL.version.FANTOM.address":{"deprecatedKeyName":"KNCL_FANTOM","validationRegex":null,"deprecated":false},"crypto.KNCL.version.HRC20.address":{"deprecatedKeyName":"KNCL_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MED.address":{"deprecatedKeyName":"MED","validationRegex":null,"deprecated":false},"crypto.XAUT.address":{"deprecatedKeyName":"XAUT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.VLX.address":{"deprecatedKeyName":"VLX","validationRegex":null,"deprecated":false},"crypto.PHA.address":{"deprecatedKeyName":"PHA","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.KOBE.address":{"deprecatedKeyName":"KOBE","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.PERP.address":{"deprecatedKeyName":"PERP","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.XHV.address":{"deprecatedKeyName":"XHV","validationRegex":null,"deprecated":false},"crypto.META.address":{"deprecatedKeyName":"META","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SEUR.address":{"deprecatedKeyName":"SEUR","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.MONA.address":{"deprecatedKeyName":"MONA","validationRegex":null,"deprecated":false},"crypto.ANT.address":{"deprecatedKeyName":"ANT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.HYDRA.address":{"deprecatedKeyName":"HYDRA","validationRegex":null,"deprecated":false},"crypto.ZKS.address":{"deprecatedKeyName":"ZKS","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SXP.version.ERC20.address":{"deprecatedKeyName":"SXP_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SXP.version.BEP20.address":{"deprecatedKeyName":"SXP_BEP20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.SXP.version.HRC20.address":{"deprecatedKeyName":"SXP_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.CSPR.address":{"deprecatedKeyName":"CSPR","validationRegex":null,"deprecated":false},"crypto.MTL.address":{"deprecatedKeyName":"MTL","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.NU.address":{"deprecatedKeyName":"NU","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ZMT.address":{"deprecatedKeyName":"ZMT","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.LOC.address":{"deprecatedKeyName":"LOC","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.TKO.address":{"deprecatedKeyName":"TKO","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.ETN.address":{"deprecatedKeyName":"ETN","validationRegex":null,"deprecated":false},"crypto.UBT.version.ERC20.address":{"deprecatedKeyName":"UBT_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.UBT.version.MATIC.address":{"deprecatedKeyName":"UBT_MATIC","validationRegex":null,"deprecated":false},"crypto.EXRD.address":{"deprecatedKeyName":"EXRD","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.NMX.address":{"deprecatedKeyName":"NMX","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.RIF.address":{"deprecatedKeyName":"RIF","validationRegex":null,"deprecated":false},"crypto.STORJ.version.ERC20.address":{"deprecatedKeyName":"STORJ_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.STORJ.version.HRC20.address":{"deprecatedKeyName":"STORJ_HRC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.AVA.address":{"deprecatedKeyName":"AVA","validationRegex":"^(bnb|tbnb)[a-zA-HJ-NP-Z0-9]{39}$","deprecated":false},"crypto.DPI.version.ERC20.address":{"deprecatedKeyName":"DPI_ERC20","validationRegex":"^0x[a-fA-F0-9]{40}$","deprecated":false},"crypto.DPI.version.MATIC.address":{"deprecatedKeyName":"DPI_MATIC","validationRegex":null,"deprecated":false}}}');

});


parcelRegister("3AD97", function(module, exports) {
"use strict";
var $29d319816a13d5b5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $29d319816a13d5b5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29d319816a13d5b5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $29d319816a13d5b5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $anWsB = parcelRequire("anWsB");

var $anKpg = parcelRequire("anKpg");

var $911HQ = parcelRequire("911HQ");

var $bq44C = parcelRequire("bq44C");

var $29d319816a13d5b5$var$Networking_1 = $29d319816a13d5b5$var$__importDefault((parcelRequire("5J7oF")));

var $jECMB = parcelRequire("jECMB");

var $bPRni = parcelRequire("bPRni");

var $2gwgp = parcelRequire("2gwgp");
/**
 * @internal
 */ var $29d319816a13d5b5$var$UdApi = /** @class */ function(_super) {
    $29d319816a13d5b5$var$__extends(UdApi, _super);
    function UdApi(api) {
        var _this = _super.call(this) || this;
        _this.url = (api === null || api === void 0 ? void 0 : api.url) || "https://unstoppabledomains.com/api/v1";
        var DefaultUserAgent = "cross-fetch/3.1.4 (+https://github.com/lquixada/cross-fetch)";
        var CustomUserAgent = "".concat(DefaultUserAgent, " Resolution");
        _this.headers = {
            "X-user-agent": CustomUserAgent
        };
        return _this;
    }
    UdApi.prototype.isSupportedDomain = function(_domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "isSupportedDomain"
                });
            });
        });
    };
    UdApi.prototype.namehash = function(_domain) {
        throw new Error("Unsupported method when using UD Resolution API");
    };
    UdApi.prototype.childhash = function(_parentHash, _label) {
        throw new Error("Unsupported method when using UD Resolution API");
    };
    UdApi.prototype.record = function(domain, key) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.records(domain, [
                                key
                            ])
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()[key]
                        ];
                }
            });
        });
    };
    UdApi.prototype.records = function(domain, keys) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var records;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.allRecords(domain)
                        ];
                    case 1:
                        records = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $jECMB.constructRecords)(keys, records)
                        ];
                }
            });
        });
    };
    UdApi.prototype.owner = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var response, _a, owner, blockchain;
            return $29d319816a13d5b5$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.resolve(domain)
                        ];
                    case 1:
                        response = _b.sent();
                        _a = response.meta, owner = _a.owner, blockchain = _a.blockchain;
                        if (!owner) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                        if (blockchain === $bq44C.BlockchainType.ZIL && !owner.startsWith("zil1")) return [
                            2 /*return*/ ,
                            (0, $anWsB.toBech32Address)(owner)
                        ];
                        return [
                            2 /*return*/ ,
                            owner
                        ];
                }
            });
        });
    };
    UdApi.prototype.twitter = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var serviceName, domainMetaData, owner, records, validationSignature, twitterHandle;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        serviceName = (0, $jECMB.findNamingServiceName)(domain);
                        if (serviceName !== $bq44C.NamingServiceName.UNS) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                            domain: domain,
                            methodName: "twitter"
                        });
                        return [
                            4 /*yield*/ ,
                            this.resolve(domain)
                        ];
                    case 1:
                        domainMetaData = _a.sent();
                        if (!domainMetaData.meta.owner) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnregisteredDomain, {
                            domain: domain
                        });
                        owner = domainMetaData.meta.owner;
                        records = domainMetaData.records || {};
                        validationSignature = records["validation.social.twitter.username"];
                        twitterHandle = records["social.twitter.username"];
                        if (!validationSignature) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.RecordNotFound, {
                            recordName: "validation.social.twitter.username",
                            domain: domain
                        });
                        if (!twitterHandle) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.RecordNotFound, {
                            recordName: "social.twitter.username",
                            domain: domain
                        });
                        if (!(0, $911HQ.isValidTwitterSignature)({
                            tokenId: domainMetaData.meta.namehash,
                            owner: owner,
                            twitterHandle: twitterHandle,
                            validationSignature: validationSignature
                        })) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.InvalidTwitterVerification, {
                            domain: domain
                        });
                        return [
                            2 /*return*/ ,
                            twitterHandle
                        ];
                }
            });
        });
    };
    UdApi.prototype.allRecords = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.resolve(domain)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent().records || {}
                        ];
                }
            });
        });
    };
    UdApi.prototype.getDomainFromTokenId = function(tokenId) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var metadata;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenId = (0, $bPRni.fromDecStringToHex)(tokenId);
                        return [
                            4 /*yield*/ ,
                            this.getMetadata(tokenId)
                        ];
                    case 1:
                        metadata = _a.sent();
                        return [
                            2 /*return*/ ,
                            metadata.meta.domain
                        ];
                }
            });
        });
    };
    UdApi.prototype.getMetadata = function(tokenId) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var tokenUri, resp, metadata, namehash;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tokenUri = "".concat(this.url, "/").concat(tokenId);
                        return [
                            4 /*yield*/ ,
                            $29d319816a13d5b5$var$Networking_1.default.fetch(tokenUri, {}).catch(function(err) {
                                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.MetadataEndpointError, {
                                    tokenUri: tokenUri || "undefined",
                                    errorMessage: err.message
                                });
                            })
                        ];
                    case 1:
                        resp = _a.sent();
                        return [
                            4 /*yield*/ ,
                            resp.json()
                        ];
                    case 2:
                        metadata = _a.sent();
                        if (!metadata.meta || !metadata.meta.domain) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnregisteredDomain, {
                            domain: "with tokenId ".concat(tokenId)
                        });
                        namehash = metadata.meta.blockchain === $bq44C.BlockchainType.ZIL ? (0, $bPRni.znsNamehash)(metadata.meta.domain) : (0, $bPRni.eip137Namehash)(metadata.meta.domain);
                        if (namehash !== tokenId) throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.ServiceProviderError, {
                            methodName: "unhash",
                            domain: metadata.meta.domain,
                            providerMessage: "Service provider returned an invalid domain name"
                        });
                        return [
                            2 /*return*/ ,
                            metadata
                        ];
                }
            });
        });
    };
    UdApi.prototype.resolve = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var response;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $29d319816a13d5b5$var$Networking_1.default.fetch("".concat(this.url, "/").concat(domain), {
                                method: "GET",
                                headers: this.headers
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            response.json()
                        ];
                }
            });
        });
    };
    UdApi.prototype.resolver = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var record;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.resolve(domain)
                        ];
                    case 1:
                        record = _a.sent();
                        return [
                            2 /*return*/ ,
                            record.meta.resolver
                        ];
                }
            });
        });
    };
    UdApi.prototype.reverse = function(_address, _currencyTicker) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "reverse"
                });
            });
        });
    };
    UdApi.prototype.reverseOf = function(_address, _location) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "reverseOf"
                });
            });
        });
    };
    UdApi.prototype.isRegistered = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            var record;
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.resolve(domain)
                        ];
                    case 1:
                        record = _a.sent();
                        return [
                            2 /*return*/ ,
                            !(0, $jECMB.isNullAddress)(record.meta.owner)
                        ];
                }
            });
        });
    };
    UdApi.prototype.getTokenUri = function(_tokenId) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "getTokenUri"
                });
            });
        });
    };
    UdApi.prototype.isAvailable = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.isRegistered(domain)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            !_a.sent()
                        ];
                }
            });
        });
    };
    UdApi.prototype.registryAddress = function(domain) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    domain: domain,
                    methodName: "registryAddress"
                });
            });
        });
    };
    UdApi.prototype.locations = function(_domains) {
        return $29d319816a13d5b5$var$__awaiter(this, void 0, void 0, function() {
            return $29d319816a13d5b5$var$__generator(this, function(_a) {
                throw new $anKpg.ResolutionError($anKpg.ResolutionErrorCode.UnsupportedMethod, {
                    methodName: "locations"
                });
            });
        });
    };
    return UdApi;
}($2gwgp.NamingService);
module.exports.default = $29d319816a13d5b5$var$UdApi;

});

parcelRegister("6dH2g", function(module, exports) {
"use strict";
var $487556ec9d658aa8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $487556ec9d658aa8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $487556ec9d658aa8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $487556ec9d658aa8$var$__createBinding(result, mod, k);
    }
    $487556ec9d658aa8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $487556ec9d658aa8$var$dnsRecordsError_1 = $487556ec9d658aa8$var$__importStar((parcelRequire("2gWQY")));

var $bq44C = parcelRequire("bq44C");
var $487556ec9d658aa8$var$DnsUtils = /** @class */ function() {
    function DnsUtils() {}
    DnsUtils.prototype.toList = function(record) {
        var _a;
        var _this = this;
        var dnsTypes = this.getAllDnsTypes(record);
        return (_a = []).concat.apply(_a, dnsTypes.map(function(type) {
            return _this.constructDnsRecords(record, type);
        }));
    };
    DnsUtils.prototype.toCrypto = function(records) {
        var cryptoRecords = {};
        for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var type = record.type, TTL = record.TTL, data = record.data;
            var ttlInRecord = this.getJsonNumber(cryptoRecords["dns.".concat(type, ".ttl")]);
            var dnsInRecord = this.getJsonArray(cryptoRecords, "dns.".concat(type));
            if (dnsInRecord) {
                dnsInRecord.push(data);
                cryptoRecords["dns.".concat(type)] = JSON.stringify(dnsInRecord);
            } else {
                cryptoRecords["dns.".concat(type)] = JSON.stringify([
                    data
                ]);
                cryptoRecords["dns.".concat(type, ".ttl")] = TTL.toString(10);
            }
            if (!!ttlInRecord && ttlInRecord !== TTL) throw new $487556ec9d658aa8$var$dnsRecordsError_1.default($487556ec9d658aa8$var$dnsRecordsError_1.DnsRecordsErrorCode.InconsistentTtl, {
                recordType: type
            });
        }
        return cryptoRecords;
    };
    DnsUtils.prototype.protectFromCorruptRecord = function(rawRecord, type) {
        try {
            return rawRecord ? JSON.parse(rawRecord) : undefined;
        } catch (err) {
            if (err instanceof SyntaxError) throw new $487556ec9d658aa8$var$dnsRecordsError_1.default($487556ec9d658aa8$var$dnsRecordsError_1.DnsRecordsErrorCode.DnsRecordCorrupted, {
                recordType: type
            });
            throw err;
        }
    };
    DnsUtils.prototype.getJsonArray = function(cryptoRecrods, key) {
        var rawRecord = cryptoRecrods[key];
        var type = key.split(".")[1];
        return this.protectFromCorruptRecord(rawRecord, type);
    };
    DnsUtils.prototype.getJsonNumber = function(rawRecord) {
        return rawRecord ? parseInt(rawRecord, 10) : undefined;
    };
    DnsUtils.prototype.getAllDnsTypes = function(records) {
        var keys = new Set();
        Object.keys(records).forEach(function(key) {
            var chunks = key.split(".");
            var type = chunks[1] && chunks[1] !== "ttl";
            if (type) keys.add($bq44C.DnsRecordType[chunks[1]]);
        });
        return Array.from(keys);
    };
    DnsUtils.prototype.constructDnsRecords = function(cryptoData, type) {
        var TTL = this.parseTtl(cryptoData, type);
        var jsonValueString = cryptoData["dns.".concat(type)];
        if (!jsonValueString) return [];
        var typeData = this.protectFromCorruptRecord(jsonValueString, type);
        if (!this.isStringArray(typeData)) return [];
        return typeData.map(function(data) {
            return {
                TTL: TTL,
                data: data,
                type: type
            };
        });
    };
    DnsUtils.prototype.parseTtl = function(data, type) {
        var defaultTtl = data["dns.ttl"];
        var recordTtl = data["dns.".concat(type, ".ttl")];
        if (recordTtl) {
            var parsedInt = this.parseIfNumber(recordTtl);
            if (parsedInt) return parsedInt;
        }
        if (defaultTtl) {
            var parsedInt = this.parseIfNumber(defaultTtl);
            if (parsedInt) return parsedInt;
        }
        return DnsUtils.DefaultTtl;
    };
    DnsUtils.prototype.parseIfNumber = function(str) {
        var parsedInt = parseInt(str, 10);
        if (!isNaN(parsedInt)) return parsedInt;
    };
    DnsUtils.prototype.isStringArray = function(value) {
        if (value instanceof Array) return value.every(function(item) {
            return typeof item === "string";
        });
        return false;
    };
    DnsUtils.DefaultTtl = 300; // 5 minutes
    return DnsUtils;
}();
module.exports.default = $487556ec9d658aa8$var$DnsUtils;

});
parcelRegister("2gWQY", function(module, exports) {
"use strict";
var $1a7aba772b4f6811$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1a7aba772b4f6811$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DnsRecordsError = module.exports.DnsRecordsErrorCode = void 0;
var $1a7aba772b4f6811$var$DnsRecordsErrorCode;
(function(DnsRecordsErrorCode) {
    DnsRecordsErrorCode["InconsistentTtl"] = "InconsistentTtl";
    DnsRecordsErrorCode["DnsRecordCorrupted"] = "DnsRecordCorrupted";
})($1a7aba772b4f6811$var$DnsRecordsErrorCode = module.exports.DnsRecordsErrorCode || (module.exports.DnsRecordsErrorCode = {}));
/**
 * @internal
 * Internal Mapping object from DnsRecordsErrorCode to a DnsRecordsErrorHandler
 */ var $1a7aba772b4f6811$var$HandlersByCode = ($1a7aba772b4f6811$var$_a = {}, $1a7aba772b4f6811$var$_a[$1a7aba772b4f6811$var$DnsRecordsErrorCode.InconsistentTtl] = function(params) {
    return "ttl for record ".concat(params.recordType, " is different for other records of the same type");
}, $1a7aba772b4f6811$var$_a[$1a7aba772b4f6811$var$DnsRecordsErrorCode.DnsRecordCorrupted] = function(params) {
    return "dns record ".concat(params.recordType, " is invalid json-string");
}, $1a7aba772b4f6811$var$_a);
/**
 * Configuration Error class is designed to control every error being thrown by wrong configurations for objects
 * @param code - Error Code
 * - IncorrectProvider - When provider doesn't have implemented send or sendAsync methods
 * - UnsupportedNetwork - When network is not specified or not supported
 * - UnspecifiedUrl - When url is not specified for custom naming service configurations
 * @param method - optional param to specify which namingService errored out
 */ var $1a7aba772b4f6811$var$DnsRecordsError = /** @class */ function(_super) {
    $1a7aba772b4f6811$var$__extends(DnsRecordsError, _super);
    function DnsRecordsError(code, options) {
        if (options === void 0) options = {};
        var _this = this;
        var DnsRecordsErrorHandler = $1a7aba772b4f6811$var$HandlersByCode[code];
        _this = _super.call(this, DnsRecordsErrorHandler(options)) || this;
        _this.code = code;
        _this.name = "DnsRecordsError";
        Object.setPrototypeOf(_this, DnsRecordsError.prototype);
        return _this;
    }
    return DnsRecordsError;
}(Error);
module.exports.DnsRecordsError = $1a7aba772b4f6811$var$DnsRecordsError;
module.exports.default = $1a7aba772b4f6811$var$DnsRecordsError;

});


parcelRegister("9GlGG", function(module, exports) {
"use strict";
var $70c8dbf443ec715f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $70c8dbf443ec715f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $70c8dbf443ec715f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $70c8dbf443ec715f$var$__createBinding(result, mod, k);
    }
    $70c8dbf443ec715f$var$__setModuleDefault(result, mod);
    return result;
};
var $70c8dbf443ec715f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $70c8dbf443ec715f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $70c8dbf443ec715f$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Eip1993Factories = void 0;

var $6yp4P = parcelRequire("6yp4P");

var $70c8dbf443ec715f$var$resolutionError_1 = $70c8dbf443ec715f$var$__importStar((parcelRequire("anKpg")));
module.exports.Eip1993Factories = {
    fromWeb3Version0Provider: $70c8dbf443ec715f$var$fromWeb3Version0Provider,
    fromWeb3Version1Provider: $70c8dbf443ec715f$var$fromWeb3Version1Provider,
    fromEthersProvider: $70c8dbf443ec715f$var$fromEthersProvider,
    fromZilliqaProvider: $70c8dbf443ec715f$var$fromZilliqaProvider
};
/**
 * Create a Provider instance from web3 0.x version provider
 * @param provider - an 0.x version provider from web3 ( must implement sendAsync(payload, callback) )
 * @see https://github.com/ethereum/web3.js/blob/0.20.7/lib/web3/httpprovider.js#L116
 */ function $70c8dbf443ec715f$var$fromWeb3Version0Provider(provider) {
    if (provider.sendAsync === undefined) throw new $6yp4P.ConfigurationError($6yp4P.ConfigurationErrorCode.IncorrectProvider);
    return {
        request: function(request) {
            return new Promise(function(resolve, reject) {
                provider.sendAsync({
                    jsonrpc: "2.0",
                    method: request.method,
                    params: $70c8dbf443ec715f$var$wrapArray(request.params),
                    id: 1
                }, function(error, result) {
                    if (error) reject(error);
                    if (result.error) reject(new $70c8dbf443ec715f$var$resolutionError_1.default($70c8dbf443ec715f$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                        providerMessage: result.error
                    }));
                    resolve(result.result);
                });
            });
        }
    };
}
/**
 * Create a Provider instance from web3 1.x version provider
 * @param provider - an 1.x version provider from web3 ( must implement send(payload, callback) )
 * @see https://github.com/ethereum/web3.js/blob/1.x/packages/web3-core-helpers/types/index.d.ts#L165
 * @see https://github.com/ethereum/web3.js/blob/1.x/packages/web3-providers-http/src/index.js#L95
 */ function $70c8dbf443ec715f$var$fromWeb3Version1Provider(provider) {
    if (provider.send === undefined) throw new $6yp4P.ConfigurationError($6yp4P.ConfigurationErrorCode.IncorrectProvider);
    return {
        request: function(request) {
            return new Promise(function(resolve, reject) {
                provider.send({
                    jsonrpc: "2.0",
                    method: request.method,
                    params: $70c8dbf443ec715f$var$wrapArray(request.params),
                    id: 1
                }, function(error, result) {
                    if (error) reject(error);
                    if (result.error) reject(new $70c8dbf443ec715f$var$resolutionError_1.default($70c8dbf443ec715f$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                        providerMessage: result.error
                    }));
                    resolve(result.result);
                });
            });
        }
    };
}
/**
 * Creates a Provider instance from a provider that implements Ethers Provider#call interface.
 * This wrapper support only `eth_call` method for now, which is enough for all the current Resolution functionality
 * @param provider - provider object
 * @see https://github.com/ethers-io/ethers.js/blob/v4-legacy/providers/abstract-provider.d.ts#L91
 * @see https://github.com/ethers-io/ethers.js/blob/v5.0.4/packages/abstract-provider/src.ts/index.ts#L224
 * @see https://docs.ethers.io/ethers.js/v5-beta/api-providers.html#jsonrpcprovider-inherits-from-provider
 * @see https://github.com/ethers-io/ethers.js/blob/master/packages/providers/src.ts/json-rpc-provider.ts
 */ function $70c8dbf443ec715f$var$fromEthersProvider(provider) {
    var _this = this;
    if (provider.call === undefined) throw new $6yp4P.ConfigurationError($6yp4P.ConfigurationErrorCode.IncorrectProvider);
    return {
        request: function(request) {
            return $70c8dbf443ec715f$var$__awaiter(_this, void 0, void 0, function() {
                var _a, error_1;
                return $70c8dbf443ec715f$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            _a = request.method;
                            switch(_a){
                                case "eth_call":
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case "eth_getLogs":
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 1:
                            return [
                                4 /*yield*/ ,
                                provider.call(request.params[0])
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _b.sent()
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                provider.getLogs(request.params[0])
                            ];
                        case 4:
                            return [
                                2 /*return*/ ,
                                _b.sent()
                            ];
                        case 5:
                            throw new $70c8dbf443ec715f$var$resolutionError_1.default($70c8dbf443ec715f$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                                providerMessage: "Unsupported provider method ".concat(request.method)
                            });
                        case 6:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _b.sent();
                            throw new $70c8dbf443ec715f$var$resolutionError_1.default($70c8dbf443ec715f$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                                providerMessage: error_1.message
                            });
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    };
}
/**
 * Creates a Provider instance from @zilliqa-js/core Provider
 * @param provider - provider object
 */ function $70c8dbf443ec715f$var$fromZilliqaProvider(provider) {
    var _this = this;
    if (provider.middleware === undefined || provider.send === undefined) throw new $6yp4P.ConfigurationError($6yp4P.ConfigurationErrorCode.IncorrectProvider);
    return {
        request: function(request) {
            return $70c8dbf443ec715f$var$__awaiter(_this, void 0, void 0, function() {
                var resp, error_2;
                return $70c8dbf443ec715f$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                provider.send.apply(provider, $70c8dbf443ec715f$var$__spreadArray([
                                    request.method
                                ], request.params || [], false))
                            ];
                        case 1:
                            resp = _a.sent();
                            if (resp.error) throw new Error(resp.error.message);
                            return [
                                2 /*return*/ ,
                                resp.result
                            ];
                        case 2:
                            error_2 = _a.sent();
                            throw new $70c8dbf443ec715f$var$resolutionError_1.default($70c8dbf443ec715f$var$resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                                providerMessage: error_2.message
                            });
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    };
}
function $70c8dbf443ec715f$var$wrapArray(params) {
    if (params === void 0) params = [];
    return params instanceof Array ? params : [
        params
    ];
}

});

parcelRegister("6dKzR", function(module, exports) {
"use strict";
var $4878164b1dcc919d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4878164b1dcc919d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4878164b1dcc919d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4878164b1dcc919d$var$__createBinding(result, mod, k);
    }
    $4878164b1dcc919d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareAndValidateDomain = void 0;

var $4878164b1dcc919d$var$resolutionError_1 = $4878164b1dcc919d$var$__importStar((parcelRequire("anKpg")));
/**
 * Checks domain name for special symbols and returns address in lowercase without spaces
 * @throws Will throw an error if domain address contains special symbols
 * @param domain - a domain address
 */ var $4878164b1dcc919d$var$reg = RegExp("^[.a-z0-9-]+$");
function $4878164b1dcc919d$var$prepareAndValidateDomain(domain) {
    var retVal = domain ? domain.trim().toLowerCase() : "";
    if (!$4878164b1dcc919d$var$reg.test(retVal)) throw new $4878164b1dcc919d$var$resolutionError_1.default($4878164b1dcc919d$var$resolutionError_1.ResolutionErrorCode.InvalidDomainAddress, {
        domain: domain
    });
    return retVal;
}
module.exports.prepareAndValidateDomain = $4878164b1dcc919d$var$prepareAndValidateDomain;

});



parcelRegister("hYfPi", function(module, exports) {
var $d154510a897fbed3$var$win;
if (typeof window !== "undefined") $d154510a897fbed3$var$win = window;
else if (typeof $parcel$global !== "undefined") $d154510a897fbed3$var$win = $parcel$global;
else if (typeof self !== "undefined") $d154510a897fbed3$var$win = self;
else $d154510a897fbed3$var$win = {};
module.exports = $d154510a897fbed3$var$win;

});

parcelRegister("5azj4", function(module, exports) {

$parcel$export(module.exports, "compactDecrypt", () => (parcelRequire("eBzhe")).compactDecrypt);
$parcel$export(module.exports, "flattenedDecrypt", () => (parcelRequire("7d4Aj")).flattenedDecrypt);
$parcel$export(module.exports, "generalDecrypt", () => (parcelRequire("3KZxR")).generalDecrypt);
$parcel$export(module.exports, "GeneralEncrypt", () => (parcelRequire("fADuC")).GeneralEncrypt);
$parcel$export(module.exports, "compactVerify", () => (parcelRequire("4Xbqx")).compactVerify);
$parcel$export(module.exports, "flattenedVerify", () => (parcelRequire("daQfU")).flattenedVerify);
$parcel$export(module.exports, "generalVerify", () => (parcelRequire("hGdsG")).generalVerify);
$parcel$export(module.exports, "jwtVerify", () => (parcelRequire("nAr06")).jwtVerify);
$parcel$export(module.exports, "jwtDecrypt", () => (parcelRequire("l7tnz")).jwtDecrypt);
$parcel$export(module.exports, "CompactEncrypt", () => (parcelRequire("pUyhf")).CompactEncrypt);
$parcel$export(module.exports, "FlattenedEncrypt", () => (parcelRequire("JRQDl")).FlattenedEncrypt);
$parcel$export(module.exports, "CompactSign", () => (parcelRequire("c5lkx")).CompactSign);
$parcel$export(module.exports, "FlattenedSign", () => (parcelRequire("g3Jck")).FlattenedSign);
$parcel$export(module.exports, "GeneralSign", () => (parcelRequire("dDeJs")).GeneralSign);
$parcel$export(module.exports, "SignJWT", () => (parcelRequire("EFHdI")).SignJWT);
$parcel$export(module.exports, "EncryptJWT", () => (parcelRequire("ehy5Z")).EncryptJWT);
$parcel$export(module.exports, "calculateJwkThumbprint", () => (parcelRequire("5XVH0")).calculateJwkThumbprint);
$parcel$export(module.exports, "calculateJwkThumbprintUri", () => (parcelRequire("5XVH0")).calculateJwkThumbprintUri);
$parcel$export(module.exports, "EmbeddedJWK", () => (parcelRequire("dokVe")).EmbeddedJWK);
$parcel$export(module.exports, "createLocalJWKSet", () => (parcelRequire("a9JhK")).createLocalJWKSet);
$parcel$export(module.exports, "createRemoteJWKSet", () => (parcelRequire("4vzXy")).createRemoteJWKSet);
$parcel$export(module.exports, "UnsecuredJWT", () => (parcelRequire("2Qfuk")).UnsecuredJWT);
$parcel$export(module.exports, "exportPKCS8", () => (parcelRequire("3C6ak")).exportPKCS8);
$parcel$export(module.exports, "exportSPKI", () => (parcelRequire("3C6ak")).exportSPKI);
$parcel$export(module.exports, "exportJWK", () => (parcelRequire("3C6ak")).exportJWK);
$parcel$export(module.exports, "importSPKI", () => (parcelRequire("3eAHr")).importSPKI);
$parcel$export(module.exports, "importPKCS8", () => (parcelRequire("3eAHr")).importPKCS8);
$parcel$export(module.exports, "importX509", () => (parcelRequire("3eAHr")).importX509);
$parcel$export(module.exports, "importJWK", () => (parcelRequire("3eAHr")).importJWK);
$parcel$export(module.exports, "decodeProtectedHeader", () => (parcelRequire("ioDOB")).decodeProtectedHeader);
$parcel$export(module.exports, "decodeJwt", () => (parcelRequire("gbvd4")).decodeJwt);
$parcel$export(module.exports, "errors", () => (parcelRequire("doEUm")));
$parcel$export(module.exports, "generateKeyPair", () => (parcelRequire("c81UX")).generateKeyPair);
$parcel$export(module.exports, "generateSecret", () => (parcelRequire("bFbaj")).generateSecret);
$parcel$export(module.exports, "base64url", () => (parcelRequire("kp9Vr")));
$parcel$export(module.exports, "cryptoRuntime", () => (parcelRequire("g38wh")).default);

var $eBzhe = parcelRequire("eBzhe");

var $7d4Aj = parcelRequire("7d4Aj");

var $3KZxR = parcelRequire("3KZxR");

var $fADuC = parcelRequire("fADuC");

var $4Xbqx = parcelRequire("4Xbqx");

var $daQfU = parcelRequire("daQfU");

var $hGdsG = parcelRequire("hGdsG");

var $nAr06 = parcelRequire("nAr06");

var $l7tnz = parcelRequire("l7tnz");

var $pUyhf = parcelRequire("pUyhf");

var $JRQDl = parcelRequire("JRQDl");

var $c5lkx = parcelRequire("c5lkx");

var $g3Jck = parcelRequire("g3Jck");

var $dDeJs = parcelRequire("dDeJs");

var $EFHdI = parcelRequire("EFHdI");

var $ehy5Z = parcelRequire("ehy5Z");

var $5XVH0 = parcelRequire("5XVH0");

var $dokVe = parcelRequire("dokVe");

var $a9JhK = parcelRequire("a9JhK");

var $4vzXy = parcelRequire("4vzXy");

var $2Qfuk = parcelRequire("2Qfuk");

var $3C6ak = parcelRequire("3C6ak");

var $3eAHr = parcelRequire("3eAHr");

var $ioDOB = parcelRequire("ioDOB");

var $gbvd4 = parcelRequire("gbvd4");

var $doEUm = parcelRequire("doEUm");

var $c81UX = parcelRequire("c81UX");

var $bFbaj = parcelRequire("bFbaj");

var $kp9Vr = parcelRequire("kp9Vr");

var $g38wh = parcelRequire("g38wh");

});
parcelRegister("eBzhe", function(module, exports) {

$parcel$export(module.exports, "compactDecrypt", () => $aa1fe2a52c69a3f0$export$c9a8efe6bfd872ce);

var $7d4Aj = parcelRequire("7d4Aj");

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");
async function $aa1fe2a52c69a3f0$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $j5DOn.decoder).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $doEUm.JWEInvalid)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $doEUm.JWEInvalid)("Invalid Compact JWE");
    const decrypted = await (0, $7d4Aj.flattenedDecrypt)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader || undefined,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

});
parcelRegister("7d4Aj", function(module, exports) {

$parcel$export(module.exports, "flattenedDecrypt", () => $53fd4dba78fdd3a7$export$b75cd12892ae94d2);

var $8HWOF = parcelRequire("8HWOF");

var $9JKHA = parcelRequire("9JKHA");

var $cr0JZ = parcelRequire("cr0JZ");

var $doEUm = parcelRequire("doEUm");

var $dCdw8 = parcelRequire("dCdw8");

var $38muk = parcelRequire("38muk");

var $gfvGE = parcelRequire("gfvGE");

var $j5DOn = parcelRequire("j5DOn");

var $hIpEd = parcelRequire("hIpEd");

var $K6zvK = parcelRequire("K6zvK");

var $xTaO6 = parcelRequire("xTaO6");
async function $53fd4dba78fdd3a7$export$b75cd12892ae94d2(jwe, key, options) {
    var _a;
    if (!(0, $38muk.default)(jwe)) throw new (0, $doEUm.JWEInvalid)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $doEUm.JWEInvalid)("JOSE Header missing");
    if (typeof jwe.iv !== "string") throw new (0, $doEUm.JWEInvalid)("JWE Initialization Vector missing or incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $doEUm.JWEInvalid)("JWE Ciphertext missing or incorrect type");
    if (typeof jwe.tag !== "string") throw new (0, $doEUm.JWEInvalid)("JWE Authentication Tag missing or incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $doEUm.JWEInvalid)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $doEUm.JWEInvalid)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $doEUm.JWEInvalid)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $38muk.default)(jwe.header)) throw new (0, $doEUm.JWEInvalid)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $38muk.default)(jwe.unprotected)) throw new (0, $doEUm.JWEInvalid)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $8HWOF.decode)(jwe.protected);
        parsedProt = JSON.parse((0, $j5DOn.decoder).decode(protectedHeader));
    } catch (_b) {
        throw new (0, $doEUm.JWEInvalid)("JWE Protected Header is invalid");
    }
    if (!(0, $dCdw8.default)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $doEUm.JWEInvalid)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $K6zvK.default)((0, $doEUm.JWEInvalid), new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) {
        if (!parsedProt || !parsedProt.zip) throw new (0, $doEUm.JWEInvalid)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
        if (joseHeader.zip !== "DEF") throw new (0, $doEUm.JOSENotSupported)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
    }
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $doEUm.JWEInvalid)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $doEUm.JWEInvalid)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $xTaO6.default)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $xTaO6.default)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg)) throw new (0, $doEUm.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $doEUm.JOSEAlgNotAllowed)('"enc" (Encryption Algorithm) Header Parameter not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $8HWOF.decode)(jwe.encrypted_key);
    } catch (_c) {
        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $gfvGE.default)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $doEUm.JWEInvalid) || err instanceof (0, $doEUm.JOSENotSupported)) throw err;
        cek = (0, $hIpEd.default)(enc);
    }
    let iv;
    let tag;
    try {
        iv = (0, $8HWOF.decode)(jwe.iv);
    } catch (_d) {
        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the iv");
    }
    try {
        tag = (0, $8HWOF.decode)(jwe.tag);
    } catch (_e) {
        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $j5DOn.encoder).encode((_a = jwe.protected) !== null && _a !== void 0 ? _a : "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $j5DOn.concat)(protectedHeader, (0, $j5DOn.encoder).encode("."), (0, $j5DOn.encoder).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $8HWOF.decode)(jwe.ciphertext);
    } catch (_f) {
        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the ciphertext");
    }
    let plaintext = await (0, $9JKHA.default)(enc, cek, ciphertext, iv, tag, additionalData);
    if (joseHeader.zip === "DEF") plaintext = await ((options === null || options === void 0 ? void 0 : options.inflateRaw) || (0, $cr0JZ.inflate))(plaintext);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $8HWOF.decode)(jwe.aad);
    } catch (_g) {
        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRegister("8HWOF", function(module, exports) {

$parcel$export(module.exports, "encodeBase64", () => $656ff693d53508b6$export$8fb536984ec8b4d7);
$parcel$export(module.exports, "encode", () => $656ff693d53508b6$export$c564cdbbe6da493);
$parcel$export(module.exports, "decodeBase64", () => $656ff693d53508b6$export$94fdf11bafc8de6b);
$parcel$export(module.exports, "decode", () => $656ff693d53508b6$export$2f872c0f2117be69);

var $j5DOn = parcelRequire("j5DOn");
const $656ff693d53508b6$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $j5DOn.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $656ff693d53508b6$export$c564cdbbe6da493 = (input)=>{
    return $656ff693d53508b6$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $656ff693d53508b6$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $656ff693d53508b6$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $j5DOn.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $656ff693d53508b6$export$94fdf11bafc8de6b(encoded);
    } catch (_a) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};

});
parcelRegister("j5DOn", function(module, exports) {

$parcel$export(module.exports, "encoder", () => $de5d5db6a6c4a9a2$export$5486af06137bf21a);
$parcel$export(module.exports, "decoder", () => $de5d5db6a6c4a9a2$export$124c96e6ce37090b);
$parcel$export(module.exports, "concat", () => $de5d5db6a6c4a9a2$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "p2s", () => $de5d5db6a6c4a9a2$export$256d3ca12372f112);
$parcel$export(module.exports, "uint64be", () => $de5d5db6a6c4a9a2$export$e7b531e00a18fdd7);
$parcel$export(module.exports, "uint32be", () => $de5d5db6a6c4a9a2$export$74c16dba6c885532);
$parcel$export(module.exports, "lengthAndInput", () => $de5d5db6a6c4a9a2$export$c1498c4a3718d967);
$parcel$export(module.exports, "concatKdf", () => $de5d5db6a6c4a9a2$export$67163693c21af44f);

var $9XDkd = parcelRequire("9XDkd");
const $de5d5db6a6c4a9a2$export$5486af06137bf21a = new TextEncoder();
const $de5d5db6a6c4a9a2$export$124c96e6ce37090b = new TextDecoder();
const $de5d5db6a6c4a9a2$var$MAX_INT32 = 2 ** 32;
function $de5d5db6a6c4a9a2$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    buffers.forEach((buffer)=>{
        buf.set(buffer, i);
        i += buffer.length;
    });
    return buf;
}
function $de5d5db6a6c4a9a2$export$256d3ca12372f112(alg, p2sInput) {
    return $de5d5db6a6c4a9a2$export$ee1b3e54f0441b22($de5d5db6a6c4a9a2$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $de5d5db6a6c4a9a2$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $de5d5db6a6c4a9a2$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$de5d5db6a6c4a9a2$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $de5d5db6a6c4a9a2$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $de5d5db6a6c4a9a2$var$MAX_INT32);
    const low = value % $de5d5db6a6c4a9a2$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $de5d5db6a6c4a9a2$var$writeUInt32BE(buf, high, 0);
    $de5d5db6a6c4a9a2$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $de5d5db6a6c4a9a2$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $de5d5db6a6c4a9a2$var$writeUInt32BE(buf, value);
    return buf;
}
function $de5d5db6a6c4a9a2$export$c1498c4a3718d967(input) {
    return $de5d5db6a6c4a9a2$export$ee1b3e54f0441b22($de5d5db6a6c4a9a2$export$74c16dba6c885532(input.length), input);
}
async function $de5d5db6a6c4a9a2$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($de5d5db6a6c4a9a2$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $9XDkd.default)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

});
parcelRegister("9XDkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $740820e713c4912b$export$2e2bcd8739ae039);

var $4WLGH = parcelRequire("4WLGH");
const $740820e713c4912b$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $4WLGH.default).subtle.digest(subtleDigest, data));
};
var $740820e713c4912b$export$2e2bcd8739ae039 = $740820e713c4912b$var$digest;

});
parcelRegister("4WLGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a191f90f089756$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isCryptoKey", () => $39a191f90f089756$export$600b5603bbac4c6);
var $39a191f90f089756$export$2e2bcd8739ae039 = crypto;
const $39a191f90f089756$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;

});




parcelRegister("9JKHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $716c8b1266ac62c8$export$2e2bcd8739ae039);

var $j5DOn = parcelRequire("j5DOn");

var $jcudG = parcelRequire("jcudG");

var $5QxlO = parcelRequire("5QxlO");

var $9dU34 = parcelRequire("9dU34");

var $doEUm = parcelRequire("doEUm");

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
async function $716c8b1266ac62c8$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $hDXRW.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $4WLGH.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $4WLGH.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $j5DOn.concat)(aad, iv, ciphertext, (0, $j5DOn.uint64be)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $4WLGH.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $9dU34.default)(tag, expectedTag);
    } catch (_a) {}
    if (!macCheckPassed) throw new (0, $doEUm.JWEDecryptionFailed)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $4WLGH.default).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch (_b) {}
    if (!plaintext) throw new (0, $doEUm.JWEDecryptionFailed)();
    return plaintext;
}
async function $716c8b1266ac62c8$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $4WLGH.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $gC6BU.checkEncCryptoKey)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $4WLGH.default).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $j5DOn.concat)(ciphertext, tag)));
    } catch (_a) {
        throw new (0, $doEUm.JWEDecryptionFailed)();
    }
}
const $716c8b1266ac62c8$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $4WLGH.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $hDXRW.default)(cek, ...(0, $bhFBq.types), "Uint8Array"));
    (0, $jcudG.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $5QxlO.default)(cek, parseInt(enc.slice(-3), 10));
            return $716c8b1266ac62c8$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $5QxlO.default)(cek, parseInt(enc.slice(1, 4), 10));
            return $716c8b1266ac62c8$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $doEUm.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $716c8b1266ac62c8$export$2e2bcd8739ae039 = $716c8b1266ac62c8$var$decrypt;

});
parcelRegister("jcudG", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa694563843635c$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");

var $6Tpad = parcelRequire("6Tpad");
const $dfa694563843635c$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $6Tpad.bitLength)(enc)) throw new (0, $doEUm.JWEInvalid)("Invalid Initialization Vector length");
};
var $dfa694563843635c$export$2e2bcd8739ae039 = $dfa694563843635c$var$checkIvLength;

});
parcelRegister("doEUm", function(module, exports) {

$parcel$export(module.exports, "JOSEError", () => $9c0d3fc1e2b24550$export$f754d6850d76bf87);
$parcel$export(module.exports, "JWTClaimValidationFailed", () => $9c0d3fc1e2b24550$export$f1e14efb908196e9);
$parcel$export(module.exports, "JWTExpired", () => $9c0d3fc1e2b24550$export$4b386bf852b7863d);
$parcel$export(module.exports, "JOSEAlgNotAllowed", () => $9c0d3fc1e2b24550$export$d51fd7fedeccc338);
$parcel$export(module.exports, "JOSENotSupported", () => $9c0d3fc1e2b24550$export$19ddbcbf2016ab28);
$parcel$export(module.exports, "JWEDecryptionFailed", () => $9c0d3fc1e2b24550$export$1a57512ad9773b2a);
$parcel$export(module.exports, "JWEDecompressionFailed", () => $9c0d3fc1e2b24550$export$93c23a0e4586b4a2);
$parcel$export(module.exports, "JWEInvalid", () => $9c0d3fc1e2b24550$export$19f281f2275f6a15);
$parcel$export(module.exports, "JWSInvalid", () => $9c0d3fc1e2b24550$export$e838de724af3d116);
$parcel$export(module.exports, "JWTInvalid", () => $9c0d3fc1e2b24550$export$936b39ada0bbfceb);
$parcel$export(module.exports, "JWKInvalid", () => $9c0d3fc1e2b24550$export$b3992e0f88fb07e3);
$parcel$export(module.exports, "JWKSInvalid", () => $9c0d3fc1e2b24550$export$9b22c2a1e2403b8e);
$parcel$export(module.exports, "JWKSNoMatchingKey", () => $9c0d3fc1e2b24550$export$3d5ed1a538bed04e);
$parcel$export(module.exports, "JWKSMultipleMatchingKeys", () => $9c0d3fc1e2b24550$export$dc036de401a5c284);
$parcel$export(module.exports, "JWKSTimeout", () => $9c0d3fc1e2b24550$export$3f30acebf25c04e6);
$parcel$export(module.exports, "JWSSignatureVerificationFailed", () => $9c0d3fc1e2b24550$export$c67a0218e7c50378);
class $9c0d3fc1e2b24550$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        var _a;
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        (_a = Error.captureStackTrace) === null || _a === void 0 || _a.call(Error, this, this.constructor);
    }
}
class $9c0d3fc1e2b24550$export$f1e14efb908196e9 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $9c0d3fc1e2b24550$export$4b386bf852b7863d extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $9c0d3fc1e2b24550$export$d51fd7fedeccc338 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $9c0d3fc1e2b24550$export$19ddbcbf2016ab28 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $9c0d3fc1e2b24550$export$1a57512ad9773b2a extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $9c0d3fc1e2b24550$export$93c23a0e4586b4a2 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECOMPRESSION_FAILED";
        this.message = "decompression operation failed";
    }
    static get code() {
        return "ERR_JWE_DECOMPRESSION_FAILED";
    }
}
class $9c0d3fc1e2b24550$export$19f281f2275f6a15 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $9c0d3fc1e2b24550$export$e838de724af3d116 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $9c0d3fc1e2b24550$export$936b39ada0bbfceb extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $9c0d3fc1e2b24550$export$b3992e0f88fb07e3 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $9c0d3fc1e2b24550$export$9b22c2a1e2403b8e extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $9c0d3fc1e2b24550$export$3d5ed1a538bed04e extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $9c0d3fc1e2b24550$export$dc036de401a5c284 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $9c0d3fc1e2b24550$export$3f30acebf25c04e6 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $9c0d3fc1e2b24550$export$c67a0218e7c50378 extends $9c0d3fc1e2b24550$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}

});

parcelRegister("6Tpad", function(module, exports) {

$parcel$export(module.exports, "bitLength", () => $504b662221c5f8d1$export$db433e85ac514a95);
$parcel$export(module.exports, "default", () => $504b662221c5f8d1$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");

var $kEhFo = parcelRequire("kEhFo");
function $504b662221c5f8d1$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $doEUm.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $504b662221c5f8d1$export$2e2bcd8739ae039 = (alg)=>(0, $kEhFo.default)(new Uint8Array($504b662221c5f8d1$export$db433e85ac514a95(alg) >> 3));

});
parcelRegister("kEhFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0853f4b0a3a5b33$export$2e2bcd8739ae039);

var $4WLGH = parcelRequire("4WLGH");
var $f0853f4b0a3a5b33$export$2e2bcd8739ae039 = (0, $4WLGH.default).getRandomValues.bind((0, $4WLGH.default));

});



parcelRegister("5QxlO", function(module, exports) {

$parcel$export(module.exports, "default", () => $441baddafa089030$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");
const $441baddafa089030$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $doEUm.JWEInvalid)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $441baddafa089030$export$2e2bcd8739ae039 = $441baddafa089030$var$checkCekLength;

});

parcelRegister("9dU34", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b70ce06068c033c$export$2e2bcd8739ae039);
const $6b70ce06068c033c$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $6b70ce06068c033c$export$2e2bcd8739ae039 = $6b70ce06068c033c$var$timingSafeEqual;

});

parcelRegister("gC6BU", function(module, exports) {

$parcel$export(module.exports, "checkSigCryptoKey", () => $c18552a43fdb16f0$export$39a36029eee6729);
$parcel$export(module.exports, "checkEncCryptoKey", () => $c18552a43fdb16f0$export$41a67f89f6678b35);
function $c18552a43fdb16f0$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $c18552a43fdb16f0$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $c18552a43fdb16f0$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $c18552a43fdb16f0$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $c18552a43fdb16f0$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $c18552a43fdb16f0$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "HMAC")) throw $c18552a43fdb16f0$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $c18552a43fdb16f0$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $c18552a43fdb16f0$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $c18552a43fdb16f0$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $c18552a43fdb16f0$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $c18552a43fdb16f0$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $c18552a43fdb16f0$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "ECDSA")) throw $c18552a43fdb16f0$var$unusable("ECDSA");
                const expected = $c18552a43fdb16f0$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $c18552a43fdb16f0$var$checkUsage(key, usages);
}
function $c18552a43fdb16f0$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $c18552a43fdb16f0$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "AES-KW")) throw $c18552a43fdb16f0$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $c18552a43fdb16f0$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $c18552a43fdb16f0$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$c18552a43fdb16f0$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $c18552a43fdb16f0$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $c18552a43fdb16f0$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $c18552a43fdb16f0$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $c18552a43fdb16f0$var$checkUsage(key, usages);
}

});

parcelRegister("hDXRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8484ef5042a000$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withAlg", () => $cd8484ef5042a000$export$e94f758d09bc1828);
function $cd8484ef5042a000$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor && actual.constructor.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $cd8484ef5042a000$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $cd8484ef5042a000$var$message("Key must be ", actual, ...types);
};
function $cd8484ef5042a000$export$e94f758d09bc1828(alg, actual, ...types) {
    return $cd8484ef5042a000$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

});

parcelRegister("bhFBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $83718da27149b8c8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "types", () => $83718da27149b8c8$export$b14ad400b1d09e0f);

var $4WLGH = parcelRequire("4WLGH");
var $83718da27149b8c8$export$2e2bcd8739ae039 = (key)=>{
    return (0, $4WLGH.isCryptoKey)(key);
};
const $83718da27149b8c8$export$b14ad400b1d09e0f = [
    "CryptoKey"
];

});


parcelRegister("cr0JZ", function(module, exports) {

$parcel$export(module.exports, "inflate", () => $90d894c73fd4d4bf$export$cae1ce83fe4a1782);
$parcel$export(module.exports, "deflate", () => $90d894c73fd4d4bf$export$2316623ecd1285ab);

var $doEUm = parcelRequire("doEUm");
const $90d894c73fd4d4bf$export$cae1ce83fe4a1782 = async ()=>{
    throw new (0, $doEUm.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `inflateRaw` decrypt option to provide Inflate Raw implementation.');
};
const $90d894c73fd4d4bf$export$2316623ecd1285ab = async ()=>{
    throw new (0, $doEUm.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported by your javascript runtime. You need to use the `deflateRaw` encrypt option to provide Deflate Raw implementation.');
};

});

parcelRegister("dCdw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e994f3807fde1a3$export$2e2bcd8739ae039);
const $9e994f3807fde1a3$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $9e994f3807fde1a3$export$2e2bcd8739ae039 = $9e994f3807fde1a3$var$isDisjoint;

});

parcelRegister("38muk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2483901d787ae421$export$2e2bcd8739ae039);
function $2483901d787ae421$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $2483901d787ae421$export$2e2bcd8739ae039(input) {
    if (!$2483901d787ae421$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

});

parcelRegister("gfvGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd46a0670244a1b8$export$2e2bcd8739ae039);

var $keImv = parcelRequire("keImv");

var $dgg7K = parcelRequire("dgg7K");

var $bY2nm = parcelRequire("bY2nm");

var $c43YP = parcelRequire("c43YP");

var $8HWOF = parcelRequire("8HWOF");

var $doEUm = parcelRequire("doEUm");

var $hIpEd = parcelRequire("hIpEd");

var $3eAHr = parcelRequire("3eAHr");

var $8aEdO = parcelRequire("8aEdO");

var $38muk = parcelRequire("38muk");

var $lNG8w = parcelRequire("lNG8w");
async function $bd46a0670244a1b8$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $8aEdO.default)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $doEUm.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $doEUm.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $38muk.default)(joseHeader.epk)) throw new (0, $doEUm.JWEInvalid)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$dgg7K.ecdhAllowed(key)) throw new (0, $doEUm.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $3eAHr.importJWK)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $doEUm.JWEInvalid)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $8HWOF.decode)(joseHeader.apu);
                    } catch (_a) {
                        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $doEUm.JWEInvalid)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $8HWOF.decode)(joseHeader.apv);
                    } catch (_b) {
                        throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $dgg7K.deriveKey(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $hIpEd.bitLength)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $doEUm.JWEInvalid)("JWE Encrypted Key missing");
                return (0, $keImv.unwrap)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $doEUm.JWEInvalid)("JWE Encrypted Key missing");
            return (0, $c43YP.decrypt)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $doEUm.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $doEUm.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = (options === null || options === void 0 ? void 0 : options.maxPBES2Count) || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $doEUm.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $doEUm.JWEInvalid)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $8HWOF.decode)(joseHeader.p2s);
                } catch (_c) {
                    throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the p2s");
                }
                return (0, $bY2nm.decrypt)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $doEUm.JWEInvalid)("JWE Encrypted Key missing");
            return (0, $keImv.unwrap)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $doEUm.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $doEUm.JWEInvalid)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $doEUm.JWEInvalid)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $8HWOF.decode)(joseHeader.iv);
                } catch (_d) {
                    throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $8HWOF.decode)(joseHeader.tag);
                } catch (_e) {
                    throw new (0, $doEUm.JWEInvalid)("Failed to base64url decode the tag");
                }
                return (0, $lNG8w.unwrap)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $bd46a0670244a1b8$export$2e2bcd8739ae039 = $bd46a0670244a1b8$var$decryptKeyManagement;

});
parcelRegister("keImv", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $ebb786d465324e7c$export$4997ffc0176396a6);
$parcel$export(module.exports, "unwrap", () => $ebb786d465324e7c$export$debb760848ca95a);

var $lGiZL = parcelRequire("lGiZL");

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
function $ebb786d465324e7c$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $ebb786d465324e7c$var$getCryptoKey(key, alg, usage) {
    if ((0, $4WLGH.isCryptoKey)(key)) {
        (0, $gC6BU.checkEncCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $4WLGH.default).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types), "Uint8Array"));
}
const $ebb786d465324e7c$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $ebb786d465324e7c$var$getCryptoKey(key, alg, "wrapKey");
    $ebb786d465324e7c$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $4WLGH.default).subtle.importKey("raw", cek, ...(0, $lGiZL.default));
    return new Uint8Array(await (0, $4WLGH.default).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $ebb786d465324e7c$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $ebb786d465324e7c$var$getCryptoKey(key, alg, "unwrapKey");
    $ebb786d465324e7c$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $4WLGH.default).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $lGiZL.default));
    return new Uint8Array(await (0, $4WLGH.default).subtle.exportKey("raw", cryptoKeyCek));
};

});
parcelRegister("lGiZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8c414082e2fbc2$export$2e2bcd8739ae039);
const $fc8c414082e2fbc2$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $fc8c414082e2fbc2$export$2e2bcd8739ae039 = $fc8c414082e2fbc2$var$bogusWebCrypto;

});


parcelRegister("dgg7K", function(module, exports) {

$parcel$export(module.exports, "deriveKey", () => $9a7946ddf8b06fb9$export$87770b6b245073b5);
$parcel$export(module.exports, "generateEpk", () => $9a7946ddf8b06fb9$export$1338dee8c889e310);
$parcel$export(module.exports, "ecdhAllowed", () => $9a7946ddf8b06fb9$export$f28ab77d793719b2);

var $j5DOn = parcelRequire("j5DOn");

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
async function $9a7946ddf8b06fb9$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $4WLGH.isCryptoKey)(publicKey)) throw new TypeError((0, $hDXRW.default)(publicKey, ...(0, $bhFBq.types)));
    (0, $gC6BU.checkEncCryptoKey)(publicKey, "ECDH");
    if (!(0, $4WLGH.isCryptoKey)(privateKey)) throw new TypeError((0, $hDXRW.default)(privateKey, ...(0, $bhFBq.types)));
    (0, $gC6BU.checkEncCryptoKey)(privateKey, "ECDH", "deriveBits");
    const value = (0, $j5DOn.concat)((0, $j5DOn.lengthAndInput)((0, $j5DOn.encoder).encode(algorithm)), (0, $j5DOn.lengthAndInput)(apu), (0, $j5DOn.lengthAndInput)(apv), (0, $j5DOn.uint32be)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $4WLGH.default).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $j5DOn.concatKdf)(sharedSecret, keyLength, value);
}
async function $9a7946ddf8b06fb9$export$1338dee8c889e310(key) {
    if (!(0, $4WLGH.isCryptoKey)(key)) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types)));
    return (0, $4WLGH.default).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $9a7946ddf8b06fb9$export$f28ab77d793719b2(key) {
    if (!(0, $4WLGH.isCryptoKey)(key)) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}

});

parcelRegister("bY2nm", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $8b672415a0fd67b3$export$5b0f6292f11d1d18);
$parcel$export(module.exports, "decrypt", () => $8b672415a0fd67b3$export$e85a0c9a1067c5d3);

var $kEhFo = parcelRequire("kEhFo");

var $j5DOn = parcelRequire("j5DOn");

var $8HWOF = parcelRequire("8HWOF");

var $keImv = parcelRequire("keImv");

var $7Ofxn = parcelRequire("7Ofxn");

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
function $8b672415a0fd67b3$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $4WLGH.default).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $4WLGH.isCryptoKey)(key)) {
        (0, $gC6BU.checkEncCryptoKey)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types), "Uint8Array"));
}
async function $8b672415a0fd67b3$var$deriveKey(p2s, alg, p2c, key) {
    (0, $7Ofxn.default)(p2s);
    const salt = (0, $j5DOn.p2s)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $8b672415a0fd67b3$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $4WLGH.default).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $4WLGH.default).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $8b672415a0fd67b3$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $kEhFo.default)(new Uint8Array(16)))=>{
    const derived = await $8b672415a0fd67b3$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $keImv.wrap)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $8HWOF.encode)(p2s)
    };
};
const $8b672415a0fd67b3$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $8b672415a0fd67b3$var$deriveKey(p2s, alg, p2c, key);
    return (0, $keImv.unwrap)(alg.slice(-6), derived, encryptedKey);
};

});
parcelRegister("7Ofxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5af94149cb0be6e8$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");
function $5af94149cb0be6e8$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $doEUm.JWEInvalid)("PBES2 Salt Input must be 8 or more octets");
}

});


parcelRegister("c43YP", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $8c88f21be8de7b1a$export$5b0f6292f11d1d18);
$parcel$export(module.exports, "decrypt", () => $8c88f21be8de7b1a$export$e85a0c9a1067c5d3);

var $h2CPq = parcelRequire("h2CPq");

var $lGiZL = parcelRequire("lGiZL");

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $7dpfg = parcelRequire("7dpfg");

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
const $8c88f21be8de7b1a$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $4WLGH.isCryptoKey)(key)) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types)));
    (0, $gC6BU.checkEncCryptoKey)(key, alg, "encrypt", "wrapKey");
    (0, $7dpfg.default)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $4WLGH.default).subtle.encrypt((0, $h2CPq.default)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $4WLGH.default).subtle.importKey("raw", cek, ...(0, $lGiZL.default));
        return new Uint8Array(await (0, $4WLGH.default).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $h2CPq.default)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $8c88f21be8de7b1a$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $4WLGH.isCryptoKey)(key)) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types)));
    (0, $gC6BU.checkEncCryptoKey)(key, alg, "decrypt", "unwrapKey");
    (0, $7dpfg.default)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $4WLGH.default).subtle.decrypt((0, $h2CPq.default)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $4WLGH.default).subtle.unwrapKey("raw", encryptedKey, key, (0, $h2CPq.default)(alg), ...(0, $lGiZL.default));
        return new Uint8Array(await (0, $4WLGH.default).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};

});
parcelRegister("h2CPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c680be1566f0f0ef$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");
function $c680be1566f0f0ef$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $doEUm.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRegister("7dpfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $540d547c0603cb27$export$2e2bcd8739ae039);
var $540d547c0603cb27$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

});


parcelRegister("hIpEd", function(module, exports) {

$parcel$export(module.exports, "bitLength", () => $ce5a70d19910f56b$export$db433e85ac514a95);
$parcel$export(module.exports, "default", () => $ce5a70d19910f56b$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");

var $kEhFo = parcelRequire("kEhFo");
function $ce5a70d19910f56b$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $doEUm.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $ce5a70d19910f56b$export$2e2bcd8739ae039 = (alg)=>(0, $kEhFo.default)(new Uint8Array($ce5a70d19910f56b$export$db433e85ac514a95(alg) >> 3));

});

parcelRegister("3eAHr", function(module, exports) {

$parcel$export(module.exports, "importSPKI", () => $25af25b573cd2dc8$export$7cdfc961c11d0266);
$parcel$export(module.exports, "importX509", () => $25af25b573cd2dc8$export$948757ecbbf4a918);
$parcel$export(module.exports, "importPKCS8", () => $25af25b573cd2dc8$export$17f5e7f6d2848df5);
$parcel$export(module.exports, "importJWK", () => $25af25b573cd2dc8$export$2b70d37b4d0b888b);

var $8HWOF = parcelRequire("8HWOF");

var $cuUf3 = parcelRequire("cuUf3");

var $78DKr = parcelRequire("78DKr");

var $doEUm = parcelRequire("doEUm");

var $38muk = parcelRequire("38muk");
async function $25af25b573cd2dc8$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $cuUf3.fromSPKI)(spki, alg, options);
}
async function $25af25b573cd2dc8$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $cuUf3.fromX509)(x509, alg, options);
}
async function $25af25b573cd2dc8$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $cuUf3.fromPKCS8)(pkcs8, alg, options);
}
async function $25af25b573cd2dc8$export$2b70d37b4d0b888b(jwk, alg, octAsKeyObject) {
    var _a;
    if (!(0, $38muk.default)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            octAsKeyObject !== null && octAsKeyObject !== void 0 ? octAsKeyObject : octAsKeyObject = jwk.ext !== true;
            if (octAsKeyObject) return (0, $78DKr.default)({
                ...jwk,
                alg: alg,
                ext: (_a = jwk.ext) !== null && _a !== void 0 ? _a : false
            });
            return (0, $8HWOF.decode)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $doEUm.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $78DKr.default)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $doEUm.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

});
parcelRegister("cuUf3", function(module, exports) {

$parcel$export(module.exports, "toSPKI", () => $9193e9d4f01f968c$export$cfba7e924fe414ca);
$parcel$export(module.exports, "toPKCS8", () => $9193e9d4f01f968c$export$cac76a78a90b914d);
$parcel$export(module.exports, "fromPKCS8", () => $9193e9d4f01f968c$export$224b0a6339c7267f);
$parcel$export(module.exports, "fromSPKI", () => $9193e9d4f01f968c$export$f9a3505cdaa1fb3e);
$parcel$export(module.exports, "fromX509", () => $9193e9d4f01f968c$export$ed788b6a8533858f);

var $4WLGH = parcelRequire("4WLGH");

var $hDXRW = parcelRequire("hDXRW");

var $8HWOF = parcelRequire("8HWOF");

var $fZarx = parcelRequire("fZarx");

var $doEUm = parcelRequire("doEUm");

var $bhFBq = parcelRequire("bhFBq");
const $9193e9d4f01f968c$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $4WLGH.isCryptoKey)(key)) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $fZarx.default)((0, $8HWOF.encodeBase64)(new Uint8Array(await (0, $4WLGH.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $9193e9d4f01f968c$export$cfba7e924fe414ca = (key)=>{
    return $9193e9d4f01f968c$var$genericExport("public", "spki", key);
};
const $9193e9d4f01f968c$export$cac76a78a90b914d = (key)=>{
    return $9193e9d4f01f968c$var$genericExport("private", "pkcs8", key);
};
const $9193e9d4f01f968c$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    let i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $9193e9d4f01f968c$var$findOid(keyData, oid, i + 1);
};
const $9193e9d4f01f968c$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $9193e9d4f01f968c$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $doEUm.JOSENotSupported)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $9193e9d4f01f968c$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    var _a;
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $9193e9d4f01f968c$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $9193e9d4f01f968c$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $4WLGH.default).subtle.importKey(keyFormat, keyData, algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
};
const $9193e9d4f01f968c$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $9193e9d4f01f968c$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $9193e9d4f01f968c$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $9193e9d4f01f968c$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $9193e9d4f01f968c$var$getElement(seq) {
    let result = [];
    let next = 0;
    while(next < seq.length){
        let nextPart = $9193e9d4f01f968c$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $9193e9d4f01f968c$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        let numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $9193e9d4f01f968c$var$spkiFromX509(buf) {
    const tbsCertificate = $9193e9d4f01f968c$var$getElement($9193e9d4f01f968c$var$getElement($9193e9d4f01f968c$var$parseElement(buf).contents)[0].contents);
    return (0, $8HWOF.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $9193e9d4f01f968c$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $8HWOF.decodeBase64)(pem);
    return (0, $fZarx.default)($9193e9d4f01f968c$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $9193e9d4f01f968c$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $9193e9d4f01f968c$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $9193e9d4f01f968c$export$f9a3505cdaa1fb3e(spki, alg, options);
};

});
parcelRegister("fZarx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba34a74ab19ebf5c$export$2e2bcd8739ae039);
var $ba34a74ab19ebf5c$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

});


parcelRegister("78DKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $53281ce761d7fe62$export$2e2bcd8739ae039);

var $4WLGH = parcelRequire("4WLGH");

var $doEUm = parcelRequire("doEUm");

var $8HWOF = parcelRequire("8HWOF");
function $53281ce761d7fe62$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "oct":
            switch(jwk.alg){
                case "HS256":
                case "HS384":
                case "HS512":
                    algorithm = {
                        name: "HMAC",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = [
                        "sign",
                        "verify"
                    ];
                    break;
                case "A128CBC-HS256":
                case "A192CBC-HS384":
                case "A256CBC-HS512":
                    throw new (0, $doEUm.JOSENotSupported)(`${jwk.alg} keys cannot be imported as CryptoKey instances`);
                case "A128GCM":
                case "A192GCM":
                case "A256GCM":
                case "A128GCMKW":
                case "A192GCMKW":
                case "A256GCMKW":
                    algorithm = {
                        name: "AES-GCM"
                    };
                    keyUsages = [
                        "encrypt",
                        "decrypt"
                    ];
                    break;
                case "A128KW":
                case "A192KW":
                case "A256KW":
                    algorithm = {
                        name: "AES-KW"
                    };
                    keyUsages = [
                        "wrapKey",
                        "unwrapKey"
                    ];
                    break;
                case "PBES2-HS256+A128KW":
                case "PBES2-HS384+A192KW":
                case "PBES2-HS512+A256KW":
                    algorithm = {
                        name: "PBKDF2"
                    };
                    keyUsages = [
                        "deriveBits"
                    ];
                    break;
                default:
                    throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $53281ce761d7fe62$var$parse = async (jwk)=>{
    var _a, _b;
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $53281ce761d7fe62$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        (_a = jwk.ext) !== null && _a !== void 0 ? _a : false,
        (_b = jwk.key_ops) !== null && _b !== void 0 ? _b : keyUsages
    ];
    if (algorithm.name === "PBKDF2") return (0, $4WLGH.default).subtle.importKey("raw", (0, $8HWOF.decode)(jwk.k), ...rest);
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $4WLGH.default).subtle.importKey("jwk", keyData, ...rest);
};
var $53281ce761d7fe62$export$2e2bcd8739ae039 = $53281ce761d7fe62$var$parse;

});


parcelRegister("8aEdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2e751b5ddc5b7e$export$2e2bcd8739ae039);

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
const $5f2e751b5ddc5b7e$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $bhFBq.default)(key)) throw new TypeError((0, $hDXRW.withAlg)(alg, key, ...(0, $bhFBq.types), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $bhFBq.types).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $5f2e751b5ddc5b7e$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $bhFBq.default)(key)) throw new TypeError((0, $hDXRW.withAlg)(alg, key, ...(0, $bhFBq.types)));
    if (key.type === "secret") throw new TypeError(`${(0, $bhFBq.types).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $bhFBq.types).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $bhFBq.types).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $bhFBq.types).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $bhFBq.types).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $5f2e751b5ddc5b7e$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $5f2e751b5ddc5b7e$var$symmetricTypeCheck(alg, key);
    else $5f2e751b5ddc5b7e$var$asymmetricTypeCheck(alg, key, usage);
};
var $5f2e751b5ddc5b7e$export$2e2bcd8739ae039 = $5f2e751b5ddc5b7e$var$checkKeyType;

});

parcelRegister("lNG8w", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $fdeedbfeef3839c7$export$4997ffc0176396a6);
$parcel$export(module.exports, "unwrap", () => $fdeedbfeef3839c7$export$debb760848ca95a);

var $k0TDd = parcelRequire("k0TDd");

var $9JKHA = parcelRequire("9JKHA");

var $6Tpad = parcelRequire("6Tpad");

var $8HWOF = parcelRequire("8HWOF");
async function $fdeedbfeef3839c7$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, $6Tpad.default)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag: tag } = await (0, $k0TDd.default)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: encryptedKey,
        iv: (0, $8HWOF.encode)(iv),
        tag: (0, $8HWOF.encode)(tag)
    };
}
async function $fdeedbfeef3839c7$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $9JKHA.default)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}

});
parcelRegister("k0TDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e91ef5f9e6802107$export$2e2bcd8739ae039);

var $j5DOn = parcelRequire("j5DOn");

var $jcudG = parcelRequire("jcudG");

var $5QxlO = parcelRequire("5QxlO");

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $hDXRW = parcelRequire("hDXRW");

var $doEUm = parcelRequire("doEUm");

var $bhFBq = parcelRequire("bhFBq");
async function $e91ef5f9e6802107$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $hDXRW.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $4WLGH.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $4WLGH.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $4WLGH.default).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $j5DOn.concat)(aad, iv, ciphertext, (0, $j5DOn.uint64be)(aad.length << 3));
    const tag = new Uint8Array((await (0, $4WLGH.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
async function $e91ef5f9e6802107$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $4WLGH.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $gC6BU.checkEncCryptoKey)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $4WLGH.default).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
const $e91ef5f9e6802107$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $4WLGH.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $hDXRW.default)(cek, ...(0, $bhFBq.types), "Uint8Array"));
    (0, $jcudG.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $5QxlO.default)(cek, parseInt(enc.slice(-3), 10));
            return $e91ef5f9e6802107$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $5QxlO.default)(cek, parseInt(enc.slice(1, 4), 10));
            return $e91ef5f9e6802107$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $doEUm.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $e91ef5f9e6802107$export$2e2bcd8739ae039 = $e91ef5f9e6802107$var$encrypt;

});



parcelRegister("K6zvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a96501ac288d5e$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");
function $08a96501ac288d5e$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $doEUm.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $08a96501ac288d5e$export$2e2bcd8739ae039 = $08a96501ac288d5e$var$validateCrit;

});

parcelRegister("xTaO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $065de17398ec473f$export$2e2bcd8739ae039);
const $065de17398ec473f$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $065de17398ec473f$export$2e2bcd8739ae039 = $065de17398ec473f$var$validateAlgorithms;

});



parcelRegister("3KZxR", function(module, exports) {

$parcel$export(module.exports, "generalDecrypt", () => $2bc5688d965d2822$export$56bc728c88264430);

var $7d4Aj = parcelRequire("7d4Aj");

var $doEUm = parcelRequire("doEUm");

var $38muk = parcelRequire("38muk");
async function $2bc5688d965d2822$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $38muk.default)(jwe)) throw new (0, $doEUm.JWEInvalid)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $38muk.default))) throw new (0, $doEUm.JWEInvalid)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $doEUm.JWEInvalid)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $7d4Aj.flattenedDecrypt)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch (_a) {}
    throw new (0, $doEUm.JWEDecryptionFailed)();
}

});

parcelRegister("fADuC", function(module, exports) {

$parcel$export(module.exports, "GeneralEncrypt", () => $b598da48de4a47ba$export$44234adffc6b0b92);

var $JRQDl = parcelRequire("JRQDl");

var $doEUm = parcelRequire("doEUm");

var $hIpEd = parcelRequire("hIpEd");

var $dCdw8 = parcelRequire("dCdw8");

var $tZtWy = parcelRequire("tZtWy");

var $8HWOF = parcelRequire("8HWOF");

var $K6zvK = parcelRequire("K6zvK");
class $b598da48de4a47ba$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $b598da48de4a47ba$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $b598da48de4a47ba$var$IndividualRecipient(this, key, {
            crit: options === null || options === void 0 ? void 0 : options.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt(options) {
        var _a, _b, _c;
        if (!this._recipients.length) throw new (0, $doEUm.JWEInvalid)("at least one recipient must be added");
        options = {
            deflateRaw: options === null || options === void 0 ? void 0 : options.deflateRaw
        };
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $JRQDl.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options,
                ...options
            });
            let jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $dCdw8.default)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $doEUm.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $doEUm.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $doEUm.JWEInvalid)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $doEUm.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $doEUm.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $K6zvK.default)((0, $doEUm.JWEInvalid), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) {
                if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, $doEUm.JWEInvalid)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            }
        }
        const cek = (0, $hIpEd.default)(enc);
        let jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $JRQDl.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    ...options,
                    [(0, $JRQDl.unprotected)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $tZtWy.default)(((_a = recipient.unprotectedHeader) === null || _a === void 0 ? void 0 : _a.alg) || ((_b = this._protectedHeader) === null || _b === void 0 ? void 0 : _b.alg) || ((_c = this._unprotectedHeader) === null || _c === void 0 ? void 0 : _c.alg), enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $8HWOF.encode)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}

});
parcelRegister("JRQDl", function(module, exports) {

$parcel$export(module.exports, "unprotected", () => $089df9292ac45816$export$39c45cb77eaf132);
$parcel$export(module.exports, "FlattenedEncrypt", () => $089df9292ac45816$export$eec23736d3c24809);

var $8HWOF = parcelRequire("8HWOF");

var $k0TDd = parcelRequire("k0TDd");

var $cr0JZ = parcelRequire("cr0JZ");

var $6Tpad = parcelRequire("6Tpad");

var $tZtWy = parcelRequire("tZtWy");

var $doEUm = parcelRequire("doEUm");

var $dCdw8 = parcelRequire("dCdw8");

var $j5DOn = parcelRequire("j5DOn");

var $K6zvK = parcelRequire("K6zvK");
const $089df9292ac45816$export$39c45cb77eaf132 = Symbol();
class $089df9292ac45816$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $doEUm.JWEInvalid)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $dCdw8.default)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $doEUm.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $K6zvK.default)((0, $doEUm.JWEInvalid), new Map(), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) {
            if (!this._protectedHeader || !this._protectedHeader.zip) throw new (0, $doEUm.JWEInvalid)('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
            if (joseHeader.zip !== "DEF") throw new (0, $doEUm.JOSENotSupported)('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
        }
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $doEUm.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $doEUm.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $tZtWy.default)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $089df9292ac45816$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, $6Tpad.default)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $j5DOn.encoder).encode((0, $8HWOF.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $j5DOn.encoder).encode("");
        if (this._aad) {
            aadMember = (0, $8HWOF.encode)(this._aad);
            additionalData = (0, $j5DOn.concat)(protectedHeader, (0, $j5DOn.encoder).encode("."), (0, $j5DOn.encoder).encode(aadMember));
        } else additionalData = protectedHeader;
        let ciphertext;
        let tag;
        if (joseHeader.zip === "DEF") {
            const deflated = await ((options === null || options === void 0 ? void 0 : options.deflateRaw) || (0, $cr0JZ.deflate))(this._plaintext);
            ({ ciphertext: ciphertext, tag: tag } = await (0, $k0TDd.default)(enc, deflated, cek, this._iv, additionalData));
        } else ({ ciphertext: ciphertext, tag: tag } = await (0, $k0TDd.default)(enc, this._plaintext, cek, this._iv, additionalData));
        const jwe = {
            ciphertext: (0, $8HWOF.encode)(ciphertext),
            iv: (0, $8HWOF.encode)(this._iv),
            tag: (0, $8HWOF.encode)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, $8HWOF.encode)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $j5DOn.decoder).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}

});
parcelRegister("tZtWy", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a26695a5fbe853$export$2e2bcd8739ae039);

var $keImv = parcelRequire("keImv");

var $dgg7K = parcelRequire("dgg7K");

var $bY2nm = parcelRequire("bY2nm");

var $c43YP = parcelRequire("c43YP");

var $8HWOF = parcelRequire("8HWOF");

var $hIpEd = parcelRequire("hIpEd");

var $doEUm = parcelRequire("doEUm");

var $3C6ak = parcelRequire("3C6ak");

var $8aEdO = parcelRequire("8aEdO");

var $lNG8w = parcelRequire("lNG8w");
async function $05a26695a5fbe853$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $8aEdO.default)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$dgg7K.ecdhAllowed(key)) throw new (0, $doEUm.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $dgg7K.generateEpk(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $3C6ak.exportJWK)(ephemeralKey);
                const sharedSecret = await $dgg7K.deriveKey(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $hIpEd.bitLength)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $8HWOF.encode)(apu);
                if (apv) parameters.apv = (0, $8HWOF.encode)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $hIpEd.default)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $keImv.wrap)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $hIpEd.default)(enc);
            encryptedKey = await (0, $c43YP.encrypt)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $hIpEd.default)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $bY2nm.encrypt)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $hIpEd.default)(enc);
            encryptedKey = await (0, $keImv.wrap)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $hIpEd.default)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $lNG8w.wrap)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $05a26695a5fbe853$export$2e2bcd8739ae039 = $05a26695a5fbe853$var$encryptKeyManagement;

});
parcelRegister("3C6ak", function(module, exports) {

$parcel$export(module.exports, "exportSPKI", () => $2a19b412ad3b184f$export$7f687badbeed246d);
$parcel$export(module.exports, "exportPKCS8", () => $2a19b412ad3b184f$export$ba4a7192ac1a47fe);
$parcel$export(module.exports, "exportJWK", () => $2a19b412ad3b184f$export$ffb510cfd482ce82);

var $cuUf3 = parcelRequire("cuUf3");

var $hM1LX = parcelRequire("hM1LX");
async function $2a19b412ad3b184f$export$7f687badbeed246d(key) {
    return (0, $cuUf3.toSPKI)(key);
}
async function $2a19b412ad3b184f$export$ba4a7192ac1a47fe(key) {
    return (0, $cuUf3.toPKCS8)(key);
}
async function $2a19b412ad3b184f$export$ffb510cfd482ce82(key) {
    return (0, $hM1LX.default)(key);
}

});
parcelRegister("hM1LX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf084b5a81b5b813$export$2e2bcd8739ae039);

var $4WLGH = parcelRequire("4WLGH");

var $hDXRW = parcelRequire("hDXRW");

var $8HWOF = parcelRequire("8HWOF");

var $bhFBq = parcelRequire("bhFBq");
const $cf084b5a81b5b813$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $8HWOF.encode)(key)
    };
    if (!(0, $4WLGH.isCryptoKey)(key)) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $4WLGH.default).subtle.exportKey("jwk", key);
    return jwk;
};
var $cf084b5a81b5b813$export$2e2bcd8739ae039 = $cf084b5a81b5b813$var$keyToJWK;

});





parcelRegister("4Xbqx", function(module, exports) {

$parcel$export(module.exports, "compactVerify", () => $39b58947aae4d3f9$export$996150e72a8992e);

var $daQfU = parcelRequire("daQfU");

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");
async function $39b58947aae4d3f9$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $j5DOn.decoder).decode(jws);
    if (typeof jws !== "string") throw new (0, $doEUm.JWSInvalid)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $doEUm.JWSInvalid)("Invalid Compact JWS");
    const verified = await (0, $daQfU.flattenedVerify)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("daQfU", function(module, exports) {

$parcel$export(module.exports, "flattenedVerify", () => $9974be6d2f710c63$export$b2614975507c40c9);

var $8HWOF = parcelRequire("8HWOF");

var $fn6SD = parcelRequire("fn6SD");

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");

var $dCdw8 = parcelRequire("dCdw8");

var $38muk = parcelRequire("38muk");

var $8aEdO = parcelRequire("8aEdO");

var $K6zvK = parcelRequire("K6zvK");

var $xTaO6 = parcelRequire("xTaO6");
async function $9974be6d2f710c63$export$b2614975507c40c9(jws, key, options) {
    var _a;
    if (!(0, $38muk.default)(jws)) throw new (0, $doEUm.JWSInvalid)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $doEUm.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $doEUm.JWSInvalid)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $doEUm.JWSInvalid)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $doEUm.JWSInvalid)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $38muk.default)(jws.header)) throw new (0, $doEUm.JWSInvalid)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $8HWOF.decode)(jws.protected);
        parsedProt = JSON.parse((0, $j5DOn.decoder).decode(protectedHeader));
    } catch (_b) {
        throw new (0, $doEUm.JWSInvalid)("JWS Protected Header is invalid");
    }
    if (!(0, $dCdw8.default)(parsedProt, jws.header)) throw new (0, $doEUm.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $K6zvK.default)((0, $doEUm.JWSInvalid), new Map([
        [
            "b64",
            true
        ]
    ]), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $doEUm.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $doEUm.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $xTaO6.default)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $doEUm.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $doEUm.JWSInvalid)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $doEUm.JWSInvalid)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $8aEdO.default)(alg, key, "verify");
    const data = (0, $j5DOn.concat)((0, $j5DOn.encoder).encode((_a = jws.protected) !== null && _a !== void 0 ? _a : ""), (0, $j5DOn.encoder).encode("."), typeof jws.payload === "string" ? (0, $j5DOn.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $8HWOF.decode)(jws.signature);
    } catch (_c) {
        throw new (0, $doEUm.JWSInvalid)("Failed to base64url decode the signature");
    }
    const verified = await (0, $fn6SD.default)(alg, key, signature, data);
    if (!verified) throw new (0, $doEUm.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, $8HWOF.decode)(jws.payload);
    } catch (_d) {
        throw new (0, $doEUm.JWSInvalid)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $j5DOn.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRegister("fn6SD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b30e573d1374feac$export$2e2bcd8739ae039);

var $inm1w = parcelRequire("inm1w");

var $4WLGH = parcelRequire("4WLGH");

var $7dpfg = parcelRequire("7dpfg");

var $kM4tB = parcelRequire("kM4tB");
const $b30e573d1374feac$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $kM4tB.default)(alg, key, "verify");
    (0, $7dpfg.default)(alg, cryptoKey);
    const algorithm = (0, $inm1w.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, $4WLGH.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch (_a) {
        return false;
    }
};
var $b30e573d1374feac$export$2e2bcd8739ae039 = $b30e573d1374feac$var$verify;

});
parcelRegister("inm1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60b756752620632$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");
function $d60b756752620632$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $doEUm.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRegister("kM4tB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1fbc342064f1261$export$2e2bcd8739ae039);

var $4WLGH = parcelRequire("4WLGH");

var $gC6BU = parcelRequire("gC6BU");

var $hDXRW = parcelRequire("hDXRW");

var $bhFBq = parcelRequire("bhFBq");
function $f1fbc342064f1261$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $4WLGH.isCryptoKey)(key)) {
        (0, $gC6BU.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types)));
        return (0, $4WLGH.default).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $hDXRW.default)(key, ...(0, $bhFBq.types), "Uint8Array"));
}

});




parcelRegister("hGdsG", function(module, exports) {

$parcel$export(module.exports, "generalVerify", () => $cdf0cd233c627dc3$export$45b643129436bc63);

var $daQfU = parcelRequire("daQfU");

var $doEUm = parcelRequire("doEUm");

var $38muk = parcelRequire("38muk");
async function $cdf0cd233c627dc3$export$45b643129436bc63(jws, key, options) {
    if (!(0, $38muk.default)(jws)) throw new (0, $doEUm.JWSInvalid)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $38muk.default))) throw new (0, $doEUm.JWSInvalid)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $daQfU.flattenedVerify)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch (_a) {}
    throw new (0, $doEUm.JWSSignatureVerificationFailed)();
}

});

parcelRegister("nAr06", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", () => $046e693a899695dd$export$c878fd0f8381da51);

var $4Xbqx = parcelRequire("4Xbqx");

var $cG6Tq = parcelRequire("cG6Tq");

var $doEUm = parcelRequire("doEUm");
async function $046e693a899695dd$export$c878fd0f8381da51(jwt, key, options) {
    var _a;
    const verified = await (0, $4Xbqx.compactVerify)(jwt, key, options);
    if (((_a = verified.protectedHeader.crit) === null || _a === void 0 ? void 0 : _a.includes("b64")) && verified.protectedHeader.b64 === false) throw new (0, $doEUm.JWTInvalid)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $cG6Tq.default)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRegister("cG6Tq", function(module, exports) {

$parcel$export(module.exports, "default", () => $93aec1152ee76520$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");

var $6PVmI = parcelRequire("6PVmI");

var $8vRQo = parcelRequire("8vRQo");

var $38muk = parcelRequire("38muk");
const $93aec1152ee76520$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $93aec1152ee76520$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $93aec1152ee76520$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $93aec1152ee76520$var$normalizeTyp(protectedHeader.typ) !== $93aec1152ee76520$var$normalizeTyp(typ))) throw new (0, $doEUm.JWTClaimValidationFailed)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $j5DOn.decoder).decode(encodedPayload));
    } catch (_a) {}
    if (!(0, $38muk.default)(payload)) throw new (0, $doEUm.JWTInvalid)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    if (maxTokenAge !== undefined) requiredClaims.push("iat");
    if (audience !== undefined) requiredClaims.push("aud");
    if (subject !== undefined) requiredClaims.push("sub");
    if (issuer !== undefined) requiredClaims.push("iss");
    for (const claim of new Set(requiredClaims.reverse())){
        if (!(claim in payload)) throw new (0, $doEUm.JWTClaimValidationFailed)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $doEUm.JWTClaimValidationFailed)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $doEUm.JWTClaimValidationFailed)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$93aec1152ee76520$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $doEUm.JWTClaimValidationFailed)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $8vRQo.default)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $6PVmI.default)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $doEUm.JWTClaimValidationFailed)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $doEUm.JWTClaimValidationFailed)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $doEUm.JWTClaimValidationFailed)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $doEUm.JWTClaimValidationFailed)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $doEUm.JWTExpired)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $8vRQo.default)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $doEUm.JWTExpired)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $doEUm.JWTClaimValidationFailed)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};

});
parcelRegister("6PVmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa401163eec5b11$export$2e2bcd8739ae039);
var $4fa401163eec5b11$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);

});

parcelRegister("8vRQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $632afc49507b6e74$export$2e2bcd8739ae039);
const $632afc49507b6e74$var$minute = 60;
const $632afc49507b6e74$var$hour = $632afc49507b6e74$var$minute * 60;
const $632afc49507b6e74$var$day = $632afc49507b6e74$var$hour * 24;
const $632afc49507b6e74$var$week = $632afc49507b6e74$var$day * 7;
const $632afc49507b6e74$var$year = $632afc49507b6e74$var$day * 365.25;
const $632afc49507b6e74$var$REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i;
var $632afc49507b6e74$export$2e2bcd8739ae039 = (str)=>{
    const matched = $632afc49507b6e74$var$REGEX.exec(str);
    if (!matched) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[1]);
    const unit = matched[2].toLowerCase();
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            return Math.round(value);
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            return Math.round(value * $632afc49507b6e74$var$minute);
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            return Math.round(value * $632afc49507b6e74$var$hour);
        case "day":
        case "days":
        case "d":
            return Math.round(value * $632afc49507b6e74$var$day);
        case "week":
        case "weeks":
        case "w":
            return Math.round(value * $632afc49507b6e74$var$week);
        default:
            return Math.round(value * $632afc49507b6e74$var$year);
    }
};

});



parcelRegister("l7tnz", function(module, exports) {

$parcel$export(module.exports, "jwtDecrypt", () => $f6010a88c7738dd8$export$6ee899505bc40a19);

var $eBzhe = parcelRequire("eBzhe");

var $cG6Tq = parcelRequire("cG6Tq");

var $doEUm = parcelRequire("doEUm");
async function $f6010a88c7738dd8$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $eBzhe.compactDecrypt)(jwt, key, options);
    const payload = (0, $cG6Tq.default)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $doEUm.JWTClaimValidationFailed)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $doEUm.JWTClaimValidationFailed)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $doEUm.JWTClaimValidationFailed)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

});

parcelRegister("pUyhf", function(module, exports) {

$parcel$export(module.exports, "CompactEncrypt", () => $04de33ef69159ee7$export$965e4de9938e070e);

var $JRQDl = parcelRequire("JRQDl");
class $04de33ef69159ee7$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $JRQDl.FlattenedEncrypt)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}

});

parcelRegister("c5lkx", function(module, exports) {

$parcel$export(module.exports, "CompactSign", () => $8cc67f637e268947$export$b6738d8e70498d17);

var $g3Jck = parcelRequire("g3Jck");
class $8cc67f637e268947$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $g3Jck.FlattenedSign)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}

});
parcelRegister("g3Jck", function(module, exports) {

$parcel$export(module.exports, "FlattenedSign", () => $bb0ffc7fbba1dfcc$export$9a8af5200da5ddb1);

var $8HWOF = parcelRequire("8HWOF");

var $eRK3J = parcelRequire("eRK3J");

var $dCdw8 = parcelRequire("dCdw8");

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");

var $8aEdO = parcelRequire("8aEdO");

var $K6zvK = parcelRequire("K6zvK");
class $bb0ffc7fbba1dfcc$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $doEUm.JWSInvalid)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $dCdw8.default)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $doEUm.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $K6zvK.default)((0, $doEUm.JWSInvalid), new Map([
            [
                "b64",
                true
            ]
        ]), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $doEUm.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $doEUm.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $8aEdO.default)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $j5DOn.encoder).encode((0, $8HWOF.encode)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $j5DOn.encoder).encode((0, $8HWOF.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $j5DOn.encoder).encode("");
        const data = (0, $j5DOn.concat)(protectedHeader, (0, $j5DOn.encoder).encode("."), payload);
        const signature = await (0, $eRK3J.default)(alg, key, data);
        const jws = {
            signature: (0, $8HWOF.encode)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $j5DOn.decoder).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $j5DOn.decoder).decode(protectedHeader);
        return jws;
    }
}

});
parcelRegister("eRK3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad29be4cba76f3af$export$2e2bcd8739ae039);

var $inm1w = parcelRequire("inm1w");

var $4WLGH = parcelRequire("4WLGH");

var $7dpfg = parcelRequire("7dpfg");

var $kM4tB = parcelRequire("kM4tB");
const $ad29be4cba76f3af$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $kM4tB.default)(alg, key, "sign");
    (0, $7dpfg.default)(alg, cryptoKey);
    const signature = await (0, $4WLGH.default).subtle.sign((0, $inm1w.default)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $ad29be4cba76f3af$export$2e2bcd8739ae039 = $ad29be4cba76f3af$var$sign;

});



parcelRegister("dDeJs", function(module, exports) {

$parcel$export(module.exports, "GeneralSign", () => $9eca585e15fe5bd8$export$7e2f94727ed1a34b);

var $g3Jck = parcelRequire("g3Jck");

var $doEUm = parcelRequire("doEUm");
class $9eca585e15fe5bd8$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $9eca585e15fe5bd8$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $9eca585e15fe5bd8$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $doEUm.JWSInvalid)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $g3Jck.FlattenedSign)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $doEUm.JWSInvalid)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}

});

parcelRegister("EFHdI", function(module, exports) {

$parcel$export(module.exports, "SignJWT", () => $07a41484b11eeded$export$88d4e5d23fbe6c84);

var $c5lkx = parcelRequire("c5lkx");

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");

var $hCreO = parcelRequire("hCreO");
class $07a41484b11eeded$export$88d4e5d23fbe6c84 extends (0, $hCreO.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        var _a;
        const sig = new (0, $c5lkx.CompactSign)((0, $j5DOn.encoder).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray((_a = this._protectedHeader) === null || _a === void 0 ? void 0 : _a.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $doEUm.JWTInvalid)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}

});
parcelRegister("hCreO", function(module, exports) {

$parcel$export(module.exports, "ProduceJWT", () => $cd3b1d2936a919a7$export$2ef1b74b7c7e6eb3);

var $6PVmI = parcelRequire("6PVmI");

var $38muk = parcelRequire("38muk");

var $8vRQo = parcelRequire("8vRQo");
class $cd3b1d2936a919a7$export$2ef1b74b7c7e6eb3 {
    constructor(payload){
        if (!(0, $38muk.default)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: input
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $6PVmI.default)(new Date()) + (0, $8vRQo.default)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: input
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $6PVmI.default)(new Date()) + (0, $8vRQo.default)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $6PVmI.default)(new Date())
        };
        else this._payload = {
            ...this._payload,
            iat: input
        };
        return this;
    }
}

});


parcelRegister("ehy5Z", function(module, exports) {

$parcel$export(module.exports, "EncryptJWT", () => $a65d19e0b23bf98b$export$28c9f8d29aec6f3d);

var $pUyhf = parcelRequire("pUyhf");

var $j5DOn = parcelRequire("j5DOn");

var $hCreO = parcelRequire("hCreO");
class $a65d19e0b23bf98b$export$28c9f8d29aec6f3d extends (0, $hCreO.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $pUyhf.CompactEncrypt)((0, $j5DOn.encoder).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}

});

parcelRegister("5XVH0", function(module, exports) {

$parcel$export(module.exports, "calculateJwkThumbprint", () => $457f36fd5fec5493$export$f1ec189735e8660f);
$parcel$export(module.exports, "calculateJwkThumbprintUri", () => $457f36fd5fec5493$export$b9879ebc49d4fd7a);

var $9XDkd = parcelRequire("9XDkd");

var $8HWOF = parcelRequire("8HWOF");

var $doEUm = parcelRequire("doEUm");

var $j5DOn = parcelRequire("j5DOn");

var $38muk = parcelRequire("38muk");
const $457f36fd5fec5493$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $doEUm.JWKInvalid)(`${description} missing or invalid`);
};
async function $457f36fd5fec5493$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $38muk.default)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $457f36fd5fec5493$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $457f36fd5fec5493$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $457f36fd5fec5493$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $457f36fd5fec5493$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $457f36fd5fec5493$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $457f36fd5fec5493$var$check(jwk.e, '"e" (Exponent) Parameter');
            $457f36fd5fec5493$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $457f36fd5fec5493$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $doEUm.JOSENotSupported)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $j5DOn.encoder).encode(JSON.stringify(components));
    return (0, $8HWOF.encode)(await (0, $9XDkd.default)(digestAlgorithm, data));
}
async function $457f36fd5fec5493$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm !== null && digestAlgorithm !== void 0 ? digestAlgorithm : digestAlgorithm = "sha256";
    const thumbprint = await $457f36fd5fec5493$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}

});

parcelRegister("dokVe", function(module, exports) {

$parcel$export(module.exports, "EmbeddedJWK", () => $9bfdbef0315297d7$export$c51e3062a159ef59);

var $3eAHr = parcelRequire("3eAHr");

var $38muk = parcelRequire("38muk");

var $doEUm = parcelRequire("doEUm");
async function $9bfdbef0315297d7$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token === null || token === void 0 ? void 0 : token.header
    };
    if (!(0, $38muk.default)(joseHeader.jwk)) throw new (0, $doEUm.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $3eAHr.importJWK)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg, true);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $doEUm.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}

});

parcelRegister("a9JhK", function(module, exports) {

$parcel$export(module.exports, "isJWKSLike", () => $764ddf54eb4d199e$export$d01e0ebadbb4baf);
$parcel$export(module.exports, "LocalJWKSet", () => $764ddf54eb4d199e$export$cfeaec9a672ea12b);
$parcel$export(module.exports, "createLocalJWKSet", () => $764ddf54eb4d199e$export$4892abc640e5f80e);

var $3eAHr = parcelRequire("3eAHr");

var $doEUm = parcelRequire("doEUm");

var $38muk = parcelRequire("38muk");
function $764ddf54eb4d199e$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $doEUm.JOSENotSupported)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $764ddf54eb4d199e$export$d01e0ebadbb4baf(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($764ddf54eb4d199e$var$isJWKLike);
}
function $764ddf54eb4d199e$var$isJWKLike(key) {
    return (0, $38muk.default)(key);
}
function $764ddf54eb4d199e$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $764ddf54eb4d199e$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$764ddf54eb4d199e$export$d01e0ebadbb4baf(jwks)) throw new (0, $doEUm.JWKSInvalid)("JSON Web Key Set malformed");
        this._jwks = $764ddf54eb4d199e$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token === null || token === void 0 ? void 0 : token.header
        };
        const kty = $764ddf54eb4d199e$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $doEUm.JWKSNoMatchingKey)();
        else if (length !== 1) {
            const error = new (0, $doEUm.JWKSMultipleMatchingKeys)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $764ddf54eb4d199e$var$importWithAlgCache(_cached, jwk, alg);
                } catch (_a) {
                    continue;
                }
            };
            throw error;
        }
        return $764ddf54eb4d199e$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $764ddf54eb4d199e$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $3eAHr.importJWK)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $doEUm.JWKSInvalid)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $764ddf54eb4d199e$export$4892abc640e5f80e(jwks) {
    const set = new $764ddf54eb4d199e$export$cfeaec9a672ea12b(jwks);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}

});

parcelRegister("4vzXy", function(module, exports) {

$parcel$export(module.exports, "createRemoteJWKSet", () => $3485f3792f48ead9$export$78ce35c2df51c333);

var $5FNMc = parcelRequire("5FNMc");

var $doEUm = parcelRequire("doEUm");

var $a9JhK = parcelRequire("a9JhK");
function $3485f3792f48ead9$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
class $3485f3792f48ead9$var$RemoteJWKSet extends (0, $a9JhK.LocalJWKSet) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options === null || options === void 0 ? void 0 : options.agent,
            headers: options === null || options === void 0 ? void 0 : options.headers
        };
        this._timeoutDuration = typeof (options === null || options === void 0 ? void 0 : options.timeoutDuration) === "number" ? options === null || options === void 0 ? void 0 : options.timeoutDuration : 5000;
        this._cooldownDuration = typeof (options === null || options === void 0 ? void 0 : options.cooldownDuration) === "number" ? options === null || options === void 0 ? void 0 : options.cooldownDuration : 30000;
        this._cacheMaxAge = typeof (options === null || options === void 0 ? void 0 : options.cacheMaxAge) === "number" ? options === null || options === void 0 ? void 0 : options.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $doEUm.JWKSNoMatchingKey)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $3485f3792f48ead9$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        this._pendingFetch || (this._pendingFetch = (0, $5FNMc.default)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, $a9JhK.isJWKSLike)(json)) throw new (0, $doEUm.JWKSInvalid)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $3485f3792f48ead9$export$78ce35c2df51c333(url, options) {
    const set = new $3485f3792f48ead9$var$RemoteJWKSet(url, options);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}

});
parcelRegister("5FNMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $421764a4f30369e8$export$2e2bcd8739ae039);

var $doEUm = parcelRequire("doEUm");
const $421764a4f30369e8$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $doEUm.JWKSTimeout)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $doEUm.JOSEError)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch (_a) {
        throw new (0, $doEUm.JOSEError)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $421764a4f30369e8$export$2e2bcd8739ae039 = $421764a4f30369e8$var$fetchJwks;

});


parcelRegister("2Qfuk", function(module, exports) {

$parcel$export(module.exports, "UnsecuredJWT", () => $211c73be53bb85af$export$6404fb90f16d8733);

var $8HWOF = parcelRequire("8HWOF");

var $j5DOn = parcelRequire("j5DOn");

var $doEUm = parcelRequire("doEUm");

var $cG6Tq = parcelRequire("cG6Tq");

var $hCreO = parcelRequire("hCreO");
class $211c73be53bb85af$export$6404fb90f16d8733 extends (0, $hCreO.ProduceJWT) {
    encode() {
        const header = $8HWOF.encode(JSON.stringify({
            alg: "none"
        }));
        const payload = $8HWOF.encode(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $doEUm.JWTInvalid)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $doEUm.JWTInvalid)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $j5DOn.decoder).decode($8HWOF.decode(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch (_a) {
            throw new (0, $doEUm.JWTInvalid)("Invalid Unsecured JWT");
        }
        const payload = (0, $cG6Tq.default)(header, $8HWOF.decode(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}

});

parcelRegister("ioDOB", function(module, exports) {

$parcel$export(module.exports, "decodeProtectedHeader", () => $d6495a5fb9c669e7$export$ca23208356ba8d90);

var $kp9Vr = parcelRequire("kp9Vr");

var $j5DOn = parcelRequire("j5DOn");

var $38muk = parcelRequire("38muk");
function $d6495a5fb9c669e7$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $j5DOn.decoder).decode((0, $kp9Vr.decode)(protectedB64u)));
        if (!(0, $38muk.default)(result)) throw new Error();
        return result;
    } catch (_a) {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}

});
parcelRegister("kp9Vr", function(module, exports) {

$parcel$export(module.exports, "encode", () => $edadd77180b706dd$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $edadd77180b706dd$export$2f872c0f2117be69);

var $8HWOF = parcelRequire("8HWOF");
const $edadd77180b706dd$export$c564cdbbe6da493 = $8HWOF.encode;
const $edadd77180b706dd$export$2f872c0f2117be69 = $8HWOF.decode;

});


parcelRegister("gbvd4", function(module, exports) {

$parcel$export(module.exports, "decodeJwt", () => $bc85e2085b60c2ed$export$dcef71b8fb9a6794);

var $kp9Vr = parcelRequire("kp9Vr");

var $j5DOn = parcelRequire("j5DOn");

var $38muk = parcelRequire("38muk");

var $doEUm = parcelRequire("doEUm");
function $bc85e2085b60c2ed$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $doEUm.JWTInvalid)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $doEUm.JWTInvalid)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $doEUm.JWTInvalid)("Invalid JWT");
    if (!payload) throw new (0, $doEUm.JWTInvalid)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $kp9Vr.decode)(payload);
    } catch (_a) {
        throw new (0, $doEUm.JWTInvalid)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $j5DOn.decoder).decode(decoded));
    } catch (_b) {
        throw new (0, $doEUm.JWTInvalid)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $38muk.default)(result)) throw new (0, $doEUm.JWTInvalid)("Invalid JWT Claims Set");
    return result;
}

});

parcelRegister("c81UX", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $8d47b832e0d474cb$export$a949d36eab55b41f);

var $81ULR = parcelRequire("81ULR");
async function $8d47b832e0d474cb$export$a949d36eab55b41f(alg, options) {
    return (0, $81ULR.generateKeyPair)(alg, options);
}

});
parcelRegister("81ULR", function(module, exports) {

$parcel$export(module.exports, "generateSecret", () => $5d8a74438d83377c$export$25395fe8d170ad7);
$parcel$export(module.exports, "generateKeyPair", () => $5d8a74438d83377c$export$a949d36eab55b41f);

var $4WLGH = parcelRequire("4WLGH");

var $doEUm = parcelRequire("doEUm");

var $kEhFo = parcelRequire("kEhFo");
async function $5d8a74438d83377c$export$25395fe8d170ad7(alg, options) {
    var _a;
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $kEhFo.default)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $4WLGH.default).subtle.generateKey(algorithm, (_a = options === null || options === void 0 ? void 0 : options.extractable) !== null && _a !== void 0 ? _a : false, keyUsages);
}
function $5d8a74438d83377c$var$getModulusLengthOption(options) {
    var _a;
    const modulusLength = (_a = options === null || options === void 0 ? void 0 : options.modulusLength) !== null && _a !== void 0 ? _a : 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $doEUm.JOSENotSupported)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $5d8a74438d83377c$export$a949d36eab55b41f(alg, options) {
    var _a, _b, _c;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $5d8a74438d83377c$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $5d8a74438d83377c$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $5d8a74438d83377c$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            keyUsages = [
                "sign",
                "verify"
            ];
            const crv = (_a = options === null || options === void 0 ? void 0 : options.crv) !== null && _a !== void 0 ? _a : "Ed25519";
            switch(crv){
                case "Ed25519":
                case "Ed448":
                    algorithm = {
                        name: crv
                    };
                    break;
                default:
                    throw new (0, $doEUm.JOSENotSupported)("Invalid or unsupported crv option provided");
            }
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = (_b = options === null || options === void 0 ? void 0 : options.crv) !== null && _b !== void 0 ? _b : "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $doEUm.JOSENotSupported)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $doEUm.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $4WLGH.default).subtle.generateKey(algorithm, (_c = options === null || options === void 0 ? void 0 : options.extractable) !== null && _c !== void 0 ? _c : false, keyUsages);
}

});


parcelRegister("bFbaj", function(module, exports) {

$parcel$export(module.exports, "generateSecret", () => $87dc2f45816d5924$export$25395fe8d170ad7);

var $81ULR = parcelRequire("81ULR");
async function $87dc2f45816d5924$export$25395fe8d170ad7(alg, options) {
    return (0, $81ULR.generateSecret)(alg, options);
}

});

parcelRegister("g38wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $baf388f3fab9c3cb$export$2e2bcd8739ae039);

var $kITJM = parcelRequire("kITJM");
var $baf388f3fab9c3cb$export$2e2bcd8739ae039 = (0, $kITJM.default);

});
parcelRegister("kITJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16326fe628abe4d$export$2e2bcd8739ae039);
var $f16326fe628abe4d$export$2e2bcd8739ae039 = "WebCryptoAPI";

});



var $d24fb0ab9d4863bc$exports = {};




!function(e, t) {
    $d24fb0ab9d4863bc$exports = t((parcelRequire("kev3W")), (parcelRequire("gtl9B")), (parcelRequire("hYfPi")), (parcelRequire("5azj4")));
}($d24fb0ab9d4863bc$exports, function(e, t, r, n) {
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var i = /*#__PURE__*/ o(r);
    function u() {
        return u = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }, u.apply(this, arguments);
    }
    function s(e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, a(e, t);
    }
    function c(e) {
        return c = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, c(e);
    }
    function a(e, t) {
        return a = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        }, a(e, t);
    }
    function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }
    function f(e, t, r) {
        return f = l() ? Reflect.construct : function(e, t, r) {
            var n = [
                null
            ];
            n.push.apply(n, t);
            var o = new (Function.bind.apply(e, n));
            return r && a(o, r.prototype), o;
        }, f.apply(null, arguments);
    }
    function h(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return h = function(e) {
            if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
            }
            function r() {
                return f(e, arguments, c(this).constructor);
            }
            return r.prototype = Object.create(e.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), a(r, e);
        }, h(e);
    }
    function p(e, t) {
        if (null == e) return {};
        var r, n, o = {}, i = Object.keys(e);
        for(n = 0; n < i.length; n++)t.indexOf(r = i[n]) >= 0 || (o[r] = e[r]);
        return o;
    }
    function d(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
        return n;
    }
    function m(e, t) {
        var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (r) return (r = r.call(e)).next.bind(r);
        if (Array.isArray(e) || (r = function(e, t) {
            if (e) {
                if ("string" == typeof e) return d(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(e, t) : void 0;
            }
        }(e)) || t && e && "number" == typeof e.length) {
            r && (e = r);
            var n = 0;
            return function() {
                return n >= e.length ? {
                    done: !0
                } : {
                    done: !1,
                    value: e[n++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function v(e, t) {
        return function(r) {
            function n() {
                var n;
                return (n = r.call(this, t) || this).name = e, n;
            }
            return s(n, r), n;
        }(/*#__PURE__*/ h(Error));
    }
    var g = v("PopupTimeoutError", "The popup has timed out."), _ = v("PopupClosedError", "The popup was closed."), y = function(e) {
        return String.fromCharCode.apply(null, Array.from(new Uint8Array(e)));
    }, w = new TextEncoder, b = function() {
        return i.default;
    }, P = function(e) {
        return b().btoa(e);
    }, k = function(e) {
        return P(e).replace(/=+$/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }, S = function() {
        var e;
        return null != (e = b().crypto) ? e : b().msCrypto;
    }, R = function(e) {
        return S().getRandomValues(new Uint8Array(e));
    }, O = function() {
        var e;
        return null != (e = S().subtle) ? e : S().webkitSubtle;
    }, A = function(e) {
        try {
            var t = O().digest({
                name: "SHA-256"
            }, e);
            return b().msCrypto ? Promise.resolve(new Promise(function(e, r) {
                t.oncomplete = function(t) {
                    return e(t.target.result);
                }, t.onerror = function(e) {
                    return r(e.error);
                }, t.onabort = function() {
                    return r("The digest operation was aborted");
                };
            })) : Promise.resolve(t);
        } catch (e) {
            return Promise.reject(e);
        }
    }, j = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.", T = function(e) {
        return b().atob(e);
    }, I = new TextDecoder;
    function z(e) {
        return Array.from(new Set(e));
    }
    var U = function(e) {
        return z(e.trim().split(/\s+/)).sort().join(" ");
    };
    function E(e) {
        var t = {};
        return e.forEach(function(r, n) {
            t[n] = e.getAll(n).length > 1 ? e.getAll(n) : e.get(n);
        }), t;
    }
    function L(e) {
        var t = new URLSearchParams([].concat(Object.entries(e)).filter(function(e) {
            return null != e[0] && null != e[1];
        }));
        return t.sort(), t.toString();
    }
    var C = {
        createCodeChallengeAndVerifier: function(e, t) {
            void 0 === e && (e = 43), void 0 === t && (t = "S256");
            try {
                var r = function(e) {
                    return Array.from(R(e)).map(function(e) {
                        return j[e % j.length];
                    }).join("");
                }(e);
                switch(t){
                    case "plain":
                        return Promise.resolve({
                            verifier: r,
                            challenge: r
                        });
                    case "S256":
                        return Promise.resolve(A(w.encode(r).buffer)).then(function(e) {
                            return {
                                verifier: r,
                                challenge: k(y(e))
                            };
                        });
                    default:
                        throw new Error("bad challenge method");
                }
            } catch (e) {
                return Promise.reject(e);
            }
        },
        getCrypto: S,
        getCryptoSubtle: O,
        getRandomBytes: R,
        sha256: A,
        verifyIdToken: function(e, t, r, o) {
            try {
                return Promise.resolve(n.jwtVerify(t, n.createRemoteJWKSet(new URL(e)), {
                    audience: o
                })).then(function(e) {
                    var n = e.payload;
                    if (n.__raw = t, r !== n.nonce) throw new Error("nonces don't match");
                    return n;
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }
    }, x = {
        decodeState: function(e) {
            var t = e.split("."), r = t[1];
            if (t.slice(2).length > 0) throw new Error("failed to decode state");
            return (null == r ? void 0 : r.length) > 0 ? JSON.parse(decodeURIComponent(T(r))) : void 0;
        },
        encodeState: function(e) {
            return k(y(R(32))) + "." + (null == e ? "" : k(encodeURIComponent(JSON.stringify(e))));
        },
        fromBase64: T,
        textDecoder: I,
        textEncoder: w,
        toBase64: P,
        toUrlEncodedBase64: k,
        stringFromBuffer: y
    }, q = {
        __proto__: null,
        crypto: C,
        encoding: x,
        getSortedScope: U,
        getWindow: b,
        objectFromEntries: function(e) {
            for(var t, r = {}, n = m(e); !(t = n()).done;){
                var o = t.value;
                r[o[0]] = o[1];
            }
            return r;
        },
        objectFromURLSearchParams: E,
        objectToKey: L,
        retry: function e(t, r, n, o, i) {
            return void 0 === r && (r = 4), void 0 === n && (n = 250), void 0 === o && (o = 2), void 0 === i && (i = null), r <= 0 ? Promise.reject(i) : t().catch(function(i) {
                try {
                    return Promise.resolve(new Promise(function(e) {
                        return setTimeout(e, n);
                    })).then(function() {
                        return e(t, r - 1, n * o, o, i);
                    });
                } catch (e) {
                    return Promise.reject(e);
                }
            });
        },
        uniqueElementsFromArray: z
    }, D = /*#__PURE__*/ function(e) {
        function t(t, r, n) {
            var o;
            return (o = e.call(this, t + ": " + r + (n ? "\nSee more at " + n + "." : "")) || this).code = void 0, o.description = void 0, o.uri = void 0, o.code = t, o.description = r, o.uri = n, o;
        }
        return s(t, e), t.fromResponse = function(e) {
            return new t(e.error, e.error_description, e.error_uri);
        }, t;
    }(/*#__PURE__*/ h(Error)), F = [
        "url"
    ], W = [
        "url",
        "client_id",
        "client_secret",
        "client_auth_method"
    ], N = /*#__PURE__*/ function() {
        function e(e) {
            this.options = void 0, this.options = e;
        }
        var t = e.prototype;
        return t.buildAuthorizeUrl = function(e) {
            return this._buildUrl(e);
        }, t.buildLogoutUrl = function(e) {
            return this._buildUrl(e);
        }, t.parseAuthorizeResponseFromFragment = function(e) {
            return this._validateResponse(E(new URLSearchParams(new URL(e).hash.substring(1))));
        }, t.parseAuthorizeResponseFromQuery = function(e) {
            return this._validateResponse(E(new URL(e).searchParams));
        }, t.authorizeWithPopup = function(e, t) {
            void 0 === t && (t = {});
            try {
                var r, n = this;
                if (!window) throw new Error("no window in options");
                var o = n.buildAuthorizeUrl(e), i = t.popup, u = null != (r = t.timeout) ? r : 36e5;
                if (i) i.location.href = o;
                else {
                    var s, c, a = null != (s = t.width) ? s : 600, l = null != (c = t.height) ? c : 800;
                    if (!(i = window.open(o, "uauth:authorize:popup", "left=" + (window.screenX + (window.innerWidth - a) / 2) + ",top=" + (window.screenY + (window.innerHeight - l) / 2) + ",width=" + a + ",height=" + l + ",resizable,scrollbars=yes,status=1"))) throw new Error("popup failed to be constructed");
                }
                var f = !1;
                return Promise.resolve(new Promise(function(t, r) {
                    var o = setTimeout(function() {
                        f || (clearInterval(s), i.close(), r(new g));
                    }, u), s = setInterval(function() {
                        var u, c, a, l;
                        !f && null != (u = i) && u.closed && (clearInterval(s), clearTimeout(o), r(new _));
                        try {
                            c = i.location.href, a = new URL(c), l = new URL(e.redirect_uri);
                        } catch (e) {
                            return;
                        }
                        if (a.hash = "", a.href === l.href) {
                            f = !0, clearInterval(s), clearTimeout(o), i.close();
                            try {
                                t(n.parseAuthorizeResponseFromFragment(c));
                            } catch (e) {
                                r(e);
                            }
                        }
                    }, 10);
                }));
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.authorizeWithDevice = function(e) {
            return Promise.resolve({});
        }, t.getToken = function(e) {
            try {
                var t = this._buildRequest(e, {
                    method: "POST"
                });
                return Promise.resolve(this._fetchJSON(t[0], t[1]));
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.introspect = function(e) {
            var t = this._buildRequest(e, {
                method: "POST"
            });
            return this._fetchJSON(t[0], t[1]);
        }, t.revoke = function(e) {
            try {
                var t = this._buildRequest(e, {
                    method: "POST"
                });
                return Promise.resolve(this._fetchJSON(t[0], t[1])).then(function() {});
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.userinfo = function(e) {
            var t = this._buildRequest(e, {
                method: "GET",
                headers: {
                    Authorization: "Basic " + e.access_token
                }
            });
            return this._fetchJSON(t[0], t[1]);
        }, t.jwks = function(e) {
            var t = this._buildRequest(e, {
                method: "GET"
            });
            return this._fetchJSON(t[0], t[1]);
        }, t.getTokenWithAuthorizationCode = function(e) {
            return this.getToken(e);
        }, t.getTokenWithRefreshToken = function(e) {
            return this.getToken(e);
        }, t.getTokenWithDeviceCode = function(e) {
            return this.getToken(e);
        }, t.getTokenWithPassword = function(e) {
            return this.getToken(e);
        }, t.getTokenWithSAML = function(e) {
            return this.getToken(e);
        }, t.getTokenWithClientCredentials = function(e) {
            return this.getToken(e);
        }, t._buildUrl = function(e) {
            for(var t = e.url, r = p(e, F), n = new URL(t), o = new URLSearchParams, i = 0, u = Object.entries(r); i < u.length; i++){
                var s = u[i], c = s[0], a = s[1];
                null != c && null != a && o.append(c, a);
            }
            return n.search = o.toString(), n.toString();
        }, t._buildRequest = function(e, t) {
            var r, n = e.url, o = e.client_id, i = e.client_secret, s = e.client_auth_method, c = p(e, W), a = t.headers, l = t.method, f = new Headers(null != (r = this.options.headers) ? r : []);
            new Headers(null != a ? a : []).forEach(function(e, t) {
                f.set(t, e);
            }), "POST" === t.method && f.set("Content-Type", "application/x-www-form-urlencoded");
            var h = u({
                client_id: o
            }, c);
            switch(s){
                case "client_secret_basic":
                    if (null == i) throw new Error("Client secret not present!");
                    f.set("Authorization", "Basic " + P(o + ":" + i));
                    break;
                case "client_secret_post":
                    if (null == i) throw new Error("Client secret not present!");
                    h.client_secret = i;
                    break;
                case "none":
                case void 0:
                case null:
                    break;
                default:
                    throw new Error("Bad client_auth_method");
            }
            return [
                n,
                {
                    method: l,
                    headers: f,
                    body: "POST" === l ? new URLSearchParams(Object.entries(h)) : void 0
                }
            ];
        }, t._validateResponse = function(t) {
            if (t.error) throw e.Error.fromResponse(t);
            return t;
        }, t._fetchJSON = function(e, t) {
            try {
                var r, n = this;
                if (t.headers) {
                    var o = new Headers(t.headers);
                    o.set("Accept", "application/json"), t.headers = o;
                } else t.headers = {
                    Accept: "application/json"
                };
                return Promise.resolve(null == (r = window) ? void 0 : r.fetch(e, t)).then(function(e) {
                    return Promise.resolve(e.json()).then(function(t) {
                        if (n._validateResponse(t), !e.ok) throw new Error(e.status + " " + e.statusText + ": " + JSON.stringify(t));
                        return t;
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, e;
    }();
    N.Error = D;
    var B, M, V, J, H, K, Q = /*#__PURE__*/ function() {
        function e(e) {
            this.client = void 0, this.client = e;
        }
        var t = e.prototype;
        return t.get = function(e, t) {
            var r = void 0 === t ? {} : t, n = r.mustExist, o = void 0 !== n && n, i = r.deleteAfter, u = void 0 !== i && i;
            try {
                var s = this;
                return Promise.resolve(s.client.getStore().get(e)).then(function(t) {
                    var r;
                    function n(t) {
                        if (r) return t;
                        var n = function() {
                            if (u) return Promise.resolve(s.client.getStore().delete(e)).then(function() {});
                        }();
                        return n && n.then ? n.then(function() {
                            return i;
                        }) : i;
                    }
                    if (null != t) {
                        var i = t.value, c = t.expiresAt, a = function() {
                            if (0 !== c && c < Date.now()) return Promise.resolve(s.client.getStore().delete(e)).then(function() {
                                if (o) throw new Error(e + " does not exist in store");
                                r = 1;
                            });
                        }();
                        return a && a.then ? a.then(n) : n(a);
                    }
                    if (o) throw new Error(e + " does not exist in store");
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.set = function(e, t, r) {
            void 0 === r && (r = 0);
            try {
                return Promise.resolve(this.client.getStore().set(e, {
                    expiresAt: 0 === r ? 0 : Date.now() + r,
                    value: t
                })).then(function() {});
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.setAuthorizeRequest = function(e) {
            try {
                return Promise.resolve(this.set("request", e, 3e5)).then(function() {});
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.getAuthorizeRequest = function() {
            return this.get("request", {
                mustExist: !0,
                deleteAfter: !0
            });
        }, t.setLogoutRequest = function(e) {
            try {
                return Promise.resolve(this.set("logout-request", e, 3e5)).then(function() {});
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.getLogoutRequest = function() {
            return this.get("logout-request", {
                mustExist: !0,
                deleteAfter: !0
            });
        }, t.setVerifier = function(e, t) {
            try {
                return Promise.resolve(this.set("verifier:" + e, t, 3e5)).then(function() {});
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.getVerifier = function(e) {
            return this.get("verifier:" + e, {
                mustExist: !0,
                deleteAfter: !0
            });
        }, t.setOpenIdConfiguration = function(e, t, r) {
            try {
                return Promise.resolve(this.set("openidConfiguration:" + e, t, r)).then(function() {});
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.getOpenIdConfiguration = function(e) {
            return this.get("openidConfiguration:" + e);
        }, t.setAuthorization = function(e) {
            try {
                var t = this, r = {
                    clientID: e.idToken.aud,
                    resource: e.resource,
                    scope: e.scope,
                    username: e.idToken.sub
                }, n = e.expiresAt - Date.now();
                return Promise.resolve(t.set("username", r.username, n)).then(function() {
                    var o = t.set;
                    return Promise.resolve(t._getAuthorizationKey(r)).then(function(r) {
                        return Promise.resolve(o.call(t, r, e, n)).then(function() {});
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.deleteAuthorization = function(e) {
            try {
                var t = this;
                return Promise.resolve(t.get("username")).then(function(r) {
                    return Promise.resolve(t._getUsername(e.username, r)).then(function(n) {
                        function o() {
                            var r = t.client.getStore(), n = r.delete;
                            return Promise.resolve(t._getAuthorizationKey(e)).then(function(e) {
                                return n.call(r, e);
                            });
                        }
                        e.username = n;
                        var i = function() {
                            if (e.username === r) return Promise.resolve(t.client.getStore().delete("username")).then(function() {});
                        }();
                        return i && i.then ? i.then(o) : o();
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, t.getAuthorization = function(e) {
            try {
                var t = this, r = t.get;
                return Promise.resolve(t._getAuthorizationKey(e)).then(function(e) {
                    return r.call(t, e, {
                        mustExist: !0
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, t._getAuthorizationKey = function(e) {
            try {
                var t = this, r = L, n = t._getUsername, o = e.username;
                return Promise.resolve(t.get("username")).then(function(i) {
                    return Promise.resolve(n.call(t, o, i)).then(function(n) {
                        var o, i, u;
                        return "authorization?" + r.call(q, {
                            username: n,
                            clientID: null != (o = e.clientID) ? o : t.client.fallbackLoginOptions.clientID,
                            scope: U(null != (i = e.scope) ? i : t.client.fallbackLoginOptions.scope),
                            resource: null != (u = e.resource) ? u : t.client.fallbackLoginOptions.resource
                        });
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, t._getUsername = function(e, t) {
            try {
                if (null == e && null == t) throw new Error("no username given");
                return Promise.resolve(null != e ? e : t);
            } catch (e) {
                return Promise.reject(e);
            }
        }, e;
    }(), G = /*#__PURE__*/ function() {
        function e(e) {
            this.storage = void 0, this.storage = e;
        }
        var t = e.prototype;
        return t.get = function(e) {
            var t = this.storage.getItem(e);
            return null != t ? JSON.parse(t) : null;
        }, t.delete = function(e) {
            return this.storage.removeItem(e), !0;
        }, t.set = function(e, t) {
            return this.storage.setItem(e, JSON.stringify(t)), this;
        }, e;
    }(), X = "2.8.0";
    !function(e) {
        e.openid = "openid", e.wallet = "wallet";
    }(V || (V = {})), function(e) {
        e.email = "email", e.badges = "badges", e.offline = "offline", e.offline_access = "offline_access", e.humanity_check = "humanity_check", e.profile = "profile", e.social = "social";
    }(J || (J = {})), function(e) {
        e.twitter = "social:twitter", e.reddit = "social:reddit", e.youtube = "social:youtube", e.discord = "social:discord", e.telegram = "social:telegram";
    }(H || (H = {})), function(e) {
        e.display_name = "profile:name", e.profile_location = "profile:location", e.profile_bio = "profile:bio", e.ipfs_website = "profile:ipfs_website", e.profile_picture = "profile:picture", e.profile_uri = "profile:uri", e.profile_phone = "profile:phone";
    }(K || (K = {}));
    var Y = ((B = {})[V.openid] = {
        optional: !1
    }, B[V.wallet] = {
        optional: !1
    }, B), $ = ((M = {})[J.email] = {
        optional: !0
    }, M[J.offline] = {
        optional: !1
    }, M[J.offline_access] = {
        optional: !1
    }, M[J.humanity_check] = {
        optional: !0
    }, M[J.badges] = {
        optional: !0
    }, M[J.profile] = {
        optional: !0
    }, M[J.social] = {
        optional: !0
    }, M[K.display_name] = {
        optional: !0
    }, M[K.profile_location] = {
        optional: !0
    }, M[K.profile_bio] = {
        optional: !0
    }, M[K.profile_picture] = {
        optional: !0
    }, M[K.profile_uri] = {
        optional: !0
    }, M[K.profile_phone] = {
        optional: !0
    }, M[K.ipfs_website] = {
        optional: !0
    }, M[H.twitter] = {
        optional: !0
    }, M[H.reddit] = {
        optional: !0
    }, M[H.youtube] = {
        optional: !0
    }, M[H.discord] = {
        optional: !0
    }, M[H.telegram] = {
        optional: !0
    }, M), Z = function(e) {
        var t = [], r = e.premium ? $ : Y;
        return Object.keys(r).forEach(function(e) {
            t.push(e), r[e].optional && t.push(e + ":optional");
        }), t;
    }, ee = [
        "clientID",
        "username",
        "scope",
        "resource"
    ];
    if ("undefined" != typeof window) {
        var te = window;
        te.UAUTH_VERSION = te.UAUTH_VERSION || {}, te.UAUTH_VERSION.JS = X;
    }
    var re = /*#__PURE__*/ function() {
        var r = n.prototype;
        function n(r) {
            var n, o, i, s, c, a, l, f, h, p;
            this.util = q, this._clientStore = new Q(this), this.api = void 0, this.fallbackIssuer = void 0, this.fallbackLoginOptions = void 0, this.fallbackLogoutOptions = void 0, this.cacheOptions = void 0, this.issuerResolver = void 0, this.resolution = void 0, this.store = void 0, this.storeOptions = void 0, this.fallbackIssuer = null != (n = r.fallbackIssuer) ? n : "https://auth.unstoppabledomains.com", this.resolution = null != (o = r.resolution) ? o : new t.Resolution, this.storeOptions = {
                store: r.store,
                storeType: null != (i = r.storeType) ? i : "localstore"
            }, this.cacheOptions = u({
                issuer: !1,
                userinfo: !0
            }, null != (s = r.cacheOptions) ? s : {}), this.api = new N({
                headers: {}
            }), this.fallbackLoginOptions = {
                clientID: r.clientID,
                clientSecret: r.clientSecret,
                clientAuthMethod: null != (c = r.clientAuthMethod) ? c : r.clientSecret ? "client_secret_post" : "none",
                maxAge: null != (a = r.maxAge) ? a : 3e5,
                prompt: null != (l = r.prompt) ? l : "login",
                resource: r.resource,
                redirectUri: r.redirectUri,
                responseMode: null != (f = r.responseMode) ? f : "fragment",
                scope: null != (h = r.scope) ? h : "openid wallet"
            }, this.fallbackLogoutOptions = {
                rpInitiatedLogout: null != (p = r.rpInitiatedLogout) ? p : "string" == typeof r.postLogoutRedirectUri,
                postLogoutRedirectUri: r.postLogoutRedirectUri
            };
            var d = this;
            this.issuerResolver = new e.DefaultIssuerResolver({
                webfingerResolver: new e.DefaultWebFingerResolver({
                    ipfsResolver: new e.DefaultIPFSResolver(function() {
                        return (r.createIpfsUrl || e.DefaultIPFSResolver.defaultCreateUrl).apply(void 0, [].slice.call(arguments));
                    }),
                    domainResolver: {
                        records: function(e, r) {
                            try {
                                return Promise.resolve(function(t, n) {
                                    try {
                                        var o = Promise.resolve(d.resolution.records(e, r));
                                    } catch (e) {
                                        return n(e);
                                    }
                                    return o && o.then ? o.then(void 0, n) : o;
                                }(0, function(e) {
                                    if (e instanceof t.ResolutionError && e.code === t.ResolutionErrorCode.UnspecifiedResolver) return {};
                                    throw e;
                                }));
                            } catch (e) {
                                return Promise.reject(e);
                            }
                        }
                    }
                })
            });
        }
        return r.getStore = function() {
            if (this.store) return this.store;
            if (this.storeOptions.store) this.store = this.storeOptions.store;
            else switch(this.storeOptions.storeType){
                case "localstore":
                    this.store = new G(window.localStorage);
                    break;
                case "sessionstore":
                    this.store = new G(window.sessionStorage);
                    break;
                case "memory":
                    this.store = new Map;
                    break;
                default:
                    throw new Error("Bad storeType provided");
            }
            return this.store;
        }, r.buildAuthorizeRequest = function(e) {
            try {
                var t = this, r = u({}, t.fallbackLoginOptions, e), n = e.username;
                return Promise.resolve(t.getOpenIdConfiguration(n)).then(function(e) {
                    return Promise.resolve(C.createCodeChallengeAndVerifier(43, "S256")).then(function(o) {
                        var i, u = o.verifier, s = o.challenge, c = x.toBase64(x.stringFromBuffer(C.getRandomBytes(32))), a = x.encodeState(r.state), l = {
                            url: e.authorization_endpoint,
                            code_challenge: s,
                            nonce: c,
                            state: a,
                            flow_id: null != (i = r.flowId) ? i : "login",
                            login_hint: n,
                            client_id: r.clientID,
                            client_secret: r.clientSecret,
                            client_auth_method: r.clientAuthMethod,
                            max_age: r.maxAge,
                            prompt: r.prompt,
                            resource: r.resource,
                            redirect_uri: r.redirectUri,
                            response_mode: r.responseMode,
                            scope: r.scope,
                            code_challenge_method: "S256",
                            response_type: "code",
                            package_name: (null == r ? void 0 : r.packageName) || "@uauth/js",
                            package_version: (null == r ? void 0 : r.packageVersion) || X,
                            signup_suggestion: r.signupSuggestion
                        };
                        return Promise.resolve(t._clientStore.setAuthorizeRequest(l)).then(function() {
                            return Promise.resolve(t._clientStore.setVerifier(s, u)).then(function() {
                                return l;
                            });
                        });
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.loginWithPopup = function(e, t) {
            void 0 === e && (e = {});
            try {
                var r = this;
                return e.responseMode = "fragment", Promise.resolve(r.buildAuthorizeRequest(e)).then(function(e) {
                    return Promise.resolve(r.api.authorizeWithPopup(e, t)).then(function(t) {
                        return Promise.resolve(r.verifyAuthorizeResponse(e, t));
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.login = function(e) {
            void 0 === e && (e = {});
            try {
                var t = this;
                return Promise.resolve(t.buildAuthorizeRequest(e)).then(function(r) {
                    function n() {
                        window.location.href = o;
                    }
                    var o = t.api.buildAuthorizeUrl(r), i = function() {
                        if ("function" == typeof e.beforeRedirect) return Promise.resolve(e.beforeRedirect(o)).then(function() {});
                    }();
                    return i && i.then ? i.then(n) : n();
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.loginCallback = function(e) {
            try {
                var t, r = this, n = null != (t = null == e ? void 0 : e.url) ? t : window.location.href;
                return Promise.resolve(r._clientStore.getAuthorizeRequest()).then(function(e) {
                    var t;
                    if ("fragment" === e.response_mode) t = r.api.parseAuthorizeResponseFromFragment(n);
                    else {
                        if ("query" !== e.response_mode) throw new Error("Unsupported response_mode");
                        t = r.api.parseAuthorizeResponseFromQuery(n);
                    }
                    return Promise.resolve(r.verifyAuthorizeResponse(e, t)).then(function(t) {
                        return {
                            authorization: t,
                            state: x.decodeState(e.state)
                        };
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.verifyAuthorizeResponse = function(e, t) {
            try {
                var r = this;
                if (e.state !== t.state) throw new Error("states don't match");
                return Promise.resolve(r.getOpenIdConfiguration(e.login_hint)).then(function(n) {
                    var o = t.code, i = e.client_auth_method, u = e.client_secret, s = e.client_id, c = n.token_endpoint;
                    return Promise.resolve(r._clientStore.getVerifier(e.code_challenge)).then(function(t) {
                        return Promise.resolve(r.api.getTokenWithAuthorizationCode({
                            url: c,
                            client_id: s,
                            client_secret: u,
                            client_auth_method: i,
                            grant_type: "authorization_code",
                            code: o,
                            code_verifier: t,
                            redirect_uri: e.redirect_uri
                        })).then(function(t) {
                            return Promise.resolve(C.verifyIdToken(n.jwks_uri, t.id_token, e.nonce, e.client_id)).then(function(n) {
                                var o = {
                                    accessToken: t.access_token,
                                    expiresAt: Date.now() + 1e3 * t.expires_in,
                                    idToken: n,
                                    scope: U(e.scope),
                                    resource: e.resource
                                };
                                return Promise.resolve(r._clientStore.setAuthorization(o)).then(function() {
                                    return o;
                                });
                            });
                        });
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.getVerifiedAccounts = function(e, t) {
            void 0 === t && (t = []);
            var r = [];
            return e.idToken.verified_addresses ? (e.idToken.verified_addresses.forEach(function(e) {
                t.length > 0 && !t.includes(e.symbol) || r.push({
                    address: e.address,
                    message: e.proof.message,
                    signature: e.proof.signature,
                    symbol: e.symbol
                });
            }), r) : r;
        }, r.getAuthorizationAccount = function(e, t, r) {
            var n;
            void 0 === t && (t = "sig"), void 0 === r && (r = "v1");
            var o = null == (n = e.idToken.amr) ? void 0 : n.filter(function(e) {
                return e.startsWith(r + "." + t);
            });
            if (o && 0 != o.length) {
                var i = o[0].split(".")[3], u = this.getVerifiedAccounts(e);
                if (u) for(var s, c = m(u); !(s = c()).done;){
                    var a = s.value;
                    if (a.address === i) return a;
                }
            }
        }, r.getOpenIdConfiguration = function(e) {
            try {
                var t, r = function(r) {
                    return t ? r : Promise.resolve(e ? n.issuerResolver.resolve(e, n.fallbackIssuer) : fetch(n.fallbackIssuer + "/.well-known/openid-configuration").then(function(e) {
                        return e.ok ? e.json() : Promise.reject(new Error("bad openid-configuration response"));
                    })).then(function(t) {
                        return Promise.resolve(n._clientStore.setOpenIdConfiguration(null != e ? e : "", t, "number" == typeof n.cacheOptions.issuer ? n.cacheOptions.issuer : 36e5)).then(function() {
                            return t;
                        });
                    });
                }, n = this, o = function() {
                    if (n.cacheOptions.issuer) return Promise.resolve(n._clientStore.getOpenIdConfiguration(null != e ? e : "")).then(function(e) {
                        if (e) return t = 1, e;
                    });
                }();
                return Promise.resolve(o && o.then ? o.then(r) : r(o));
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.authorization = function(e) {
            void 0 === e && (e = {});
            try {
                var t = this;
                return Promise.resolve(t._clientStore.getAuthorization(e)).then(function(e) {
                    return e.scope && !t.checkPremiumScopes(e.scope) && (e.upgrade = {
                        text: "Please contact Unstoppable Domains to upgrade your account to access premium scopes bd@unstoppabledomains.com",
                        upgrade_for_premium: Z({
                            premium: !0
                        }).join(" ")
                    }), e;
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.checkPremiumScopes = function(e) {
            return e.split(" ").filter(function(e) {
                return !Z({
                    premium: !1
                }).includes(e);
            }).length > 0;
        }, r.user = function(e) {
            void 0 === e && (e = {});
            try {
                var t, r = this, n = null != (t = e.claims) ? t : [
                    "name",
                    "given_name",
                    "family_name",
                    "middle_name",
                    "nickname",
                    "preferred_username",
                    "profile",
                    "picture",
                    "website",
                    "email",
                    "email_verified",
                    "gender",
                    "birthdate",
                    "zoneinfo",
                    "locale",
                    "phone_number",
                    "phone_number_verified",
                    "address",
                    "updated_at",
                    "wallet_address",
                    "wallet_type_hint",
                    "eip4361_message",
                    "eip4361_signature",
                    "humanity_check_id"
                ];
                return Promise.resolve(r.authorization(e)).then(function(e) {
                    var t = {
                        sub: e.idToken.sub
                    };
                    if (e.upgrade && (t.upgrade = e.upgrade, t.email = "upgrade-for-premium", t.address = {
                        formatted: "upgrade-for-premium",
                        street_address: "upgrade-for-premium",
                        locality: "upgrade-for-premium",
                        region: "upgrade-for-premium",
                        postal_code: "upgrade-for-premium",
                        country: "upgrade-for-premium"
                    }, t.phone_number = "upgrade-for-premium", t.name = "upgrade-for-premium", t.given_name = "upgrade-for-premium", t.family_name = "upgrade-for-premium", t.middle_name = "upgrade-for-premium", t.nickname = "upgrade-for-premium", t.preferred_username = "upgrade-for-premium", t.profile = "upgrade-for-premium", t.picture = "https://storage.googleapis.com/unstoppable-client-assets/images/partners/avatar-placeholder.png", t.website = "upgrade-for-premium", t.gender = "upgrade-for-premium", t.birthdate = "upgrade-for-premium", t.zoneinfo = "upgrade-for-premium", t.locale = "upgrade-for-premium", t.updated_at = "upgrade-for-premium", t.humanity_check_id = "upgrade-for-premium"), r.cacheOptions.userinfo) {
                        for(var o, i = m(n); !(o = i()).done;){
                            var u = o.value;
                            e.idToken[u] && (t[u] = e.idToken[u]);
                        }
                        return t;
                    }
                    return Promise.resolve(r.getOpenIdConfiguration(e.idToken.sub)).then(function(o) {
                        return Promise.resolve(r.api.userinfo({
                            client_id: r.fallbackLoginOptions.clientID,
                            client_secret: r.fallbackLoginOptions.clientSecret,
                            client_auth_method: r.fallbackLoginOptions.clientAuthMethod,
                            access_token: e.accessToken,
                            url: o.userinfo_endpoint
                        })).then(function(e) {
                            for(var r, o = m(n); !(r = o()).done;){
                                var i = r.value;
                                e[i] && (t[i] = e[i]);
                            }
                            return t;
                        });
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.buildLogoutRequest = function(e) {
            try {
                var t = this;
                return Promise.resolve(t.authorization(e)).then(function(r) {
                    return Promise.resolve(t.getOpenIdConfiguration(r.idToken.sub)).then(function(n) {
                        var o;
                        if (null == n.end_session_endpoint) throw new Error("end_session_endpoint must exist");
                        var i = null != (o = e.postLogoutRedirectUri) ? o : t.fallbackLogoutOptions.postLogoutRedirectUri;
                        if (null == i) throw new Error("postLogoutRedirectUri must be supplied");
                        var u = {
                            client_id: t.fallbackLoginOptions.clientID,
                            client_secret: t.fallbackLoginOptions.clientSecret,
                            client_auth_method: t.fallbackLoginOptions.clientAuthMethod,
                            url: n.end_session_endpoint,
                            id_token_hint: r.idToken.__raw,
                            post_logout_redirect_uri: i,
                            state: x.encodeState(e.state)
                        };
                        return Promise.resolve(t._clientStore.setLogoutRequest(u)).then(function() {
                            return u;
                        });
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.logout = function(e) {
            var t = void 0 === e ? {} : e, r = t.clientID, n = t.username, o = t.scope, i = t.resource, s = p(t, ee);
            try {
                var c, a = function(e) {
                    return c ? e : Promise.resolve(l.buildLogoutRequest(f)).then(function(e) {
                        function t() {
                            return Promise.resolve(l._clientStore.deleteAuthorization(h)).then(function() {
                                window.location.href = r;
                            });
                        }
                        var r = l.api.buildLogoutUrl(e), n = function() {
                            if ("function" == typeof f.beforeRedirect) return Promise.resolve(f.beforeRedirect(r)).then(function() {});
                        }();
                        return n && n.then ? n.then(t) : t();
                    });
                }, l = this, f = u({}, l.fallbackLogoutOptions, s), h = {
                    clientID: r,
                    username: n,
                    scope: o,
                    resource: i
                }, d = function() {
                    if (!f.rpInitiatedLogout) return Promise.resolve(l._clientStore.deleteAuthorization(h)).then(function() {
                        c = 1;
                    });
                }();
                return Promise.resolve(d && d.then ? d.then(a) : a(d));
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.logoutCallback = function(e) {
            void 0 === e && (e = {});
            try {
                var t, r, n = this, o = null != (t = null == (r = e) ? void 0 : r.url) ? t : window.location.href;
                return Promise.resolve(n._clientStore.getLogoutRequest()).then(function(e) {
                    var t = n.api.parseAuthorizeResponseFromQuery(o);
                    return Promise.resolve(n.verifyLogoutResponse(e, t)).then(function() {
                        return x.decodeState(e.state);
                    });
                });
            } catch (e) {
                return Promise.reject(e);
            }
        }, r.verifyLogoutResponse = function(e, t) {
            try {
                if (e.state !== t.state) throw new Error("states don't match");
                return Promise.resolve();
            } catch (e) {
                return Promise.reject(e);
            }
        }, n;
    }();
    return re;
});


console.log("my app ");
const $4d4f6843d4cf9c81$var$uauth = new (0, (/*@__PURE__*/$parcel$interopDefault($d24fb0ab9d4863bc$exports)))({
    clientID: "e8af4509-3c02-4ff6-bec5-d3af71e43f27",
    redirectUri: "https://beemee.buzz/register",
    scope: "openid wallet messaging:notifications:optional"
});
window.loginWithUnstoppable = async ()=>{
    try {
        console.log("loginWithUnstoppable");
        const authorization = await $4d4f6843d4cf9c81$var$uauth.loginWithPopup();
        console.log(authorization);
        return authorization;
    } catch (error) {
        console.error(error);
        return null;
    }
};

})();
//# sourceMappingURL=app.js.map
